const partList = [
    {
        "code": "2V5-129-589-D",
        "name": "VEDACAO"
    },
    {
        "code": "2P0-000-367-B",
        "name": "ADESIVO"
    },
    {
        "code": "2S2-970-010",
        "name": "CHICOTE"
    },
    {
        "code": "23K-611-757",
        "name": "suporte"
    },
    {
        "code": "23K-611-793-A",
        "name": "suporte"
    },
    {
        "code": "23K-611-793-B",
        "name": "suporte"
    },
    {
        "code": "23K-611-793-C",
        "name": "suporte"
    },
    {
        "code": "23K-611-793-E",
        "name": "suporte"
    },
    {
        "code": "23K-611-820",
        "name": "SUPORTE"
    },
    {
        "code": "23K-611-820-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-612-129",
        "name": "CABECOTE"
    },
    {
        "code": "23K-614-159",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-614-166-B",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-971-073",
        "name": "CHICOTE"
    },
    {
        "code": "23K-614-167-B",
        "name": "SUPORTE"
    },
    {
        "code": "23K-614-173",
        "name": "LUVA"
    },
    {
        "code": "23K-615-329",
        "name": "CAMARA DO"
    },
    {
        "code": "23K-615-329-A",
        "name": "CAMARA DO"
    },
    {
        "code": "23K-615-330",
        "name": "CAMARA DO"
    },
    {
        "code": "23K-615-330-A",
        "name": "CAMARA DO"
    },
    {
        "code": "23K-615-331",
        "name": "CAMARA DO"
    },
    {
        "code": "23K-615-331-A",
        "name": "CAMARA DO"
    },
    {
        "code": "23K-615-331-B",
        "name": "CAMARA DO"
    },
    {
        "code": "23K-615-331-C",
        "name": "CAMARA DO"
    },
    {
        "code": "2S2-971-073-B",
        "name": "CHICOTE"
    },
    {
        "code": "23K-615-332",
        "name": "CAMARA DO"
    },
    {
        "code": "23K-698-075",
        "name": "JG. LONA"
    },
    {
        "code": "23K-701-021",
        "name": "CHASSI"
    },
    {
        "code": "23K-701-021-C",
        "name": "CHASSI"
    },
    {
        "code": "23K-701-021-D",
        "name": "CHASSI"
    },
    {
        "code": "23K-701-131",
        "name": "TRAVESSA"
    },
    {
        "code": "23K-701-131-A",
        "name": "TRAVESSA"
    },
    {
        "code": "23K-701-149",
        "name": "suporte"
    },
    {
        "code": "23K-701-150",
        "name": "suporte"
    },
    {
        "code": "23K-701-151",
        "name": "QUINTA ROD"
    },
    {
        "code": "2S2-971-073-C",
        "name": "CHICOTE"
    },
    {
        "code": "23K-701-151-A",
        "name": "QUINTA ROD"
    },
    {
        "code": "23K-701-151-B",
        "name": "QUINTA ROD"
    },
    {
        "code": "23K-701-151-C",
        "name": "QUINTA ROD"
    },
    {
        "code": "23K-701-169",
        "name": "suporte"
    },
    {
        "code": "23K-701-169-A",
        "name": "suporte"
    },
    {
        "code": "23K-701-185",
        "name": "suporte"
    },
    {
        "code": "23K-701-186",
        "name": "suporte"
    },
    {
        "code": "2T2-201-260-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-201-283-B",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-201-283-N",
        "name": "DEFLETOR"
    },
    {
        "code": "2S2-971-073-D",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-201-283-P",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-201-283-Q",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-201-341-D",
        "name": "TUBO"
    },
    {
        "code": "2T2-201-351-BB",
        "name": "tubulacao"
    },
    {
        "code": "23L-129-591",
        "name": "COLETOR"
    },
    {
        "code": "23L-129-723",
        "name": "BRACADEIRA"
    },
    {
        "code": "23L-129-828",
        "name": "SENSOR"
    },
    {
        "code": "23L-129-926",
        "name": "SUPORTE"
    },
    {
        "code": "23L-129-999",
        "name": "ANEL"
    },
    {
        "code": "23L-130-085",
        "name": "TUBO"
    },
    {
        "code": "2S2-971-113-A",
        "name": "CHICOTE"
    },
    {
        "code": "23L-130-085-A",
        "name": "TUBO"
    },
    {
        "code": "23L-130-099",
        "name": "suporte"
    },
    {
        "code": "23L-130-099-A",
        "name": "suporte"
    },
    {
        "code": "23L-130-099-B",
        "name": "suporte"
    },
    {
        "code": "23L-130-105",
        "name": "BOMBA COMB"
    },
    {
        "code": "23L-130-120",
        "name": "ANEL"
    },
    {
        "code": "23L-130-120-A",
        "name": "ANEL"
    },
    {
        "code": "23L-130-139",
        "name": "ANEL"
    },
    {
        "code": "23L-130-139-A",
        "name": "ANEL"
    },
    {
        "code": "23L-130-201",
        "name": "BICO INJET"
    },
    {
        "code": "2S2-971-113-B",
        "name": "CHICOTE"
    },
    {
        "code": "23L-130-305",
        "name": "TUBO"
    },
    {
        "code": "23L-130-305-A",
        "name": "TUBO"
    },
    {
        "code": "23L-130-305-B",
        "name": "TUBO"
    },
    {
        "code": "23L-130-305-C",
        "name": "TUBO"
    },
    {
        "code": "23L-130-305-D",
        "name": "TUBO"
    },
    {
        "code": "23L-130-311",
        "name": "TUBO"
    },
    {
        "code": "23L-130-311-A",
        "name": "TUBO"
    },
    {
        "code": "23L-130-311-B",
        "name": "TUBO"
    },
    {
        "code": "23L-130-311-C",
        "name": "TUBO"
    },
    {
        "code": "23L-130-311-D",
        "name": "TUBO"
    },
    {
        "code": "2S2-971-118",
        "name": "CHICOTE"
    },
    {
        "code": "23L-130-431",
        "name": "PRESILHA"
    },
    {
        "code": "23L-130-639",
        "name": "ENGRENAGEM"
    },
    {
        "code": "23L-130-758",
        "name": "SENSOR"
    },
    {
        "code": "23L-131-113",
        "name": "UNIDADE"
    },
    {
        "code": "23L-131-185",
        "name": "CONEXAO"
    },
    {
        "code": "23L-131-185-A",
        "name": "CONEXAO"
    },
    {
        "code": "23L-131-185-B",
        "name": "CONEXAO"
    },
    {
        "code": "23L-131-529",
        "name": "PORCA"
    },
    {
        "code": "23L-131-759",
        "name": "FILTRO"
    },
    {
        "code": "23L-133-319",
        "name": "distribuid"
    },
    {
        "code": "2S2-971-285-A",
        "name": "CHICOTE"
    },
    {
        "code": "23L-141-025-A",
        "name": "PLATO"
    },
    {
        "code": "23L-141-031-A",
        "name": "DISCO EMBR"
    },
    {
        "code": "23L-145-061",
        "name": "TURBO"
    },
    {
        "code": "23L-145-061-A",
        "name": "TURBO"
    },
    {
        "code": "23L-145-162",
        "name": "suporte"
    },
    {
        "code": "23L-145-367",
        "name": "TUBO"
    },
    {
        "code": "23L-145-367-A",
        "name": "TUBO"
    },
    {
        "code": "23L-145-367-B",
        "name": "TUBO"
    },
    {
        "code": "23L-145-555",
        "name": "MANGUEIRA"
    },
    {
        "code": "23L-145-705",
        "name": "VALVULA"
    },
    {
        "code": "2S2-971-561-L",
        "name": "CHICOTE"
    },
    {
        "code": "23L-145-735",
        "name": "TUBO"
    },
    {
        "code": "23L-145-735-A",
        "name": "TUBO"
    },
    {
        "code": "23L-145-744",
        "name": "FLANGE"
    },
    {
        "code": "23L-145-745",
        "name": "MANGUEIRA"
    },
    {
        "code": "23L-145-757",
        "name": "JUNTA"
    },
    {
        "code": "23L-145-773",
        "name": "JUNTA"
    },
    {
        "code": "23L-145-820",
        "name": "TUBO"
    },
    {
        "code": "23L-145-828",
        "name": "MANGUEIRA"
    },
    {
        "code": "23L-198-011",
        "name": "JG JUNTAS"
    },
    {
        "code": "23L-198-012",
        "name": "JG JUNTAS"
    },
    {
        "code": "2P0-019-873",
        "name": "Paraf torx"
    },
    {
        "code": "2S2-971-561-M",
        "name": "CHICOTE"
    },
    {
        "code": "23L-198-115",
        "name": "JG.BRONZIN"
    },
    {
        "code": "23L-198-151",
        "name": "JG. ANEL"
    },
    {
        "code": "23L-198-451",
        "name": "CASQUILHO"
    },
    {
        "code": "23L-198-451-A",
        "name": "CASQUILHO"
    },
    {
        "code": "23L-198-451-B",
        "name": "CASQUILHO"
    },
    {
        "code": "2V1-810-899-F",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-817-017",
        "name": "TETO"
    },
    {
        "code": "2V1-817-025",
        "name": "TETO"
    },
    {
        "code": "2V1-817-025-A",
        "name": "TETO"
    },
    {
        "code": "2V1-817-383",
        "name": "COBERTURA"
    },
    {
        "code": "2S2-971-561-N",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-817-383-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V1-817-384",
        "name": "COBERTURA"
    },
    {
        "code": "2V1-817-384-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V1-820-367",
        "name": "Filtro de"
    },
    {
        "code": "2V1-820-721",
        "name": "TUBO"
    },
    {
        "code": "2V1-820-722",
        "name": "TUBO"
    },
    {
        "code": "2V1-820-742",
        "name": "TUBO"
    },
    {
        "code": "2V1-821-175",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-821-176",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-823-433",
        "name": "BATENTE"
    },
    {
        "code": "2S2-971-641-D",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-837-015-  -69D",
        "name": "FECHADURA"
    },
    {
        "code": "2V1-837-016-  -69D",
        "name": "FECHADURA"
    },
    {
        "code": "2V1-837-399-A",
        "name": "MECANISMO"
    },
    {
        "code": "2V1-837-400-A",
        "name": "MECANISMO"
    },
    {
        "code": "2V1-837-431",
        "name": "QUADRO"
    },
    {
        "code": "2V1-837-431-  -6ZT",
        "name": "QUADRO"
    },
    {
        "code": "2V1-837-432",
        "name": "QUADRO"
    },
    {
        "code": "2V1-837-432-  -6ZT",
        "name": "QUADRO"
    },
    {
        "code": "2V1-837-577",
        "name": "GUIA"
    },
    {
        "code": "2V1-845-437",
        "name": "GUARNICAO"
    },
    {
        "code": "2S2-971-723",
        "name": "RETENCAO"
    },
    {
        "code": "2V1-853-421",
        "name": "ADESIVO"
    },
    {
        "code": "2V1-853-421-A",
        "name": "ADESIVO"
    },
    {
        "code": "2V1-853-421-B",
        "name": "ADESIVO"
    },
    {
        "code": "2V1-853-422",
        "name": "ADESIVO"
    },
    {
        "code": "2V1-853-422-A",
        "name": "ADESIVO"
    },
    {
        "code": "2V1-853-422-B",
        "name": "ADESIVO"
    },
    {
        "code": "2V1-853-601",
        "name": "EMBLEMA VW"
    },
    {
        "code": "2V1-853-653",
        "name": "GRADE"
    },
    {
        "code": "2V1-853-653-  -9B9",
        "name": "GRADE"
    },
    {
        "code": "2V1-853-653-C",
        "name": "GRADE"
    },
    {
        "code": "2S2-971-880",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-853-655",
        "name": "DEFLETOR"
    },
    {
        "code": "2V1-853-656",
        "name": "DEFLETOR"
    },
    {
        "code": "2V1-853-709",
        "name": "FRISO"
    },
    {
        "code": "2V1-853-709-A",
        "name": "FRISO"
    },
    {
        "code": "2V1-853-710",
        "name": "FRISO"
    },
    {
        "code": "2V1-853-710-A",
        "name": "FRISO"
    },
    {
        "code": "2V1-853-899",
        "name": "REVESTIMEN"
    },
    {
        "code": "N  -106-756-03",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-863-531",
        "name": "suporte"
    },
    {
        "code": "2V5-863-741",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2S4-858-561",
        "name": "ESPELHO"
    },
    {
        "code": "2V5-863-742",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2V5-863-883",
        "name": "SILENCIADO"
    },
    {
        "code": "2V5-863-884",
        "name": "SILENCIADO"
    },
    {
        "code": "2V5-863-895",
        "name": "SILENCIADO"
    },
    {
        "code": "2V5-863-896",
        "name": "SILENCIADO"
    },
    {
        "code": "2V5-864-125",
        "name": "MOLA"
    },
    {
        "code": "2V5-864-137",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-864-901-A",
        "name": "PECA MOLDE"
    },
    {
        "code": "2V5-864-902-A",
        "name": "PECA MOLDE"
    },
    {
        "code": "2V5-864-933",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2S4-867-501-  -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-033-D",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-033-E",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-033-F",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-033-G",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-809-344",
        "name": "CHAPA"
    },
    {
        "code": "2V5-809-405",
        "name": "Soleira"
    },
    {
        "code": "2V5-809-406",
        "name": "Soleira"
    },
    {
        "code": "2V5-809-583-A",
        "name": "PROTECAO"
    },
    {
        "code": "2V5-809-864-G",
        "name": "REBITE"
    },
    {
        "code": "2V5-809-940",
        "name": "ANEL"
    },
    {
        "code": "2S4-881-019-  -CIL",
        "name": "BANCO"
    },
    {
        "code": "2V5-809-957",
        "name": "PARALAMAS"
    },
    {
        "code": "2V5-809-958",
        "name": "PARA BARRO"
    },
    {
        "code": "2V5-809-967",
        "name": "PARA BARRO"
    },
    {
        "code": "2V5-810-083",
        "name": "painel"
    },
    {
        "code": "2V5-810-084",
        "name": "painel"
    },
    {
        "code": "2V5-813-103-C",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-813-103-D",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-813-359",
        "name": "TRAVESSA"
    },
    {
        "code": "2V5-813-467-A",
        "name": "PAINEL"
    },
    {
        "code": "2V5-813-541",
        "name": "SUPORTE"
    },
    {
        "code": "2S4-881-019-  -CIO",
        "name": "BANCO"
    },
    {
        "code": "2V5-813-542",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-867-362-A",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-867-477-B",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-489-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-867-501-C",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-503-A",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-585-C",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-867-585-D",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-867-585-G",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-867-586-B",
        "name": "MOLDURA"
    },
    {
        "code": "2S4-881-023-  -CIL",
        "name": "ASSENTO"
    },
    {
        "code": "2V5-867-586-E",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-867-621",
        "name": "puxador"
    },
    {
        "code": "2V5-867-622",
        "name": "puxador"
    },
    {
        "code": "2V5-867-641",
        "name": "PECA RETEN"
    },
    {
        "code": "2V5-867-648",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-867-648-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-867-648-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-867-648-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-867-648-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-107-069",
        "name": "PISTAO"
    },
    {
        "code": "2P0-103-448-H",
        "name": "PARAFUSO"
    },
    {
        "code": "2S4-881-023-  -CIO",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-107-069-A",
        "name": "PISTAO"
    },
    {
        "code": "2V3-107-311-C",
        "name": "ANEL"
    },
    {
        "code": "2V3-107-321-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-107-321-C",
        "name": "ANEL"
    },
    {
        "code": "2V3-109-045",
        "name": "PINO"
    },
    {
        "code": "2V3-109-101-A",
        "name": "COMANDO"
    },
    {
        "code": "2V3-109-101-B",
        "name": "COMANDO"
    },
    {
        "code": "2V3-109-307",
        "name": "PINO"
    },
    {
        "code": "2V3-109-307-A",
        "name": "PINO"
    },
    {
        "code": "2V3-109-337-D",
        "name": "BALANCIM"
    },
    {
        "code": "2S4-881-023-A -CIL",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-109-337-F",
        "name": "BALANCIM"
    },
    {
        "code": "2V3-109-337-G",
        "name": "BALANCIM"
    },
    {
        "code": "2V3-109-337-H",
        "name": "BALANCIM"
    },
    {
        "code": "2V3-109-447",
        "name": "BALANCIM"
    },
    {
        "code": "2V3-109-447-A",
        "name": "BALANCIM"
    },
    {
        "code": "2V3-109-447-B",
        "name": "BALANCIM"
    },
    {
        "code": "2V3-109-447-C",
        "name": "BALANCIM"
    },
    {
        "code": "2V3-109-476",
        "name": "PONTE"
    },
    {
        "code": "2V5-817-868-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-819-005-J",
        "name": "CAIXA"
    },
    {
        "code": "2S4-881-023-A -CIO",
        "name": "ASSENTO"
    },
    {
        "code": "2V5-819-031-A",
        "name": "AQUECEDOR"
    },
    {
        "code": "2V5-819-128",
        "name": "REG.SUPLEM"
    },
    {
        "code": "2V5-819-151",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-151-A",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-151-B",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-152-A",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-152-B",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-152-E",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-153",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-819-164-B",
        "name": "COBERTURA"
    },
    {
        "code": "2S4-881-023-B -CIL",
        "name": "ASSENTO"
    },
    {
        "code": "2V5-819-166-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-819-217",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-819-240",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-240-A",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-899-445",
        "name": "APOIO"
    },
    {
        "code": "2V5-899-501-E",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2V5-899-505-C",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2V5-899-507",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-899-507-A",
        "name": "APOIO"
    },
    {
        "code": "2V5-899-508",
        "name": "SUPORTE"
    },
    {
        "code": "2S4-881-023-B -CIO",
        "name": "ASSENTO"
    },
    {
        "code": "2V5-899-508-A",
        "name": "APOIO"
    },
    {
        "code": "2V5-899-521",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-899-531-A",
        "name": "BUCHA"
    },
    {
        "code": "2V5-899-531-B",
        "name": "BUCHA"
    },
    {
        "code": "2V5-899-541",
        "name": "BUCHA"
    },
    {
        "code": "2V5-899-541-A",
        "name": "COXIM"
    },
    {
        "code": "2V5-899-545-B",
        "name": "JG. BUCHA"
    },
    {
        "code": "2V5-899-545-C",
        "name": "LUVA"
    },
    {
        "code": "2V5-899-901",
        "name": "CHP COBERT"
    },
    {
        "code": "2V3-301-331-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2S4-881-031-  -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2V3-301-331-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-331-H",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-331-J",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-331-K",
        "name": "Parafuso"
    },
    {
        "code": "2V3-301-331-L",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-339",
        "name": "ANEL"
    },
    {
        "code": "2V3-301-340",
        "name": "POSICAO"
    },
    {
        "code": "2V3-301-340-A",
        "name": "POSICAO"
    },
    {
        "code": "2V3-301-340-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-341",
        "name": "PARAFUSO"
    },
    {
        "code": "2S4-881-031-  -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2V3-301-341-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-343",
        "name": "Paraf torx"
    },
    {
        "code": "2V5-971-262",
        "name": "suporte"
    },
    {
        "code": "2V5-971-280-C",
        "name": "suporte"
    },
    {
        "code": "2V5-971-301",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-971-303-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-971-335",
        "name": "suporte"
    },
    {
        "code": "2V5-971-502",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-971-530",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-971-531-A",
        "name": "CHICOTE"
    },
    {
        "code": "2S4-881-031-A -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2V3-311-168",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-183",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-187",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-187-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-187-B",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-187-C",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-187-D",
        "name": "ANEL"
    },
    {
        "code": "2V5-525-397",
        "name": "PROTECAO"
    },
    {
        "code": "2V5-525-403",
        "name": "EIXO"
    },
    {
        "code": "2V5-525-539",
        "name": "FILTRO OLE"
    },
    {
        "code": "2S4-881-031-A -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2V5-525-539-A",
        "name": "FILTRO OLE"
    },
    {
        "code": "2V5-525-623-A",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V5-525-649",
        "name": "EIXO"
    },
    {
        "code": "2V5-525-715",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V5-525-728",
        "name": "MOLA"
    },
    {
        "code": "2V5-525-777",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-598-081-J",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-598-081-K",
        "name": "JOGO"
    },
    {
        "code": "2V5-598-149-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-598-287-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S4-881-031-C -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2V5-598-998-D",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-598-998-F",
        "name": "JG.PECAS"
    },
    {
        "code": "2T0-311-312-A",
        "name": "MOLA"
    },
    {
        "code": "2V3-607-262-A",
        "name": "valvula"
    },
    {
        "code": "2V3-607-262-B",
        "name": "valvula"
    },
    {
        "code": "2V3-607-263",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V3-607-307",
        "name": "BUCHA"
    },
    {
        "code": "2V3-607-312",
        "name": "TUBO"
    },
    {
        "code": "2V3-607-312-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-607-312-B",
        "name": "TUBO"
    },
    {
        "code": "2P0-105-315",
        "name": "ANEL"
    },
    {
        "code": "2S4-881-031-C -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2V3-607-312-C",
        "name": "TUBO"
    },
    {
        "code": "2V3-607-312-D",
        "name": "TUBO"
    },
    {
        "code": "2V3-607-315",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-315-A",
        "name": "PECA EM T"
    },
    {
        "code": "2V3-607-315-B",
        "name": "PECA EM T"
    },
    {
        "code": "2V3-607-315-C",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-315-D",
        "name": "PECA EM T"
    },
    {
        "code": "2V3-607-323",
        "name": "LUVA"
    },
    {
        "code": "2V3-607-323-A",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-329",
        "name": "VALVULA"
    },
    {
        "code": "2S4-881-031-D -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "N  -105-361-03",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-802-646-E",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-802-646-F",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-802-646-F -I9A",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-802-903-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-803-249",
        "name": "HASTE"
    },
    {
        "code": "2V3-803-347",
        "name": "PLATAFORMA"
    },
    {
        "code": "2V3-803-347-A",
        "name": "PLATAFORMA"
    },
    {
        "code": "2V3-803-347-B",
        "name": "PLATAFORMA"
    },
    {
        "code": "2V3-803-347-C",
        "name": "PLATAFORMA"
    },
    {
        "code": "2S4-881-032-  -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2V3-803-383-B",
        "name": "suporte"
    },
    {
        "code": "2V3-803-384-A",
        "name": "suporte"
    },
    {
        "code": "2V3-803-543",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-803-544",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-803-777",
        "name": "GUIA"
    },
    {
        "code": "2V3-803-875",
        "name": "PORCA"
    },
    {
        "code": "2V3-803-877",
        "name": "Parafuso"
    },
    {
        "code": "2V3-803-877-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-803-877-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-803-877-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2S4-881-032-  -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2V3-803-877-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-803-889-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-803-890-A",
        "name": "suporte"
    },
    {
        "code": "T2D-957-079",
        "name": "PARAFUSO"
    },
    {
        "code": "T12-525-359",
        "name": "MOLA"
    },
    {
        "code": "23B-721-466",
        "name": "ADAPTADOR"
    },
    {
        "code": "TJG-103-213",
        "name": "PARAFUSO"
    },
    {
        "code": "TJG-109-411",
        "name": "ARRUELA"
    },
    {
        "code": "TJG-121-805",
        "name": "PARAFUSO"
    },
    {
        "code": "TJG-121-811",
        "name": "PORCA"
    },
    {
        "code": "2S4-881-032-A -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "TJG-121-833",
        "name": "TUBO"
    },
    {
        "code": "23K-317-039",
        "name": "ESPACADOR"
    },
    {
        "code": "23K-317-065",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-317-065-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-317-752-D",
        "name": "Tubo de ag"
    },
    {
        "code": "23K-399-243-F",
        "name": "suporte"
    },
    {
        "code": "23K-399-243-G",
        "name": "suporte"
    },
    {
        "code": "23K-413-031-C",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-419-421",
        "name": "FLANGE"
    },
    {
        "code": "23K-419-523",
        "name": "COBERTURA"
    },
    {
        "code": "2S4-881-032-A -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "23K-419-655-A -999",
        "name": "VOLANTE"
    },
    {
        "code": "23K-422-843",
        "name": "TUBO ASPI."
    },
    {
        "code": "23K-500-051-H",
        "name": "EIXOTRASEI"
    },
    {
        "code": "23K-500-051-J",
        "name": "EIXOTRASEI"
    },
    {
        "code": "23K-500-051-M",
        "name": "EIXOTRASEI"
    },
    {
        "code": "23K-500-051-N",
        "name": "EIXOTRASEI"
    },
    {
        "code": "23K-500-051-N -PEA",
        "name": "EIXOTRASEI"
    },
    {
        "code": "23K-500-051-P",
        "name": "EIXOTRASEI"
    },
    {
        "code": "23K-500-051-Q",
        "name": "EIXOTRASEI"
    },
    {
        "code": "23K-501-091",
        "name": "CORPOEIXO"
    },
    {
        "code": "2S4-881-041-  -CIL",
        "name": "ENCOSTO"
    },
    {
        "code": "23K-501-091-A",
        "name": "CORPOEIXO"
    },
    {
        "code": "23K-501-091-B",
        "name": "CORPOEIXO"
    },
    {
        "code": "23K-501-091-C",
        "name": "CORPOEIXO"
    },
    {
        "code": "23K-501-091-D",
        "name": "CORPOEIXO"
    },
    {
        "code": "23K-501-091-E",
        "name": "CORPOEIXO"
    },
    {
        "code": "23K-501-109",
        "name": "HASTE"
    },
    {
        "code": "23K-501-123",
        "name": "suporte"
    },
    {
        "code": "23K-501-123-A",
        "name": "suporte"
    },
    {
        "code": "23K-501-141",
        "name": "suporte"
    },
    {
        "code": "23K-501-147",
        "name": "TAMPA"
    },
    {
        "code": "2S4-881-041-  -CIO",
        "name": "ENCOSTO"
    },
    {
        "code": "23K-501-203",
        "name": "SEMI EIXO"
    },
    {
        "code": "23K-501-203-A",
        "name": "SEMI EIXO"
    },
    {
        "code": "23K-501-204",
        "name": "SEMI EIXO"
    },
    {
        "code": "23K-501-204-A",
        "name": "SEMI EIXO"
    },
    {
        "code": "23K-501-205",
        "name": "SEMI EIXO"
    },
    {
        "code": "23K-501-206",
        "name": "SEMI EIXO"
    },
    {
        "code": "07W-927-803",
        "name": "SENSOR"
    },
    {
        "code": "23K-525-987",
        "name": "CONECTOR"
    },
    {
        "code": "23K-599-183",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-599-183-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2S4-881-053",
        "name": "ELEMENTO"
    },
    {
        "code": "23K-599-183-B",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-601-029",
        "name": "RODA"
    },
    {
        "code": "23K-601-295",
        "name": "porca"
    },
    {
        "code": "23K-601-295-A",
        "name": "porca"
    },
    {
        "code": "23K-607-079",
        "name": "CONEXAO"
    },
    {
        "code": "23K-607-110",
        "name": "suporte"
    },
    {
        "code": "23K-607-110-B",
        "name": "suporte"
    },
    {
        "code": "23K-607-110-C",
        "name": "suporte"
    },
    {
        "code": "23K-607-110-D",
        "name": "suporte"
    },
    {
        "code": "23K-607-112-D",
        "name": "SUPORTE"
    },
    {
        "code": "2S4-881-053-A",
        "name": "ELEMENTO"
    },
    {
        "code": "23K-607-193",
        "name": "SUPORTE"
    },
    {
        "code": "23K-607-261",
        "name": "VALVULA"
    },
    {
        "code": "23K-607-262",
        "name": "valvula"
    },
    {
        "code": "23K-607-262-A",
        "name": "valvula"
    },
    {
        "code": "WHT-001-013",
        "name": "ARRUELA"
    },
    {
        "code": "1C0-945-511-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "TJG-411-129",
        "name": "ESTRIBO"
    },
    {
        "code": "2S0-011-031-A",
        "name": "MACACO"
    },
    {
        "code": "23H-899-355",
        "name": "CHAPA"
    },
    {
        "code": "23H-899-361-C",
        "name": "SUPORTE"
    },
    {
        "code": "2P0-115-406",
        "name": "CONECTOR"
    },
    {
        "code": "2S4-881-231",
        "name": "MANOPLA"
    },
    {
        "code": "23H-899-361-D",
        "name": "SUPORTE"
    },
    {
        "code": "23H-899-362-C",
        "name": "SUPORTE"
    },
    {
        "code": "23H-899-362-D",
        "name": "SUPORTE"
    },
    {
        "code": "23H-899-365-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-899-365-B",
        "name": "TUBO"
    },
    {
        "code": "23H-899-365-E",
        "name": "TUBO"
    },
    {
        "code": "23H-899-381",
        "name": "CHAPA"
    },
    {
        "code": "23H-899-382",
        "name": "CHAPA"
    },
    {
        "code": "23H-899-505",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "23H-899-515-C",
        "name": "AMORTECEDO"
    },
    {
        "code": "2S4-881-478",
        "name": "CAPA COBER"
    },
    {
        "code": "23H-899-515-D",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-881-041-  -QFF",
        "name": "ENCOSTO"
    },
    {
        "code": "2V3-881-041-A -QFE",
        "name": "ENCOSTO"
    },
    {
        "code": "2V3-881-041-A -QFF",
        "name": "ENCOSTO"
    },
    {
        "code": "2V3-881-041-B -ZDY",
        "name": "ENCOSTO"
    },
    {
        "code": "2V3-881-041-C -ZDY",
        "name": "ENCOSTO"
    },
    {
        "code": "2V3-881-041-D -9PY",
        "name": "ENCOSTO"
    },
    {
        "code": "2V3-881-041-E -9PY",
        "name": "ENCOSTO"
    },
    {
        "code": "2V3-881-053",
        "name": "ELEMENTO"
    },
    {
        "code": "2V3-881-053-A",
        "name": "ELEMENTO"
    },
    {
        "code": "2S4-881-478-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V3-121-050-M",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-051",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-121-064-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-064-C",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-064-D",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-064-E",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-064-F",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-064-G",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-064-J",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-064-K",
        "name": "TUBO"
    },
    {
        "code": "2S4-881-479",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-121-066-C",
        "name": "suporte"
    },
    {
        "code": "2V3-121-070",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-070-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-070-C",
        "name": "Tubo de ag"
    },
    {
        "code": "2V3-121-076-D",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-094",
        "name": "suporte"
    },
    {
        "code": "2V3-121-101",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-121-101-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-121-102",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-121-103-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2S4-881-547",
        "name": "MOLDURA"
    },
    {
        "code": "2V3-121-103-D",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-121-115",
        "name": "CARCACA"
    },
    {
        "code": "2V3-121-133-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-133-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-133-C",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-158-A",
        "name": "Bucha redu"
    },
    {
        "code": "2V3-121-207",
        "name": "DEFLET AR"
    },
    {
        "code": "2V3-121-215",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2V3-121-253",
        "name": "RADIADOR"
    },
    {
        "code": "2V3-121-255",
        "name": "BRACADEIRA"
    },
    {
        "code": "2SH-599-177",
        "name": "ARRUELA"
    },
    {
        "code": "23R-407-403",
        "name": "MANG EIXO"
    },
    {
        "code": "23R-407-404",
        "name": "MANG EIXO"
    },
    {
        "code": "2V5-821-681-A",
        "name": "DEGRAU"
    },
    {
        "code": "2V5-821-685-A",
        "name": "estribo"
    },
    {
        "code": "2V5-821-688",
        "name": "estribo"
    },
    {
        "code": "2V5-821-809",
        "name": "PARA BARRO"
    },
    {
        "code": "2V5-821-810",
        "name": "PARA BARRO"
    },
    {
        "code": "2V5-823-187",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-823-188",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-823-301-A",
        "name": "PINO"
    },
    {
        "code": "2T0-000-377",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V5-823-359-B",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V5-823-359-C",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V5-823-513",
        "name": "MAT.ADESIV"
    },
    {
        "code": "2V5-823-513-A",
        "name": "MAT.ADESIV"
    },
    {
        "code": "23B-941-531-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-531-A -TKK",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-531-E -TKK",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-531-M -TKK",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-531-N -TKK",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-531-S -TKK",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T0-000-377-A",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-823-543",
        "name": "CABO"
    },
    {
        "code": "2V3-823-559",
        "name": "FECHADURA"
    },
    {
        "code": "2V3-823-573-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-823-574-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-823-593",
        "name": "MANOPLA"
    },
    {
        "code": "2V3-823-655-A",
        "name": "FECHADURA"
    },
    {
        "code": "2V3-823-656-A",
        "name": "FECHADURA"
    },
    {
        "code": "2V3-823-663",
        "name": "CANTONEIRA"
    },
    {
        "code": "2V3-831-051",
        "name": "PORTA"
    },
    {
        "code": "2V3-831-052",
        "name": "PORTA"
    },
    {
        "code": "2T0-000-481",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-831-449",
        "name": "APOIO"
    },
    {
        "code": "2V3-831-449-A",
        "name": "TAMPAO"
    },
    {
        "code": "2V3-831-449-B",
        "name": "TAMPAO"
    },
    {
        "code": "2V3-831-721",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-831-721-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-837-199",
        "name": "GRAMPO"
    },
    {
        "code": "2V3-837-219-C",
        "name": "BRUTA"
    },
    {
        "code": "2V3-837-219-E",
        "name": "BRUTA"
    },
    {
        "code": "2V3-837-219-F",
        "name": "BRUTA"
    },
    {
        "code": "2V3-837-219-H",
        "name": "BRUTA"
    },
    {
        "code": "2T0-000-481-C",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-837-713",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-837-713-B",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-837-911",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-837-911-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-839-267-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-839-268-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-841-063",
        "name": "BUCHA"
    },
    {
        "code": "2V3-845-041",
        "name": "VIDRO LAT."
    },
    {
        "code": "2V3-845-041-  -NVB",
        "name": "VIDRO LAT."
    },
    {
        "code": "WHT-008-783",
        "name": "BOCAL"
    },
    {
        "code": "2P0-121-483",
        "name": "TAMPA"
    },
    {
        "code": "2T0-000-719-B",
        "name": "ETIQUETA"
    },
    {
        "code": "23B-131-736",
        "name": "BRACADEIR"
    },
    {
        "code": "23B-131-759",
        "name": "FILTRO"
    },
    {
        "code": "2V3-971-593",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-971-641",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-641-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-641-C",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-641-D",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-641-E",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-759-A",
        "name": "SENSOR"
    },
    {
        "code": "2V3-971-777",
        "name": "CHICOTE"
    },
    {
        "code": "2T0-012-219",
        "name": "CHAVE"
    },
    {
        "code": "2V3-971-778",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-819",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-911",
        "name": "GALAO"
    },
    {
        "code": "2V3-971-911-A",
        "name": "GALAO"
    },
    {
        "code": "2V3-971-911-B",
        "name": "GALAO"
    },
    {
        "code": "2V3-971-921-A",
        "name": "CHIC MOTOR"
    },
    {
        "code": "2V3-971-921-AB",
        "name": "CAPA PROTE"
    },
    {
        "code": "2V3-971-921-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-921-E",
        "name": "CHIC MOTOR"
    },
    {
        "code": "2V3-971-963-K",
        "name": "RECEPTACUL"
    },
    {
        "code": "2T0-012-219-A",
        "name": "CHAVE"
    },
    {
        "code": "2V3-972-082",
        "name": "FRISO"
    },
    {
        "code": "2V3-972-253",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-972-337-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-998-021",
        "name": "Repair set"
    },
    {
        "code": "2V3-998-098",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V3-998-100",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-998-120",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-998-120-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-998-120-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-998-120-C",
        "name": "JG.PECAS"
    },
    {
        "code": "2T0-103-548",
        "name": "CALCO"
    },
    {
        "code": "2V4-141-131",
        "name": "ARRUELA"
    },
    {
        "code": "WHT-009-364",
        "name": "ANEL VEDAC"
    },
    {
        "code": "WHT-009-381",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-857-555",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-857-556",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-857-557",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-588-B",
        "name": "ESPELHO"
    },
    {
        "code": "2V5-857-607-A",
        "name": "PUXADOR"
    },
    {
        "code": "2V5-857-607-C",
        "name": "PUXADOR"
    },
    {
        "code": "2V5-857-611",
        "name": "APOIO"
    },
    {
        "code": "2T0-103-548-A",
        "name": "CALCO"
    },
    {
        "code": "2V5-857-611-A",
        "name": "APOIO"
    },
    {
        "code": "2V5-857-627-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-629-A",
        "name": "GANCHOPROT"
    },
    {
        "code": "2V5-857-684",
        "name": "FECHO"
    },
    {
        "code": "2V5-857-704-A",
        "name": "CINTO 3 PT"
    },
    {
        "code": "2V5-857-715",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-857-719",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-725",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-857-768-B",
        "name": "HASTE"
    },
    {
        "code": "2V5-857-768-C",
        "name": "HASTE"
    },
    {
        "code": "2T0-103-609",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-861-607",
        "name": "TRILHO"
    },
    {
        "code": "2V5-861-608",
        "name": "TRILHO"
    },
    {
        "code": "2V5-861-609",
        "name": "BATENTE"
    },
    {
        "code": "2V5-861-669",
        "name": "APOIO"
    },
    {
        "code": "2V5-861-690-B",
        "name": "REDE"
    },
    {
        "code": "2V5-861-690-C",
        "name": "REDE"
    },
    {
        "code": "2V5-861-895",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-861-955",
        "name": "TOLDO"
    },
    {
        "code": "2V5-861-955-A",
        "name": "TOLDO"
    },
    {
        "code": "2V5-861-955-B",
        "name": "TOLDO"
    },
    {
        "code": "2T0-115-315",
        "name": "ANEL"
    },
    {
        "code": "2V5-862-113",
        "name": "BUCHA"
    },
    {
        "code": "2V5-862-533",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-862-628",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-862-656",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-862-701",
        "name": "GUIA"
    },
    {
        "code": "2V5-862-701-A",
        "name": "GUIA"
    },
    {
        "code": "2V5-862-701-C",
        "name": "COBERTURA"
    },
    {
        "code": "2R0-857-441-B",
        "name": "DISCO"
    },
    {
        "code": "2VF-607-525-A",
        "name": "CONEXAO"
    },
    {
        "code": "2S0-598-287-E",
        "name": "ROLAMENTO"
    },
    {
        "code": "2T0-115-441",
        "name": "JUNTA CABE"
    },
    {
        "code": "2S0-598-287-F",
        "name": "ROLAMENTO"
    },
    {
        "code": "2Z0-609-289",
        "name": "DISCO"
    },
    {
        "code": "2Z0-609-465",
        "name": "MOLA"
    },
    {
        "code": "2Z0-609-485",
        "name": "MOLA"
    },
    {
        "code": "1C0-945-511-A -RDW",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T0-413-031-B",
        "name": "AMORTECEDO"
    },
    {
        "code": "2T0-413-055",
        "name": "BUCHA"
    },
    {
        "code": "2T0-413-423",
        "name": "ARRUELA"
    },
    {
        "code": "N  -106-915-01",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-129-321",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T0-115-441-A",
        "name": "JUNTA CABE"
    },
    {
        "code": "2V5-121-163-B",
        "name": "REDUTOR"
    },
    {
        "code": "2V5-121-207-B",
        "name": "CUBO"
    },
    {
        "code": "2V5-121-215",
        "name": "CABECAESFE"
    },
    {
        "code": "2V5-121-301-A",
        "name": "VENTILADOR"
    },
    {
        "code": "2V5-121-301-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-121-313",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-121-313-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-121-313-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-121-313-D",
        "name": "suporte"
    },
    {
        "code": "2V5-121-327-B",
        "name": "VEDACAO"
    },
    {
        "code": "2T0-115-499-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-121-327-C",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-121-651",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-121-651-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-127-177-A",
        "name": "ELEM FILTR"
    },
    {
        "code": "2V5-127-223-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-127-505",
        "name": "TUBO"
    },
    {
        "code": "2V5-127-505-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-127-505-B",
        "name": "TUBO"
    },
    {
        "code": "2V5-129-044-A",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-129-049",
        "name": "PEC VEDAC"
    },
    {
        "code": "2P0-130-421",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T0-115-561",
        "name": "ELEM FILTR"
    },
    {
        "code": "2V5-129-051",
        "name": "INDICADOR"
    },
    {
        "code": "2V5-129-180",
        "name": "COXIM"
    },
    {
        "code": "N  -105-421-03",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-919-823",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T2-920-806-F",
        "name": "INSTRUMENT"
    },
    {
        "code": "2T2-927-103",
        "name": "UNIDADE"
    },
    {
        "code": "2T2-927-103-C",
        "name": "UNIDADE"
    },
    {
        "code": "2T2-927-109",
        "name": "UNIDADE"
    },
    {
        "code": "2T2-927-109-B",
        "name": "UNIDADE"
    },
    {
        "code": "2T2-927-138",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T0-127-250-B",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-927-138-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T2-927-192",
        "name": "INTERRUPTO"
    },
    {
        "code": "2U2-321-143-A",
        "name": "ROLETE"
    },
    {
        "code": "2U2-321-143-B",
        "name": "PINO"
    },
    {
        "code": "2U2-321-143-D",
        "name": "ROLETE"
    },
    {
        "code": "2U2-321-143-E",
        "name": "ROLETE"
    },
    {
        "code": "2U2-321-447-B",
        "name": "PECABLOQUE"
    },
    {
        "code": "2U2-323-121",
        "name": "PISTAO"
    },
    {
        "code": "2U2-323-121-A",
        "name": "PISTAO"
    },
    {
        "code": "2U2-323-123",
        "name": "PISTPRESSA"
    },
    {
        "code": "2T0-130-154",
        "name": "PRISIONEIR"
    },
    {
        "code": "2U2-323-157",
        "name": "ANEL"
    },
    {
        "code": "2U2-323-301",
        "name": "JG.ENGRENA"
    },
    {
        "code": "2U2-323-315",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-323-316-A",
        "name": "LAMINA"
    },
    {
        "code": "2U2-323-319",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-323-319-A",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-323-319-B",
        "name": "ANEL"
    },
    {
        "code": "2U2-323-341-A",
        "name": "CORPOSINCR"
    },
    {
        "code": "23G-807-412",
        "name": "TAMPA"
    },
    {
        "code": "23G-807-412-  -999",
        "name": "TAMPA"
    },
    {
        "code": "2T0-130-228-A",
        "name": "ANEL"
    },
    {
        "code": "23G-853-635-  -999",
        "name": "GRADE"
    },
    {
        "code": "23G-853-651",
        "name": "GRADE"
    },
    {
        "code": "23G-853-651-D",
        "name": "GRADE"
    },
    {
        "code": "23G-853-651-E",
        "name": "GRADE"
    },
    {
        "code": "23G-853-653-  -999",
        "name": "SUPORTE"
    },
    {
        "code": "23G-853-679-  -9SR",
        "name": "LOGOTIPO"
    },
    {
        "code": "23G-857-005-  -82V",
        "name": "PAINEL"
    },
    {
        "code": "T16-945-525",
        "name": "INTERRUPTO"
    },
    {
        "code": "T21-411-045",
        "name": "BUCHA"
    },
    {
        "code": "2V3-311-499-F",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2T0-145-540-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-311-499-G",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-H",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-J",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-K",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-L",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-M",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-N",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-P",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-Q",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-R",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2T0-145-723",
        "name": "JUNTA"
    },
    {
        "code": "2V3-311-499-S",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-T",
        "name": "ANEL VEDAC"
    },
    {
        "code": "23H-501-213-C",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-501-213-E",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-501-213-F",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-511-197-B",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-511-197-C",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-513-031-C",
        "name": "AMORTECEDO"
    },
    {
        "code": "TAG-201-343",
        "name": "CINTATENSO"
    },
    {
        "code": "TAG-411-171",
        "name": "LUVA"
    },
    {
        "code": "2T0-145-735",
        "name": "TUBO"
    },
    {
        "code": "TAG-411-235",
        "name": "porca"
    },
    {
        "code": "2V3-311-919-F",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-919-G",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-919-H",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-919-J",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-927",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-311-927-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-311-978",
        "name": "ANEL"
    },
    {
        "code": "2V3-315-119",
        "name": "RODA"
    },
    {
        "code": "2V3-315-123",
        "name": "EIXO"
    },
    {
        "code": "2T0-145-757",
        "name": "JUNTA"
    },
    {
        "code": "2V3-315-123-A",
        "name": "EIXO"
    },
    {
        "code": "2V3-315-141",
        "name": "TAMPA"
    },
    {
        "code": "TAP-599-203",
        "name": "PARAFUSO"
    },
    {
        "code": "TAP-599-205",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-103-448-N",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-103-448-R",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-103-541",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-103-541-A",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-103-704",
        "name": "TAMPA"
    },
    {
        "code": "2V5-105-139",
        "name": "VOLANTE"
    },
    {
        "code": "2T0-201-551",
        "name": "TAMPA"
    },
    {
        "code": "2V5-105-215",
        "name": "CUBO"
    },
    {
        "code": "2V5-105-253",
        "name": "POLIA"
    },
    {
        "code": "2V5-105-313",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-959-433",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-959-442-A",
        "name": "CONJUNTO"
    },
    {
        "code": "2V3-959-565",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-959-593",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-959-802",
        "name": "motor"
    },
    {
        "code": "2V3-959-802-A",
        "name": "motor"
    },
    {
        "code": "2V3-959-856",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T0-253-101-M",
        "name": "TUBO"
    },
    {
        "code": "2V3-959-856-  -9K0",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-962-125",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-971-003-A",
        "name": "suporte"
    },
    {
        "code": "2V3-971-004-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-971-015",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-048-A",
        "name": "CONDUTOR"
    },
    {
        "code": "2V3-971-051",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AC",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AD",
        "name": "CHICOTE"
    },
    {
        "code": "2P0-131-157-B",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-253-143",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V3-971-051-AE",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AF",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AG",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AH",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AJ",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AK",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AN",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AP",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AQ",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AR",
        "name": "CHICOTE"
    },
    {
        "code": "2T0-301-185",
        "name": "RESPIRO"
    },
    {
        "code": "2V3-971-051-AS",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-AT",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-BA",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-BB",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-BL",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-BM",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-BN",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-BP",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-C",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-D",
        "name": "CHICOTE"
    },
    {
        "code": "2T0-301-218",
        "name": "MOLA"
    },
    {
        "code": "2V3-971-051-E",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-F",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-G",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-H",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-J",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-K",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-L",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-M",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-N",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-P",
        "name": "CHICOTE"
    },
    {
        "code": "2T0-301-275-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-971-051-Q",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-051-R",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-061",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-061-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-088",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-113",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-113-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-113-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-113-C",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-118",
        "name": "CHICOTE"
    },
    {
        "code": "2T0-301-366",
        "name": "PINO"
    },
    {
        "code": "2V3-971-118-C",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-118-D",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-118-E",
        "name": "CHICOTE"
    },
    {
        "code": "TE3-599-183-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-411-019",
        "name": "MOLA"
    },
    {
        "code": "2V5-411-019-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V5-411-019-B",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V5-411-023-B",
        "name": "BARRA"
    },
    {
        "code": "2V5-411-049-D",
        "name": "APOIO"
    },
    {
        "code": "2V5-411-101-G",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2T0-301-431-A",
        "name": "PINO"
    },
    {
        "code": "2V5-411-129",
        "name": "ESTRIBO"
    },
    {
        "code": "2V5-411-151-B",
        "name": "BATENTE"
    },
    {
        "code": "2V5-411-152-B",
        "name": "BATENTE"
    },
    {
        "code": "2V5-411-177-D",
        "name": "CHAPA"
    },
    {
        "code": "2V5-411-185-A",
        "name": "placa"
    },
    {
        "code": "2V5-411-235-A",
        "name": "SUPORTE"
    },
    {
        "code": "WHT-005-045",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-046",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-047",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-413-354-D",
        "name": "suporte"
    },
    {
        "code": "2T0-301-483",
        "name": "MOLA"
    },
    {
        "code": "2V5-413-354-F",
        "name": "APOIO"
    },
    {
        "code": "2V5-419-207",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-419-352",
        "name": "COLUNA DIR"
    },
    {
        "code": "2V5-419-352-A",
        "name": "ALAVANCA"
    },
    {
        "code": "2V5-419-523",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-419-625",
        "name": "MOLA"
    },
    {
        "code": "2V5-419-635",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-419-635-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-419-635-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-419-635-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-301-483-A",
        "name": "MOLA"
    },
    {
        "code": "2V5-419-655-B",
        "name": "CONJUNTO"
    },
    {
        "code": "2V5-419-671-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-422-067-B",
        "name": "COLUNA DIR"
    },
    {
        "code": "2V5-422-069",
        "name": "CAIXA"
    },
    {
        "code": "23H-411-129",
        "name": "GRAMPO"
    },
    {
        "code": "23H-411-129-A",
        "name": "GRAMPO"
    },
    {
        "code": "23H-411-207",
        "name": "PLACASUPOR"
    },
    {
        "code": "23H-411-235",
        "name": "SUPORTE"
    },
    {
        "code": "23H-411-235-C",
        "name": "porca"
    },
    {
        "code": "23H-411-235-D",
        "name": "porca"
    },
    {
        "code": "2T0-301-685",
        "name": "TUBO"
    },
    {
        "code": "23H-411-367",
        "name": "suporte"
    },
    {
        "code": "23H-411-705-A",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-411-719",
        "name": "BUCHA"
    },
    {
        "code": "23H-413-031-J",
        "name": "AMORTECEDO"
    },
    {
        "code": "23H-413-031-P",
        "name": "AMORTECEDO"
    },
    {
        "code": "23H-413-031-Q",
        "name": "AMORTECEDO"
    },
    {
        "code": "23H-413-353",
        "name": "SUPORTE"
    },
    {
        "code": "23H-413-354",
        "name": "SUPORTE"
    },
    {
        "code": "23H-419-049",
        "name": "ESPACADOR"
    },
    {
        "code": "23H-419-421",
        "name": "CASQUILHO"
    },
    {
        "code": "2T0-301-729-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2RP-501-222",
        "name": "CAPA VEDAC"
    },
    {
        "code": "2RP-607-039",
        "name": "MOLA"
    },
    {
        "code": "WHT-005-093",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-094",
        "name": "porca"
    },
    {
        "code": "23H-949-101",
        "name": "LUZ"
    },
    {
        "code": "23H-949-102",
        "name": "LUZ"
    },
    {
        "code": "23H-971-003-C",
        "name": "SUPORTE"
    },
    {
        "code": "23H-973-374-A",
        "name": "CAPA PROTE"
    },
    {
        "code": "23K-000-013-  -I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-000-013-A -I9A",
        "name": "Cabina"
    },
    {
        "code": "2P0-201-100-E",
        "name": "NIPLE"
    },
    {
        "code": "2T0-301-845-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "23K-000-271",
        "name": "ETIQUETAID"
    },
    {
        "code": "23K-000-271-A",
        "name": "ETIQUETAID"
    },
    {
        "code": "23K-000-271-B",
        "name": "ETIQUETAID"
    },
    {
        "code": "23K-000-271-C",
        "name": "ETIQUETAID"
    },
    {
        "code": "23K-000-271-D",
        "name": "ETIQUETAID"
    },
    {
        "code": "23K-000-271-E",
        "name": "ETIQUETAID"
    },
    {
        "code": "23K-000-271-M",
        "name": "ETIQUETAID"
    },
    {
        "code": "23K-010-007",
        "name": "ETIQUETA"
    },
    {
        "code": "23K-010-007-A",
        "name": "ETIQUETA"
    },
    {
        "code": "23K-010-039",
        "name": "ETIQUETA"
    },
    {
        "code": "2T0-311-113",
        "name": "RETENTOR"
    },
    {
        "code": "23K-010-039-A",
        "name": "ETIQUETA"
    },
    {
        "code": "23K-010-039-M",
        "name": "ETIQUETA"
    },
    {
        "code": "23K-011-031",
        "name": "MACACO"
    },
    {
        "code": "23K-011-107",
        "name": "SUPORTE"
    },
    {
        "code": "23K-012-115",
        "name": "BOLSA"
    },
    {
        "code": "23K-012-766",
        "name": "LITERATURA"
    },
    {
        "code": "23K-012-766-N",
        "name": "MANUAL DE"
    },
    {
        "code": "23K-019-873",
        "name": "Paraf torx"
    },
    {
        "code": "23K-035-502",
        "name": "BASE ANTEN"
    },
    {
        "code": "23K-035-505",
        "name": "ANTENA"
    },
    {
        "code": "2T0-311-122",
        "name": "ANEL"
    },
    {
        "code": "23K-035-505-A",
        "name": "ANTENA"
    },
    {
        "code": "23K-103-196",
        "name": "ANEL"
    },
    {
        "code": "23K-103-448",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-103-448-A",
        "name": "ARRUELA"
    },
    {
        "code": "23K-103-448-B",
        "name": "PORCA"
    },
    {
        "code": "23K-109-337",
        "name": "BALANCIM"
    },
    {
        "code": "23K-121-003-B",
        "name": "VENTILADOR"
    },
    {
        "code": "23K-121-094",
        "name": "suporte"
    },
    {
        "code": "23K-121-101",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-101-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T0-311-242-B",
        "name": "LUVA ENGAT"
    },
    {
        "code": "23K-121-102",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-102-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-102-H",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-103",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-103-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-103-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-103-D",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-103-E",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-136",
        "name": "BRACADEIR"
    },
    {
        "code": "23K-121-136-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2T0-311-269",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-217",
        "name": "porca"
    },
    {
        "code": "23K-915-516-C",
        "name": "suporte"
    },
    {
        "code": "23K-919-131",
        "name": "ANEL"
    },
    {
        "code": "23K-919-183",
        "name": "SENSOR"
    },
    {
        "code": "23K-920-807",
        "name": "INSTRUMENT"
    },
    {
        "code": "23K-920-807-B",
        "name": "INSTRUMENT"
    },
    {
        "code": "23K-920-807-C",
        "name": "INSTRUMENT"
    },
    {
        "code": "23K-920-807-D",
        "name": "INSTRUMENT"
    },
    {
        "code": "23K-925-200",
        "name": "sensor"
    },
    {
        "code": "23K-927-103",
        "name": "UNIDADE"
    },
    {
        "code": "2T0-311-287",
        "name": "ANEL"
    },
    {
        "code": "23K-927-103-B",
        "name": "UNIDADE"
    },
    {
        "code": "23K-927-123-  -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-927-123-A -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-927-521-  -9B9",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-927-521-C -9B9",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-927-745",
        "name": "SENSOR"
    },
    {
        "code": "23K-927-748",
        "name": "SENSOR"
    },
    {
        "code": "23K-927-753-A",
        "name": "SENSOR"
    },
    {
        "code": "23K-927-754-A",
        "name": "SENSOR"
    },
    {
        "code": "23K-937-149",
        "name": "suporte"
    },
    {
        "code": "2T0-311-287-A",
        "name": "ANEL"
    },
    {
        "code": "23K-937-149-A",
        "name": "suporte"
    },
    {
        "code": "23K-941-033",
        "name": "FAROL"
    },
    {
        "code": "23K-941-034",
        "name": "FAROL"
    },
    {
        "code": "23K-941-531",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-941-531-  -TKK",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-945-341-  -1NN",
        "name": "LUZ PISCA"
    },
    {
        "code": "23K-945-341-A -1NN",
        "name": "LUZ PISCA"
    },
    {
        "code": "23K-947-315-A -9B9",
        "name": "interrupt."
    },
    {
        "code": "N  -011-666-18",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-857-161",
        "name": "GRAMPO"
    },
    {
        "code": "2T0-311-287-AC",
        "name": "ANEL"
    },
    {
        "code": "2V5-857-161-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-173",
        "name": "BORRACHA"
    },
    {
        "code": "2V5-857-174",
        "name": "BORRACHA"
    },
    {
        "code": "2V5-857-192",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-192-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-192-AC",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-857-192-AD",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-857-192-AF",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-857-192-AG",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-857-192-AH",
        "name": "MOLDURA"
    },
    {
        "code": "2T0-311-287-AD",
        "name": "ANEL"
    },
    {
        "code": "2V5-857-192-AJ",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-857-192-D",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-192-E",
        "name": "CAPA"
    },
    {
        "code": "2V5-857-192-F",
        "name": "CAPA"
    },
    {
        "code": "2V5-857-192-G",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-192-K",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-857-192-M",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-192-P",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-857-192-R",
        "name": "PORTAOBJ"
    },
    {
        "code": "2V5-857-213",
        "name": "DOBRADICA"
    },
    {
        "code": "2T0-311-287-B",
        "name": "ANEL"
    },
    {
        "code": "2V5-857-213-A",
        "name": "DOBRADICA"
    },
    {
        "code": "2V5-857-215",
        "name": "CLIP"
    },
    {
        "code": "2V5-857-215-A",
        "name": "CLIP"
    },
    {
        "code": "2V5-857-231",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-249",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-857-249-D",
        "name": "PORCA"
    },
    {
        "code": "2V5-857-279",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-945-096-A",
        "name": "CARCACA"
    },
    {
        "code": "2V5-945-096-C",
        "name": "LANTERNA"
    },
    {
        "code": "2V5-945-096-D",
        "name": "LANTERNA"
    },
    {
        "code": "2P0-201-100-G",
        "name": "NIPLE"
    },
    {
        "code": "2T0-311-287-C",
        "name": "ANEL"
    },
    {
        "code": "2V5-945-111",
        "name": "LENTE"
    },
    {
        "code": "2V5-945-112",
        "name": "LENTE"
    },
    {
        "code": "2V5-945-113",
        "name": "suporte"
    },
    {
        "code": "2V5-945-114",
        "name": "suporte"
    },
    {
        "code": "2V5-945-187-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-945-223",
        "name": "lente"
    },
    {
        "code": "2V5-945-341-A",
        "name": "LUZ"
    },
    {
        "code": "2V5-947-105",
        "name": "LUZ INTERN"
    },
    {
        "code": "2V5-947-105-A",
        "name": "LUZ INTERN"
    },
    {
        "code": "2V5-947-105-B",
        "name": "LUZ INTERN"
    },
    {
        "code": "2T0-311-287-D",
        "name": "ANEL"
    },
    {
        "code": "2V5-947-111",
        "name": "LUZ INTERN"
    },
    {
        "code": "2V5-947-111-A",
        "name": "LUZ INTERN"
    },
    {
        "code": "2V5-947-111-D",
        "name": "LUZ INTERN"
    },
    {
        "code": "2V5-947-117-A",
        "name": "CLIP"
    },
    {
        "code": "N  -900-963-01",
        "name": "PINO"
    },
    {
        "code": "2R0-857-538",
        "name": "CAPA"
    },
    {
        "code": "23H-121-102-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-121-207-A",
        "name": "DEFLET AR"
    },
    {
        "code": "23H-121-251-A",
        "name": "RADIADOR"
    },
    {
        "code": "23H-121-455-B",
        "name": "TUBO"
    },
    {
        "code": "2T0-311-287-E",
        "name": "ANEL"
    },
    {
        "code": "23H-121-477-A",
        "name": "BRACADEIR"
    },
    {
        "code": "23H-127-177",
        "name": "ELEM FILTR"
    },
    {
        "code": "N  -913-197-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-937-035",
        "name": "CAIXA"
    },
    {
        "code": "2S2-937-523",
        "name": "CONECTOR"
    },
    {
        "code": "2S2-941-334-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-941-334-C",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-941-334-D",
        "name": "INTERRUPTO"
    },
    {
        "code": "TAC-413-435",
        "name": "LUVA"
    },
    {
        "code": "2R0-115-315-D",
        "name": "ANEL"
    },
    {
        "code": "2T0-311-287-F",
        "name": "ANEL"
    },
    {
        "code": "2R0-115-315-E",
        "name": "ANEL"
    },
    {
        "code": "2R0-115-399",
        "name": "TAMPA"
    },
    {
        "code": "2R0-115-406-C",
        "name": "CONECTOR"
    },
    {
        "code": "2V2-525-267-D",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-E",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-F",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-G",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-H",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-J",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-K",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-311-287-G",
        "name": "ANEL"
    },
    {
        "code": "2V2-525-267-L",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-M",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-N",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-P",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-Q",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-270",
        "name": "PINO"
    },
    {
        "code": "2V2-525-271",
        "name": "ANEL"
    },
    {
        "code": "2V2-525-283-A",
        "name": "CABECOTE"
    },
    {
        "code": "2V2-525-283-B",
        "name": "FLANGE"
    },
    {
        "code": "2V2-525-295",
        "name": "APOIO"
    },
    {
        "code": "2T0-311-287-L",
        "name": "ANEL"
    },
    {
        "code": "2V2-525-343",
        "name": "TAMPA"
    },
    {
        "code": "2V2-525-343-A",
        "name": "TAMPA"
    },
    {
        "code": "2V2-525-345",
        "name": "ANEL"
    },
    {
        "code": "2V1-607-891-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-607-891-E",
        "name": "suporte"
    },
    {
        "code": "2V1-607-891-F",
        "name": "suporte"
    },
    {
        "code": "2V1-607-915",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-609-623-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-609-649",
        "name": "TAMPAO"
    },
    {
        "code": "2V1-614-137",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-311-287-P",
        "name": "ANEL"
    },
    {
        "code": "2V1-614-138",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-614-173",
        "name": "LUVA"
    },
    {
        "code": "2V1-701-021",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-A",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-C",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-D",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-E",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-F",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-G",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-H",
        "name": "CHASSI"
    },
    {
        "code": "2T0-311-287-Q",
        "name": "ANEL"
    },
    {
        "code": "2V1-701-021-J",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-K",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-021-L",
        "name": "CHASSI"
    },
    {
        "code": "2V1-701-095",
        "name": "suporte"
    },
    {
        "code": "2V1-701-095-A",
        "name": "suporte"
    },
    {
        "code": "2V1-701-141-A",
        "name": "LONGARINA"
    },
    {
        "code": "2V1-701-142-A",
        "name": "LONGARINA"
    },
    {
        "code": "2V1-701-151",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V1-701-165",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V1-701-165-A",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2T0-311-295-B",
        "name": "ANEL"
    },
    {
        "code": "2V1-701-166",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V1-701-166-A",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2R0-129-830",
        "name": "INDICADOR"
    },
    {
        "code": "2V3-612-074-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-612-109",
        "name": "ANEL"
    },
    {
        "code": "2V3-612-109-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-612-267",
        "name": "PINO"
    },
    {
        "code": "2V3-614-166",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-614-167",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-614-775",
        "name": "CHP UNIAO"
    },
    {
        "code": "2T0-311-312",
        "name": "MOLA"
    },
    {
        "code": "2V3-615-329",
        "name": "CAMARA DO"
    },
    {
        "code": "2V3-615-331-B",
        "name": "CAMARA DO"
    },
    {
        "code": "2V3-615-331-C",
        "name": "CAMARA DO"
    },
    {
        "code": "2V3-615-331-E",
        "name": "CAMARA DO"
    },
    {
        "code": "2V3-615-332-B",
        "name": "CAMARA DO"
    },
    {
        "code": "2V3-615-332-D",
        "name": "CAMARA DO"
    },
    {
        "code": "2V3-615-332-E",
        "name": "CAMARA DO"
    },
    {
        "code": "2V3-616-041",
        "name": "MOLA"
    },
    {
        "code": "2V3-616-041-A",
        "name": "MOLA"
    },
    {
        "code": "2V3-616-041-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-129-653",
        "name": "MANGUEIRA"
    },
    {
        "code": "2P0-407-989-A",
        "name": "PORCA"
    },
    {
        "code": "2T0-311-457-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-616-041-D",
        "name": "MOLA"
    },
    {
        "code": "2V3-698-075",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-698-075-A",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-698-135",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-907-291-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-907-631",
        "name": "VALVULA"
    },
    {
        "code": "2V3-907-703",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-907-811",
        "name": "SENSOR"
    },
    {
        "code": "2V3-907-811-A",
        "name": "SENSOR"
    },
    {
        "code": "2V3-911-023",
        "name": "MOTOR"
    },
    {
        "code": "2T0-311-527-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-915-089",
        "name": "BATERIA"
    },
    {
        "code": "2V3-915-345-B",
        "name": "Bracket"
    },
    {
        "code": "2V3-915-345-C",
        "name": "Bracket"
    },
    {
        "code": "2V3-915-346",
        "name": "ESTRIBO"
    },
    {
        "code": "2V3-915-411",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-915-516",
        "name": "REGUA"
    },
    {
        "code": "2V3-919-121",
        "name": "PROTECAO"
    },
    {
        "code": "2V3-919-249",
        "name": "CHAPAFUNDO"
    },
    {
        "code": "2V3-919-249-A",
        "name": "CHAPAFUNDO"
    },
    {
        "code": "2V3-919-249-B",
        "name": "CHAPAFUNDO"
    },
    {
        "code": "2T0-311-527-H",
        "name": "SEXTAVADO"
    },
    {
        "code": "2V3-919-249-C",
        "name": "CHAPAFUNDO"
    },
    {
        "code": "2V3-919-307",
        "name": "RECEPTACUL"
    },
    {
        "code": "2T0-109-293",
        "name": "RETENTOR"
    },
    {
        "code": "2T0-109-313",
        "name": "LUVA"
    },
    {
        "code": "2V5-607-389-A",
        "name": "PLACA"
    },
    {
        "code": "2V5-607-390",
        "name": "PLACASUPOR"
    },
    {
        "code": "2V5-607-390-A",
        "name": "PLACA ANCO"
    },
    {
        "code": "2V5-607-441-A",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-607-441-B",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-607-461-B",
        "name": "ANEL"
    },
    {
        "code": "2T0-311-580",
        "name": "PINO"
    },
    {
        "code": "2V5-607-461-C",
        "name": "APOIO"
    },
    {
        "code": "2V5-607-461-E",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-607-463",
        "name": "TUBO"
    },
    {
        "code": "2V5-607-463-A",
        "name": "TUBO"
    },
    {
        "code": "23B-253-137-B",
        "name": "ANEL"
    },
    {
        "code": "2V5-803-878-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-803-878-E",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-803-878-G",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-803-878-J",
        "name": "ARRUELA"
    },
    {
        "code": "N  -909-932-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-311-585-A",
        "name": "LUVA"
    },
    {
        "code": "N  -010-221-8",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-845-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-846-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-863-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-865-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-889-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-899-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2V1-253-319-F",
        "name": "suporte"
    },
    {
        "code": "2V1-298-021",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V1-300-027-K",
        "name": "CX.MUDANCA"
    },
    {
        "code": "2T0-311-978-J",
        "name": "ANEL"
    },
    {
        "code": "2V1-300-027-L",
        "name": "CX.MUDANCA"
    },
    {
        "code": "2V1-300-057-C",
        "name": "TRANSMIS."
    },
    {
        "code": "2V1-300-057-D",
        "name": "TRANSMIS."
    },
    {
        "code": "2V1-300-057-E",
        "name": "TRANSMIS."
    },
    {
        "code": "2V1-300-057-J",
        "name": "TRANSMIS."
    },
    {
        "code": "2V1-419-669",
        "name": "TECLA"
    },
    {
        "code": "2V1-422-515",
        "name": "COBERTURA"
    },
    {
        "code": "2V1-422-849",
        "name": "suporte"
    },
    {
        "code": "2V1-422-897",
        "name": "TUBO"
    },
    {
        "code": "2V1-422-963",
        "name": "TUBO"
    },
    {
        "code": "2T0-313-629",
        "name": "PINO ARRAS"
    },
    {
        "code": "2V1-500-051",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V1-500-051-B",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V1-500-051-C",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V1-500-051-G",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V1-500-051-H",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V1-500-061-K",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V1-500-061-N",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V1-505-245",
        "name": "PROTETOR"
    },
    {
        "code": "2V1-505-469-D",
        "name": "TIRANTE"
    },
    {
        "code": "2V1-505-469-E",
        "name": "TIRANTE"
    },
    {
        "code": "2T0-398-101",
        "name": "JG.PECAS"
    },
    {
        "code": "2V1-505-469-F",
        "name": "TIRANTE"
    },
    {
        "code": "2V1-505-469-G",
        "name": "TIRANTE"
    },
    {
        "code": "2V1-505-469-H",
        "name": "TIRANTE"
    },
    {
        "code": "2V1-505-469-J",
        "name": "TIRANTE"
    },
    {
        "code": "2V1-511-139-A",
        "name": "BASE"
    },
    {
        "code": "2V1-511-139-B",
        "name": "BASE"
    },
    {
        "code": "2V1-511-149",
        "name": "suporte"
    },
    {
        "code": "2V1-511-151",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V1-511-151-A",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V1-511-535-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-399-223-A",
        "name": "TRAVA"
    },
    {
        "code": "2V1-511-536-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-525-021",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V1-525-077",
        "name": "PINHAOCORO"
    },
    {
        "code": "23K-129-971",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-129-971-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-129-971-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-129-971-D",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-129-971-E",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-129-973",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-131-121-B",
        "name": "suporte"
    },
    {
        "code": "2T0-411-101-H",
        "name": "FEIXE MOLA"
    },
    {
        "code": "23K-131-157-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-131-877",
        "name": "RESERVATOR"
    },
    {
        "code": "23K-131-877-B",
        "name": "ESERVATOR"
    },
    {
        "code": "23K-131-983-B",
        "name": "TUBULACAO"
    },
    {
        "code": "23K-131-983-D",
        "name": "TUBULACAO"
    },
    {
        "code": "23K-131-984-D",
        "name": "TUBULACAO"
    },
    {
        "code": "23K-131-984-H",
        "name": "TUBULACAO"
    },
    {
        "code": "23K-131-984-J",
        "name": "TUBULACAO"
    },
    {
        "code": "23K-145-805",
        "name": "RESFRIADOR"
    },
    {
        "code": "23K-201-021",
        "name": "RESERVATOR"
    },
    {
        "code": "2P0-412-117",
        "name": "chaveta"
    },
    {
        "code": "2T0-411-129-A",
        "name": "ESTRIBO"
    },
    {
        "code": "23K-201-021-A",
        "name": "RESERVATOR"
    },
    {
        "code": "23K-201-060",
        "name": "RESERVATOR"
    },
    {
        "code": "23K-201-103",
        "name": "SUPORTE"
    },
    {
        "code": "23K-201-103-A",
        "name": "PLACA"
    },
    {
        "code": "23K-201-104",
        "name": "SUPORTE"
    },
    {
        "code": "23K-201-104-A",
        "name": "PLACA"
    },
    {
        "code": "23K-201-116",
        "name": "VEDACAO"
    },
    {
        "code": "23K-201-173",
        "name": "TUBO"
    },
    {
        "code": "23K-201-173-B",
        "name": "TUBO"
    },
    {
        "code": "23K-201-291",
        "name": "BujÆo"
    },
    {
        "code": "2T0-422-367",
        "name": "REDUTOR"
    },
    {
        "code": "23K-201-341-C",
        "name": "TUBO"
    },
    {
        "code": "23K-201-341-H",
        "name": "TUBO"
    },
    {
        "code": "23K-201-351-C",
        "name": "tubulacao"
    },
    {
        "code": "23K-201-351-F",
        "name": "tubulacao"
    },
    {
        "code": "23K-201-351-H",
        "name": "tubulacao"
    },
    {
        "code": "23K-201-351-J",
        "name": "tubulacao"
    },
    {
        "code": "23K-201-353",
        "name": "TUBO"
    },
    {
        "code": "23K-201-353-B",
        "name": "TUBO"
    },
    {
        "code": "23K-201-353-G",
        "name": "TUBO"
    },
    {
        "code": "23K-201-353-J",
        "name": "TUBO"
    },
    {
        "code": "2T0-498-445",
        "name": "JOGOREPARA"
    },
    {
        "code": "1H0-857-133-  -B41",
        "name": "FECHO"
    },
    {
        "code": "2V5-803-877-ER",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-ES",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-FA",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-FB",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-FC",
        "name": "CAPA PARAF"
    },
    {
        "code": "2V5-803-877-FD",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-FH",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-FJ",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-498-445-A",
        "name": "JOGOREPARA"
    },
    {
        "code": "2V5-803-877-FQ",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-FR",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-FS",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-954-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-607-099",
        "name": "DEFLETOR"
    },
    {
        "code": "2W0-607-099-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2R0-881-545-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-311-641",
        "name": "MOLA"
    },
    {
        "code": "2V3-129-740",
        "name": "COIFA"
    },
    {
        "code": "2V3-129-753",
        "name": "TUBO"
    },
    {
        "code": "2T0-499-041",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-129-760",
        "name": "FREIO MOT"
    },
    {
        "code": "2V3-129-857",
        "name": "TUBO ASPI."
    },
    {
        "code": "2V3-129-857-E",
        "name": "TUBO"
    },
    {
        "code": "2V3-129-857-F",
        "name": "TUBO"
    },
    {
        "code": "2V3-129-857-J",
        "name": "TUBO ASPI."
    },
    {
        "code": "2V3-129-895",
        "name": "FILTRO AR"
    },
    {
        "code": "2V3-129-926",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-129-926-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-129-954",
        "name": "TAMPA"
    },
    {
        "code": "2V3-129-954-A",
        "name": "TAMPA"
    },
    {
        "code": "2T0-501-249",
        "name": "CAPA FECHA"
    },
    {
        "code": "2V3-129-954-B",
        "name": "TAMPA"
    },
    {
        "code": "2V3-130-105",
        "name": "CARCACA"
    },
    {
        "code": "2V3-130-105-A",
        "name": "CARCACA"
    },
    {
        "code": "2V3-130-105-B",
        "name": "CARCACA"
    },
    {
        "code": "2V3-130-139",
        "name": "ANEL"
    },
    {
        "code": "2V3-130-349",
        "name": "TUBO"
    },
    {
        "code": "2V3-130-417",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-130-765",
        "name": "valvula"
    },
    {
        "code": "WHT-005-027",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-028",
        "name": "PORCA"
    },
    {
        "code": "2T0-501-279",
        "name": "ANEL"
    },
    {
        "code": "WHT-005-029",
        "name": "PARAFUSO"
    },
    {
        "code": "191-827-471",
        "name": "FOLHA"
    },
    {
        "code": "23G-857-007-B -82V",
        "name": "PAINEL"
    },
    {
        "code": "23G-857-367-  -Y20",
        "name": "CAPA COBER"
    },
    {
        "code": "23G-857-503-  -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "23G-857-504-  -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "23G-858-227-  -Y20",
        "name": "moldura"
    },
    {
        "code": "23G-858-304-  -82V",
        "name": "MOLDURA"
    },
    {
        "code": "23G-858-304-B -NG9",
        "name": "moldura"
    },
    {
        "code": "5Z0-853-685-F -739",
        "name": "LOGOTIPO"
    },
    {
        "code": "2T0-501-287",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-501-317-S",
        "name": "RETENTOR"
    },
    {
        "code": "2V5-501-317-T",
        "name": "ANEL"
    },
    {
        "code": "2V5-501-319-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-501-395",
        "name": "CHP EXTERN"
    },
    {
        "code": "2V5-501-471",
        "name": "PORCA"
    },
    {
        "code": "2V5-501-475",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-501-615-G",
        "name": "TAMBOR"
    },
    {
        "code": "TMJ-803-909",
        "name": "TIRANTE"
    },
    {
        "code": "TN4-103-113-D",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V3-035-689-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-501-287-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-035-727",
        "name": "INTERFACE"
    },
    {
        "code": "2V3-071-782",
        "name": "BICO INJET"
    },
    {
        "code": "2V3-088-411",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V3-088-570",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V3-100-015-AF",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V3-100-015-AH",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V3-100-015-AM",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V3-100-015-AS",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V3-100-015-C",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V3-100-015-L",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T0-501-395",
        "name": "CHAPA"
    },
    {
        "code": "2V3-100-025",
        "name": "MOTOR BAS."
    },
    {
        "code": "2V3-100-025- X",
        "name": "MOTOR BAS."
    },
    {
        "code": "2V3-100-025-A",
        "name": "MOTOR BAS."
    },
    {
        "code": "2V3-100-025-AX",
        "name": "MOTOR BAS."
    },
    {
        "code": "2V3-100-103",
        "name": "MOTOR"
    },
    {
        "code": "2V3-100-103-A",
        "name": "MOTOR"
    },
    {
        "code": "2V3-100-213",
        "name": "COMPRESSOR"
    },
    {
        "code": "2V3-100-722",
        "name": "VALVULA"
    },
    {
        "code": "2V3-103-011",
        "name": "BLOCO"
    },
    {
        "code": "2V3-103-011-A",
        "name": "BLOCO"
    },
    {
        "code": "2P0-607-313-A",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-501-653",
        "name": "CUBO RODA"
    },
    {
        "code": "2V3-103-157",
        "name": "BICO EJETO"
    },
    {
        "code": "2V3-103-189",
        "name": "TAMPA"
    },
    {
        "code": "23B-607-085-D",
        "name": "CONECTOR"
    },
    {
        "code": "2VH-803-330",
        "name": "CHAPA"
    },
    {
        "code": "2V3-325-057-B",
        "name": "ATUADOR"
    },
    {
        "code": "2V3-325-057-C",
        "name": "ATUADOR"
    },
    {
        "code": "2V3-325-212",
        "name": "APOIO"
    },
    {
        "code": "2V3-325-443",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-325-443-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-325-583",
        "name": "VALVULA"
    },
    {
        "code": "2T0-505-469",
        "name": "TIRANTE"
    },
    {
        "code": "2V3-325-583-A",
        "name": "VALVULA"
    },
    {
        "code": "2V3-325-583-B",
        "name": "VALVULA"
    },
    {
        "code": "2V3-325-583-D",
        "name": "VALVULA"
    },
    {
        "code": "2V3-398-008",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V3-398-747",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V3-398-747-A",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V3-398-747-B",
        "name": "JG.MONTAGE"
    },
    {
        "code": "N  -011-524-23",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-524-25",
        "name": "ARRUELA"
    },
    {
        "code": "23H-601-173",
        "name": "PROTECAO"
    },
    {
        "code": "2T0-505-545",
        "name": "BUCHA"
    },
    {
        "code": "23H-607-127",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-607-127-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-607-251",
        "name": "RESERVATOR"
    },
    {
        "code": "23H-607-312-F",
        "name": "TUBO"
    },
    {
        "code": "23H-607-312-G",
        "name": "TUBO"
    },
    {
        "code": "23H-607-315",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-607-359-C",
        "name": "VALVULA"
    },
    {
        "code": "23H-607-359-D",
        "name": "VALVULA"
    },
    {
        "code": "23H-607-363-A",
        "name": "suporte"
    },
    {
        "code": "23H-607-363-C",
        "name": "suporte"
    },
    {
        "code": "2T0-505-573",
        "name": "SUPORTE"
    },
    {
        "code": "23H-607-403",
        "name": "VALVULA"
    },
    {
        "code": "23H-607-861",
        "name": "TUBO"
    },
    {
        "code": "23H-607-891-C",
        "name": "SUPORTE"
    },
    {
        "code": "23H-607-891-D",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-501-249",
        "name": "CAPA FECHA"
    },
    {
        "code": "2U2-501-471",
        "name": "PORCA"
    },
    {
        "code": "2U2-501-573-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-501-582-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-501-611",
        "name": "CAIXA"
    },
    {
        "code": "2U2-501-953",
        "name": "DISCO"
    },
    {
        "code": "2T0-507-141",
        "name": "CONECTOR"
    },
    {
        "code": "2U2-505-455",
        "name": "PINO"
    },
    {
        "code": "2U2-505-469",
        "name": "TIRANTE"
    },
    {
        "code": "2U2-505-469-A",
        "name": "TIRANTE"
    },
    {
        "code": "2U2-507-139",
        "name": "suporte"
    },
    {
        "code": "2U2-507-145",
        "name": "TAMPAO"
    },
    {
        "code": "2U2-507-627",
        "name": "ANEL"
    },
    {
        "code": "2U2-507-627-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-507-627-B",
        "name": "ANEL"
    },
    {
        "code": "2U2-507-627-C",
        "name": "ANEL"
    },
    {
        "code": "2U2-511-105",
        "name": "CALCO"
    },
    {
        "code": "2T0-511-105-B",
        "name": "CALCO"
    },
    {
        "code": "2U2-511-149",
        "name": "suporte"
    },
    {
        "code": "2U2-511-149-A",
        "name": "suporte"
    },
    {
        "code": "2U2-511-150",
        "name": "suporte"
    },
    {
        "code": "2U2-511-150-A",
        "name": "suporte"
    },
    {
        "code": "2U2-511-151-A",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2U2-511-163",
        "name": "LAMINA"
    },
    {
        "code": "2U2-511-165",
        "name": "LAMINA"
    },
    {
        "code": "2U2-511-167",
        "name": "LAMINA"
    },
    {
        "code": "2U2-511-171",
        "name": "COXIM"
    },
    {
        "code": "2U2-511-235",
        "name": "porca"
    },
    {
        "code": "2T0-511-105-C",
        "name": "CALCO"
    },
    {
        "code": "2U2-511-298",
        "name": "placa"
    },
    {
        "code": "2U2-511-331",
        "name": "PORCA"
    },
    {
        "code": "2U2-525-271",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-271-A",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-271-B",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-271-C",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-271-D",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-271-E",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-271-F",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-271-G",
        "name": "ESPACADOR"
    },
    {
        "code": "2T0-511-149-A",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-525-271-H",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-271-J",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-283",
        "name": "FLANGE"
    },
    {
        "code": "2U2-525-283-B",
        "name": "FLANGE"
    },
    {
        "code": "2U2-525-283-C",
        "name": "FLANGE"
    },
    {
        "code": "2U2-525-305",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-525-305-A",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-525-305-B",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-525-307",
        "name": "CAIXA"
    },
    {
        "code": "2U2-525-329",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-511-149-B",
        "name": "suporte"
    },
    {
        "code": "2U2-525-728",
        "name": "MOLA"
    },
    {
        "code": "2U2-525-771",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-771-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-771-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-771-C",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-771-D",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-771-E",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-777",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-777-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-777-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2T0-511-149-C",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-525-777-C",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-777-D",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-777-E",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-525-781",
        "name": "ROLETE"
    },
    {
        "code": "2U2-525-781-A",
        "name": "ROLETE"
    },
    {
        "code": "2U2-525-781-B",
        "name": "ROLETE"
    },
    {
        "code": "2U2-598-081",
        "name": "JG.DIFEREN"
    },
    {
        "code": "2U2-598-403",
        "name": "JG.PECAS"
    },
    {
        "code": "2U2-598-575",
        "name": "JG.PECAS"
    },
    {
        "code": "2U2-598-611",
        "name": "CUBO RODA"
    },
    {
        "code": "2P0-607-367-C",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-511-167-AA",
        "name": "LAMINA"
    },
    {
        "code": "2U2-598-611-A",
        "name": "CUBO RODA"
    },
    {
        "code": "2U2-599-173",
        "name": "GRAMPO"
    },
    {
        "code": "2U2-599-269",
        "name": "PRISIONEIR"
    },
    {
        "code": "2U2-599-269-A",
        "name": "PRISIONEIR"
    },
    {
        "code": "2U2-601-161-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-616-173",
        "name": "TUCHO"
    },
    {
        "code": "2U2-616-173-A",
        "name": "TUCHO"
    },
    {
        "code": "2U2-616-185-F",
        "name": "CHAPA"
    },
    {
        "code": "2U2-616-189",
        "name": "EIXOSUPORT"
    },
    {
        "code": "2U2-616-197",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-511-167-AB",
        "name": "LAMINA"
    },
    {
        "code": "2U2-616-197-A",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-616-885",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-616-885-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-616-885-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-616-885-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-701-149",
        "name": "CONSOLE"
    },
    {
        "code": "2U2-701-149-A",
        "name": "CONSOLE"
    },
    {
        "code": "2U2-701-150",
        "name": "CONSOLE"
    },
    {
        "code": "2U2-701-150-A",
        "name": "CONSOLE"
    },
    {
        "code": "2U0-129-142",
        "name": "BRACADEIR"
    },
    {
        "code": "2T0-511-167-AC",
        "name": "LAMINA"
    },
    {
        "code": "2U0-130-119",
        "name": "PLACA"
    },
    {
        "code": "1J0-121-321-B",
        "name": "TAMPA"
    },
    {
        "code": "2T2-601-371",
        "name": "TUBO"
    },
    {
        "code": "2R2-971-113-A",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-971-113-C",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-971-113-D",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-971-113-E",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-971-118-C",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-971-118-D",
        "name": "CHICOTE"
    },
    {
        "code": "2S0-129-142",
        "name": "BRACADEIR"
    },
    {
        "code": "2T0-511-167-AD",
        "name": "LAMINA"
    },
    {
        "code": "2S0-129-142-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-411-101",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V3-411-101-A",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V3-411-235",
        "name": "porca"
    },
    {
        "code": "2V3-411-379",
        "name": "CONSOLE"
    },
    {
        "code": "2V3-411-705",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-411-719",
        "name": "BUCHA"
    },
    {
        "code": "2V3-411-719-A",
        "name": "BUCHA"
    },
    {
        "code": "2V3-413-031",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-413-031-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2T0-511-167-B",
        "name": "LAMINA"
    },
    {
        "code": "2V3-413-031-B",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-413-031-C",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-413-031-L",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-413-354",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-413-363",
        "name": "CHAPA"
    },
    {
        "code": "2V3-419-523",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-419-655-A -999",
        "name": "VOLANTE"
    },
    {
        "code": "2V3-419-655-C -999",
        "name": "VOLANTE"
    },
    {
        "code": "2V3-422-067-B",
        "name": "COLUNA DIR"
    },
    {
        "code": "2V3-422-067-C",
        "name": "COLUNA DIR"
    },
    {
        "code": "2T0-511-167-C",
        "name": "LAMINA"
    },
    {
        "code": "2V3-422-069-A",
        "name": "CAIXA"
    },
    {
        "code": "2V3-422-069-B",
        "name": "CAIXA"
    },
    {
        "code": "2V3-422-162",
        "name": "suporte"
    },
    {
        "code": "2V3-422-247-B",
        "name": "Socket"
    },
    {
        "code": "2V3-422-333",
        "name": "QUADRADA"
    },
    {
        "code": "2V3-422-336",
        "name": "BRACO"
    },
    {
        "code": "2V3-422-355",
        "name": "RESERVATOR"
    },
    {
        "code": "377-819-129-C",
        "name": "BOTAO"
    },
    {
        "code": "377-947-561-E",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-858-639-  -999",
        "name": "PUXADOR"
    },
    {
        "code": "2T0-511-167-D",
        "name": "LAMINA"
    },
    {
        "code": "23K-860-939",
        "name": "DEFLETOR"
    },
    {
        "code": "23K-861-031",
        "name": "CAMA"
    },
    {
        "code": "23K-861-091",
        "name": "PAINEL"
    },
    {
        "code": "23K-861-091-A",
        "name": "PAINEL"
    },
    {
        "code": "23K-861-709-A",
        "name": "TELA"
    },
    {
        "code": "23K-861-709-C",
        "name": "TELA"
    },
    {
        "code": "23K-863-247-A",
        "name": "SILENCIADO"
    },
    {
        "code": "23K-863-248-A",
        "name": "SILENCIADO"
    },
    {
        "code": "23K-863-268",
        "name": "suporte"
    },
    {
        "code": "23K-863-345",
        "name": "suporte"
    },
    {
        "code": "2T0-511-167-E",
        "name": "LAMINA"
    },
    {
        "code": "23K-863-367-B -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-367-C -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-  -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-A -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-B -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-C -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-F -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-G -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-H -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-J -NA2",
        "name": "TAPETE"
    },
    {
        "code": "2T0-511-167-F",
        "name": "LAMINA"
    },
    {
        "code": "23K-863-368-K -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-368-L -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-421",
        "name": "SILENCIADO"
    },
    {
        "code": "23K-863-421-A",
        "name": "SILENCIADO"
    },
    {
        "code": "23K-863-421-D",
        "name": "SILENCIADO"
    },
    {
        "code": "23K-863-711-B -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-711-C -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23K-863-809",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-863-809-A",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-863-809-B",
        "name": "ISOLANTE"
    },
    {
        "code": "2T0-511-167-G",
        "name": "LAMINA"
    },
    {
        "code": "23K-863-809-C",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-863-809-D",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-863-809-F",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-863-809-G",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-863-809-H",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-881-038-  -QFE",
        "name": "BANCO"
    },
    {
        "code": "23K-881-038-A -9PY",
        "name": "BANCO"
    },
    {
        "code": "23K-881-041-A -9PY",
        "name": "ENCOSTO"
    },
    {
        "code": "23K-881-041-D -9PY",
        "name": "ENCOSTO"
    },
    {
        "code": "23K-881-053-A",
        "name": "ELEMENTO"
    },
    {
        "code": "2P0-611-778",
        "name": "PRESILHA"
    },
    {
        "code": "2T0-511-167-H",
        "name": "LAMINA"
    },
    {
        "code": "23K-881-251",
        "name": "JG.PECAS"
    },
    {
        "code": "23K-881-493",
        "name": "ANEL"
    },
    {
        "code": "23K-898-015",
        "name": "JG.PECAS"
    },
    {
        "code": "23K-898-016",
        "name": "JG.PECAS"
    },
    {
        "code": "23K-898-025",
        "name": "CONJUNTO"
    },
    {
        "code": "23K-898-047",
        "name": "CLIMATIZAD"
    },
    {
        "code": "23K-898-047-A",
        "name": "CLIMATIZAD"
    },
    {
        "code": "23K-898-099",
        "name": "CONJUNTO"
    },
    {
        "code": "23K-898-100",
        "name": "CONJUNTO"
    },
    {
        "code": "23K-898-165",
        "name": "JOGO DOBRA"
    },
    {
        "code": "2T0-511-167-J",
        "name": "LAMINA"
    },
    {
        "code": "23K-898-211",
        "name": "TRILHO"
    },
    {
        "code": "23K-898-337",
        "name": "JG.MONTAGE"
    },
    {
        "code": "23K-898-509",
        "name": "CONJUNTO"
    },
    {
        "code": "23K-898-511",
        "name": "SUPORTE"
    },
    {
        "code": "23H-145-745",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-145-813-E",
        "name": "SUPORTE"
    },
    {
        "code": "23H-145-813-F",
        "name": "SUPORTE"
    },
    {
        "code": "23H-145-813-H",
        "name": "SUPORTE"
    },
    {
        "code": "23H-145-828",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-145-828-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T0-511-167-K",
        "name": "LAMINA"
    },
    {
        "code": "23H-145-844-A",
        "name": "TUBO"
    },
    {
        "code": "23H-199-255",
        "name": "SUPORTE"
    },
    {
        "code": "23H-199-255-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-201-060-F",
        "name": "RESERVATOR"
    },
    {
        "code": "23H-201-060-G",
        "name": "RESERVATOR"
    },
    {
        "code": "23H-201-060-H",
        "name": "RESERVATOR"
    },
    {
        "code": "23H-201-060-J",
        "name": "RESERVATOR"
    },
    {
        "code": "23H-201-100",
        "name": "CONEXAO"
    },
    {
        "code": "23H-201-100-A",
        "name": "CONEXAO"
    },
    {
        "code": "23H-201-103-A",
        "name": "PLACA"
    },
    {
        "code": "2T0-511-167-L",
        "name": "LAMINA"
    },
    {
        "code": "23H-201-104-A",
        "name": "PLACA"
    },
    {
        "code": "23H-201-136",
        "name": "VALVULA"
    },
    {
        "code": "23H-201-173",
        "name": "TUBO"
    },
    {
        "code": "23H-201-173-A",
        "name": "TUBO"
    },
    {
        "code": "23H-201-173-B",
        "name": "TUBO"
    },
    {
        "code": "23H-201-179",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-201-259",
        "name": "TRAVESSA"
    },
    {
        "code": "23H-201-260-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-201-260-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-201-260-C",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-511-167-M",
        "name": "LAMINA"
    },
    {
        "code": "23H-201-341",
        "name": "TUBO"
    },
    {
        "code": "23H-201-341-B",
        "name": "TUBO"
    },
    {
        "code": "23H-201-341-D",
        "name": "TUBO"
    },
    {
        "code": "23H-201-351-E",
        "name": "TUBO"
    },
    {
        "code": "23H-201-353-H",
        "name": "TUBO"
    },
    {
        "code": "23H-201-353-J",
        "name": "TUBO"
    },
    {
        "code": "23H-201-353-K",
        "name": "TUBO"
    },
    {
        "code": "23H-201-353-L",
        "name": "TUBO"
    },
    {
        "code": "23H-201-353-M",
        "name": "TUBO"
    },
    {
        "code": "23H-201-353-N",
        "name": "TUBO"
    },
    {
        "code": "2T0-511-167-N",
        "name": "LAMINA"
    },
    {
        "code": "23H-201-427",
        "name": "CONTRAPINO"
    },
    {
        "code": "23H-201-433",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-311-528-D",
        "name": "TUBO"
    },
    {
        "code": "2U2-311-532",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-311-532-C",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-311-532-D",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-311-532-E",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-311-533",
        "name": "LUVA"
    },
    {
        "code": "2U2-311-536",
        "name": "HASTE"
    },
    {
        "code": "2U2-311-540",
        "name": "ALAVENGATE"
    },
    {
        "code": "2T0-511-167-P",
        "name": "LAMINA"
    },
    {
        "code": "2U2-311-541-A",
        "name": "EIXO"
    },
    {
        "code": "2U2-311-541-B",
        "name": "EIXO"
    },
    {
        "code": "2U2-311-542",
        "name": "HASTE"
    },
    {
        "code": "2U2-311-542-A",
        "name": "HASTE"
    },
    {
        "code": "2U2-311-543-A",
        "name": "EIXOMUDANC"
    },
    {
        "code": "2U2-311-551-A",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2U2-311-551-B",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V2-599-309",
        "name": "suporte"
    },
    {
        "code": "2V2-601-027-A -XD6",
        "name": "RODA"
    },
    {
        "code": "2V2-601-027-C -XD6",
        "name": "RODA"
    },
    {
        "code": "2T0-511-167-Q",
        "name": "LAMINA"
    },
    {
        "code": "2V2-601-029",
        "name": "RODA"
    },
    {
        "code": "2V2-601-371",
        "name": "VALVULA"
    },
    {
        "code": "2V2-601-371-A",
        "name": "TUBO"
    },
    {
        "code": "N  -108-617-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-618-01",
        "name": "PARAFUSO"
    },
    {
        "code": "23F-607-251-A",
        "name": "RESERVATOR"
    },
    {
        "code": "23F-614-173",
        "name": "LUVA"
    },
    {
        "code": "2V2-957-046-A",
        "name": "BOBINA"
    },
    {
        "code": "2V2-957-549",
        "name": "JG.PECAS"
    },
    {
        "code": "N  -909-144-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-511-167-R",
        "name": "LAMINA"
    },
    {
        "code": "2V3-301-143",
        "name": "MAGNETO"
    },
    {
        "code": "2V3-301-193",
        "name": "ANEL"
    },
    {
        "code": "2V3-301-193-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-301-193-B",
        "name": "ANEL"
    },
    {
        "code": "2V3-301-193-C",
        "name": "ANEL"
    },
    {
        "code": "2V3-301-201",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-201-A",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-201-B",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-201-C",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-201-E",
        "name": "TAMPA"
    },
    {
        "code": "2T0-511-167-S",
        "name": "LAMINA"
    },
    {
        "code": "23L-525-155",
        "name": "PINHAOCORO"
    },
    {
        "code": "23L-525-717",
        "name": "CRUZETA"
    },
    {
        "code": "23L-607-373",
        "name": "SECADOR"
    },
    {
        "code": "23L-614-137",
        "name": "SUPORTE"
    },
    {
        "code": "23L-614-138",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-301-215-B",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-301-215-C",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-301-215-D",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-301-218",
        "name": "MOLA"
    },
    {
        "code": "2V3-301-252",
        "name": "TAMPA"
    },
    {
        "code": "2P0-803-583",
        "name": "TAMPAO"
    },
    {
        "code": "2T0-511-167-T",
        "name": "LAMINA"
    },
    {
        "code": "2V3-301-252-A",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-293",
        "name": "PLACAINTER"
    },
    {
        "code": "2V3-301-293-A",
        "name": "Flange"
    },
    {
        "code": "2V3-301-293-B",
        "name": "PLACAINTER"
    },
    {
        "code": "NF -383-896-AA",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-311-230-BB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BD",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BE",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BF",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-511-172",
        "name": "PORCA"
    },
    {
        "code": "T2D-312-085",
        "name": "RESPIRO"
    },
    {
        "code": "T2D-411-239",
        "name": "porca"
    },
    {
        "code": "2V5-311-381-K",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-L",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-M",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-P",
        "name": "ANEL"
    },
    {
        "code": "TAR-411-273-A",
        "name": "TUBO"
    },
    {
        "code": "2R0-611-777",
        "name": "BRACADEIRA"
    },
    {
        "code": "2R0-611-909-A",
        "name": "COTOVELO"
    },
    {
        "code": "2Z0-607-463-A",
        "name": "TUBO"
    },
    {
        "code": "2T0-511-172-A",
        "name": "PORCA"
    },
    {
        "code": "2Z0-607-465",
        "name": "TUBO"
    },
    {
        "code": "TJG-411-185",
        "name": "ESPACADOR"
    },
    {
        "code": "TJG-413-353",
        "name": "APOIO"
    },
    {
        "code": "TJG-413-354",
        "name": "APOIO"
    },
    {
        "code": "2R2-000-348-AN",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-000-547",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-000-547-A",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-000-547-B",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-000-607-A",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-000-911-A",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T0-511-172-B",
        "name": "PORCA"
    },
    {
        "code": "2R2-000-911-B",
        "name": "ETIQUETAID"
    },
    {
        "code": "JZV-405-645",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-498-628",
        "name": "ROLAMENTO"
    },
    {
        "code": "TKT-803-459",
        "name": "BUCHA"
    },
    {
        "code": "N  -012-108-2",
        "name": "Arruela"
    },
    {
        "code": "2RD-601-371",
        "name": "TUBO"
    },
    {
        "code": "N  -911-235-01",
        "name": "PARAFUSO"
    },
    {
        "code": "JZV-525-275-B",
        "name": "RETENTOR"
    },
    {
        "code": "JZV-525-275-C",
        "name": "RETENTOR"
    },
    {
        "code": "JZV-525-275-D",
        "name": "RETENTOR"
    },
    {
        "code": "2T0-511-173",
        "name": "LUVA"
    },
    {
        "code": "JZV-598-313",
        "name": "ROLAMENTO"
    },
    {
        "code": "2RS-129-745",
        "name": "TUBO ADMIS"
    },
    {
        "code": "2RS-129-746",
        "name": "BRACADEIRA"
    },
    {
        "code": "2RS-130-659",
        "name": "ANEL"
    },
    {
        "code": "2RS-145-297",
        "name": "ANEL"
    },
    {
        "code": "2T0-820-191",
        "name": "SECADOR"
    },
    {
        "code": "2T0-820-197-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T0-820-197-B",
        "name": "BRACADEIRA"
    },
    {
        "code": "WHT-007-668",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-669",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-511-535-B",
        "name": "suporte"
    },
    {
        "code": "WHT-007-670",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-311-288-K",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-L",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-M",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-309-A",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-311-310",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-311-329",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2U2-311-337",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-351",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-311-351-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2T0-511-536",
        "name": "APOIO"
    },
    {
        "code": "2U2-311-365",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-311-365-A",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-311-372",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-372-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-374",
        "name": "APOIO"
    },
    {
        "code": "2P0-145-061-L",
        "name": "TURBOCOMPRESSOR"
    },
    {
        "code": "2R0-145-805-F",
        "name": "INTERCOOLER"
    },
    {
        "code": "G-052-838-Q4",
        "name": "LUBRIFICANTE CAIXA DE TRANSMISSAO"
    },
    {
        "code": "23B-906-012-AE",
        "name": "UNIDADE DE COMANDO"
    },
    {
        "code": "2R0-415-801-B",
        "name": "BARRA DA DIREÇÃO"
    },
    {
        "code": "2T0-512-041",
        "name": "PORCA"
    },
    {
        "code": "2R0-415-801-A",
        "name": "BARRA DA DIREÇÃO"
    },
    {
        "code": "2V3-145-703",
        "name": "Turbocompressor gases escape"
    },
    {
        "code": "07W-115-685-B",
        "name": "Junta"
    },
    {
        "code": "07W-130-154",
        "name": "Cavilha roscada"
    },
    {
        "code": "07W-145-723-D",
        "name": "Junta"
    },
    {
        "code": "2V3-881-031-G9P-Y",
        "name": "Assento completo preto titan"
    },
    {
        "code": "2T0-512-041-A",
        "name": "PARAFUSO"
    },
    {
        "code": "23B-800-401-I9A",
        "name": "CABINA PINTADA COM PORTAS E TEJADILHO"
    },
    {
        "code": "23K-703-795-E",
        "name": "reforco"
    },
    {
        "code": "2V3-321-005",
        "name": "1 cjt. peças de fixação"
    },
    {
        "code": "07W-829-095-B",
        "name": "Cárter"
    },
    {
        "code": "2V3-311-657",
        "name": "Peça de deslize"
    },
    {
        "code": "2RR-525-877-A",
        "name": "Parafuso sextavado"
    },
    {
        "code": "2P0-525-169",
        "name": "Satélite"
    },
    {
        "code": "23B-525-221-A",
        "name": "Rolamento de rolos cilíndricos"
    },
    {
        "code": "T12-525-275",
        "name": "Retentor"
    },
    {
        "code": "T11-525-268-P",
        "name": "Anilha de regulação"
    },
    {
        "code": "2T0-512-041-B",
        "name": "porca"
    },
    {
        "code": "23M-820-005",
        "name": "Caixa de ventilação"
    },
    {
        "code": "2V1-253-101-C",
        "name": "Tb escape"
    },
    {
        "code": "23M-525-143-D",
        "name": "Pinhão ataque e roda de coroa"
    },
    {
        "code": "07W-103-480-C",
        "name": "Anel de blindagem"
    },
    {
        "code": "2V3-301-865-A",
        "name": "Junta de cardan"
    },
    {
        "code": "2V3-145-703-C",
        "name": "Turbocompressor gases escape"
    },
    {
        "code": "23M-820-803-C",
        "name": "Compressor do ar"
    },
    {
        "code": "23M-607-841-M",
        "name": "Compressor elétrico"
    },
    {
        "code": "23M-901-091-J",
        "name": "motor"
    },
    {
        "code": "2V1-253-101-C",
        "name": "Tb escape"
    },
    {
        "code": "2P0-845-353",
        "name": "VEDACAO"
    },
    {
        "code": "2T0-513-471",
        "name": "PARAFUSO"
    },
    {
        "code": "23M-607-841-B",
        "name": "Compressor elétrico"
    },
    {
        "code": "2T0-513-471-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-513-471-E",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-513-471-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-525-121-A",
        "name": "CAIXA"
    },
    {
        "code": "2T0-525-133",
        "name": "PORCA"
    },
    {
        "code": "2T0-525-155",
        "name": "SATELITE"
    },
    {
        "code": "2T0-525-215",
        "name": "PORCA"
    },
    {
        "code": "2T0-525-251-B",
        "name": "CONE"
    },
    {
        "code": "2T0-525-258",
        "name": "PARAFUSO"
    },
    {
        "code": "2P0-903-015-E",
        "name": "ALTERNADOR"
    },
    {
        "code": "2T0-525-258-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-525-258-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-525-258-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-525-271",
        "name": "PECA DISTA"
    },
    {
        "code": "2T0-598-081-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2T0-599-109",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-599-111-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-599-111-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-599-111-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-599-111-H",
        "name": "PARAFUSO"
    },
    {
        "code": "2P0-903-203",
        "name": "PLA COBERT"
    },
    {
        "code": "2T0-599-501",
        "name": "PINO"
    },
    {
        "code": "2T0-599-505",
        "name": "PORCA"
    },
    {
        "code": "2T0-599-505-A",
        "name": "PORCA"
    },
    {
        "code": "2T0-599-505-B",
        "name": "PORCA"
    },
    {
        "code": "2T0-599-505-C",
        "name": "PORCA"
    },
    {
        "code": "2T0-599-505-D",
        "name": "PORCA"
    },
    {
        "code": "2T0-599-547",
        "name": "PORCA"
    },
    {
        "code": "2T0-607-313",
        "name": "COTOVELO"
    },
    {
        "code": "2T0-607-313-D",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-607-313-E",
        "name": "CONEXAO"
    },
    {
        "code": "2P0-903-213-B",
        "name": "INDUZIDO"
    },
    {
        "code": "2T0-607-315",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-607-359-D",
        "name": "valvula"
    },
    {
        "code": "2T0-607-359-H",
        "name": "valvula"
    },
    {
        "code": "2T0-607-359-J",
        "name": "VALVULA"
    },
    {
        "code": "2T0-607-359-K",
        "name": "VALVULA"
    },
    {
        "code": "2T0-607-363-D",
        "name": "suporte"
    },
    {
        "code": "2T0-607-367",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-607-815-A",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T0-608-713",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-609-423",
        "name": "SUP FREIO"
    },
    {
        "code": "2V5-129-653-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2P0-903-213-C",
        "name": "INDUZIDO"
    },
    {
        "code": "2T0-609-623",
        "name": "APOIO"
    },
    {
        "code": "2T0-611-707",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T0-611-717",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T0-611-717-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T0-611-909-B",
        "name": "COTOVELO"
    },
    {
        "code": "2T0-612-129",
        "name": "CABECOTE"
    },
    {
        "code": "2T0-615-331-F",
        "name": "CAMARA DO"
    },
    {
        "code": "2T0-615-332-F",
        "name": "CAMARA DO"
    },
    {
        "code": "2T0-615-332-G",
        "name": "CAMARA DO"
    },
    {
        "code": "2T0-615-332-L",
        "name": "CAMARA DO"
    },
    {
        "code": "2P0-903-339",
        "name": "RETIFICADO"
    },
    {
        "code": "2T0-616-011-A",
        "name": "ELEVADOR"
    },
    {
        "code": "2T0-802-151",
        "name": "TRAVESSA"
    },
    {
        "code": "2T0-803-245",
        "name": "suporte"
    },
    {
        "code": "2T0-803-246",
        "name": "suporte"
    },
    {
        "code": "2T0-803-383",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-803-384",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-803-571-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-803-572-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-804-874",
        "name": "BASE"
    },
    {
        "code": "2T0-804-874-A",
        "name": "BASE"
    },
    {
        "code": "2P0-903-343-E",
        "name": "CAPA COBER"
    },
    {
        "code": "2T0-804-875",
        "name": "QUINTA ROD"
    },
    {
        "code": "2T0-804-875-A",
        "name": "QUINTA ROD"
    },
    {
        "code": "2T0-804-883",
        "name": "PLACA"
    },
    {
        "code": "2T0-804-899",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2T0-804-899-A",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2T0-804-899-B",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2T0-804-899-C",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2T0-804-899-D",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2T0-804-909",
        "name": "PECAINTERM"
    },
    {
        "code": "2T0-804-919",
        "name": "ARRUELA"
    },
    {
        "code": "2P0-903-343-F",
        "name": "PROTECAO"
    },
    {
        "code": "2T0-804-923",
        "name": "HASTE"
    },
    {
        "code": "2T0-804-942",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-804-947",
        "name": "PINO"
    },
    {
        "code": "2T0-804-949",
        "name": "suporte"
    },
    {
        "code": "2T0-819-045-A",
        "name": "REGULAGEM"
    },
    {
        "code": "2T0-819-045-B",
        "name": "REGULAGEM"
    },
    {
        "code": "2T0-823-519",
        "name": "NIPLE"
    },
    {
        "code": "2T0-823-561",
        "name": "NIPLE"
    },
    {
        "code": "2T0-860-114",
        "name": "VALVULA"
    },
    {
        "code": "2T0-877-455",
        "name": "ARRUELA"
    },
    {
        "code": "2P0-903-351",
        "name": "BOBINA"
    },
    {
        "code": "2T0-877-559",
        "name": "COXIM"
    },
    {
        "code": "2T0-877-559-A",
        "name": "COXIM"
    },
    {
        "code": "2T0-903-147",
        "name": "EIXO INTER"
    },
    {
        "code": "2T0-903-803",
        "name": "REGULADOR"
    },
    {
        "code": "2T0-907-171",
        "name": "CONVERSOR"
    },
    {
        "code": "2T0-907-171-B",
        "name": "CONVERSOR"
    },
    {
        "code": "2T0-907-631-F",
        "name": "VALVULA"
    },
    {
        "code": "2T0-911-023-F",
        "name": "MOTOR"
    },
    {
        "code": "2T0-911-023-L",
        "name": "MOTOR"
    },
    {
        "code": "2T0-911-094",
        "name": "PORCA"
    },
    {
        "code": "2P0-906-261-B",
        "name": "SENSOR"
    },
    {
        "code": "2T0-911-211-C",
        "name": "MANCAL"
    },
    {
        "code": "2T0-911-251",
        "name": "RELE"
    },
    {
        "code": "2T0-911-253",
        "name": "RELE"
    },
    {
        "code": "2T0-911-287-E",
        "name": "SOLENOIDE"
    },
    {
        "code": "2T0-911-335-H",
        "name": "PINHAO"
    },
    {
        "code": "2T0-915-519",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T0-919-823",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T0-945-055-A",
        "name": "BUCHA"
    },
    {
        "code": "2T0-945-705",
        "name": "LUVA"
    },
    {
        "code": "2T0-971-255",
        "name": "CHICOTE"
    },
    {
        "code": "2P0-915-089-A",
        "name": "BATERIA"
    },
    {
        "code": "2T0-971-753",
        "name": "CHICOTE"
    },
    {
        "code": "2T0-998-141",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2T2-000-258-AA",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T2-000-258-AB",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T2-000-258-AC",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T2-000-284",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T2-000-348-L",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T2-000-377",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T2-012-499",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-100-015-FK",
        "name": "MOTOR COMP"
    },
    {
        "code": "2P0-915-089-B",
        "name": "BATERIA"
    },
    {
        "code": "2T2-100-015-FL",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-FM",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-FN",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-HR",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-JJ",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-JK",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-JM",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-JN",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-JQ",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-JR",
        "name": "MOTOR COMP"
    },
    {
        "code": "2P0-915-089-C",
        "name": "BATERIA"
    },
    {
        "code": "2T2-100-015-KD",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-KE",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-KF",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-LK",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-LL",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-LM",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-LN",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-LP",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-LQ",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-MQ",
        "name": "MOTOR COMP"
    },
    {
        "code": "2P0-915-089-D",
        "name": "BATERIA"
    },
    {
        "code": "2T2-100-015-MR",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-MS",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-MT",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-PC",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-PE",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-PF",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-PG",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-PH",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-PJ",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-PK",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V5-129-687-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2P0-915-089-E",
        "name": "BATERIA"
    },
    {
        "code": "2T2-103-113-C",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-103-113-E",
        "name": "SELO"
    },
    {
        "code": "2T2-103-113-F",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-103-181",
        "name": "JUNTA"
    },
    {
        "code": "2T2-103-182",
        "name": "TAMPA"
    },
    {
        "code": "2T2-103-196",
        "name": "ANEL"
    },
    {
        "code": "2T2-103-203-E",
        "name": "CARCACA"
    },
    {
        "code": "2T2-103-261",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-103-351-C",
        "name": "CABECOTE"
    },
    {
        "code": "2T2-103-448-P",
        "name": "PARAFUSO"
    },
    {
        "code": "2P0-941-589-A",
        "name": "RELE"
    },
    {
        "code": "2T2-103-448-T",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-103-457",
        "name": "CAPA"
    },
    {
        "code": "2T2-103-457-A",
        "name": "CAPA"
    },
    {
        "code": "2T2-103-480",
        "name": "ROTOR"
    },
    {
        "code": "2T2-103-483",
        "name": "ANEL"
    },
    {
        "code": "2T2-103-483-A",
        "name": "ANEL"
    },
    {
        "code": "2T2-103-485",
        "name": "TAMPA"
    },
    {
        "code": "2T2-105-549",
        "name": "MANCAL"
    },
    {
        "code": "2T2-105-701",
        "name": "CASQUILHO"
    },
    {
        "code": "2T2-105-701-E",
        "name": "CASQUILHO"
    },
    {
        "code": "2P0-998-120-K",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-105-701-F",
        "name": "CASQUILHO"
    },
    {
        "code": "2T2-105-701-G",
        "name": "CASQUILHO"
    },
    {
        "code": "2T2-105-701-H",
        "name": "CASQUILHO"
    },
    {
        "code": "2T2-109-101",
        "name": "COMANDO"
    },
    {
        "code": "2T2-109-115",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2T2-109-115-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2T2-109-139",
        "name": "JUNTA"
    },
    {
        "code": "2T2-109-139-A",
        "name": "JUNTA"
    },
    {
        "code": "2T2-109-139-B",
        "name": "JUNTA"
    },
    {
        "code": "2T2-109-177",
        "name": "PARAFUSO"
    },
    {
        "code": "2P0-998-120-M",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-109-183",
        "name": "suporte"
    },
    {
        "code": "2T2-109-447-E",
        "name": "BALANCIM"
    },
    {
        "code": "2T2-109-601",
        "name": "VALVULA"
    },
    {
        "code": "2T2-109-611",
        "name": "VALVULA"
    },
    {
        "code": "2T2-109-623-B",
        "name": "MOLA"
    },
    {
        "code": "2T2-109-623-C",
        "name": "MOLA VALV."
    },
    {
        "code": "2T2-109-623-D",
        "name": "MOLA"
    },
    {
        "code": "2T2-109-659",
        "name": "CRUZETA"
    },
    {
        "code": "2T2-109-675",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-109-675-A",
        "name": "CONEXAO"
    },
    {
        "code": "2P0-998-120-N",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-109-675-B",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-109-675-F",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-109-713",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-115-105",
        "name": "BOMBA OLEO"
    },
    {
        "code": "2T2-115-409",
        "name": "VALVULA"
    },
    {
        "code": "2T2-115-417",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-115-417-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-115-418",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-115-611-BA",
        "name": "VARETA"
    },
    {
        "code": "2T2-115-629-Q",
        "name": "TUBO"
    },
    {
        "code": "2P0-998-120-Q",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-121-103-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-121-103-G",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-121-112-A",
        "name": "AQUECEDOR"
    },
    {
        "code": "2T2-121-113-D",
        "name": "TERMOSTATO"
    },
    {
        "code": "2T2-121-179-A",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-121-179-E",
        "name": "TUBO"
    },
    {
        "code": "2T2-121-179-F",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-121-253-T",
        "name": "RADIADOR"
    },
    {
        "code": "2T2-121-269",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-121-273",
        "name": "MANCAL"
    },
    {
        "code": "2R0-000-331-A",
        "name": "MAT.ADESIV"
    },
    {
        "code": "2T2-121-283",
        "name": "suporte"
    },
    {
        "code": "2T2-121-283-D",
        "name": "suporte"
    },
    {
        "code": "2T2-121-301-D",
        "name": "VENTILADOR"
    },
    {
        "code": "2T2-121-302",
        "name": "EMBREAGEM"
    },
    {
        "code": "2T2-121-313",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-121-402",
        "name": "RESERVATOR"
    },
    {
        "code": "2T2-121-405-K",
        "name": "RESERVATOR"
    },
    {
        "code": "2T2-121-405-L",
        "name": "RESERVATOR"
    },
    {
        "code": "2T2-121-425-A",
        "name": "TIRANTE"
    },
    {
        "code": "2T2-121-425-J",
        "name": "SUPORTE"
    },
    {
        "code": "2R0-000-911-B",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T2-121-477",
        "name": "PRESILHA"
    },
    {
        "code": "2T2-127-177-B",
        "name": "ELEM FILTR"
    },
    {
        "code": "2T2-127-177-D",
        "name": "ELEM FILTR"
    },
    {
        "code": "2T2-127-213",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T2-127-223",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-127-223-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-127-404",
        "name": "ANEL"
    },
    {
        "code": "2T2-127-413-C",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-129-051",
        "name": "VALVULA"
    },
    {
        "code": "2T2-129-203",
        "name": "suporte"
    },
    {
        "code": "2R0-016-995-B",
        "name": "EXTINTOR"
    },
    {
        "code": "2T2-129-589-A",
        "name": "JUNTA"
    },
    {
        "code": "2T2-129-589-B",
        "name": "JUNTA"
    },
    {
        "code": "2T2-129-591-B",
        "name": "COLETOR"
    },
    {
        "code": "2T2-129-644",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-129-644-C",
        "name": "TUBO"
    },
    {
        "code": "2T2-129-657-D",
        "name": "BOCAL"
    },
    {
        "code": "2T2-129-657-E",
        "name": "BOCAL"
    },
    {
        "code": "2T2-129-671-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-129-857-H",
        "name": "TUBO ASPI."
    },
    {
        "code": "2T2-129-926-G",
        "name": "SUPORTE"
    },
    {
        "code": "2R0-016-995-C",
        "name": "EXTINTOR"
    },
    {
        "code": "2T2-129-926-H",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-129-954",
        "name": "TAMPA"
    },
    {
        "code": "2T2-130-085-L",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-099",
        "name": "suporte"
    },
    {
        "code": "2T2-130-099-A",
        "name": "suporte"
    },
    {
        "code": "2T2-130-105-A",
        "name": "BOMBA COMB"
    },
    {
        "code": "2T2-130-105-AX",
        "name": "BOMBA COMB"
    },
    {
        "code": "2T2-130-105-C",
        "name": "BOMBA COMB"
    },
    {
        "code": "2T2-130-115",
        "name": "porca"
    },
    {
        "code": "2T2-130-119",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-129-926-A",
        "name": "SUPORTE"
    },
    {
        "code": "2R0-103-035-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-130-119-A",
        "name": "VEDACAO"
    },
    {
        "code": "2T2-130-119-B",
        "name": "VEDACAO"
    },
    {
        "code": "2T2-130-139",
        "name": "ANEL"
    },
    {
        "code": "2T2-130-305-H",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-305-J",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-305-L",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-311",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-311-C",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-319",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-130-421",
        "name": "BRACADEIR"
    },
    {
        "code": "2R0-103-037",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-130-639",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2T2-130-639-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2T2-130-639-B",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2T2-130-659",
        "name": "ANEL"
    },
    {
        "code": "2T2-131-980-A",
        "name": "TAMPA"
    },
    {
        "code": "2T2-131-983-D",
        "name": "TUBULACAO"
    },
    {
        "code": "2T2-131-983-E",
        "name": "TUBULACAO"
    },
    {
        "code": "2T2-131-984-A",
        "name": "TUBULACAO"
    },
    {
        "code": "2T2-131-984-F",
        "name": "TUBULACAO"
    },
    {
        "code": "2T2-131-984-G",
        "name": "TUBULACAO"
    },
    {
        "code": "2R0-103-037-A",
        "name": "TAMPAO"
    },
    {
        "code": "2T2-133-319-C",
        "name": "distribuid"
    },
    {
        "code": "2T2-141-025-F",
        "name": "PLATO"
    },
    {
        "code": "2T2-141-025-N",
        "name": "PLATO"
    },
    {
        "code": "2T2-141-031-J",
        "name": "DISCO EMBR"
    },
    {
        "code": "2T2-141-033-A",
        "name": "DISCO EMBR"
    },
    {
        "code": "2T2-145-039",
        "name": "JUNTA"
    },
    {
        "code": "2T2-145-061-F",
        "name": "Turbo"
    },
    {
        "code": "2T2-145-555",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-145-577-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-145-577-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R0-103-037-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-145-577-D",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-145-594",
        "name": "TUBO"
    },
    {
        "code": "2T2-145-625",
        "name": "ANEL"
    },
    {
        "code": "2T2-145-744",
        "name": "COTOVELO"
    },
    {
        "code": "2T2-145-744-A",
        "name": "COTOVELO"
    },
    {
        "code": "2T2-145-773",
        "name": "COIFA"
    },
    {
        "code": "2T2-145-782",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-145-805-B",
        "name": "RESFRIADOR"
    },
    {
        "code": "2T2-145-805-C",
        "name": "RESFRIADOR"
    },
    {
        "code": "2T2-145-813-C",
        "name": "suporte"
    },
    {
        "code": "2R0-103-196",
        "name": "ANEL"
    },
    {
        "code": "2T2-145-828",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-198-012",
        "name": "JG.VEDACAO"
    },
    {
        "code": "2T2-198-026",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2T2-198-040",
        "name": "JG CAM PIS"
    },
    {
        "code": "2T2-198-040-A",
        "name": "JG CAM PIS"
    },
    {
        "code": "2T2-198-040-B",
        "name": "JG CAM PIS"
    },
    {
        "code": "2T2-198-040-C",
        "name": "JG CAM PIS"
    },
    {
        "code": "2T2-198-040-D",
        "name": "JG CAM PIS"
    },
    {
        "code": "2T2-198-088",
        "name": "VALVULA"
    },
    {
        "code": "2T2-198-088-A",
        "name": "VALVULA"
    },
    {
        "code": "2R0-103-196-A",
        "name": "ANEL"
    },
    {
        "code": "2T2-198-115",
        "name": "JG.BRONZIN"
    },
    {
        "code": "2T2-198-229-E",
        "name": "CONJUNTO"
    },
    {
        "code": "2T2-198-567",
        "name": "JG. FILTRO"
    },
    {
        "code": "2T2-199-095-C",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-199-095-D",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-199-149-D",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-199-149-E",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-199-149-F",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-199-221-E",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-201-156",
        "name": "CONECTOR"
    },
    {
        "code": "2R0-103-196-B",
        "name": "ANEL"
    },
    {
        "code": "2T2-201-156-A",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-201-156-E",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-201-156-F",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-201-156-H",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-201-351-P",
        "name": "tubulacao"
    },
    {
        "code": "2T2-201-353-A",
        "name": "TUBO"
    },
    {
        "code": "2T2-201-353-E",
        "name": "TUBO"
    },
    {
        "code": "2T2-201-353-F",
        "name": "TUBO"
    },
    {
        "code": "2T2-201-353-K",
        "name": "TUBO"
    },
    {
        "code": "2T2-201-433",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2R0-103-196-E",
        "name": "ANEL"
    },
    {
        "code": "2T2-201-512",
        "name": "FILTR COMB"
    },
    {
        "code": "2T2-253-101-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-253-143-AB",
        "name": "BRACADEIR"
    },
    {
        "code": "2T2-253-143-AF",
        "name": "BRACADEIR"
    },
    {
        "code": "2T2-253-227-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-253-853",
        "name": "FREIO MOT"
    },
    {
        "code": "2T2-253-853-H",
        "name": "FREIO MOT"
    },
    {
        "code": "2T2-298-021",
        "name": "TAMPA"
    },
    {
        "code": "2T2-298-021-A",
        "name": "COLETOR"
    },
    {
        "code": "2T2-301-177",
        "name": "suporte"
    },
    {
        "code": "2R0-109-439",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-301-314",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T2-301-314-C",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T2-301-327",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-301-340",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-301-340-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-301-340-AG",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-301-340-AH",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-301-340-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-301-340-J",
        "name": "POSICAO"
    },
    {
        "code": "2T2-301-340-R",
        "name": "PARAFUSO"
    },
    {
        "code": "2R0-109-475",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-301-729",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-301-845",
        "name": "BUCHA"
    },
    {
        "code": "2T2-311-113",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-311-457-B",
        "name": "ANEL"
    },
    {
        "code": "2T2-311-457-C",
        "name": "ANEL"
    },
    {
        "code": "2T2-311-457-D",
        "name": "ANEL"
    },
    {
        "code": "2T2-311-457-E",
        "name": "ANEL"
    },
    {
        "code": "2T2-311-457-F",
        "name": "ANEL"
    },
    {
        "code": "2T2-311-457-G",
        "name": "ANEL"
    },
    {
        "code": "2T2-311-457-H",
        "name": "ANEL"
    },
    {
        "code": "2V5-129-926-C",
        "name": "suporte"
    },
    {
        "code": "2R0-115-257",
        "name": "ANEL"
    },
    {
        "code": "2T2-311-457-J",
        "name": "ANEL"
    },
    {
        "code": "2T2-311-499",
        "name": "ANEL"
    },
    {
        "code": "2T2-325-021",
        "name": "RADIADOR"
    },
    {
        "code": "2T2-325-116",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-325-212",
        "name": "APOIO"
    },
    {
        "code": "2T2-399-223",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-400-025",
        "name": "EIXODIANTE"
    },
    {
        "code": "2T2-405-645",
        "name": "ROLAMENTO"
    },
    {
        "code": "2T2-407-021",
        "name": "ALAVANCA"
    },
    {
        "code": "2T2-407-261",
        "name": "CONTRAPINO"
    },
    {
        "code": "2R0-121-136",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T2-407-343-A",
        "name": "CAPA"
    },
    {
        "code": "2T2-411-049",
        "name": "APOIO"
    },
    {
        "code": "2T2-411-049-A",
        "name": "APOIO"
    },
    {
        "code": "2T2-411-055-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T2-411-055-B",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T2-411-077",
        "name": "suporte"
    },
    {
        "code": "2T2-411-085",
        "name": "suporte"
    },
    {
        "code": "2T2-411-085-B",
        "name": "suporte"
    },
    {
        "code": "2T2-411-177",
        "name": "PECAINTERM"
    },
    {
        "code": "2T2-411-178",
        "name": "PLACAINTER"
    },
    {
        "code": "2R0-121-136-B",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T2-413-031",
        "name": "AMORTECEDO"
    },
    {
        "code": "2T2-419-352",
        "name": "ALAVANCA"
    },
    {
        "code": "2T2-419-523",
        "name": "COBERTURA"
    },
    {
        "code": "2T2-419-523-A",
        "name": "COBERTURA"
    },
    {
        "code": "2T2-419-548-B",
        "name": "PINO RETEN"
    },
    {
        "code": "2T2-422-053",
        "name": "CAIXA"
    },
    {
        "code": "2T2-422-053-A",
        "name": "CAIXA"
    },
    {
        "code": "2T2-422-067-D",
        "name": "COLUNA DIR"
    },
    {
        "code": "2T2-422-067-E",
        "name": "COLUNA DIR"
    },
    {
        "code": "2T2-422-067-F",
        "name": "COLUNA DIR"
    },
    {
        "code": "2R0-129-266",
        "name": "ESPACADOR"
    },
    {
        "code": "2T2-422-067-G",
        "name": "COLUNA DIR"
    },
    {
        "code": "2T2-422-067-K",
        "name": "COLUNA DIR"
    },
    {
        "code": "2T2-422-067-L",
        "name": "COLUNA DIR"
    },
    {
        "code": "2T2-422-069",
        "name": "CAIXA"
    },
    {
        "code": "2T2-422-753-C",
        "name": "Eixo inte."
    },
    {
        "code": "2T2-422-753-D",
        "name": "Eixo inte."
    },
    {
        "code": "2T2-422-753-E",
        "name": "Eixo inte."
    },
    {
        "code": "2T2-422-859",
        "name": "TUBO"
    },
    {
        "code": "2T2-422-892-J",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-422-897-E",
        "name": "TUBO"
    },
    {
        "code": "2R0-129-288-A",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-501-091-R",
        "name": "CORPOEIXO"
    },
    {
        "code": "2T2-501-317",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-501-319",
        "name": "ROLAMENTO"
    },
    {
        "code": "2T2-501-319-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2T2-501-319-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2T2-501-319-C",
        "name": "ROLAMENTO"
    },
    {
        "code": "2T2-512-041-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-512-383",
        "name": "TRAVESSA"
    },
    {
        "code": "2T2-513-031",
        "name": "AMORTECEDO"
    },
    {
        "code": "2T2-521-145",
        "name": "FLANGE"
    },
    {
        "code": "2R0-130-758",
        "name": "SENSOR"
    },
    {
        "code": "2T2-521-183",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-521-291-B",
        "name": "CRUZETA"
    },
    {
        "code": "2T2-521-525",
        "name": "TIRANTE"
    },
    {
        "code": "2T2-525-021-AA",
        "name": "DIFERENCIA"
    },
    {
        "code": "2T2-525-021-AB",
        "name": "DIFERENCIA"
    },
    {
        "code": "2T2-525-021-AF",
        "name": "DIFERENCIA"
    },
    {
        "code": "2T2-525-021-E",
        "name": "DIFERENCIA"
    },
    {
        "code": "2T2-525-021-F",
        "name": "DIFERENCIA"
    },
    {
        "code": "2T2-525-107",
        "name": "CAIXA"
    },
    {
        "code": "2T2-601-027-A -XD6",
        "name": "RODA"
    },
    {
        "code": "2R0-130-821",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-601-027-B -XD6",
        "name": "RODA"
    },
    {
        "code": "2T2-601-173",
        "name": "PROTECAO"
    },
    {
        "code": "2T2-607-251-F",
        "name": "RESERVATOR"
    },
    {
        "code": "2T2-607-251-Q",
        "name": "RESERVATOR"
    },
    {
        "code": "2T2-607-252-B",
        "name": "RESERVATOR"
    },
    {
        "code": "2T2-607-287-AD",
        "name": "TUBO FREIO"
    },
    {
        "code": "2T2-607-287-AE",
        "name": "TUBO FREIO"
    },
    {
        "code": "2T2-607-315-A",
        "name": "COTOVELO"
    },
    {
        "code": "2T2-607-315-B",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-607-315-D",
        "name": "PECA EM T"
    },
    {
        "code": "2R0-145-487",
        "name": "ANEL"
    },
    {
        "code": "2T2-607-316",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-607-316-A",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-607-316-C",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-607-316-D",
        "name": "VALVULA"
    },
    {
        "code": "2T2-607-329-A",
        "name": "VALVULA"
    },
    {
        "code": "2T2-607-373-AK",
        "name": "SECADOR"
    },
    {
        "code": "2T2-607-373-AM",
        "name": "SECADOR"
    },
    {
        "code": "2T2-607-403-A",
        "name": "VALVULA"
    },
    {
        "code": "2T2-607-403-B",
        "name": "VALVULA"
    },
    {
        "code": "2T2-607-891-N",
        "name": "suporte"
    },
    {
        "code": "2R0-201-100",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-607-891-R",
        "name": "suporte"
    },
    {
        "code": "2T2-607-899",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-609-719-F",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-609-741",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-609-742",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-609-745",
        "name": "suporte"
    },
    {
        "code": "2T2-609-746",
        "name": "suporte"
    },
    {
        "code": "2T2-609-853-F",
        "name": "REGULADOR"
    },
    {
        "code": "2T2-611-555",
        "name": "REGULADOR"
    },
    {
        "code": "2T2-611-555-C",
        "name": "VALVULA"
    },
    {
        "code": "2R0-201-100-D",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-611-770",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-611-777",
        "name": "BRACADEIR"
    },
    {
        "code": "2T2-611-778-C",
        "name": "PRESILHA"
    },
    {
        "code": "2T2-611-778-D",
        "name": "PRESILHA"
    },
    {
        "code": "2T2-612-405-A",
        "name": "suporte"
    },
    {
        "code": "2T2-698-459",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-698-485",
        "name": "JOGOREPARA"
    },
    {
        "code": "2T2-698-509",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-698-509-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-711-118-C -1NN",
        "name": "MANOPLA"
    },
    {
        "code": "2V5-129-926-D",
        "name": "REFORCO"
    },
    {
        "code": "2R0-201-136",
        "name": "VALVULA"
    },
    {
        "code": "2T2-711-118-J -1NN",
        "name": "MANOPLA"
    },
    {
        "code": "2T2-711-118-K -1NN",
        "name": "MANOPLA"
    },
    {
        "code": "2T2-711-141",
        "name": "MANOPLA"
    },
    {
        "code": "2T2-711-144-C",
        "name": "PLACA"
    },
    {
        "code": "2T2-711-144-E",
        "name": "PLACA"
    },
    {
        "code": "2T2-711-144-F",
        "name": "PLACA"
    },
    {
        "code": "2T2-711-156",
        "name": "CARCACA"
    },
    {
        "code": "2T2-711-167-  -9B9",
        "name": "COIFA"
    },
    {
        "code": "2T2-711-224",
        "name": "TAMPA"
    },
    {
        "code": "2T2-711-452-A",
        "name": "ARTICULA."
    },
    {
        "code": "2R0-201-146",
        "name": "SENSOR"
    },
    {
        "code": "2T2-711-769-B",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-711-837",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-711-837-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-711-847-  -NA2",
        "name": "CAPA COBER"
    },
    {
        "code": "2T2-711-881",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-711-881-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-721-261-E",
        "name": "CILINDRO"
    },
    {
        "code": "2T2-721-261-F",
        "name": "CILINDRO"
    },
    {
        "code": "2T2-721-267",
        "name": "PISTPRESSA"
    },
    {
        "code": "2T2-721-315-A",
        "name": "PEDALEMBRA"
    },
    {
        "code": "2R0-201-156",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T2-721-405",
        "name": "CIL.TRANSM"
    },
    {
        "code": "2T2-800-401-A -I7N",
        "name": "CABINA"
    },
    {
        "code": "2T2-800-401-A -I9A",
        "name": "CABINA"
    },
    {
        "code": "2T2-800-401-C -I9A",
        "name": "CABINA"
    },
    {
        "code": "2T2-800-401-D -I9A",
        "name": "CABINA"
    },
    {
        "code": "2T2-800-701-B",
        "name": "CABINA"
    },
    {
        "code": "2T2-802-013",
        "name": "CHAPA"
    },
    {
        "code": "2T2-802-014",
        "name": "CHAPA"
    },
    {
        "code": "2T2-802-215-A",
        "name": "CHAPA"
    },
    {
        "code": "2T2-803-165",
        "name": "TRAVESSA"
    },
    {
        "code": "2R0-260-921",
        "name": "LUVA"
    },
    {
        "code": "2T2-803-165-B",
        "name": "TRAVESSA"
    },
    {
        "code": "2T2-803-255",
        "name": "suporte"
    },
    {
        "code": "2T2-803-256",
        "name": "suporte"
    },
    {
        "code": "2T2-803-349",
        "name": "TRAVESSA"
    },
    {
        "code": "2T2-803-399-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-803-609",
        "name": "suporte"
    },
    {
        "code": "2T2-803-645",
        "name": "suporte"
    },
    {
        "code": "2T2-803-777",
        "name": "GUIA"
    },
    {
        "code": "2T2-803-857",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-803-875",
        "name": "SUPORTE"
    },
    {
        "code": "2R0-407-261",
        "name": "CONTRAPINO"
    },
    {
        "code": "2T2-803-875-A",
        "name": "PORCA"
    },
    {
        "code": "2T2-803-875-B",
        "name": "PORCA"
    },
    {
        "code": "2T2-803-877",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-803-877-A",
        "name": "PORCA"
    },
    {
        "code": "2T2-803-877-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-803-877-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-803-877-E",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-803-877-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-804-185",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-804-185-C",
        "name": "SUPORTE"
    },
    {
        "code": "2R0-412-117",
        "name": "chaveta"
    },
    {
        "code": "2T2-804-186",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-804-186-C",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-809-032-A",
        "name": "painel"
    },
    {
        "code": "2T2-809-047",
        "name": "painel"
    },
    {
        "code": "2T2-809-048",
        "name": "painel"
    },
    {
        "code": "2T2-809-123",
        "name": "REFORCO"
    },
    {
        "code": "2T2-809-124",
        "name": "REFORCO"
    },
    {
        "code": "2T2-809-165",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-809-165-B",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-809-166",
        "name": "SUPORTE"
    },
    {
        "code": "2R0-419-635",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-809-166-B",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-809-225-A",
        "name": "COLUNA A"
    },
    {
        "code": "2T2-809-225-A -PAC",
        "name": "COLUNA A"
    },
    {
        "code": "2T2-817-017-A -I3H",
        "name": "TETO"
    },
    {
        "code": "2T2-817-017-A -I3X",
        "name": "TETO"
    },
    {
        "code": "2T2-817-017-A -I3Y",
        "name": "TETO"
    },
    {
        "code": "2T2-817-017-A -I7N",
        "name": "TETO"
    },
    {
        "code": "2T2-817-017-A -I9A",
        "name": "TETO"
    },
    {
        "code": "2T2-817-017-B",
        "name": "TETO"
    },
    {
        "code": "2T2-817-017-C",
        "name": "TETO"
    },
    {
        "code": "2R0-422-913",
        "name": "conexÆo"
    },
    {
        "code": "2T2-817-117-A",
        "name": "QUAD TETO"
    },
    {
        "code": "2T2-817-129",
        "name": "PECA DE FE"
    },
    {
        "code": "2T2-817-174-A -Y20",
        "name": "MOLDURA"
    },
    {
        "code": "2T2-817-864",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-820-413",
        "name": "CONDENSADO"
    },
    {
        "code": "2T2-820-721-P",
        "name": "TUBO"
    },
    {
        "code": "2T2-820-721-Q",
        "name": "TUBO"
    },
    {
        "code": "2T2-820-722-R",
        "name": "TUBO"
    },
    {
        "code": "2T2-820-722-S",
        "name": "TUBO"
    },
    {
        "code": "2T2-820-741-A",
        "name": "TUBO"
    },
    {
        "code": "2R0-599-109",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-820-742-A",
        "name": "TUBO"
    },
    {
        "code": "2T2-820-742-C",
        "name": "TUBO"
    },
    {
        "code": "2T2-820-742-E",
        "name": "TUBO"
    },
    {
        "code": "2T2-821-105",
        "name": "paralama"
    },
    {
        "code": "2T2-821-105-  -54V",
        "name": "paralama"
    },
    {
        "code": "2T2-821-105-  -I9A",
        "name": "paralama"
    },
    {
        "code": "2T2-821-105-  -N28",
        "name": "paralama"
    },
    {
        "code": "2T2-821-106",
        "name": "paralama"
    },
    {
        "code": "2T2-821-106-  -54V",
        "name": "paralama"
    },
    {
        "code": "2T2-821-106-  -I9A",
        "name": "paralama"
    },
    {
        "code": "2R0-607-261",
        "name": "VALVULA"
    },
    {
        "code": "2T2-821-106-  -N28",
        "name": "paralama"
    },
    {
        "code": "2T2-821-151-E",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-821-151-J",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-821-152-K",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-821-152-L",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-821-152-Q",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-821-152-R",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-821-301",
        "name": "paralama"
    },
    {
        "code": "2T2-821-301-  -54V",
        "name": "paralama"
    },
    {
        "code": "2T2-821-301-  -I9A",
        "name": "paralama"
    },
    {
        "code": "2V5-130-118",
        "name": "DISCO"
    },
    {
        "code": "2R0-607-261-D",
        "name": "VALVULA"
    },
    {
        "code": "2T2-821-301-  -N28",
        "name": "paralama"
    },
    {
        "code": "2T2-821-305-A",
        "name": "paralama"
    },
    {
        "code": "2T2-821-305-A -54V",
        "name": "paralama"
    },
    {
        "code": "2T2-821-305-A -I9A",
        "name": "paralama"
    },
    {
        "code": "2T2-821-305-A -N28",
        "name": "paralama"
    },
    {
        "code": "2T2-821-305-B -1NN",
        "name": "paralama"
    },
    {
        "code": "2T2-821-306",
        "name": "paralama"
    },
    {
        "code": "2T2-821-306-  -54V",
        "name": "paralama"
    },
    {
        "code": "2T2-821-306-  -I9A",
        "name": "paralama"
    },
    {
        "code": "2T2-821-306-  -N28",
        "name": "paralama"
    },
    {
        "code": "2R0-607-463",
        "name": "TUBO"
    },
    {
        "code": "2T2-821-685-  -9B9",
        "name": "estribo"
    },
    {
        "code": "2T2-821-686-  -9B9",
        "name": "estribo"
    },
    {
        "code": "2T2-821-687-  -9B9",
        "name": "estribo"
    },
    {
        "code": "2T2-821-688-  -9B9",
        "name": "estribo"
    },
    {
        "code": "2T2-821-701",
        "name": "GALAO"
    },
    {
        "code": "2T2-821-701-A",
        "name": "GALAO"
    },
    {
        "code": "2T2-821-719",
        "name": "PLACA"
    },
    {
        "code": "2T2-857-293",
        "name": "QUADRO"
    },
    {
        "code": "2T2-857-341-A",
        "name": "APOIO"
    },
    {
        "code": "2T2-857-350-A -Y20",
        "name": "COBERTURA"
    },
    {
        "code": "2R0-609-163",
        "name": "TAMPAO"
    },
    {
        "code": "2T2-857-367-A -Y20",
        "name": "CAPA COBER"
    },
    {
        "code": "2T2-858-153",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-858-185",
        "name": "CHAPA"
    },
    {
        "code": "2T2-861-031-D -81U",
        "name": "CAMA"
    },
    {
        "code": "2T2-861-091-A -L64",
        "name": "PAINEL"
    },
    {
        "code": "2T2-861-091-B -VN2",
        "name": "PAINEL"
    },
    {
        "code": "2T2-861-091-C -SL1",
        "name": "PAINEL"
    },
    {
        "code": "2T2-861-125",
        "name": "BATENTE"
    },
    {
        "code": "2T2-861-227-  -Y20",
        "name": "PARASOL"
    },
    {
        "code": "2T2-861-343",
        "name": "FRISOTETO"
    },
    {
        "code": "2R0-609-225",
        "name": "PINHAO"
    },
    {
        "code": "2T2-861-355",
        "name": "FRISOTETO"
    },
    {
        "code": "2T2-861-355-  -Y20",
        "name": "FRISOTETO"
    },
    {
        "code": "2T2-861-549",
        "name": "DOBRADICA"
    },
    {
        "code": "2T2-861-709-E",
        "name": "TELA"
    },
    {
        "code": "2T2-861-709-K",
        "name": "TELA"
    },
    {
        "code": "2T2-861-817",
        "name": "COBERTURA"
    },
    {
        "code": "2T2-861-817-  -54V",
        "name": "COBERTURA"
    },
    {
        "code": "2T2-861-818",
        "name": "COBERTURA"
    },
    {
        "code": "2T2-861-818-  -54V",
        "name": "COBERTURA"
    },
    {
        "code": "2T2-861-971",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2R0-609-523-L",
        "name": "SAPATA"
    },
    {
        "code": "2T2-863-835",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-863-861-D",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-863-862-D",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-863-884",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-863-895-D",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-867-500-  -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2T2-867-501-A -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2T2-867-502-  -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2T2-867-506-  -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2T2-867-599",
        "name": "REFORCO"
    },
    {
        "code": "2R0-611-363-A",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-867-599-A",
        "name": "REFORCO"
    },
    {
        "code": "2T2-867-599-B",
        "name": "REFORCO"
    },
    {
        "code": "2T2-881-023-B -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2T2-899-365-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-899-365-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-899-381",
        "name": "CHAPA"
    },
    {
        "code": "2T2-899-382",
        "name": "CHAPA"
    },
    {
        "code": "2T2-899-515",
        "name": "AMORTECEDO"
    },
    {
        "code": "2T2-899-521-A",
        "name": "BARRA"
    },
    {
        "code": "2T2-899-523-A",
        "name": "BARRA"
    },
    {
        "code": "2R0-611-379",
        "name": "ANEL"
    },
    {
        "code": "2T2-899-545",
        "name": "LUVA"
    },
    {
        "code": "2T2-899-545-A",
        "name": "BUCHA"
    },
    {
        "code": "2T2-899-545-B",
        "name": "JG. BUCHA"
    },
    {
        "code": "2T2-905-367-C",
        "name": "UNI.COMAND"
    },
    {
        "code": "2T2-906-012-C",
        "name": "UNID.COMAN"
    },
    {
        "code": "2T2-906-041-A",
        "name": "SENSOR"
    },
    {
        "code": "2T2-906-041-B",
        "name": "SENSOR"
    },
    {
        "code": "2T2-906-051-B",
        "name": "SENSOR"
    },
    {
        "code": "2T2-906-051-H",
        "name": "HALL"
    },
    {
        "code": "2T2-906-051-J",
        "name": "HALL"
    },
    {
        "code": "2R0-612-535-A",
        "name": "HASTE"
    },
    {
        "code": "2T2-906-097-A",
        "name": "RESFRIADOR"
    },
    {
        "code": "2T2-911-115",
        "name": "CAIXA"
    },
    {
        "code": "2T2-911-209",
        "name": "MANCAL"
    },
    {
        "code": "2T2-911-253",
        "name": "RELE"
    },
    {
        "code": "2T2-911-255",
        "name": "MANCAL"
    },
    {
        "code": "2T2-911-255-B",
        "name": "MANCAL"
    },
    {
        "code": "2T2-911-287",
        "name": "SOLENOIDE"
    },
    {
        "code": "2T2-911-303",
        "name": "EIXO"
    },
    {
        "code": "2T2-911-311",
        "name": "INDUZIDO"
    },
    {
        "code": "2T2-911-335",
        "name": "PINHAO"
    },
    {
        "code": "2R0-616-787-A",
        "name": "FILTRO"
    },
    {
        "code": "2T2-911-365",
        "name": "ACIONAMENT"
    },
    {
        "code": "2T2-915-516",
        "name": "suporte"
    },
    {
        "code": "2T2-919-457-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T2-919-501",
        "name": "SENSOR"
    },
    {
        "code": "2T2-927-353-A",
        "name": "valvula"
    },
    {
        "code": "2T2-927-353-B",
        "name": "valvula"
    },
    {
        "code": "2T2-927-353-C",
        "name": "valvula"
    },
    {
        "code": "2T2-927-353-D",
        "name": "valvula"
    },
    {
        "code": "2T2-927-521",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T2-927-521-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R0-698-211-D",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-927-748",
        "name": "SENSOR"
    },
    {
        "code": "2T2-927-803",
        "name": "SENSOR"
    },
    {
        "code": "2T2-927-804",
        "name": "SENSOR"
    },
    {
        "code": "2T2-937-025",
        "name": "QUADRO"
    },
    {
        "code": "2T2-971-014",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-014-E",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-FS",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-FT",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-GA",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-GB",
        "name": "CHICOTE"
    },
    {
        "code": "2V5-130-120",
        "name": "ANEL"
    },
    {
        "code": "2R0-703-529",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-971-237",
        "name": "CABO MASSA"
    },
    {
        "code": "2T2-971-561",
        "name": "CONECTOR C"
    },
    {
        "code": "2T4-609-425",
        "name": "SUPORTE"
    },
    {
        "code": "2T4-609-425-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T4-609-425-B",
        "name": "SUPORTE"
    },
    {
        "code": "2T4-609-426",
        "name": "SUPORTE"
    },
    {
        "code": "2T4-609-426-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T4-609-426-B",
        "name": "SUPORTE"
    },
    {
        "code": "2T4-821-455",
        "name": "COBERTURA"
    },
    {
        "code": "2T4-861-709-A",
        "name": "TELA"
    },
    {
        "code": "2R0-837-564",
        "name": "ESPACADOR"
    },
    {
        "code": "2T4-861-711-A",
        "name": "TELA"
    },
    {
        "code": "2T4-881-019-  -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2T4-971-753",
        "name": "CHICOTE"
    },
    {
        "code": "2TA-145-171",
        "name": "RESERVATOR"
    },
    {
        "code": "2TA-265-220",
        "name": "PRESILHA"
    },
    {
        "code": "2TA-525-365",
        "name": "BUCHA"
    },
    {
        "code": "2TA-525-369",
        "name": "TUBO"
    },
    {
        "code": "2TA-525-371",
        "name": "PISTAO"
    },
    {
        "code": "2TA-525-377",
        "name": "ANEL"
    },
    {
        "code": "2TA-525-377-A",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2R0-854-434",
        "name": "LOGOTIPO"
    },
    {
        "code": "2TA-525-467",
        "name": "PORCA"
    },
    {
        "code": "2TA-607-028",
        "name": "porca"
    },
    {
        "code": "2TA-607-051",
        "name": "NIPLE"
    },
    {
        "code": "2TA-607-515",
        "name": "ADAPTADOR"
    },
    {
        "code": "2TA-608-701-A",
        "name": "ANEL"
    },
    {
        "code": "2TA-608-701-B",
        "name": "ANEL"
    },
    {
        "code": "2TA-608-703-A",
        "name": "ANELAPERTO"
    },
    {
        "code": "2TA-608-703-B",
        "name": "ANELAPERTO"
    },
    {
        "code": "2TA-608-705-A",
        "name": "ANEL"
    },
    {
        "code": "2TA-608-705-B",
        "name": "ANEL"
    },
    {
        "code": "2R0-857-119-A",
        "name": "TRAVA"
    },
    {
        "code": "2TA-608-717-A",
        "name": "PECAJUNCAO"
    },
    {
        "code": "2TA-608-717-C",
        "name": "PECAJUNCAO"
    },
    {
        "code": "2TA-608-719-A",
        "name": "COTOVELO"
    },
    {
        "code": "2TA-608-749-A",
        "name": "CONECTOR"
    },
    {
        "code": "2TA-698-427",
        "name": "JG.PECAS"
    },
    {
        "code": "2TA-699-123",
        "name": "PARAFUSO"
    },
    {
        "code": "2TA-699-669",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-000-654",
        "name": "MAT.ADESIV"
    },
    {
        "code": "2TB-121-303",
        "name": "HELICE"
    },
    {
        "code": "2TB-129-142",
        "name": "BRACADEIRA"
    },
    {
        "code": "2R0-857-443",
        "name": "ANEL"
    },
    {
        "code": "2TB-145-907",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-499-085",
        "name": "ARRUELA"
    },
    {
        "code": "2TB-499-085-A",
        "name": "ARRUELA"
    },
    {
        "code": "2TB-499-151",
        "name": "PORCA"
    },
    {
        "code": "2TB-525-253",
        "name": "ROLAMROLO"
    },
    {
        "code": "2TB-599-115",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-599-219-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-601-027-A",
        "name": "RODA"
    },
    {
        "code": "2TB-607-048",
        "name": "MECANISMO"
    },
    {
        "code": "2TB-607-251-A",
        "name": "RESERVATOR"
    },
    {
        "code": "2R0-857-537",
        "name": "CAPA"
    },
    {
        "code": "2TB-607-306",
        "name": "MANGUEIRA"
    },
    {
        "code": "2TB-607-515-A",
        "name": "ADAPTADOR"
    },
    {
        "code": "2TB-608-743-A",
        "name": "CONEXAO"
    },
    {
        "code": "2TB-608-797",
        "name": "ANEL"
    },
    {
        "code": "2TB-903-127-A",
        "name": "ANEL"
    },
    {
        "code": "2TB-903-221-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2TB-903-339-A",
        "name": "CAPA"
    },
    {
        "code": "2TB-903-351-A",
        "name": "BOBINA"
    },
    {
        "code": "2TB-903-395-B",
        "name": "CAPA"
    },
    {
        "code": "2TB-903-545-B",
        "name": "MANG APOIO"
    },
    {
        "code": "2R0-857-654",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-941-534",
        "name": "INTERRUPTO"
    },
    {
        "code": "2TC-105-257",
        "name": "PARAFUSO"
    },
    {
        "code": "2TC-121-801",
        "name": "PARAFUSO"
    },
    {
        "code": "2TC-129-463",
        "name": "BRACADEIR"
    },
    {
        "code": "2TD-103-113-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2TD-103-113-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2TD-121-255",
        "name": "BRACADEIRA"
    },
    {
        "code": "2TE-117-273",
        "name": "BRACADEIRA"
    },
    {
        "code": "2TE-121-255",
        "name": "BRACADEIRA"
    },
    {
        "code": "2TJ-121-831",
        "name": "BRACADEIRA"
    },
    {
        "code": "2R0-857-719",
        "name": "CAPA COBER"
    },
    {
        "code": "2TJ-129-660-B",
        "name": "BRACADEIRA"
    },
    {
        "code": "2TJ-411-183",
        "name": "CALCO"
    },
    {
        "code": "2TJ-511-263",
        "name": "CALCO"
    },
    {
        "code": "2TJ-525-249",
        "name": "ANEL"
    },
    {
        "code": "2TJ-698-096",
        "name": "JG. LONA"
    },
    {
        "code": "2TJ-698-431",
        "name": "JG. LONA"
    },
    {
        "code": "2TJ-957-040",
        "name": "DISCO"
    },
    {
        "code": "2TK-821-123",
        "name": "TIRANTE"
    },
    {
        "code": "2U0-103-113-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U0-103-689",
        "name": "LUVA"
    },
    {
        "code": "2R0-857-773",
        "name": "ARRUELA"
    },
    {
        "code": "2U0-105-325",
        "name": "CASQUILHO"
    },
    {
        "code": "2U0-105-325-A",
        "name": "MANCAL"
    },
    {
        "code": "2U0-107-441",
        "name": "ANEL"
    },
    {
        "code": "2U0-115-273",
        "name": "ESPACADOR"
    },
    {
        "code": "2U0-130-231",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U0-130-479",
        "name": "PARAFUSO"
    },
    {
        "code": "2U0-198-451-A",
        "name": "MANCAL"
    },
    {
        "code": "2U0-198-451-B",
        "name": "MANCAL"
    },
    {
        "code": "2U0-199-343",
        "name": "TIRANTE"
    },
    {
        "code": "2U0-501-109",
        "name": "PINO"
    },
    {
        "code": "2R0-857-853",
        "name": "RETENCAO"
    },
    {
        "code": "2U0-501-319-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U0-501-319-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U0-501-319-D",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U0-501-319-F",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U0-501-319-M",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U0-511-227",
        "name": "suporte"
    },
    {
        "code": "2U0-511-239",
        "name": "LUVA"
    },
    {
        "code": "2U0-511-239-A",
        "name": "LUVA"
    },
    {
        "code": "2U0-511-441",
        "name": "TIRANTE"
    },
    {
        "code": "2U0-511-441-A",
        "name": "TIRANTE"
    },
    {
        "code": "2V5-311-287-A",
        "name": "ANEL"
    },
    {
        "code": "2R0-871-195-A",
        "name": "GALAO"
    },
    {
        "code": "2U0-525-121-B",
        "name": "CARCACA"
    },
    {
        "code": "2U0-525-159",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U0-525-163",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2U0-525-169-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U0-525-251",
        "name": "CAPA"
    },
    {
        "code": "2U0-525-261",
        "name": "ROLAMROLO"
    },
    {
        "code": "2U0-525-267",
        "name": "ESPACADOR"
    },
    {
        "code": "2U0-525-267-B",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-C",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-D",
        "name": "DISCO"
    },
    {
        "code": "2R0-906-217-A",
        "name": "SUPORTE"
    },
    {
        "code": "2U0-525-267-E",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-F",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-G",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-H",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-J",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-K",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-L",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-M",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-N",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-P",
        "name": "DISCO"
    },
    {
        "code": "2R0-911-273",
        "name": "ESPACADOR"
    },
    {
        "code": "2U0-525-267-Q",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-R",
        "name": "DISCO"
    },
    {
        "code": "2U0-598-777",
        "name": "MECANISMO"
    },
    {
        "code": "2U0-599-173-A",
        "name": "GRAMPO"
    },
    {
        "code": "2U0-599-195-A",
        "name": "suporte"
    },
    {
        "code": "2U0-599-269",
        "name": "PARAFUSO"
    },
    {
        "code": "2U0-607-252",
        "name": "RESERVATOR"
    },
    {
        "code": "2U0-607-252-A",
        "name": "RESERVATOR"
    },
    {
        "code": "2U0-803-875",
        "name": "PORCA"
    },
    {
        "code": "2U0-804-571-A",
        "name": "SUPORTE"
    },
    {
        "code": "2R0-937-099-A",
        "name": "RELE"
    },
    {
        "code": "2U0-804-572-A",
        "name": "SUPORTE"
    },
    {
        "code": "2U0-919-183",
        "name": "SENSOR"
    },
    {
        "code": "2U2-100-015-AA",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-AC",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-AD",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-AH",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-AJ",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-AK",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-AN",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-AP",
        "name": "MOTOR COMP"
    },
    {
        "code": "2R0-945-223",
        "name": "lente"
    },
    {
        "code": "2U2-100-015-BA",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-BB",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-BC",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-BD",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-BE",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-BF",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-R",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-100-015-T",
        "name": "MOTOR COMP"
    },
    {
        "code": "2U2-103-448-CT",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-105-387",
        "name": "ADAPTADOR"
    },
    {
        "code": "2R0-945-403-A",
        "name": "suporte"
    },
    {
        "code": "2U2-115-267-A",
        "name": "suporte"
    },
    {
        "code": "2U2-115-315-E",
        "name": "ANEL"
    },
    {
        "code": "2U2-115-406-C",
        "name": "CONECTOR"
    },
    {
        "code": "2U2-115-406-D",
        "name": "CONECTOR"
    },
    {
        "code": "2U2-121-103-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2U2-121-168",
        "name": "TAMPA"
    },
    {
        "code": "2U2-121-321",
        "name": "TAMPA"
    },
    {
        "code": "2U2-121-359",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-121-373-A",
        "name": "PROTETOR"
    },
    {
        "code": "2U2-121-393",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R0-947-561",
        "name": "INTERRUPTO"
    },
    {
        "code": "2U2-121-405",
        "name": "RESERVATOR"
    },
    {
        "code": "2U2-121-455",
        "name": "TUBO"
    },
    {
        "code": "2U2-121-473",
        "name": "MANGUEIRA"
    },
    {
        "code": "2U2-121-590-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2U2-127-245",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-127-245-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-127-250",
        "name": "GRAMPO"
    },
    {
        "code": "2U2-130-139-C",
        "name": "ANEL"
    },
    {
        "code": "2U2-130-139-D",
        "name": "ANEL"
    },
    {
        "code": "2U2-130-311-A",
        "name": "TUBO"
    },
    {
        "code": "2R0-951-209-A",
        "name": "BUZINA"
    },
    {
        "code": "2U2-130-311-B",
        "name": "TUBO"
    },
    {
        "code": "2U2-130-311-C",
        "name": "TUBO"
    },
    {
        "code": "2U2-130-311-D",
        "name": "TUBO"
    },
    {
        "code": "2U2-130-421-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2U2-141-169",
        "name": "caixa"
    },
    {
        "code": "2U2-141-169-A",
        "name": "caixa"
    },
    {
        "code": "2U2-141-255",
        "name": "ANEL"
    },
    {
        "code": "2U2-141-255-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-141-715",
        "name": "LUVA"
    },
    {
        "code": "2U2-145-061-D",
        "name": "TURBO"
    },
    {
        "code": "2R0-951-209-B",
        "name": "BUZINA"
    },
    {
        "code": "2U2-145-061-E",
        "name": "TURBO"
    },
    {
        "code": "2U2-145-061-F",
        "name": "Turbo"
    },
    {
        "code": "2U2-145-061-G",
        "name": "TURBO"
    },
    {
        "code": "2U2-145-061-H",
        "name": "TURBO"
    },
    {
        "code": "2U2-145-061-J",
        "name": "TURBO"
    },
    {
        "code": "2U2-145-375-A",
        "name": "REGULADOR"
    },
    {
        "code": "2U2-145-375-B",
        "name": "REGULADOR"
    },
    {
        "code": "2U2-145-375-C",
        "name": "REGULADOR"
    },
    {
        "code": "2U2-145-757-A",
        "name": "JUNTA"
    },
    {
        "code": "2U2-145-782",
        "name": "DEFLETOR"
    },
    {
        "code": "2R0-955-985-A",
        "name": "BICO EJETO"
    },
    {
        "code": "2U2-145-782-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2U2-198-049",
        "name": "RETENTOR"
    },
    {
        "code": "2U2-198-199-C",
        "name": "JG.PECAS"
    },
    {
        "code": "2U2-198-567-A",
        "name": "JG. FILTRO"
    },
    {
        "code": "2U2-199-255",
        "name": "COXIM"
    },
    {
        "code": "2U2-253-091",
        "name": "TUBO"
    },
    {
        "code": "2U2-253-143",
        "name": "BRACADEIR"
    },
    {
        "code": "2U2-261-847-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2U2-301-141-G",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-301-162-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-311-287-E",
        "name": "ANEL"
    },
    {
        "code": "2R0-971-012",
        "name": "CHICOTE"
    },
    {
        "code": "2U2-301-192",
        "name": "ANEL"
    },
    {
        "code": "2U2-301-193-C",
        "name": "ANEL"
    },
    {
        "code": "2U2-301-193-D",
        "name": "ANEL"
    },
    {
        "code": "2U2-301-193-E",
        "name": "ANEL"
    },
    {
        "code": "2U2-301-193-F",
        "name": "ANEL"
    },
    {
        "code": "2U2-301-193-G",
        "name": "ANEL"
    },
    {
        "code": "2U2-301-211",
        "name": "TAMPA"
    },
    {
        "code": "2U2-301-215",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-301-215-A",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-301-218",
        "name": "MOLA"
    },
    {
        "code": "2R0-971-013",
        "name": "CHICOTE"
    },
    {
        "code": "2U2-301-293",
        "name": "PLACAINTER"
    },
    {
        "code": "2U2-301-339-A",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-301-340-AD",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-AG",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-AH",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-AK",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-AP",
        "name": "BUCHA"
    },
    {
        "code": "2U2-301-340-AQ",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-AR",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-AS",
        "name": "PARAFUSO"
    },
    {
        "code": "2R0-971-161",
        "name": "CHICOTE P"
    },
    {
        "code": "2U2-301-340-BB",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-349",
        "name": "porca"
    },
    {
        "code": "2U2-301-367-B",
        "name": "VALVULA"
    },
    {
        "code": "2U2-301-367-E",
        "name": "VALVULA"
    },
    {
        "code": "2U2-301-373",
        "name": "TAMPA"
    },
    {
        "code": "2U2-301-431-A",
        "name": "PINO"
    },
    {
        "code": "2U2-301-431-C",
        "name": "PINO"
    },
    {
        "code": "2U2-301-431-E",
        "name": "PINO"
    },
    {
        "code": "2U2-301-431-F",
        "name": "PINO"
    },
    {
        "code": "2U2-301-443",
        "name": "PINO"
    },
    {
        "code": "2R0-971-161-A",
        "name": "CHICOTE P"
    },
    {
        "code": "2U2-301-443-A",
        "name": "PINO"
    },
    {
        "code": "2U2-301-443-B",
        "name": "PINO"
    },
    {
        "code": "2U2-301-463",
        "name": "JUNTA"
    },
    {
        "code": "2U2-301-463-A",
        "name": "TAMPA"
    },
    {
        "code": "2U2-301-807-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-301-807-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-301-857",
        "name": "CHAPA"
    },
    {
        "code": "2U2-301-865",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-301-865-A",
        "name": "JUNTA"
    },
    {
        "code": "2U2-301-891",
        "name": "LUVA"
    },
    {
        "code": "2R0-971-162",
        "name": "CHICOTE P"
    },
    {
        "code": "2U2-301-891-A",
        "name": "LUVA"
    },
    {
        "code": "2U2-307-215",
        "name": "EIXO INTER"
    },
    {
        "code": "2U2-311-127-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-311-143",
        "name": "EIXO"
    },
    {
        "code": "2U2-311-146",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2U2-311-219",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-230",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-A",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AA",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AB",
        "name": "FRICCAO"
    },
    {
        "code": "2R0-971-882",
        "name": "PROTECAO"
    },
    {
        "code": "2U2-311-230-AC",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AD",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AE",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AF",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AG",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AH",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AJ",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AK",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AL",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AM",
        "name": "FRICCAO"
    },
    {
        "code": "2R0-971-903",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-230-AN",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AP",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AQ",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-AR",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BS",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BT",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-C",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-CA",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-CB",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-CC",
        "name": "FRICCAO"
    },
    {
        "code": "2R2-000-299",
        "name": "ETIQUETAID"
    },
    {
        "code": "2U2-311-230-CD",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-CE",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-CF",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-CG",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-CH",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-CJ",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-D",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-E",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-F",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-G",
        "name": "FRICCAO"
    },
    {
        "code": "2R2-000-300",
        "name": "ETIQUETAID"
    },
    {
        "code": "2U2-311-230-H",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-J",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-K",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-L",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-288",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-B",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-C",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-D",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-E",
        "name": "ANEL"
    },
    {
        "code": "2R2-000-348-AM",
        "name": "ETIQUETAID"
    },
    {
        "code": "2U2-311-288-F",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-G",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-H",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-288-J",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-499-G",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-499-H",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-511-A",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-311-511-B",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-311-511-C",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-311-514",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-295-B",
        "name": "ANEL"
    },
    {
        "code": "2R2-000-911-C",
        "name": "ETIQUETAID"
    },
    {
        "code": "2U2-311-514-B",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-311-514-E",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-311-514-F",
        "name": "PORCA"
    },
    {
        "code": "2U2-311-514-K",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-311-515",
        "name": "EIXO"
    },
    {
        "code": "2U2-311-551-C",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2U2-311-553",
        "name": "EIXO"
    },
    {
        "code": "2U2-311-561-A",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2U2-311-571-A",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2U2-311-585-A",
        "name": "LUVA"
    },
    {
        "code": "2R2-035-365-  -Y20",
        "name": "COBERTURA"
    },
    {
        "code": "2U2-311-585-B",
        "name": "ADAPTADOR"
    },
    {
        "code": "2U2-311-599-B",
        "name": "TAMPAO"
    },
    {
        "code": "2U2-311-599-C",
        "name": "TAMPAO"
    },
    {
        "code": "2U2-311-613",
        "name": "PINO"
    },
    {
        "code": "2U2-311-799",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-807-C",
        "name": "CAPA"
    },
    {
        "code": "2U2-311-809-A",
        "name": "FLANGE"
    },
    {
        "code": "2U2-311-809-B",
        "name": "FLANGE"
    },
    {
        "code": "2U2-311-848",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-848-A",
        "name": "BUCHA"
    },
    {
        "code": "2R2-035-366-  -Y20",
        "name": "COBERTURA"
    },
    {
        "code": "2U2-311-862",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-311-862-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-311-868",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2U2-311-868-A",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2U2-311-893-A",
        "name": "TUBO"
    },
    {
        "code": "2U2-311-893-B",
        "name": "TUBO OLEO"
    },
    {
        "code": "2U2-311-927",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-311-944",
        "name": "ANEL"
    },
    {
        "code": "2U2-313-241",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-313-242",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2R2-035-550",
        "name": "CABO ANTEN"
    },
    {
        "code": "2U2-313-243",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-313-255",
        "name": "BORRACHA"
    },
    {
        "code": "2U2-313-312",
        "name": "EIXO"
    },
    {
        "code": "2U2-313-689",
        "name": "PLACA ANCO"
    },
    {
        "code": "2U2-315-109",
        "name": "CAIXA"
    },
    {
        "code": "2U2-315-119",
        "name": "RODA"
    },
    {
        "code": "2U2-315-123",
        "name": "EIXO"
    },
    {
        "code": "2U2-315-141",
        "name": "TAMPA"
    },
    {
        "code": "2U2-315-380",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-321-143",
        "name": "ROLO"
    },
    {
        "code": "2R2-035-550-A",
        "name": "CABO ANTEN"
    },
    {
        "code": "2U2-323-341-B",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-323-357",
        "name": "EIXO ENGRE"
    },
    {
        "code": "2U2-323-357-A",
        "name": "EIXO ENGRE"
    },
    {
        "code": "2U2-323-375",
        "name": "CORPO DE V"
    },
    {
        "code": "2U2-323-515",
        "name": "PINO"
    },
    {
        "code": "2U2-323-515-A",
        "name": "PINO"
    },
    {
        "code": "2U2-325-307-B",
        "name": "CILINCOMUT"
    },
    {
        "code": "2U2-398-007",
        "name": "JG JUNTAS"
    },
    {
        "code": "2U2-398-008",
        "name": "JG.PECAS"
    },
    {
        "code": "2U2-413-353",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-129-778",
        "name": "BRACADEIR"
    },
    {
        "code": "2U2-413-354",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-511-339",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-511-441",
        "name": "TIRANTE"
    },
    {
        "code": "2U2-512-041-A",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-512-041-B",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-512-041-C",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-512-041-D",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-512-303",
        "name": "CALCO"
    },
    {
        "code": "2U2-513-031",
        "name": "AMORTECEDO"
    },
    {
        "code": "2U2-513-059",
        "name": "PISTAO"
    },
    {
        "code": "2R2-129-857-B",
        "name": "CONDUTOR A"
    },
    {
        "code": "2U2-513-381",
        "name": "CONJUNTO"
    },
    {
        "code": "2U2-517-606",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-E",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-K",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-201-063-A",
        "name": "JG.CILINDR"
    },
    {
        "code": "2U2-517-606-L",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-M",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-N",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-606-Q",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-517-633",
        "name": "BUCHA"
    },
    {
        "code": "2U2-519-073",
        "name": "BUCHA"
    },
    {
        "code": "2U2-521-109-P",
        "name": "EIXO"
    },
    {
        "code": "2U2-521-110-B",
        "name": "EIXO"
    },
    {
        "code": "2U2-521-110-F",
        "name": "EIXO"
    },
    {
        "code": "2U2-607-110",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-265-473",
        "name": "CABO COMAN"
    },
    {
        "code": "2U2-607-110-A",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-607-191",
        "name": "REGULADOR"
    },
    {
        "code": "2U2-607-191-A",
        "name": "REGULADOR"
    },
    {
        "code": "2U2-607-251",
        "name": "RESERVATOR"
    },
    {
        "code": "2U2-607-273",
        "name": "REBITE"
    },
    {
        "code": "2U2-607-273-A",
        "name": "REBITE"
    },
    {
        "code": "2U2-607-307",
        "name": "BUCHA"
    },
    {
        "code": "2U2-607-348",
        "name": "TRAVA"
    },
    {
        "code": "2U2-612-313",
        "name": "COIFA"
    },
    {
        "code": "2U2-612-377",
        "name": "TAMPA"
    },
    {
        "code": "2R2-419-661",
        "name": "ANEL"
    },
    {
        "code": "2U2-612-517",
        "name": "PLACA"
    },
    {
        "code": "2U2-612-535",
        "name": "HASTE"
    },
    {
        "code": "2U2-612-565-A",
        "name": "PINO"
    },
    {
        "code": "2U2-612-565-B",
        "name": "PINO"
    },
    {
        "code": "2U2-614-129",
        "name": "RETENTOR"
    },
    {
        "code": "2U2-614-129-A",
        "name": "RETENTOR"
    },
    {
        "code": "2U2-614-149",
        "name": "RODAPULSO"
    },
    {
        "code": "2U2-615-331-B",
        "name": "CAMARA DO"
    },
    {
        "code": "2U2-615-331-J",
        "name": "CAMARA DO"
    },
    {
        "code": "2U2-615-332-B",
        "name": "CAMARA DO"
    },
    {
        "code": "2V5-311-295-C",
        "name": "ANEL"
    },
    {
        "code": "2R2-419-669",
        "name": "TECLA"
    },
    {
        "code": "2U2-615-332-G",
        "name": "CAMARA DO"
    },
    {
        "code": "2U2-616-045",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2U2-616-045-A",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2U2-616-045-B",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2U2-803-383",
        "name": "suporte"
    },
    {
        "code": "2U2-803-642",
        "name": "PINO"
    },
    {
        "code": "2U2-803-823",
        "name": "MANCAL"
    },
    {
        "code": "2U2-803-877",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-927-127",
        "name": "INTERRUPTO"
    },
    {
        "code": "2U2-927-127-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R2-419-669-  -999",
        "name": "TECLA"
    },
    {
        "code": "2U2-927-353",
        "name": "valvula"
    },
    {
        "code": "2U2-955-425",
        "name": "JG.PALHETA"
    },
    {
        "code": "2U2-971-759",
        "name": "SENSOR"
    },
    {
        "code": "2UU-511-349",
        "name": "suporte"
    },
    {
        "code": "2V2-000-271-D",
        "name": "ETIQUETA"
    },
    {
        "code": "2V2-000-271-E",
        "name": "ETIQUETA"
    },
    {
        "code": "2V2-000-271-H",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-271-J",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-271-K",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-271-L",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-422-515",
        "name": "COBERTURA"
    },
    {
        "code": "2V2-000-271-S",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-271-T",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-348-E",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-348-G",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-547",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-547-A",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-547-B",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-000-719-A",
        "name": "ETIQUETA"
    },
    {
        "code": "2V2-012-766-CB",
        "name": "LITERATURA"
    },
    {
        "code": "2V2-012-766-CH",
        "name": "LITERATURA"
    },
    {
        "code": "2R2-422-567",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V2-012-766-CP",
        "name": "LITERATURA"
    },
    {
        "code": "2V2-012-766-CR",
        "name": "LITERATURA"
    },
    {
        "code": "2V2-012-766-D",
        "name": "LITERATURA"
    },
    {
        "code": "2V2-012-766-DD",
        "name": "LITERATURA"
    },
    {
        "code": "2V2-100-015-AA",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-AB",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-AM",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-AN",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-AP",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-BB",
        "name": "MOTOR COMP"
    },
    {
        "code": "2R2-422-567-  -999",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V2-100-015-BC",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-J",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-K",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-L",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-M",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-S",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-015-T",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V2-100-179",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V2-103-113",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V2-103-196",
        "name": "ANEL"
    },
    {
        "code": "2R2-422-849-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-103-203",
        "name": "CARCACA"
    },
    {
        "code": "2V2-103-203-A",
        "name": "CARCACA"
    },
    {
        "code": "2V2-103-351",
        "name": "CABECOTE"
    },
    {
        "code": "2V2-121-546",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-121-590-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-127-177",
        "name": "ELEM FILTR"
    },
    {
        "code": "2V2-129-142",
        "name": "BRACADEIR"
    },
    {
        "code": "2V2-129-644",
        "name": "TUBO"
    },
    {
        "code": "2V2-129-857-A",
        "name": "TUBO ASPI."
    },
    {
        "code": "2V2-129-973-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R2-711-141-  -999",
        "name": "MANOPLA"
    },
    {
        "code": "2V2-129-973-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-130-154",
        "name": "PRISIONEIR"
    },
    {
        "code": "2V2-130-233",
        "name": "ANEL"
    },
    {
        "code": "2V2-131-157-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-131-157-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-131-159",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-131-159-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-131-639-A",
        "name": "CINTATENSO"
    },
    {
        "code": "2V2-131-807-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-131-832",
        "name": "SENSOR"
    },
    {
        "code": "2R2-711-289-  -999",
        "name": "TUBO"
    },
    {
        "code": "2V2-131-832-A",
        "name": "SENSOR"
    },
    {
        "code": "2V2-131-873",
        "name": "RESERVATOR"
    },
    {
        "code": "2V2-131-877",
        "name": "RESERVATOR"
    },
    {
        "code": "2V2-131-877-A",
        "name": "RESERVATOR"
    },
    {
        "code": "2V2-131-877-D",
        "name": "RESERVATOR"
    },
    {
        "code": "2V2-133-551",
        "name": "INJETOR"
    },
    {
        "code": "2V2-141-025-B",
        "name": "PLATO"
    },
    {
        "code": "2V2-141-031-C",
        "name": "DISCO EMBR"
    },
    {
        "code": "2V2-141-165",
        "name": "MANCAL"
    },
    {
        "code": "2V2-141-165-A",
        "name": "MANCAL"
    },
    {
        "code": "2R2-711-329-B",
        "name": "MOLA"
    },
    {
        "code": "2V2-141-165-C",
        "name": "MANCAL"
    },
    {
        "code": "2V2-141-250",
        "name": "PRESILHA"
    },
    {
        "code": "2V2-141-305",
        "name": "ESPACADOR"
    },
    {
        "code": "2V2-141-327",
        "name": "PINOCILIND"
    },
    {
        "code": "2V2-141-719",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V2-141-719-A",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V2-201-259-A",
        "name": "TRAVESSA"
    },
    {
        "code": "2V2-201-260-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-201-260-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-201-260-C",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-711-504-  -999",
        "name": "BOTAO"
    },
    {
        "code": "2V2-201-260-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-201-341",
        "name": "TUBO"
    },
    {
        "code": "2V2-201-341-A",
        "name": "TUBO"
    },
    {
        "code": "2V2-201-353",
        "name": "TUBO"
    },
    {
        "code": "2V2-201-353-A",
        "name": "TUBO"
    },
    {
        "code": "2V2-201-392",
        "name": "TIRANTE"
    },
    {
        "code": "2V2-201-427",
        "name": "PINO ROSCA"
    },
    {
        "code": "2V2-201-427-A",
        "name": "CONTRAPINO"
    },
    {
        "code": "2V2-201-427-B",
        "name": "CONTRAPINO"
    },
    {
        "code": "2V2-201-512-A",
        "name": "FILTR COMB"
    },
    {
        "code": "2V5-311-295-E",
        "name": "ANEL"
    },
    {
        "code": "2R2-711-893",
        "name": "LUVA"
    },
    {
        "code": "2V2-201-722",
        "name": "suporte"
    },
    {
        "code": "2V2-201-722-A",
        "name": "suporte"
    },
    {
        "code": "2V2-253-037-B",
        "name": "DEFLETOR"
    },
    {
        "code": "2V2-253-047-B",
        "name": "suporte"
    },
    {
        "code": "2V2-253-047-C",
        "name": "suporte"
    },
    {
        "code": "2V2-253-047-D",
        "name": "suporte"
    },
    {
        "code": "2V2-253-047-E",
        "name": "suporte"
    },
    {
        "code": "2V2-253-091-A",
        "name": "TUBO"
    },
    {
        "code": "2V2-253-091-B",
        "name": "TUBO"
    },
    {
        "code": "2V2-253-101",
        "name": "TUBO"
    },
    {
        "code": "2R2-721-043-B",
        "name": "GUARNICAO"
    },
    {
        "code": "2V2-253-137",
        "name": "VEDACAO"
    },
    {
        "code": "2V2-301-141-D",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V2-301-193",
        "name": "ANEL"
    },
    {
        "code": "2V2-301-251",
        "name": "PLACPRESSA"
    },
    {
        "code": "2V2-301-293",
        "name": "PLACAINTER"
    },
    {
        "code": "2V2-301-340",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-301-431",
        "name": "PINO"
    },
    {
        "code": "2V2-301-675",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-301-675-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-301-685",
        "name": "TUBO OLEO"
    },
    {
        "code": "2R2-721-257-B",
        "name": "CIL.TRANSM"
    },
    {
        "code": "2V2-301-685-C",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V2-301-685-D",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V2-311-115",
        "name": "RETENTOR"
    },
    {
        "code": "2V2-311-115-A",
        "name": "RETENTOR"
    },
    {
        "code": "2V2-311-482-A",
        "name": "suporte"
    },
    {
        "code": "2V2-311-482-B",
        "name": "suporte"
    },
    {
        "code": "2V2-311-499",
        "name": "ANEL"
    },
    {
        "code": "2V2-311-515",
        "name": "EIXO INTER"
    },
    {
        "code": "2V2-311-515-A",
        "name": "EIXO INTER"
    },
    {
        "code": "2V2-311-515-B",
        "name": "EIXO INTER"
    },
    {
        "code": "2R2-721-277",
        "name": "TRAVA"
    },
    {
        "code": "2V2-311-515-C",
        "name": "EIXO INTER"
    },
    {
        "code": "2V2-311-540-B",
        "name": "HASTE"
    },
    {
        "code": "2V2-311-613-A",
        "name": "PINO"
    },
    {
        "code": "2V2-311-809",
        "name": "FLANGE"
    },
    {
        "code": "2V2-311-809-A",
        "name": "TAMPA"
    },
    {
        "code": "2V2-311-862",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-311-914",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V2-315-141",
        "name": "TAMPA"
    },
    {
        "code": "2V2-317-021",
        "name": "trocador"
    },
    {
        "code": "2V2-317-752",
        "name": "TUBO OLEO"
    },
    {
        "code": "2R2-721-381-A",
        "name": "BATENTE"
    },
    {
        "code": "2V2-323-301",
        "name": "JG.ENGRENA"
    },
    {
        "code": "2V2-323-301-A",
        "name": "JG.ENGRENA"
    },
    {
        "code": "2V2-323-315",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V2-323-315-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V2-323-515",
        "name": "PINO"
    },
    {
        "code": "2V2-323-515-A",
        "name": "PINO"
    },
    {
        "code": "2V2-501-085-S",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-T",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-091-G",
        "name": "CARCACA"
    },
    {
        "code": "2V2-501-091-K",
        "name": "CARCACA"
    },
    {
        "code": "2R2-800-375",
        "name": "JG.CILINDR"
    },
    {
        "code": "2V2-501-093",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-101",
        "name": "CARCACA"
    },
    {
        "code": "2V2-501-109-A",
        "name": "HASTE"
    },
    {
        "code": "2V2-501-123",
        "name": "suporte"
    },
    {
        "code": "2V2-501-128",
        "name": "CAIXA"
    },
    {
        "code": "2V2-501-131",
        "name": "JUNTA"
    },
    {
        "code": "2V2-501-147",
        "name": "TAMPA"
    },
    {
        "code": "2V2-501-147-A",
        "name": "TAMPA"
    },
    {
        "code": "2V2-501-205",
        "name": "SEMI EIXO"
    },
    {
        "code": "2V2-501-205-A",
        "name": "SEMI EIXO"
    },
    {
        "code": "2R2-802-013",
        "name": "CHAPA"
    },
    {
        "code": "2V2-501-206",
        "name": "SEMI EIXO"
    },
    {
        "code": "2V2-501-206-A",
        "name": "SEMI EIXO"
    },
    {
        "code": "2V2-501-213",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-501-213-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-B",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-501-213-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-H",
        "name": "PRISIONEIR"
    },
    {
        "code": "2R2-802-014-A",
        "name": "CHAPA"
    },
    {
        "code": "2V2-501-213-J",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-501-213-K",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-L",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-M",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-N",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-P",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-Q",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-R",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-213-S",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-215",
        "name": "ANEL"
    },
    {
        "code": "2R2-802-205-A",
        "name": "CHAPA"
    },
    {
        "code": "2V2-501-215-A",
        "name": "ANEL"
    },
    {
        "code": "2V2-501-249-A",
        "name": "CAPA FECHA"
    },
    {
        "code": "2V2-501-299",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-299-A",
        "name": "APOIO"
    },
    {
        "code": "2V2-501-299-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-501-317",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-501-317-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-501-317-B",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-501-317-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-511-167-N",
        "name": "LAMINA"
    },
    {
        "code": "2R2-803-593",
        "name": "TAMPAO"
    },
    {
        "code": "2V2-511-167-P",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-Q",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-R",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-170",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-180",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-187",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-188",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-193",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-194",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-196",
        "name": "LAMINA"
    },
    {
        "code": "2V5-311-312-C",
        "name": "MOLA"
    },
    {
        "code": "2R2-803-875",
        "name": "PORCA"
    },
    {
        "code": "2V2-511-275",
        "name": "TRAVA"
    },
    {
        "code": "2V2-511-331",
        "name": "CINTA"
    },
    {
        "code": "2V2-511-331-A",
        "name": "PORCA"
    },
    {
        "code": "2V2-511-339",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-511-439",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V2-512-041",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-512-135",
        "name": "JG.PECAS"
    },
    {
        "code": "2V2-512-135-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2V2-512-383-A",
        "name": "TRAVESSA"
    },
    {
        "code": "2V2-513-059",
        "name": "PISTAO"
    },
    {
        "code": "2R2-803-875-C",
        "name": "PORCA"
    },
    {
        "code": "2V2-521-101-C",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-107-L",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-109-E",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-115",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-115-A",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-115-B",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-115-C",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-115-D",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-115-E",
        "name": "EIXO"
    },
    {
        "code": "2V2-521-115-M",
        "name": "EIXO"
    },
    {
        "code": "2R2-803-875-F",
        "name": "PORCA"
    },
    {
        "code": "2V2-521-145-A",
        "name": "FLANGE"
    },
    {
        "code": "2V2-525-349",
        "name": "ANEL"
    },
    {
        "code": "2V2-525-631",
        "name": "ACIONAMENT"
    },
    {
        "code": "2V2-525-631-A",
        "name": "ACIONAMENT"
    },
    {
        "code": "2V2-525-728",
        "name": "MOLA"
    },
    {
        "code": "2V2-525-777",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-525-777-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-525-777-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-525-777-C",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-525-777-D",
        "name": "ROLAMENTO"
    },
    {
        "code": "2R2-803-875-G",
        "name": "PORCA"
    },
    {
        "code": "2V2-525-777-E",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-525-987",
        "name": "CONECTOR"
    },
    {
        "code": "2V2-598-081",
        "name": "JG.PECAS"
    },
    {
        "code": "2V2-598-998",
        "name": "BUCHA"
    },
    {
        "code": "2V2-599-109",
        "name": "DISCO"
    },
    {
        "code": "2V2-599-173-B",
        "name": "GRAMPO"
    },
    {
        "code": "2V2-599-175",
        "name": "PLACA"
    },
    {
        "code": "2V2-599-175-A",
        "name": "PLACA"
    },
    {
        "code": "2V2-599-215",
        "name": "PORCA"
    },
    {
        "code": "2V2-607-891-D",
        "name": "suporte"
    },
    {
        "code": "2R2-803-875-H",
        "name": "PORCA"
    },
    {
        "code": "2V2-607-891-F",
        "name": "suporte"
    },
    {
        "code": "2V2-607-891-G",
        "name": "suporte"
    },
    {
        "code": "2V2-607-891-H",
        "name": "suporte"
    },
    {
        "code": "2V2-607-891-J",
        "name": "suporte"
    },
    {
        "code": "2V2-607-891-M",
        "name": "suporte"
    },
    {
        "code": "2V2-609-719-B",
        "name": "suporte"
    },
    {
        "code": "2V2-609-745",
        "name": "suporte"
    },
    {
        "code": "2V2-609-746",
        "name": "suporte"
    },
    {
        "code": "2V2-609-819",
        "name": "MECANISMO"
    },
    {
        "code": "2V2-609-819-A",
        "name": "MECANISMO"
    },
    {
        "code": "2R2-803-877-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-609-819-C",
        "name": "MECANISMO"
    },
    {
        "code": "2V2-609-820",
        "name": "MECANISMO"
    },
    {
        "code": "2V2-609-820-A",
        "name": "MECANISMO"
    },
    {
        "code": "2V2-609-820-C",
        "name": "MECANISMO"
    },
    {
        "code": "2V2-609-853",
        "name": "REGULADOR"
    },
    {
        "code": "2V2-612-147",
        "name": "valvula"
    },
    {
        "code": "2V2-612-405-A",
        "name": "suporte"
    },
    {
        "code": "2V2-612-406-A",
        "name": "suporte"
    },
    {
        "code": "2V2-614-137",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-614-137-C",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-803-877-AA",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-614-138",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-614-138-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-614-150",
        "name": "RODAPULSO"
    },
    {
        "code": "2V2-614-173",
        "name": "LUVA"
    },
    {
        "code": "2V2-615-331-A",
        "name": "CAMARA DO"
    },
    {
        "code": "2V2-615-331-B",
        "name": "CAMARA DO"
    },
    {
        "code": "2V2-615-331-C",
        "name": "CAMARA DO"
    },
    {
        "code": "2V2-615-331-D",
        "name": "CAMARA DO"
    },
    {
        "code": "2V2-615-331-F",
        "name": "CAMARA DO"
    },
    {
        "code": "2V2-615-331-G",
        "name": "CAMARA DO"
    },
    {
        "code": "2R2-803-877-AB",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-615-332-A",
        "name": "CAMARA DO"
    },
    {
        "code": "2V2-615-332-B",
        "name": "CAMARA DO"
    },
    {
        "code": "2V2-615-332-D",
        "name": "CAMARA DO"
    },
    {
        "code": "2V2-803-134-A",
        "name": "TIRANTE"
    },
    {
        "code": "2V2-803-185-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-185-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-185-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-186-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-186-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-186-C",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-803-877-AD",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-803-189",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-255-A",
        "name": "suporte"
    },
    {
        "code": "2V2-803-255-B",
        "name": "suporte"
    },
    {
        "code": "2V2-803-256-A",
        "name": "suporte"
    },
    {
        "code": "2V2-803-347-B",
        "name": "PLATAFORMA"
    },
    {
        "code": "2V2-803-367-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-393-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-394-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-413",
        "name": "REFORCO"
    },
    {
        "code": "2V2-803-533-A",
        "name": "TRAVESSA"
    },
    {
        "code": "2R2-803-877-AJ",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-803-533-B",
        "name": "TRAVESSA"
    },
    {
        "code": "2V2-803-543-A",
        "name": "REFORCO"
    },
    {
        "code": "2V2-803-543-B",
        "name": "REFORCO"
    },
    {
        "code": "2V2-803-544-A",
        "name": "REFORCO"
    },
    {
        "code": "2V2-803-544-B",
        "name": "REFORCO"
    },
    {
        "code": "2V2-803-551-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-552-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-571-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-572-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-803-777",
        "name": "GUIA"
    },
    {
        "code": "2V5-311-351-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2R2-803-877-AQ",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-803-957",
        "name": "PINO"
    },
    {
        "code": "2V2-854-431-R",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V2-854-431-S",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V2-854-431-T",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V2-863-631",
        "name": "ISOLANTE"
    },
    {
        "code": "2V2-863-884",
        "name": "ISOLANTE"
    },
    {
        "code": "2V2-864-923-A",
        "name": "ISOLANTE"
    },
    {
        "code": "2V2-881-031-C -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2V2-881-031-C -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2V2-899-361",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-803-877-AR",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-899-361-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-899-361-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-899-362",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-899-362-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-899-362-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-899-365",
        "name": "TUBO"
    },
    {
        "code": "2V2-899-365-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-899-505",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2V2-899-505-A",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2V2-899-515",
        "name": "AMORTECEDO"
    },
    {
        "code": "2R2-803-877-AS",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-899-515-B",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V2-899-515-C",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V2-899-515-D",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V2-899-515-E",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V2-927-127-A -1NN",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V2-927-127-A -9B9",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V2-927-192",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V2-927-521-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V2-927-521-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V2-927-748",
        "name": "SENSOR"
    },
    {
        "code": "2R2-803-877-AT",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-941-063-A",
        "name": "FAROL"
    },
    {
        "code": "2V2-945-403-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-947-561",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V2-949-101",
        "name": "LUZ"
    },
    {
        "code": "2V2-949-101-A",
        "name": "LUZ"
    },
    {
        "code": "2V2-957-046",
        "name": "BOBINA"
    },
    {
        "code": "2V2-971-057-F",
        "name": "CHIC MOTOR"
    },
    {
        "code": "2V2-971-057-G",
        "name": "CHIC MOTOR"
    },
    {
        "code": "2V2-971-169-AA",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AB",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-803-877-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-971-169-AH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AJ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AK",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AL",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AM",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AN",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AP",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AQ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-AS",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-803-877-BD",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-971-169-BA",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BB",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BD",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BE",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BF",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BG",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BJ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BK",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-803-877-BN",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-971-169-BL",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BM",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BN",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BP",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BQ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-BR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-CB",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-CC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-CM",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-CN",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-803-877-BQ",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-971-169-CP",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-CQ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-CR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-CS",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-DA",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-DB",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-P",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-Q",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-R",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-169-S",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-803-877-BR",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-971-169-T",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-225-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-225-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-739",
        "name": "CINTA"
    },
    {
        "code": "2V2-971-753",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-753-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-000-013-  -I9A",
        "name": "Cabina"
    },
    {
        "code": "2V3-000-271",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-000-271-A",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-000-271-B",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-803-877-BS",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-000-271-C",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-000-271-D",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-000-451",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-000-547",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-000-547-C",
        "name": "ETIQUETA"
    },
    {
        "code": "2V4-142-109",
        "name": "PARAFUSO"
    },
    {
        "code": "2V4-301-340-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V4-311-280",
        "name": "ARRUELA"
    },
    {
        "code": "2V4-501-091",
        "name": "CARCACA"
    },
    {
        "code": "2V4-501-206",
        "name": "SEMI EIXO"
    },
    {
        "code": "2V5-311-351-B",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2R2-803-877-CN",
        "name": "PARAFUSO"
    },
    {
        "code": "2V4-501-213",
        "name": "PARAFUSO"
    },
    {
        "code": "2V4-501-213-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V4-505-245",
        "name": "PROTETOR"
    },
    {
        "code": "2V4-505-577",
        "name": "suporte"
    },
    {
        "code": "2V5-010-782-T",
        "name": "ETIQUETA"
    },
    {
        "code": "2V5-010-802-R",
        "name": "PLAQUETA"
    },
    {
        "code": "2V5-011-023",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-011-215",
        "name": "suporte"
    },
    {
        "code": "2V5-012-123",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-012-225-B",
        "name": "CHAVE"
    },
    {
        "code": "2R2-803-877-CP",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-012-229",
        "name": "MOLA DISCO"
    },
    {
        "code": "2V5-012-233",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V5-012-239",
        "name": "PINO"
    },
    {
        "code": "2V5-012-239-B",
        "name": "HASTE"
    },
    {
        "code": "2V5-016-209",
        "name": "PLACASUPOR"
    },
    {
        "code": "2V5-016-219",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-035-502-A",
        "name": "ANTENA"
    },
    {
        "code": "2V5-035-551",
        "name": "CONECTOR"
    },
    {
        "code": "2V5-035-623",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-035-849-A",
        "name": "ANTENA"
    },
    {
        "code": "2R2-803-877-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-071-335",
        "name": "porca"
    },
    {
        "code": "2V5-103-232",
        "name": "BOCAL"
    },
    {
        "code": "2V5-103-245",
        "name": "VALVULA"
    },
    {
        "code": "2V5-103-321-A",
        "name": "CAMISA"
    },
    {
        "code": "2V5-103-342-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-103-388",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-103-392-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-103-396",
        "name": "BUCHA"
    },
    {
        "code": "2V5-103-448-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-103-448-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-DB",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-103-448-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-103-448-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-103-448-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-115-467",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-115-467-A",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-115-467-B",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-115-561",
        "name": "ELEM FILTR"
    },
    {
        "code": "2V5-115-645-B",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-115-645-D",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-115-645-E",
        "name": "BRACADEIR"
    },
    {
        "code": "2R2-803-877-DG",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-115-645-F",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-115-661-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-115-685",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-117-189",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-117-273",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V5-121-037-C",
        "name": "CARCACA"
    },
    {
        "code": "2V5-121-050-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-121-050-E",
        "name": "DISTRIBUID"
    },
    {
        "code": "2V5-121-050-F",
        "name": "DISTRIBUID"
    },
    {
        "code": "2V5-121-059-B",
        "name": "ADAPTADOR"
    },
    {
        "code": "2R2-803-877-J",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-121-347-C",
        "name": "EIXO"
    },
    {
        "code": "2V5-121-350-B",
        "name": "EMBREAGEM"
    },
    {
        "code": "2V5-121-359",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-121-367",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-121-375",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-121-523",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V5-121-549-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-121-549-B",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-121-549-C",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-121-549-E",
        "name": "BRACADEIR"
    },
    {
        "code": "2R2-803-877-K",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-121-577",
        "name": "PINO"
    },
    {
        "code": "2V5-121-589",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-130-120-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-130-154",
        "name": "PRISIONEIR"
    },
    {
        "code": "2V5-130-240",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-130-303-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-130-303-B",
        "name": "TUBO"
    },
    {
        "code": "2V5-130-303-C",
        "name": "TUBO"
    },
    {
        "code": "2V5-130-639",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-130-744",
        "name": "BOMBA COMB"
    },
    {
        "code": "2R2-803-877-M",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-130-758",
        "name": "SENSOR"
    },
    {
        "code": "2V5-130-758-A",
        "name": "SENSOR"
    },
    {
        "code": "2V5-130-758-B",
        "name": "SENSOR"
    },
    {
        "code": "2V5-130-758-D",
        "name": "SENSOR"
    },
    {
        "code": "2V5-130-759",
        "name": "BOMBA COMB"
    },
    {
        "code": "2V5-141-109",
        "name": "TAMPA"
    },
    {
        "code": "2V5-141-231",
        "name": "ANEL"
    },
    {
        "code": "2V5-141-250",
        "name": "PRESILHA"
    },
    {
        "code": "2V5-141-250-A",
        "name": "PRESILHA"
    },
    {
        "code": "2V5-141-250-B",
        "name": "PRESILHA"
    },
    {
        "code": "2R2-803-877-Q",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-141-250-C",
        "name": "PRESILHA"
    },
    {
        "code": "2V5-141-327",
        "name": "EIXO"
    },
    {
        "code": "2V5-141-715",
        "name": "LUVA"
    },
    {
        "code": "2V5-142-423",
        "name": "TUBO"
    },
    {
        "code": "2V5-145-117-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-145-299-A",
        "name": "TENSOR"
    },
    {
        "code": "2V5-201-100-C",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-201-136-B",
        "name": "CONECTORES"
    },
    {
        "code": "2V5-201-139",
        "name": "ACOPLAMENT"
    },
    {
        "code": "2V5-201-156-C",
        "name": "VALVULA"
    },
    {
        "code": "2R2-805-324",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-201-156-D",
        "name": "CONECTOR"
    },
    {
        "code": "2V5-201-250",
        "name": "QUADRADA"
    },
    {
        "code": "2V5-201-254",
        "name": "ANEL"
    },
    {
        "code": "2V5-201-289-A",
        "name": "PLACA"
    },
    {
        "code": "2V5-201-351-K",
        "name": "TUBO"
    },
    {
        "code": "2V5-201-581-A",
        "name": "TAMPA"
    },
    {
        "code": "2V5-201-589",
        "name": "COLETOR"
    },
    {
        "code": "2V5-201-923",
        "name": "Placa"
    },
    {
        "code": "2V5-201-939",
        "name": "ANEL"
    },
    {
        "code": "2V5-201-939-B",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-365-B",
        "name": "LUVA"
    },
    {
        "code": "2R2-806-709",
        "name": "TRAVESSA"
    },
    {
        "code": "2V5-201-939-C",
        "name": "ANEL"
    },
    {
        "code": "2V5-251-523",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-253-037-D",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-298-021",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V5-298-054-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V5-301-090-B",
        "name": "PINOCILIND"
    },
    {
        "code": "2V5-301-101-B",
        "name": "CARCACA"
    },
    {
        "code": "2V5-301-141-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V5-301-193-H",
        "name": "ANEL"
    },
    {
        "code": "2V5-301-205",
        "name": "TAMPA"
    },
    {
        "code": "2R2-809-023-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-301-215-B",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-301-431-E",
        "name": "PINO"
    },
    {
        "code": "2V5-301-469",
        "name": "VALVULA"
    },
    {
        "code": "2V5-301-469-B",
        "name": "RESPIRO"
    },
    {
        "code": "2V5-301-580-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-301-685-B",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-301-685-F",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-301-685-G",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-301-729-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-301-807",
        "name": "ROLAMENTO"
    },
    {
        "code": "2R2-809-024-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-311-063",
        "name": "DISCO"
    },
    {
        "code": "2V5-311-063-A",
        "name": "DISCO"
    },
    {
        "code": "2V5-311-109",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-109-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-146",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V5-311-146-C",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-167-A",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V5-311-168",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AP",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AQ",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-809-031-A",
        "name": "painel"
    },
    {
        "code": "2V5-311-230-AR",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AS",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AT",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BA",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-381-Q",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-R",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-S",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-T",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-425",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-311-427-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2R2-809-032-A",
        "name": "painel"
    },
    {
        "code": "2V5-311-427-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-311-499-B",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V5-311-515-A",
        "name": "EIXO"
    },
    {
        "code": "2V5-311-515-C",
        "name": "EIXO"
    },
    {
        "code": "2V5-311-532-F",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-311-532-G",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-311-542-B",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V5-311-542-C",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V5-311-542-F",
        "name": "HASTE"
    },
    {
        "code": "2V5-311-542-G",
        "name": "HASTE"
    },
    {
        "code": "2R2-809-169-E",
        "name": "QUADRO"
    },
    {
        "code": "2V5-311-553",
        "name": "EIXO"
    },
    {
        "code": "2V5-311-553-A",
        "name": "EIXO"
    },
    {
        "code": "2V5-311-553-B",
        "name": "EIXO"
    },
    {
        "code": "2V5-311-585-A",
        "name": "LUVA"
    },
    {
        "code": "2V5-311-585-B",
        "name": "LUVA"
    },
    {
        "code": "2V5-311-613-B",
        "name": "PINO"
    },
    {
        "code": "2V5-311-613-C",
        "name": "PINO"
    },
    {
        "code": "2V5-311-978-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-D",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-E",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-809-169-E -PAC",
        "name": "QUADRO"
    },
    {
        "code": "2V5-311-978-F",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-G",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-H",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-J",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-K",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-L",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-M",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-N",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-115",
        "name": "TAMPA"
    },
    {
        "code": "2V5-407-171",
        "name": "LUVA"
    },
    {
        "code": "2R2-809-170-E",
        "name": "QUADRO"
    },
    {
        "code": "2V5-407-171-A",
        "name": "LUVA"
    },
    {
        "code": "2V5-407-361-A",
        "name": "PINO"
    },
    {
        "code": "2V5-407-443",
        "name": "PINOESFERI"
    },
    {
        "code": "2V5-407-499",
        "name": "TAMPA"
    },
    {
        "code": "2V5-407-617-C",
        "name": "CUBO RODA"
    },
    {
        "code": "2V5-407-635",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-641",
        "name": "ANEL"
    },
    {
        "code": "2V5-409-150",
        "name": "ESTRIBO"
    },
    {
        "code": "2V5-409-213-A",
        "name": "MANCAL"
    },
    {
        "code": "2V5-409-828",
        "name": "ESTRIBO"
    },
    {
        "code": "2R2-809-170-E -PAC",
        "name": "QUADRO"
    },
    {
        "code": "2V5-422-156",
        "name": "BOMBA"
    },
    {
        "code": "2V5-422-156-B",
        "name": "BOMBA"
    },
    {
        "code": "2V5-422-247",
        "name": "BOCAL"
    },
    {
        "code": "2V5-422-250",
        "name": "TUBO"
    },
    {
        "code": "2V5-422-272",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-422-335-G",
        "name": "BARRA DIR"
    },
    {
        "code": "2V5-422-335-M",
        "name": "BARRA DIR"
    },
    {
        "code": "2V5-422-336-C",
        "name": "BRACO"
    },
    {
        "code": "2V5-422-359",
        "name": "TAMPA"
    },
    {
        "code": "2V5-422-409",
        "name": "ANEL"
    },
    {
        "code": "2R2-809-205-A",
        "name": "COLUNA A"
    },
    {
        "code": "2V5-422-417",
        "name": "ANEL"
    },
    {
        "code": "2V5-422-515-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-422-515-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-422-515-C",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-422-515-E",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-422-515-F",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-422-517",
        "name": "conexÆo"
    },
    {
        "code": "2V5-422-553",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-422-567",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-422-705",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-311-365-C",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2R2-809-232",
        "name": "REFORCO"
    },
    {
        "code": "2V5-422-705-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-501-233-A",
        "name": "BOCAL"
    },
    {
        "code": "2V5-501-241",
        "name": "ANEL"
    },
    {
        "code": "2V5-501-249-A",
        "name": "RETENTOR"
    },
    {
        "code": "2V5-501-250-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-501-261-E",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-501-261-F",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-501-299-J",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-501-315",
        "name": "ANEL"
    },
    {
        "code": "2V5-501-317-N",
        "name": "ANEL"
    },
    {
        "code": "2R2-809-274",
        "name": "PLACA"
    },
    {
        "code": "2V5-501-317-P",
        "name": "ANEL"
    },
    {
        "code": "2V5-501-317-Q",
        "name": "ANEL"
    },
    {
        "code": "2V5-511-151-E",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V5-511-151-F",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V5-511-160",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V5-511-163",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-165",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-167",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-169",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-171",
        "name": "LAMINA"
    },
    {
        "code": "2R2-809-559-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-511-173",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-175",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-177",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-179",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-181",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-183",
        "name": "LAMINA"
    },
    {
        "code": "2V5-511-339",
        "name": "PINO"
    },
    {
        "code": "2V5-511-415",
        "name": "MANCAL"
    },
    {
        "code": "2V5-511-417",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-511-441-H",
        "name": "TIRANTE"
    },
    {
        "code": "2R2-809-560-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-512-180-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-512-180-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-512-385-A",
        "name": "MANCAL"
    },
    {
        "code": "2V5-525-267-AB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AD",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AE",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AF",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AG",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AH",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-809-583",
        "name": "PROTECAO"
    },
    {
        "code": "2V5-525-267-AJ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AK",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AL",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AM",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AN",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AP",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AQ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AR",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AS",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AT",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-815-682-  -71N",
        "name": "CANAL AR"
    },
    {
        "code": "2V5-525-267-B",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BA",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BD",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-GF",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-GG",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-H",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-J",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-K",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-815-682-  -82V",
        "name": "CANAL AR"
    },
    {
        "code": "2V5-525-267-L",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-M",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-N",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-P",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-Q",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-R",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-S",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-T",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-284-B",
        "name": "FLANGE"
    },
    {
        "code": "2V5-525-289",
        "name": "CABECOTE"
    },
    {
        "code": "2R2-817-017",
        "name": "TETO"
    },
    {
        "code": "2V5-525-311",
        "name": "BUCHA"
    },
    {
        "code": "2V5-525-343",
        "name": "TAMPA"
    },
    {
        "code": "2V5-525-355-A",
        "name": "EIXO"
    },
    {
        "code": "2V5-525-389-B",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-607-095-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-607-097",
        "name": "TUBO FREIO"
    },
    {
        "code": "2V5-607-098",
        "name": "TUBO FREIO"
    },
    {
        "code": "2V5-607-110",
        "name": "suporte"
    },
    {
        "code": "2V5-607-193",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-607-193-A",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-817-687",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-607-193-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-607-251-AA",
        "name": "RESERVATOR"
    },
    {
        "code": "2V5-607-257-B",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-607-260",
        "name": "VALVULA"
    },
    {
        "code": "2V5-607-299-A",
        "name": "PINO"
    },
    {
        "code": "2V5-607-313-A",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-607-313-AD",
        "name": "ACOPLAMENT"
    },
    {
        "code": "2V5-607-617-C",
        "name": "TAMBOR"
    },
    {
        "code": "2V5-607-787",
        "name": "suporte"
    },
    {
        "code": "2V5-607-815-A",
        "name": "BOCAL"
    },
    {
        "code": "2R2-819-005-A",
        "name": "CAIXA"
    },
    {
        "code": "2V5-607-815-F",
        "name": "TAMPA"
    },
    {
        "code": "2V5-607-815-G",
        "name": "BOCAL"
    },
    {
        "code": "2V5-607-862-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V5-607-891-AG",
        "name": "suporte"
    },
    {
        "code": "2V5-607-891-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-607-891-L",
        "name": "PLACA"
    },
    {
        "code": "2V5-607-891-S",
        "name": "suporte"
    },
    {
        "code": "2V5-609-163-C",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-611-190",
        "name": "BOCAL"
    },
    {
        "code": "2V5-611-231",
        "name": "PC PRESSAO"
    },
    {
        "code": "2V5-311-365-D",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2R2-819-005-B",
        "name": "CAIXA"
    },
    {
        "code": "2V5-611-320-A",
        "name": "suporte"
    },
    {
        "code": "2V5-611-335",
        "name": "PEC VEDAC"
    },
    {
        "code": "2V5-611-403-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-611-430",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-611-430-B",
        "name": "CONECTOR"
    },
    {
        "code": "2V5-611-430-D",
        "name": "LUVA"
    },
    {
        "code": "2V5-611-555-C",
        "name": "valvula"
    },
    {
        "code": "2V5-611-555-D",
        "name": "valvula"
    },
    {
        "code": "2V5-611-671-B",
        "name": "suporte"
    },
    {
        "code": "2V5-611-757",
        "name": "suporte"
    },
    {
        "code": "2R2-819-201-B -1NN",
        "name": "DIFUSOR AR"
    },
    {
        "code": "2V5-611-758",
        "name": "suporte"
    },
    {
        "code": "2V5-611-793",
        "name": "suporte"
    },
    {
        "code": "2V5-611-797",
        "name": "suporte"
    },
    {
        "code": "2V5-611-797-A",
        "name": "suporte"
    },
    {
        "code": "2V5-614-775-C",
        "name": "HASTE"
    },
    {
        "code": "2V5-615-157",
        "name": "PINO"
    },
    {
        "code": "2V5-615-329",
        "name": "CAMARA DO"
    },
    {
        "code": "2V5-615-331-E",
        "name": "CAMARA DO"
    },
    {
        "code": "2V5-615-332-E",
        "name": "CAMARA DO"
    },
    {
        "code": "2V5-616-847-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2R2-819-201-B -9B9",
        "name": "DIFUSOR AR"
    },
    {
        "code": "2V5-616-848",
        "name": "BASE"
    },
    {
        "code": "2V5-701-487-A",
        "name": "APOIO"
    },
    {
        "code": "2V5-701-487-C",
        "name": "CONSOLE"
    },
    {
        "code": "2V5-701-799-A",
        "name": "MANCALBORR"
    },
    {
        "code": "2V5-701-865-B",
        "name": "DISCO"
    },
    {
        "code": "2V5-705-583",
        "name": "suporte"
    },
    {
        "code": "2V5-711-277",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-711-371",
        "name": "JG.PARAFUS"
    },
    {
        "code": "2V5-711-575",
        "name": "BARRA"
    },
    {
        "code": "2V5-721-021-A",
        "name": "CILINDRO"
    },
    {
        "code": "2R2-819-202-B -1NN",
        "name": "DIFUSOR AR"
    },
    {
        "code": "2V5-721-205",
        "name": "HASTE"
    },
    {
        "code": "2V5-803-186-G",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-803-301",
        "name": "TRAVESSA"
    },
    {
        "code": "2V5-803-325-A",
        "name": "PLACA"
    },
    {
        "code": "2V5-803-377",
        "name": "porca"
    },
    {
        "code": "2V5-803-577",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-579-A",
        "name": "suporte"
    },
    {
        "code": "2V5-803-583",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-803-583-A",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-803-583-F",
        "name": "TAMPAO"
    },
    {
        "code": "2R2-819-202-B -9B9",
        "name": "DIFUSOR AR"
    },
    {
        "code": "2V5-803-583-G",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-803-646-B",
        "name": "CHAPA"
    },
    {
        "code": "2V5-803-724",
        "name": "TAMPA"
    },
    {
        "code": "2V5-803-724-A",
        "name": "TAMPA"
    },
    {
        "code": "2V5-803-875-AA",
        "name": "porca"
    },
    {
        "code": "2V5-803-875-AD",
        "name": "porca"
    },
    {
        "code": "2V5-803-875-AF",
        "name": "porca"
    },
    {
        "code": "2V5-803-875-AH",
        "name": "porca"
    },
    {
        "code": "2V5-803-875-AL",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-875-AM",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-819-240",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-803-877-AQ",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AT",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-BE",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-BK",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-BL",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-BM",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-BN",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-BQ",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-BR",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-BT",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-819-241",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-803-877-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CA",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CC",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-GA",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-GB",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-GE",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-GH",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-GJ",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-GL",
        "name": "REBITE"
    },
    {
        "code": "2R2-819-703-  -999",
        "name": "DIFUSOR AR"
    },
    {
        "code": "2V5-803-877-HC",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-HD",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-HF",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-HG",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-HL",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-J",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-878-P",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-803-878-Q",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-803-878-S",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-804-111",
        "name": "CHAPA"
    },
    {
        "code": "2R2-819-704-  -999",
        "name": "DIFUSOR AR"
    },
    {
        "code": "2V5-804-195",
        "name": "GUIA"
    },
    {
        "code": "2V5-804-591-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-804-879",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-804-880",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-804-883-B",
        "name": "PLACA"
    },
    {
        "code": "2V5-804-889",
        "name": "DISCO"
    },
    {
        "code": "2V5-804-889-B",
        "name": "DISCO"
    },
    {
        "code": "2V5-804-942",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-804-949",
        "name": "FIXADOR"
    },
    {
        "code": "2V5-804-960",
        "name": "TRAVA"
    },
    {
        "code": "2R2-819-707-  -999",
        "name": "PECA CONEX"
    },
    {
        "code": "2V5-804-966",
        "name": "TUBO"
    },
    {
        "code": "2V5-804-966-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-805-027",
        "name": "PAINEL"
    },
    {
        "code": "2V5-805-095-A",
        "name": "TRAVESSA"
    },
    {
        "code": "2V5-805-111",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-807-889-B",
        "name": "PORCA"
    },
    {
        "code": "2V5-809-024",
        "name": "QUADRO"
    },
    {
        "code": "2V5-809-039",
        "name": "PAINEL"
    },
    {
        "code": "2V5-809-040",
        "name": "PAINEL"
    },
    {
        "code": "2V5-809-051",
        "name": "COLUNA A"
    },
    {
        "code": "2V3-321-476",
        "name": "chaveta"
    },
    {
        "code": "2V5-311-365-E",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2R2-820-005-A",
        "name": "CAIXA"
    },
    {
        "code": "2V5-809-052",
        "name": "COLUNA A"
    },
    {
        "code": "2V5-809-055-C",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-809-056",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-809-056-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-809-071",
        "name": "REFORCO"
    },
    {
        "code": "2V5-809-231-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-809-231-B",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-809-231-C",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-809-232",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-809-265",
        "name": "PLACAROSCA"
    },
    {
        "code": "2R2-820-005-C",
        "name": "CAIXA"
    },
    {
        "code": "2V5-809-265-A",
        "name": "PLACAROSCA"
    },
    {
        "code": "2V5-809-265-B",
        "name": "PLACAROSCA"
    },
    {
        "code": "2V5-819-259-B",
        "name": "suporte"
    },
    {
        "code": "2V5-819-465-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-819-501-A",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-502-A",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-555-A",
        "name": "VALVULA"
    },
    {
        "code": "2V5-819-609",
        "name": "ESTRIBO"
    },
    {
        "code": "2V5-819-639-B",
        "name": "TAMPA"
    },
    {
        "code": "2V5-819-670",
        "name": "MOLDURA"
    },
    {
        "code": "2R2-820-013",
        "name": "EVAPORADOR"
    },
    {
        "code": "2V5-819-691",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-691-A",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-692",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-692-A",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V5-819-707",
        "name": "PECA CONEX"
    },
    {
        "code": "2V5-819-867",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-820-102-A",
        "name": "EVAPORADOR"
    },
    {
        "code": "2V5-820-115-F",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V5-820-115-G",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V5-820-115-J",
        "name": "ANEL"
    },
    {
        "code": "2R2-820-071",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-820-145",
        "name": "ALAVANCA"
    },
    {
        "code": "2V5-820-181-A",
        "name": "VALVULA"
    },
    {
        "code": "2V5-820-197-B",
        "name": "suporte"
    },
    {
        "code": "2V5-820-197-C",
        "name": "suporte"
    },
    {
        "code": "2V5-820-199",
        "name": "PRESILHA"
    },
    {
        "code": "2V5-821-173-A",
        "name": "PARA BARRO"
    },
    {
        "code": "2V5-821-175-E",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-821-175-G",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-821-176-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-821-176-D",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-820-504",
        "name": "MOTOR"
    },
    {
        "code": "2V5-821-176-E",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-821-176-F",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-821-213",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-821-213-C",
        "name": "PORCA"
    },
    {
        "code": "2V5-821-213-D",
        "name": "PORCA"
    },
    {
        "code": "2V5-821-311",
        "name": "ALOJAMENTO"
    },
    {
        "code": "2V5-821-653-A",
        "name": "CAPA"
    },
    {
        "code": "2V5-837-297",
        "name": "HASTE"
    },
    {
        "code": "2V5-837-311",
        "name": "BATENTE"
    },
    {
        "code": "2V5-837-319",
        "name": "GRAMPO"
    },
    {
        "code": "2R2-820-647",
        "name": "TAMPA"
    },
    {
        "code": "2V5-837-399",
        "name": "MECANISMO"
    },
    {
        "code": "2V5-837-399-A",
        "name": "motor"
    },
    {
        "code": "2V5-837-400",
        "name": "MECANISMO"
    },
    {
        "code": "2V5-837-571",
        "name": "TRILHO"
    },
    {
        "code": "2V5-837-571-A",
        "name": "TRILHO"
    },
    {
        "code": "2V5-837-572-B",
        "name": "TRILHO"
    },
    {
        "code": "2V5-837-572-C",
        "name": "TRILHO"
    },
    {
        "code": "2V5-837-577",
        "name": "GUIA"
    },
    {
        "code": "2V5-837-621",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-837-621-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-820-653",
        "name": "TUBO"
    },
    {
        "code": "2V5-837-621-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-837-646-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-837-713-A",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-837-722",
        "name": "CAPA"
    },
    {
        "code": "2V5-837-735-A",
        "name": "PC.ISOLANT"
    },
    {
        "code": "2V5-837-736-A",
        "name": "PC.ISOLANT"
    },
    {
        "code": "2V5-837-911",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-839-267",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-839-268",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-841-063",
        "name": "BUCHA"
    },
    {
        "code": "2R2-820-679",
        "name": "VALVULA"
    },
    {
        "code": "2V5-845-121-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-845-149",
        "name": "CANALETA"
    },
    {
        "code": "2V5-845-149-C",
        "name": "QUADRO"
    },
    {
        "code": "2V5-845-149-D",
        "name": "CANALETA"
    },
    {
        "code": "2V5-845-150",
        "name": "CANALETA"
    },
    {
        "code": "2V5-845-327",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-845-342",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-845-353",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-845-353-J",
        "name": "PAST VEDAC"
    },
    {
        "code": "2V5-857-006-B",
        "name": "REVESTIMEN"
    },
    {
        "code": "2R2-820-741-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-857-007-A",
        "name": "PORTAOBJ"
    },
    {
        "code": "2V5-857-007-H",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-857-007-K",
        "name": "PAINEL"
    },
    {
        "code": "2V5-857-019-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-037",
        "name": "TAMPA"
    },
    {
        "code": "2V5-857-057",
        "name": "TAMPA"
    },
    {
        "code": "2V5-857-085",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-085-B",
        "name": "TAMPA"
    },
    {
        "code": "2V5-857-086",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-086-A",
        "name": "TAMPA"
    },
    {
        "code": "2R2-820-761",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V5-857-101-C",
        "name": "TAPETE"
    },
    {
        "code": "2V5-857-108",
        "name": "PECAINTERM"
    },
    {
        "code": "2V5-857-109",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-110",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-115-B",
        "name": "ISOLANTE"
    },
    {
        "code": "2V5-857-115-D",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-142",
        "name": "GAVETA"
    },
    {
        "code": "2V5-857-152-B",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-857-781-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-815-A",
        "name": "CINTO 3 PT"
    },
    {
        "code": "2V5-311-365-F",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2R2-823-506",
        "name": "TRAVA"
    },
    {
        "code": "2V5-857-820",
        "name": "REGULADOR"
    },
    {
        "code": "2V5-857-922-B",
        "name": "PORTA OBJE"
    },
    {
        "code": "2V5-857-922-C",
        "name": "PORTA OBJE"
    },
    {
        "code": "2V5-857-923",
        "name": "CONSOLE TE"
    },
    {
        "code": "2V5-857-923-B",
        "name": "CONSOLE TE"
    },
    {
        "code": "2V5-857-924",
        "name": "CONSOLE TE"
    },
    {
        "code": "2V5-857-966-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-857-995",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-857-996",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-858-039-A",
        "name": "PAINEL"
    },
    {
        "code": "2R2-823-507",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-858-045-B",
        "name": "PAINEL"
    },
    {
        "code": "2V5-858-063-B",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-858-079",
        "name": "ALOJAMENTO"
    },
    {
        "code": "2V5-858-081",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-858-137",
        "name": "PRESILHA"
    },
    {
        "code": "2V5-858-151",
        "name": "PLACA FECH"
    },
    {
        "code": "2V5-858-153",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-858-153-A",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-858-153-B",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-858-153-C",
        "name": "DEFLETOR"
    },
    {
        "code": "2R2-823-531",
        "name": "CABO CLIP"
    },
    {
        "code": "2V5-858-157-A",
        "name": "MANOPLA"
    },
    {
        "code": "2V5-858-169",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-858-178",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-858-179",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-858-193",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-858-193-A",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-858-193-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V5-858-194",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-858-217-A",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-858-218",
        "name": "painel"
    },
    {
        "code": "2R2-823-531-A",
        "name": "CABO CLIP"
    },
    {
        "code": "2V5-858-262",
        "name": "CHAPA"
    },
    {
        "code": "2V5-858-262-A",
        "name": "TAPETE"
    },
    {
        "code": "2V5-858-274",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-858-274-B",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V5-858-274-C",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V5-858-283",
        "name": "suporte"
    },
    {
        "code": "2V5-858-284",
        "name": "suporte"
    },
    {
        "code": "2V5-858-301-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-860-173",
        "name": "PORCA"
    },
    {
        "code": "2V5-860-335",
        "name": "HASTE"
    },
    {
        "code": "2R2-823-531-D",
        "name": "CABO CLIP"
    },
    {
        "code": "2V5-860-337-A",
        "name": "HASTE"
    },
    {
        "code": "2V5-861-151-E",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-861-151-F",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-861-225",
        "name": "PROTETOR"
    },
    {
        "code": "2V5-861-226",
        "name": "PROTETOR"
    },
    {
        "code": "2V5-861-339",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-861-340-A",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-861-343-A",
        "name": "FRISOTETO"
    },
    {
        "code": "2V5-861-344-A",
        "name": "FRISOTETO"
    },
    {
        "code": "2V5-861-351",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-823-593",
        "name": "MANOPLA"
    },
    {
        "code": "2V5-861-395-A",
        "name": "FRISOTETO"
    },
    {
        "code": "2V5-861-525",
        "name": "TRILHO"
    },
    {
        "code": "2V5-861-589",
        "name": "TRILHO"
    },
    {
        "code": "2V5-861-590",
        "name": "TRILHO"
    },
    {
        "code": "2V5-867-034-D",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-034-E",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-141",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-867-157-A",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-867-158",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-867-161",
        "name": "PUXADOR"
    },
    {
        "code": "2R2-831-111-B -PAC",
        "name": "CHAPA EXT."
    },
    {
        "code": "2V5-867-162",
        "name": "PUXADOR"
    },
    {
        "code": "2V5-867-171-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-867-192",
        "name": "MOLDURA"
    },
    {
        "code": "2V5-867-235",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-867-243-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-867-244-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-867-276-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-867-283",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-867-360-A",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-360-C",
        "name": "REVESTIMEN"
    },
    {
        "code": "2R2-831-112-A",
        "name": "CHAPA EXT."
    },
    {
        "code": "2V5-867-360-D",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-361-C",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-867-361-D",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-881-478-B",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-881-478-C",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-881-479-C",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-881-479-D",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-881-479-E",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-881-545-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-881-545-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-831-112-A -PAC",
        "name": "CHAPA EXT."
    },
    {
        "code": "2V5-881-545-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-881-545-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-881-557",
        "name": "JG.MANGUEI"
    },
    {
        "code": "2V5-885-161",
        "name": "DOBRADICA"
    },
    {
        "code": "2V5-885-711",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-903-141-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-903-142",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-903-144",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-903-152-A",
        "name": "PORCA"
    },
    {
        "code": "2V5-903-152-B",
        "name": "PORCA"
    },
    {
        "code": "2R2-831-112-B -PAC",
        "name": "CHAPA EXT."
    },
    {
        "code": "2V5-903-252",
        "name": "APERTO"
    },
    {
        "code": "2V5-903-260-B",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-910-468-B",
        "name": "UNIDADE"
    },
    {
        "code": "2V5-911-256",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-911-287",
        "name": "SOLENOIDE"
    },
    {
        "code": "2V5-911-303-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-911-303-B",
        "name": "EIXO"
    },
    {
        "code": "2V5-911-309-A",
        "name": "REDUTOR"
    },
    {
        "code": "2V5-919-457-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-919-689",
        "name": "RECEPTACUL"
    },
    {
        "code": "2V5-311-375",
        "name": "GAIOLA"
    },
    {
        "code": "2R2-831-119",
        "name": "REFORCO"
    },
    {
        "code": "2V5-919-689-A",
        "name": "RECEPTACUL"
    },
    {
        "code": "2V5-927-341",
        "name": "BOTAO"
    },
    {
        "code": "2V5-927-748-F",
        "name": "SENSOR"
    },
    {
        "code": "2V5-927-748-G",
        "name": "SENSOR"
    },
    {
        "code": "2V5-927-801-A",
        "name": "SENSOR"
    },
    {
        "code": "2V5-927-801-B",
        "name": "SENSOR"
    },
    {
        "code": "2V5-937-031",
        "name": "suporte"
    },
    {
        "code": "2V5-937-031-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-937-035",
        "name": "CENTRAL EL"
    },
    {
        "code": "2V5-937-035-A",
        "name": "PORTA RELE"
    },
    {
        "code": "2R2-831-401",
        "name": "DOBRADICA"
    },
    {
        "code": "2V5-941-125",
        "name": "MOLA RETEN"
    },
    {
        "code": "2V5-941-273",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-941-333",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-941-341",
        "name": "SOQUETE"
    },
    {
        "code": "2V5-941-555",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-941-555-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-941-569",
        "name": "TAMPA"
    },
    {
        "code": "2V5-941-569-A",
        "name": "TAMPA"
    },
    {
        "code": "2V5-941-809",
        "name": "TAMPA"
    },
    {
        "code": "2V5-941-925",
        "name": "GRAMPO"
    },
    {
        "code": "2R2-831-402",
        "name": "DOBRADICA"
    },
    {
        "code": "2V5-945-055",
        "name": "MANCALBORR"
    },
    {
        "code": "2V5-945-089",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-945-095",
        "name": "CARCACA"
    },
    {
        "code": "2V5-945-095-B",
        "name": "LANTERNA"
    },
    {
        "code": "2V5-945-095-D",
        "name": "LANTERNA"
    },
    {
        "code": "2V5-955-491",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-955-776-A",
        "name": "suporte"
    },
    {
        "code": "2V5-955-993",
        "name": "PECA"
    },
    {
        "code": "2V5-957-817",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-959-263",
        "name": "RELE"
    },
    {
        "code": "2R2-831-721",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-959-483",
        "name": "INTERRUPT."
    },
    {
        "code": "2V5-959-567",
        "name": "PINO ROSCA"
    },
    {
        "code": "2V5-959-577",
        "name": "UNIDADE"
    },
    {
        "code": "2V5-959-577-A",
        "name": "UNIDADE"
    },
    {
        "code": "2V5-959-802",
        "name": "motor"
    },
    {
        "code": "2V5-959-845",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V5-959-858-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-962-125",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-971-531-M",
        "name": "CHICOTE"
    },
    {
        "code": "2V5-971-615",
        "name": "BRACADEIR"
    },
    {
        "code": "2R2-837-013",
        "name": "FECHADURA"
    },
    {
        "code": "2V5-971-796",
        "name": "suporte"
    },
    {
        "code": "2V5-972-489",
        "name": "PLACA"
    },
    {
        "code": "2V5-998-754-A",
        "name": "JG.GRAMPO"
    },
    {
        "code": "2V5-998-761",
        "name": "JG.PECAS"
    },
    {
        "code": "2VB-863-708",
        "name": "PC.ISOLANT"
    },
    {
        "code": "2VC-011-107",
        "name": "SUPORTE"
    },
    {
        "code": "2VC-607-375",
        "name": "CONEXAO"
    },
    {
        "code": "2VC-608-715",
        "name": "CONECTOR"
    },
    {
        "code": "2VC-608-715-A",
        "name": "conexÆo"
    },
    {
        "code": "2VC-608-717",
        "name": "conexÆo"
    },
    {
        "code": "2R2-837-014",
        "name": "FECHADURA"
    },
    {
        "code": "2VC-608-717-B",
        "name": "conexÆo"
    },
    {
        "code": "2VC-608-719",
        "name": "CONEXAO"
    },
    {
        "code": "2VC-608-719-B",
        "name": "conexÆo"
    },
    {
        "code": "2VC-608-719-D",
        "name": "CONECTOR"
    },
    {
        "code": "2VC-608-727",
        "name": "ADAPTADOR"
    },
    {
        "code": "2VC-608-727-A",
        "name": "ADAPTADOR"
    },
    {
        "code": "2VC-608-727-B",
        "name": "ADAPTADOR"
    },
    {
        "code": "2VC-608-743-B",
        "name": "CONEXAO"
    },
    {
        "code": "2VC-608-749",
        "name": "CONECTOR"
    },
    {
        "code": "2VC-608-785",
        "name": "TUBO"
    },
    {
        "code": "2R2-837-015",
        "name": "FECHADURA"
    },
    {
        "code": "2VC-608-793",
        "name": "ANEL"
    },
    {
        "code": "2VC-608-795",
        "name": "ANEL"
    },
    {
        "code": "2VC-608-797-A",
        "name": "ANEL"
    },
    {
        "code": "2VC-608-797-B",
        "name": "ANEL"
    },
    {
        "code": "2VC-857-998",
        "name": "PARAFUSO"
    },
    {
        "code": "2VE-607-065",
        "name": "PARAFUSO"
    },
    {
        "code": "2VF-607-161",
        "name": "ANEL"
    },
    {
        "code": "2VF-607-161-A",
        "name": "ANEL"
    },
    {
        "code": "2VF-607-161-B",
        "name": "ANEL"
    },
    {
        "code": "2VF-607-312-B",
        "name": "TUBO"
    },
    {
        "code": "2R2-837-016",
        "name": "FECHADURA"
    },
    {
        "code": "2VF-607-591-A",
        "name": "COTOVELO"
    },
    {
        "code": "2VF-607-761",
        "name": "CONEXAO"
    },
    {
        "code": "2VF-607-761-B",
        "name": "conexÆo"
    },
    {
        "code": "2VF-607-789",
        "name": "PORCA"
    },
    {
        "code": "2VF-607-789-A",
        "name": "PORCA"
    },
    {
        "code": "2VF-607-789-B",
        "name": "PORCA"
    },
    {
        "code": "2VF-899-129",
        "name": "PARAFUSO"
    },
    {
        "code": "2VF-915-415",
        "name": "PORCA"
    },
    {
        "code": "2VF-971-235",
        "name": "CABO MASSA"
    },
    {
        "code": "2VG-411-765",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-837-115-B -71N",
        "name": "MACANETA"
    },
    {
        "code": "2VK-499-071-A",
        "name": "PORCA"
    },
    {
        "code": "2VK-601-027-B",
        "name": "RODA"
    },
    {
        "code": "2VK-601-027-B -Z31",
        "name": "RODA"
    },
    {
        "code": "2VQ-607-359",
        "name": "VALVULA"
    },
    {
        "code": "2VR-115-471",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-130-120-B",
        "name": "ANEL"
    },
    {
        "code": "07W-130-141-B",
        "name": "GRAMPO"
    },
    {
        "code": "2VT-525-187",
        "name": "FRICCAO"
    },
    {
        "code": "2VV-411-159",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-121-425-B",
        "name": "COXIM"
    },
    {
        "code": "2R2-837-194-A",
        "name": "haste"
    },
    {
        "code": "2W0-301-141",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2W0-301-141-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2W0-301-340",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-301-340-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-301-340-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-301-505",
        "name": "porca"
    },
    {
        "code": "2W0-311-478",
        "name": "IMPULSOR"
    },
    {
        "code": "2W0-401-055",
        "name": "CORPO EIXO"
    },
    {
        "code": "2W0-401-161",
        "name": "ENGRAXADEI"
    },
    {
        "code": "2W0-407-361",
        "name": "PINO"
    },
    {
        "code": "2V5-311-375-A",
        "name": "BUCHA"
    },
    {
        "code": "2R2-837-195",
        "name": "HASTE"
    },
    {
        "code": "2W0-407-361-A",
        "name": "PINO"
    },
    {
        "code": "2W0-407-393",
        "name": "ROLAMENTO"
    },
    {
        "code": "2W0-411-129-B",
        "name": "ESTRIBO"
    },
    {
        "code": "2W0-422-817",
        "name": "TERMINAL"
    },
    {
        "code": "2W0-501-299",
        "name": "PORCA"
    },
    {
        "code": "2W0-511-157",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-511-417",
        "name": "BRACADEIRA"
    },
    {
        "code": "2W0-601-273",
        "name": "ANEL"
    },
    {
        "code": "2W0-601-295",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-601-363",
        "name": "VALVULA"
    },
    {
        "code": "2R2-837-199",
        "name": "CLIP"
    },
    {
        "code": "2W0-607-315-C",
        "name": "PECAJUNCAO"
    },
    {
        "code": "2W0-607-367",
        "name": "CONEXAO"
    },
    {
        "code": "2W0-609-125",
        "name": "SUP FREIO"
    },
    {
        "code": "2W0-609-457",
        "name": "MECANISMO"
    },
    {
        "code": "2W0-609-457-A",
        "name": "MECANISMO"
    },
    {
        "code": "2W0-611-778-B",
        "name": "PRESILHA"
    },
    {
        "code": "2W0-611-778-C",
        "name": "PRESILHA"
    },
    {
        "code": "2W0-611-909-B",
        "name": "COTOVELO"
    },
    {
        "code": "2W0-615-437",
        "name": "ANEL"
    },
    {
        "code": "2W0-698-431",
        "name": "JG. LONA"
    },
    {
        "code": "2R2-837-205",
        "name": "MACANETA"
    },
    {
        "code": "2W0-698-431-A",
        "name": "JG. LONA"
    },
    {
        "code": "2W0-703-529-AE",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-AM",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-AP",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-E",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-F",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-K",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-L",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-N",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-T",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-837-205-A",
        "name": "MACANETA"
    },
    {
        "code": "2W0-905-121",
        "name": "BRACADEIR"
    },
    {
        "code": "2W0-905-121-A",
        "name": "PRESILHA"
    },
    {
        "code": "2W0-905-121-B",
        "name": "CINTATENSO"
    },
    {
        "code": "2Z0-000-451-C",
        "name": "ETIQUETA"
    },
    {
        "code": "2Z0-100-759-C",
        "name": "COMPRESSOR"
    },
    {
        "code": "2Z0-103-113",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2Z0-103-115",
        "name": "DRENO"
    },
    {
        "code": "2Z0-103-182",
        "name": "TAMPA"
    },
    {
        "code": "2Z0-103-196",
        "name": "ANEL"
    },
    {
        "code": "2Z0-103-213",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-837-206",
        "name": "MACANETA"
    },
    {
        "code": "2Z0-103-383",
        "name": "JUNTA CABE"
    },
    {
        "code": "2Z0-103-448-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-103-448-E",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-103-448-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-103-448-H",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-105-385",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-105-401",
        "name": "BIELA"
    },
    {
        "code": "2Z0-105-401-B",
        "name": "BIELA"
    },
    {
        "code": "2Z0-105-701",
        "name": "CASQUILHO"
    },
    {
        "code": "2Z0-109-115-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2R2-837-297",
        "name": "HASTE"
    },
    {
        "code": "2Z0-109-157",
        "name": "CARCACA"
    },
    {
        "code": "2Z0-109-163",
        "name": "ANEL"
    },
    {
        "code": "2Z0-109-177",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-109-177-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-109-183",
        "name": "suporte"
    },
    {
        "code": "2Z0-109-224",
        "name": "PINO"
    },
    {
        "code": "2Z0-109-447",
        "name": "BALANCIM"
    },
    {
        "code": "2Z0-109-641",
        "name": "PRATO MOLA"
    },
    {
        "code": "2Z0-109-641-A",
        "name": "PRATO MOLA"
    },
    {
        "code": "2Z0-109-659",
        "name": "CRUZETA"
    },
    {
        "code": "2R2-837-298",
        "name": "HASTE"
    },
    {
        "code": "2Z0-109-659-A",
        "name": "CRUZETA"
    },
    {
        "code": "2Z0-109-659-B",
        "name": "ALAVANCA"
    },
    {
        "code": "2Z0-115-283",
        "name": "ARRUELA"
    },
    {
        "code": "2Z0-115-283-A",
        "name": "ARRUELA"
    },
    {
        "code": "2Z0-121-135",
        "name": "TUBO"
    },
    {
        "code": "2Z0-121-179",
        "name": "CONEXAO"
    },
    {
        "code": "2Z0-121-179-A",
        "name": "TUBO"
    },
    {
        "code": "2Z0-127-250-A",
        "name": "GRAMPO"
    },
    {
        "code": "2Z0-127-250-B",
        "name": "GRAMPO"
    },
    {
        "code": "2Z0-129-142",
        "name": "BRACADEIR"
    },
    {
        "code": "2R2-837-311",
        "name": "batente"
    },
    {
        "code": "2Z0-129-285",
        "name": "ARRUELA"
    },
    {
        "code": "2Z0-130-200",
        "name": "GRAMPO"
    },
    {
        "code": "2Z0-130-201",
        "name": "BICO INJET"
    },
    {
        "code": "2Z0-130-201-A",
        "name": "BICO INJET"
    },
    {
        "code": "2Z0-130-201-AX",
        "name": "BICO INJET"
    },
    {
        "code": "2Z0-130-229",
        "name": "porca"
    },
    {
        "code": "2Z0-130-305",
        "name": "TUBO"
    },
    {
        "code": "2Z0-130-311",
        "name": "TUBO"
    },
    {
        "code": "2Z0-130-319-C",
        "name": "SUPORTE"
    },
    {
        "code": "2Z0-130-319-D",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-837-359",
        "name": "PRESILHA"
    },
    {
        "code": "2Z0-130-319-E",
        "name": "suporte"
    },
    {
        "code": "2Z0-130-349",
        "name": "CONECTOR C"
    },
    {
        "code": "2Z0-130-349-A",
        "name": "CONECTOR C"
    },
    {
        "code": "2Z0-130-421",
        "name": "BRACADEIRA"
    },
    {
        "code": "2Z0-130-431",
        "name": "PRESILHA"
    },
    {
        "code": "2Z0-130-431-A",
        "name": "PRESILHA"
    },
    {
        "code": "2Z0-130-659",
        "name": "ANEL"
    },
    {
        "code": "2Z0-130-801",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-131-063",
        "name": "VALVULA"
    },
    {
        "code": "2Z0-131-121",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-837-360",
        "name": "PRESILHA"
    },
    {
        "code": "2Z0-145-129",
        "name": "suporte"
    },
    {
        "code": "2Z0-145-877",
        "name": "CONECTOR"
    },
    {
        "code": "2Z0-145-877-A",
        "name": "CONECTOR"
    },
    {
        "code": "2Z0-198-011-A",
        "name": "JG.VEDACAO"
    },
    {
        "code": "2Z0-198-012",
        "name": "JG.VEDACAO"
    },
    {
        "code": "2Z0-198-012-A",
        "name": "JG.VEDACAO"
    },
    {
        "code": "2Z0-198-065",
        "name": "PISTAO"
    },
    {
        "code": "2Z0-198-065-A",
        "name": "PISTAO"
    },
    {
        "code": "2Z0-198-151",
        "name": "JG. ANEL"
    },
    {
        "code": "2Z0-198-151-A",
        "name": "JG. ANEL"
    },
    {
        "code": "2V5-311-381",
        "name": "ANEL"
    },
    {
        "code": "2R2-837-360-A",
        "name": "PRESILHA"
    },
    {
        "code": "2Z0-198-151-B",
        "name": "JG. ANEL"
    },
    {
        "code": "2Z0-198-156",
        "name": "JG.PECAS"
    },
    {
        "code": "2Z0-198-156-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2Z0-201-146-A",
        "name": "VALVULA"
    },
    {
        "code": "2Z0-201-156-C",
        "name": "CONECTOR"
    },
    {
        "code": "2Z0-201-551",
        "name": "TAMPA"
    },
    {
        "code": "2Z0-411-324",
        "name": "MANCAL"
    },
    {
        "code": "2Z0-422-319",
        "name": "PORCA"
    },
    {
        "code": "2Z0-422-705",
        "name": "BRACADEIRA"
    },
    {
        "code": "2Z0-501-213",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-837-397",
        "name": "ACIONAMETO"
    },
    {
        "code": "2Z0-501-213-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-501-213-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-501-249",
        "name": "CAPA VEDAC"
    },
    {
        "code": "2Z0-501-615-E",
        "name": "TAMBOR"
    },
    {
        "code": "2Z0-501-653-A",
        "name": "CUBO RODA"
    },
    {
        "code": "2Z0-513-371",
        "name": "BUCHA"
    },
    {
        "code": "2Z0-601-183",
        "name": "PESO BALAN"
    },
    {
        "code": "2Z0-601-295",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-601-295-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-601-295-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-837-708",
        "name": "MANGUEIRA"
    },
    {
        "code": "2Z0-607-091-B",
        "name": "CAPA"
    },
    {
        "code": "2Z0-607-262-B",
        "name": "UNIDADE"
    },
    {
        "code": "2Z0-607-367-A",
        "name": "CONECTOR"
    },
    {
        "code": "2Z0-607-367-E",
        "name": "TUBO"
    },
    {
        "code": "2Z0-607-415",
        "name": "CINTA"
    },
    {
        "code": "2Z0-607-415-A",
        "name": "CINTA"
    },
    {
        "code": "2Z0-607-775",
        "name": "TUBO"
    },
    {
        "code": "2Z0-609-759",
        "name": "PRATO MOLA"
    },
    {
        "code": "2Z0-611-105",
        "name": "EIXO"
    },
    {
        "code": "2Z0-611-113",
        "name": "CARCACA"
    },
    {
        "code": "2R2-837-723",
        "name": "MOLA"
    },
    {
        "code": "2Z0-611-227",
        "name": "PORCA"
    },
    {
        "code": "2Z0-611-229-A",
        "name": "BATENTE"
    },
    {
        "code": "2Z0-611-229-B",
        "name": "BATENTE"
    },
    {
        "code": "2Z0-611-243",
        "name": "ANEL"
    },
    {
        "code": "2Z0-611-249",
        "name": "ANEL"
    },
    {
        "code": "2Z0-611-345",
        "name": "CAPA"
    },
    {
        "code": "2Z0-611-357",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2Z0-611-359",
        "name": "MANGUEIRA"
    },
    {
        "code": "2Z0-611-389",
        "name": "PISTAO"
    },
    {
        "code": "2Z0-611-441",
        "name": "MEMBRANA"
    },
    {
        "code": "2R2-837-724",
        "name": "MOLA"
    },
    {
        "code": "2Z0-611-767",
        "name": "SUPORTE"
    },
    {
        "code": "2Z0-611-941",
        "name": "ELEMENTO"
    },
    {
        "code": "2Z0-611-941-G",
        "name": "ELEMENTO"
    },
    {
        "code": "2Z0-612-405",
        "name": "suporte"
    },
    {
        "code": "2Z0-612-406",
        "name": "suporte"
    },
    {
        "code": "2Z0-616-227",
        "name": "BUCHA"
    },
    {
        "code": "2Z0-616-787",
        "name": "FILTRO AR"
    },
    {
        "code": "2Z0-616-873",
        "name": "ARRUELA"
    },
    {
        "code": "2Z0-703-529",
        "name": "ARRUELA"
    },
    {
        "code": "2Z0-711-940",
        "name": "CLIP"
    },
    {
        "code": "2R2-843-423",
        "name": "ROLETE"
    },
    {
        "code": "2Z0-903-015-G",
        "name": "ALTERNADOR"
    },
    {
        "code": "2Z0-903-093-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-903-093-B",
        "name": "JG.PARAFUS"
    },
    {
        "code": "2Z0-903-119-A",
        "name": "POLIA"
    },
    {
        "code": "2Z0-903-119-B",
        "name": "POLIA"
    },
    {
        "code": "2Z0-903-213-A",
        "name": "INDUZIDO"
    },
    {
        "code": "2Z0-905-367-E",
        "name": "UNID.COMAN"
    },
    {
        "code": "2Z0-905-367-K",
        "name": "UNID.COMAN"
    },
    {
        "code": "2Z0-905-367-L",
        "name": "UNID.COMAN"
    },
    {
        "code": "2Z0-906-051",
        "name": "SENSOR"
    },
    {
        "code": "2R2-845-101",
        "name": "PARABRISA"
    },
    {
        "code": "2Z0-906-051-A",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-906-051-B",
        "name": "HALL"
    },
    {
        "code": "2Z0-906-051-C",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-906-051-D",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-906-051-E",
        "name": "HALL"
    },
    {
        "code": "2Z0-906-051-F",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-906-051-G",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-906-051-H",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-927-748",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-971-537",
        "name": "FIO"
    },
    {
        "code": "2R2-845-150-A",
        "name": "CANALETA"
    },
    {
        "code": "2Z0-971-820",
        "name": "TUBO"
    },
    {
        "code": "2Z0-998-705-A",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2Z0-998-705-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2Z0-998-705-C",
        "name": "JG.FIXACAO"
    },
    {
        "code": "2Z0-998-907",
        "name": "JG.ALTERNA"
    },
    {
        "code": "2Z0-998-907-A",
        "name": "JG.ALTERNA"
    },
    {
        "code": "301-953-170-2",
        "name": "PORCA"
    },
    {
        "code": "357-971-939",
        "name": "suporte"
    },
    {
        "code": "377-809-373",
        "name": "CINTAFICAC"
    },
    {
        "code": "377-819-129-B",
        "name": "BOTAO"
    },
    {
        "code": "2R2-845-201",
        "name": "VIDRO"
    },
    {
        "code": "377-823-499-A",
        "name": "BATENTE"
    },
    {
        "code": "377-860-250",
        "name": "TRIANGULO"
    },
    {
        "code": "377-905-869",
        "name": "FRISO"
    },
    {
        "code": "377-947-561-F",
        "name": "BOTAO"
    },
    {
        "code": "3B0-837-861-A",
        "name": "COIFA"
    },
    {
        "code": "3B0-837-891-A -09Z",
        "name": "EMBLEMA VW"
    },
    {
        "code": "3B0-857-169",
        "name": "PINO"
    },
    {
        "code": "3B0-858-137",
        "name": "PRESILHA"
    },
    {
        "code": "3B0-867-190",
        "name": "PRESILHA"
    },
    {
        "code": "2U2-311-381-A",
        "name": "ANEL"
    },
    {
        "code": "2R2-845-202",
        "name": "VIDRO"
    },
    {
        "code": "2U2-311-381-B",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-381-C",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-388",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-427",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-427-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-457",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-457-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-460",
        "name": "RODA"
    },
    {
        "code": "2U2-311-460-A",
        "name": "Eixo princ"
    },
    {
        "code": "2U2-311-499",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-AA",
        "name": "ANEL"
    },
    {
        "code": "2R2-845-321-A",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-311-499-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-499-B",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-499-C",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-499-D",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-499-E",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-499-F",
        "name": "ANEL"
    },
    {
        "code": "2V3-105-123",
        "name": "VIRABREQUI"
    },
    {
        "code": "2V3-105-219",
        "name": "APOIO"
    },
    {
        "code": "2V3-105-219-A",
        "name": "APOIO"
    },
    {
        "code": "2V3-105-237-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2R2-845-322-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-105-253",
        "name": "POLIA"
    },
    {
        "code": "2V3-105-269",
        "name": "VOLANTE"
    },
    {
        "code": "2V3-105-387",
        "name": "CUBO"
    },
    {
        "code": "2V3-105-401",
        "name": "BIELA"
    },
    {
        "code": "2V3-105-595",
        "name": "CASQUILHO"
    },
    {
        "code": "2V3-105-595-A",
        "name": "CASQUILHO"
    },
    {
        "code": "2V3-105-595-B",
        "name": "CASQUILHO"
    },
    {
        "code": "2V3-105-595-E",
        "name": "CASQUILHO"
    },
    {
        "code": "2V3-105-595-F",
        "name": "CASQUILHO"
    },
    {
        "code": "2V3-105-713-B",
        "name": "CASQUILHO"
    },
    {
        "code": "2R2-845-341",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-105-713-C",
        "name": "CASQUILHO"
    },
    {
        "code": "2V3-105-713-D",
        "name": "CASQUILHO"
    },
    {
        "code": "2U2-525-139",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2U2-525-155-B",
        "name": "PINHAOCORO"
    },
    {
        "code": "2U2-525-155-C",
        "name": "PINHAOCORO"
    },
    {
        "code": "2U2-525-159",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-525-159-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-525-163",
        "name": "GARFO MUDA"
    },
    {
        "code": "2U2-525-169",
        "name": "SATELITE"
    },
    {
        "code": "2U2-525-169-A",
        "name": "SATELITE"
    },
    {
        "code": "2R2-853-575",
        "name": "CLIP"
    },
    {
        "code": "2U2-525-181",
        "name": "PINO"
    },
    {
        "code": "2U2-525-181-A",
        "name": "PINO"
    },
    {
        "code": "2U2-525-181-B",
        "name": "PINO"
    },
    {
        "code": "2U2-525-193",
        "name": "ROLETE"
    },
    {
        "code": "2U2-525-213",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2U2-525-267",
        "name": "DISCO"
    },
    {
        "code": "2U2-525-267-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-525-267-B",
        "name": "ANEL"
    },
    {
        "code": "3D0-971-838-C",
        "name": "ABRACADEIR"
    },
    {
        "code": "3D0-971-838-K",
        "name": "CABO"
    },
    {
        "code": "2R2-853-601-A",
        "name": "EMBLEMA VW"
    },
    {
        "code": "3D0-971-838-L",
        "name": "ABRACADEIR"
    },
    {
        "code": "2V5-867-729",
        "name": "suporte"
    },
    {
        "code": "2V5-867-730",
        "name": "suporte"
    },
    {
        "code": "2V5-867-730-A",
        "name": "suporte"
    },
    {
        "code": "2V5-867-867",
        "name": "FRISOTETO"
    },
    {
        "code": "2V5-867-959-A",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-867-960-A",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-868-071",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-868-072",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-868-280",
        "name": "GRAMPO"
    },
    {
        "code": "2R2-853-635",
        "name": "GRADE"
    },
    {
        "code": "2V5-868-324-A",
        "name": "TRILHO"
    },
    {
        "code": "2V5-868-501",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-868-675",
        "name": "PORTA OBJE"
    },
    {
        "code": "2V5-868-675-A",
        "name": "PORTA OBJE"
    },
    {
        "code": "2V5-868-902",
        "name": "DIFUSOR"
    },
    {
        "code": "2V5-877-229-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-877-230-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-877-621-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-881-053",
        "name": "ELEMENTO"
    },
    {
        "code": "2V5-881-082",
        "name": "APOIO BRAC"
    },
    {
        "code": "2R2-853-647",
        "name": "REFORCO"
    },
    {
        "code": "2V5-881-125",
        "name": "APOIO"
    },
    {
        "code": "2V5-881-201-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-881-231-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-881-246",
        "name": "CASQUILHO"
    },
    {
        "code": "2V5-881-311",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-937-115",
        "name": "FOLHA"
    },
    {
        "code": "2V5-937-501-D",
        "name": "PORTA RELE"
    },
    {
        "code": "2V5-937-540",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-937-565",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-937-565-B",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-853-648",
        "name": "REFORCO"
    },
    {
        "code": "2V5-937-565-C",
        "name": "TAMPA"
    },
    {
        "code": "2V5-937-565-D",
        "name": "TAMPA"
    },
    {
        "code": "2V5-937-565-E",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-941-001",
        "name": "GRAMPO"
    },
    {
        "code": "2V5-941-006",
        "name": "FAROL"
    },
    {
        "code": "2V5-941-025",
        "name": "SOQUETE"
    },
    {
        "code": "2V5-941-025-B",
        "name": "SOQUETE"
    },
    {
        "code": "2V5-941-031-F",
        "name": "FAROL"
    },
    {
        "code": "2V5-941-032-F",
        "name": "FAROL"
    },
    {
        "code": "2V5-941-063",
        "name": "FAROL"
    },
    {
        "code": "2R2-857-005-L -71N",
        "name": "PAINEL"
    },
    {
        "code": "2V5-941-063-A",
        "name": "FAROL"
    },
    {
        "code": "2V5-941-063-B",
        "name": "FAROL"
    },
    {
        "code": "2V5-941-063-C",
        "name": "FAROL"
    },
    {
        "code": "2V5-941-115",
        "name": "LENTE"
    },
    {
        "code": "2V5-941-115-A",
        "name": "LENTE"
    },
    {
        "code": "2V5-941-115-B",
        "name": "LENTE"
    },
    {
        "code": "2V5-941-116",
        "name": "LENTE"
    },
    {
        "code": "2V5-941-116-A",
        "name": "LENTE"
    },
    {
        "code": "2V5-941-116-B",
        "name": "LENTE"
    },
    {
        "code": "2V5-941-119",
        "name": "VEDACAO"
    },
    {
        "code": "2R2-857-007-A -71N",
        "name": "PAINEL"
    },
    {
        "code": "2V3-898-025",
        "name": "CONJUNTO"
    },
    {
        "code": "2V3-898-047",
        "name": "CLIMATIZAD"
    },
    {
        "code": "2V3-898-047-A",
        "name": "CLIMATIZAD"
    },
    {
        "code": "2V3-898-099",
        "name": "CONJUNTO"
    },
    {
        "code": "2V3-898-100",
        "name": "CONJUNTO"
    },
    {
        "code": "2V3-898-100-A",
        "name": "CONJUNTO"
    },
    {
        "code": "2V3-898-211",
        "name": "TRILHO"
    },
    {
        "code": "2V3-898-213",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-898-337",
        "name": "COIFA"
    },
    {
        "code": "2V3-898-337-A -ZDY",
        "name": "COIFA"
    },
    {
        "code": "1K0-971-848-L",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-857-007-A -82V",
        "name": "PAINEL"
    },
    {
        "code": "2V3-898-337-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-898-337-C",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-898-337-D -9PY",
        "name": "COIFA"
    },
    {
        "code": "2V3-898-337-E",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-898-509",
        "name": "CONJUNTO"
    },
    {
        "code": "2V3-898-705-A",
        "name": "JOGO"
    },
    {
        "code": "2V3-898-705-B",
        "name": "JOGO"
    },
    {
        "code": "2V3-898-705-C",
        "name": "JOGO"
    },
    {
        "code": "2V3-898-773",
        "name": "JG.BATENTE"
    },
    {
        "code": "2V3-899-181-A",
        "name": "CLIP"
    },
    {
        "code": "2R2-857-085-  -999",
        "name": "CAPA"
    },
    {
        "code": "2V3-899-181-B",
        "name": "CLIP"
    },
    {
        "code": "2V3-899-355",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-899-355-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-899-355-C",
        "name": "REFORCO"
    },
    {
        "code": "2V3-899-355-E",
        "name": "REFORCO"
    },
    {
        "code": "2V3-899-355-F",
        "name": "REFORCO"
    },
    {
        "code": "2V3-899-365-C",
        "name": "TUBO"
    },
    {
        "code": "2V3-899-365-D",
        "name": "TUBO"
    },
    {
        "code": "2V3-899-365-E",
        "name": "TUBO"
    },
    {
        "code": "2V3-899-365-F",
        "name": "TUBO"
    },
    {
        "code": "2R2-857-086-  -999",
        "name": "CAPA"
    },
    {
        "code": "2V3-899-365-G",
        "name": "TUBO"
    },
    {
        "code": "3X0-803-583",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-971-803",
        "name": "CONDUTOR"
    },
    {
        "code": "2V5-971-815",
        "name": "CONDUTOR"
    },
    {
        "code": "2V5-971-818-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-971-869",
        "name": "BUCHA"
    },
    {
        "code": "2V5-971-896",
        "name": "CONDUTOR"
    },
    {
        "code": "2V5-971-896-A",
        "name": "CONDUTOR"
    },
    {
        "code": "2V5-971-896-B",
        "name": "CONDUTOR"
    },
    {
        "code": "2V5-971-896-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R2-857-101-A -71N",
        "name": "PORTA LUVA"
    },
    {
        "code": "2V5-971-903",
        "name": "ANEL"
    },
    {
        "code": "2V5-971-904",
        "name": "ANEL"
    },
    {
        "code": "2V5-971-908",
        "name": "ANEL"
    },
    {
        "code": "2V5-971-920",
        "name": "CAPA PROTE"
    },
    {
        "code": "2V5-971-946-AQ",
        "name": "RECEPTACUL"
    },
    {
        "code": "2V5-971-946-B",
        "name": "RECEPTACUL"
    },
    {
        "code": "2V5-972-081-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-972-082",
        "name": "FRISO"
    },
    {
        "code": "4B0-905-849",
        "name": "COMUTADOR"
    },
    {
        "code": "4B0-971-848-K",
        "name": "Clip"
    },
    {
        "code": "2R2-857-101-A -82V",
        "name": "PORTA LUVA"
    },
    {
        "code": "WHT-009-509",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-620",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-621",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "WHT-006-622",
        "name": "PINO"
    },
    {
        "code": "WHT-006-623",
        "name": "PINO"
    },
    {
        "code": "WHT-006-624",
        "name": "PINO"
    },
    {
        "code": "WHT-006-625",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-626",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-627",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-628",
        "name": "ANEL"
    },
    {
        "code": "2R2-857-131-  -82V",
        "name": "FECHADURA"
    },
    {
        "code": "WHT-006-631",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-632",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-636",
        "name": "PINO"
    },
    {
        "code": "WHT-006-637",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-638",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-645",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-646",
        "name": "ANEL"
    },
    {
        "code": "2V5-947-171-A",
        "name": "LAMPADA"
    },
    {
        "code": "2V5-947-171-B",
        "name": "LAMPADA"
    },
    {
        "code": "2V5-947-171-C",
        "name": "LAMPADA"
    },
    {
        "code": "2R2-857-131-  -Y20",
        "name": "FECHADURA"
    },
    {
        "code": "2V5-947-171-D",
        "name": "LAMPADA"
    },
    {
        "code": "2V5-947-171-E",
        "name": "LAMPADA"
    },
    {
        "code": "2V5-947-171-F",
        "name": "LAMPADA"
    },
    {
        "code": "2V5-947-171-H",
        "name": "LAMPADA"
    },
    {
        "code": "2V5-947-171-J",
        "name": "LAMPADA"
    },
    {
        "code": "2V5-947-311",
        "name": "LUZ PORTA"
    },
    {
        "code": "2V5-947-561",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-947-561-F",
        "name": "SENSOR"
    },
    {
        "code": "2V5-949-101-C",
        "name": "LUZ"
    },
    {
        "code": "2V5-953-501-A",
        "name": "COMUTADOR"
    },
    {
        "code": "2R2-857-192-A -WL7",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-953-513-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-955-169-A",
        "name": "PALHETA"
    },
    {
        "code": "2V5-955-489-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-919-061-A",
        "name": "PLACDIODOS"
    },
    {
        "code": "2V5-919-090-J",
        "name": "RELE"
    },
    {
        "code": "2V5-919-111-M",
        "name": "RECEPTACUL"
    },
    {
        "code": "2V5-919-111-N",
        "name": "TOMADA"
    },
    {
        "code": "2V5-919-111-S",
        "name": "ALOJAMENTO"
    },
    {
        "code": "2V5-919-121-C",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V5-919-121-D",
        "name": "ADAPTADOR"
    },
    {
        "code": "2R2-857-192-C -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-919-121-E",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V5-919-121-G",
        "name": "PROTECAO"
    },
    {
        "code": "2V5-919-131",
        "name": "ANEL"
    },
    {
        "code": "2V5-919-203-A",
        "name": "RELOGIO"
    },
    {
        "code": "2V5-919-243",
        "name": "CONECTOR C"
    },
    {
        "code": "2V5-919-281-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-919-307-A",
        "name": "ACENDEDOR"
    },
    {
        "code": "2V5-919-381-CN",
        "name": "RECEPTACUL"
    },
    {
        "code": "2V5-919-381-CR",
        "name": "RECEPTACUL"
    },
    {
        "code": "2V5-919-381-CS",
        "name": "RECEPTACUL"
    },
    {
        "code": "2R2-857-301-A -NA2",
        "name": "CINZEIRO"
    },
    {
        "code": "2V5-919-381-H",
        "name": "RECEPTACUL"
    },
    {
        "code": "542-937-131-J",
        "name": "FUSIVEL"
    },
    {
        "code": "542-937-131-K",
        "name": "FUSIVEL"
    },
    {
        "code": "542-937-131-L",
        "name": "FUSIVEL"
    },
    {
        "code": "542-937-131-N",
        "name": "FUSIVEL"
    },
    {
        "code": "547-955-481",
        "name": "VALVULA"
    },
    {
        "code": "551-999-616",
        "name": "ANEL"
    },
    {
        "code": "WHT-005-985",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-988",
        "name": "ANEL"
    },
    {
        "code": "WHT-005-989",
        "name": "PARAFUSO"
    },
    {
        "code": "1T0-919-341-C -9B9",
        "name": "PINO"
    },
    {
        "code": "2R2-857-503-A -WL7",
        "name": "REVESTIMEN"
    },
    {
        "code": "WHT-005-991",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-994",
        "name": "ANEL VEDAC"
    },
    {
        "code": "WHT-005-997",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-011",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-014",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-018",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-022",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-029",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-030",
        "name": "porca"
    },
    {
        "code": "WHT-006-034",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-857-504-A -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "5G0-959-858-F -WHS",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-131-510-A",
        "name": "TAMPA"
    },
    {
        "code": "5U0-035-209",
        "name": "PLACA"
    },
    {
        "code": "5U0-035-498-E",
        "name": "ANTENA"
    },
    {
        "code": "5U0-035-501-D",
        "name": "BASE ANTEN"
    },
    {
        "code": "5U0-035-689-A",
        "name": "porca"
    },
    {
        "code": "5U0-035-726",
        "name": "CONEC.USB"
    },
    {
        "code": "5U0-035-849-C",
        "name": "ANTENA"
    },
    {
        "code": "2V5-411-281-A",
        "name": "INSERTO"
    },
    {
        "code": "2V5-411-281-B",
        "name": "DISCO"
    },
    {
        "code": "2R2-857-504-A -WL7",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-411-283-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-411-284-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-411-333",
        "name": "FIXADOR"
    },
    {
        "code": "2V5-411-346-A",
        "name": "BUCHA"
    },
    {
        "code": "2V5-411-379",
        "name": "CONSOLE"
    },
    {
        "code": "2V5-411-380-A",
        "name": "CONSOLE"
    },
    {
        "code": "2V5-411-399-A",
        "name": "BUCHA"
    },
    {
        "code": "2V5-411-611-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-412-185",
        "name": "VALVULA"
    },
    {
        "code": "2V5-413-031-F",
        "name": "AMORTECEDO"
    },
    {
        "code": "2R2-857-513-  -999",
        "name": "CARCACA"
    },
    {
        "code": "2V5-413-351-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-413-353-D",
        "name": "suporte"
    },
    {
        "code": "2V5-413-353-F",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-721-261-B",
        "name": "CILINDRO"
    },
    {
        "code": "2V5-721-395",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V5-721-509-B",
        "name": "PEDAL DO A"
    },
    {
        "code": "2V5-721-611",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-721-613-A",
        "name": "VALVULA"
    },
    {
        "code": "2V5-800-701-E",
        "name": "CABINA"
    },
    {
        "code": "2V5-801-313",
        "name": "BUCHA"
    },
    {
        "code": "2R2-857-513-A -999",
        "name": "CARCACA"
    },
    {
        "code": "2V5-801-499",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-801-849-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-801-849-C",
        "name": "CONSOLE"
    },
    {
        "code": "2V5-801-849-D",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-802-013",
        "name": "CHAPA"
    },
    {
        "code": "2V5-802-013-A",
        "name": "CHAPA"
    },
    {
        "code": "2V5-802-014",
        "name": "CHAPA"
    },
    {
        "code": "2V5-802-147",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-802-210",
        "name": "CHAPA"
    },
    {
        "code": "2V5-802-215",
        "name": "CHAPA"
    },
    {
        "code": "2R2-857-513-B -999",
        "name": "CARCACA"
    },
    {
        "code": "2V5-802-229-B",
        "name": "CHAPA"
    },
    {
        "code": "2V5-803-183-A",
        "name": "TRAVESSA"
    },
    {
        "code": "5U0-980-611",
        "name": "ANTENA"
    },
    {
        "code": "5X0-837-581-  -033",
        "name": "MANIVELA"
    },
    {
        "code": "5X0-837-581-  -9B9",
        "name": "MANIVELA"
    },
    {
        "code": "5X0-867-299",
        "name": "PINO"
    },
    {
        "code": "5X0-905-855",
        "name": "CILINDRO"
    },
    {
        "code": "5Z0-853-685-C -739",
        "name": "LOGOTIPO"
    },
    {
        "code": "5Z0-857-231-  -1FR",
        "name": "COBERTURA"
    },
    {
        "code": "5Z0-857-231-A -1QB",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-857-522",
        "name": "VIDRO ESPE"
    },
    {
        "code": "5Z0-959-565-C -9B9",
        "name": "INTERRUPTO"
    },
    {
        "code": "5Z0-959-856-A -1NN",
        "name": "INTERRUPTO"
    },
    {
        "code": "600-971-849-A",
        "name": "PRESILHA"
    },
    {
        "code": "6N0-129-355",
        "name": "ARRUELA"
    },
    {
        "code": "6Q0-807-643",
        "name": "PINO"
    },
    {
        "code": "6Q0-959-858-A -9B9",
        "name": "INTERRUPTO"
    },
    {
        "code": "6Q6-827-499-C",
        "name": "BATENTE"
    },
    {
        "code": "2V5-323-301-C",
        "name": "JG.ENGRENA"
    },
    {
        "code": "2V5-323-301-D",
        "name": "JG.ENGRENA"
    },
    {
        "code": "2V5-323-733",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-857-531",
        "name": "INSERTO"
    },
    {
        "code": "2V5-325-057-C",
        "name": "ATUADOR"
    },
    {
        "code": "2V5-325-477",
        "name": "VALVULA"
    },
    {
        "code": "2V5-326-118",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-326-118-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-398-001",
        "name": "JG.VEDACAO"
    },
    {
        "code": "2V5-398-001-A",
        "name": "JG.VEDACAO"
    },
    {
        "code": "2V5-398-047",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-398-747",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V5-398-747-A",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V5-398-747-B",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2R2-857-532",
        "name": "INSERTO"
    },
    {
        "code": "2V5-398-941-A",
        "name": "UNIDADE"
    },
    {
        "code": "2V5-398-941-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-398-941-C",
        "name": "JOGOREPARA"
    },
    {
        "code": "2V5-398-941-D",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-398-941-E",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V5-407-071",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-071-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-071-B",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-071-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-071-D",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-857-543",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-407-071-E",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-071-F",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-071-G",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-407-071-H",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-501-653-L",
        "name": "CUBO RODA"
    },
    {
        "code": "2V5-501-753",
        "name": "BUCHA"
    },
    {
        "code": "2V5-501-771-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-505-085-B",
        "name": "suporte"
    },
    {
        "code": "2V5-505-177",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-505-179",
        "name": "BUCHA"
    },
    {
        "code": "211-955-975-1",
        "name": "PECA EM T"
    },
    {
        "code": "2R2-857-544",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-505-179-B",
        "name": "BUCHA"
    },
    {
        "code": "2V5-505-189-B",
        "name": "BATENTE"
    },
    {
        "code": "2V5-505-233",
        "name": "BATENTE"
    },
    {
        "code": "2V5-505-469-C",
        "name": "TIRANTE"
    },
    {
        "code": "2V5-505-469-D",
        "name": "TIRANTE"
    },
    {
        "code": "2V5-505-469-H",
        "name": "TIRANTE"
    },
    {
        "code": "2V5-505-469-J",
        "name": "TIRANTE"
    },
    {
        "code": "2V5-505-577-A",
        "name": "suporte"
    },
    {
        "code": "2V5-507-105-C",
        "name": "TAMPA"
    },
    {
        "code": "2V5-507-145-B",
        "name": "TAMPAO"
    },
    {
        "code": "2R2-857-551-  -Y20",
        "name": "PARASOL"
    },
    {
        "code": "2V5-507-145-F",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-507-401-A",
        "name": "PORCA"
    },
    {
        "code": "2V5-507-632",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-511-025-C",
        "name": "BARRA"
    },
    {
        "code": "2V5-511-139",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-511-149",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-511-149-C",
        "name": "CALCO"
    },
    {
        "code": "2V5-511-150",
        "name": "PLACPRESSA"
    },
    {
        "code": "2V5-511-151",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V5-525-267-CT",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-857-551-A -Y20",
        "name": "PARASOL"
    },
    {
        "code": "2V5-525-267-D",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DA",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DD",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DE",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DF",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DG",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DJ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DK",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-857-565-A -WL7",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-525-267-DL",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DM",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DN",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DP",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DQ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DR",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DS",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-DT",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-E",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EA",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-857-607-  -Y20",
        "name": "PUXADOR"
    },
    {
        "code": "2V5-525-267-EB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-ED",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EE",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EF",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EG",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EH",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EJ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EK",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EL",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-857-627-  -WH6",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-599-173-D",
        "name": "ESTRIBO"
    },
    {
        "code": "2V5-599-175",
        "name": "placa"
    },
    {
        "code": "2V5-601-027-B",
        "name": "RODA"
    },
    {
        "code": "2V5-601-027-B -XD6",
        "name": "RODA"
    },
    {
        "code": "2V5-601-027-B -Z31",
        "name": "RODA"
    },
    {
        "code": "2V5-601-161-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-601-161-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-601-295-A",
        "name": "porca"
    },
    {
        "code": "2V5-601-387-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-301-443",
        "name": "PINO"
    },
    {
        "code": "2R2-857-629-  -WH6",
        "name": "GANCHOPROT"
    },
    {
        "code": "2V3-301-443-A",
        "name": "PINO"
    },
    {
        "code": "2V3-301-443-B",
        "name": "PINO"
    },
    {
        "code": "2V3-301-517",
        "name": "FILTRO"
    },
    {
        "code": "2V3-301-517-A",
        "name": "ELEM FILTR"
    },
    {
        "code": "2V3-301-517-B",
        "name": "ELEM FILTR"
    },
    {
        "code": "2V3-301-580",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-301-685",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V3-301-685-A",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-311-183-G",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-H",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-857-784",
        "name": "REBITE"
    },
    {
        "code": "2V5-311-183-J",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-K",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-L",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-M",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-P",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-Q",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-R",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-S",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-187-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-187-B",
        "name": "ANEL"
    },
    {
        "code": "2R2-857-784-  -1NN",
        "name": "REBITE"
    },
    {
        "code": "2V5-311-187-C",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-187-D",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-187-E",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-187-J",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-189",
        "name": "RETENTOR"
    },
    {
        "code": "2V5-311-623-C",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-311-623-D",
        "name": "JUNTA"
    },
    {
        "code": "2V5-311-623-E",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-311-625",
        "name": "MOLA"
    },
    {
        "code": "2V5-311-641-A",
        "name": "PINO"
    },
    {
        "code": "2R2-857-805-A -1NN",
        "name": "CINTO 3 PT"
    },
    {
        "code": "2V5-311-738",
        "name": "PISTAO"
    },
    {
        "code": "2V5-311-807-C",
        "name": "FLANGE"
    },
    {
        "code": "2V5-311-809-B",
        "name": "FLANGE"
    },
    {
        "code": "2V5-311-868-B",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V5-311-868-C",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V5-311-893-B",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-311-893-C",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-311-914",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-311-914-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-311-927-A",
        "name": "EIXO"
    },
    {
        "code": "22B-121-136-H",
        "name": "PINO"
    },
    {
        "code": "2R2-857-815-H -1NN",
        "name": "CINTO 3 PT"
    },
    {
        "code": "2V5-311-944-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-971",
        "name": "JUNTA"
    },
    {
        "code": "2V5-311-978",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-805-615-B",
        "name": "REBOQUE"
    },
    {
        "code": "2V5-805-787",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-807-127",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-807-279-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-807-279-C",
        "name": "PARAFUSO S"
    },
    {
        "code": "2V5-807-299",
        "name": "REBITE"
    },
    {
        "code": "2V5-807-299-A",
        "name": "CEGA"
    },
    {
        "code": "2R2-857-815-J -1NN",
        "name": "CINTO 3 PT"
    },
    {
        "code": "2V5-807-299-E",
        "name": "CLIP"
    },
    {
        "code": "2V5-807-461",
        "name": "PLACAROSCA"
    },
    {
        "code": "2V5-807-859",
        "name": "APOIO"
    },
    {
        "code": "2V5-807-877-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-899-181-A",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-899-181-G",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-899-369",
        "name": "PINOESFERI"
    },
    {
        "code": "2V5-899-371",
        "name": "PLACA FECH"
    },
    {
        "code": "2V5-899-381-A",
        "name": "CHAPA"
    },
    {
        "code": "2V5-899-381-B",
        "name": "CHAPA"
    },
    {
        "code": "2R2-857-906-  -WL7",
        "name": "SOLEIRA"
    },
    {
        "code": "2V5-899-383-A",
        "name": "CONSOLE"
    },
    {
        "code": "2V5-899-383-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-899-387-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-899-387-E",
        "name": "suporte"
    },
    {
        "code": "2V5-899-388-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-899-399",
        "name": "MANCAL"
    },
    {
        "code": "2V5-899-411",
        "name": "LUVA"
    },
    {
        "code": "2V5-899-411-A",
        "name": "suporte"
    },
    {
        "code": "2V5-899-421",
        "name": "BASE"
    },
    {
        "code": "7L6-819-139",
        "name": "GRAMPO"
    },
    {
        "code": "2R2-857-923-  -Y20",
        "name": "CONSOLE TE"
    },
    {
        "code": "7M0-868-563",
        "name": "CLIP"
    },
    {
        "code": "7M3-721-647",
        "name": "TAMPA"
    },
    {
        "code": "WHT-008-750",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-751",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-753",
        "name": "PINO"
    },
    {
        "code": "WHT-008-762",
        "name": "CONEXAO"
    },
    {
        "code": "803-959-849",
        "name": "suporte"
    },
    {
        "code": "8E0-919-309",
        "name": "TOMADA"
    },
    {
        "code": "2V3-311-321-D",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-321-E",
        "name": "ANEL"
    },
    {
        "code": "2R2-857-973",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-321-F",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-321-G",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-351",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-351-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-351-B",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-351-C",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-374",
        "name": "APOIO"
    },
    {
        "code": "2V3-311-374-A",
        "name": "APOIO"
    },
    {
        "code": "2V3-311-374-B",
        "name": "APOIO"
    },
    {
        "code": "2V3-311-374-C",
        "name": "APOIO"
    },
    {
        "code": "2R2-858-023",
        "name": "suporte"
    },
    {
        "code": "2V3-311-375",
        "name": "BUCHA"
    },
    {
        "code": "2V3-311-375-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-311-375-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-311-381",
        "name": "ANEL"
    },
    {
        "code": "2V5-301-215-C",
        "name": "JUNTA"
    },
    {
        "code": "2V5-301-231",
        "name": "TAMPA"
    },
    {
        "code": "2V5-301-240",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-301-251",
        "name": "PLACPRESSA"
    },
    {
        "code": "2V5-301-252-B",
        "name": "TAMPA"
    },
    {
        "code": "2V5-301-283",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-858-045-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-301-293-A",
        "name": "CAPA"
    },
    {
        "code": "2V5-301-293-B",
        "name": "PLACAINTER"
    },
    {
        "code": "2V5-301-339",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-301-339-E",
        "name": "ANEL"
    },
    {
        "code": "2V5-301-339-F",
        "name": "ANEL"
    },
    {
        "code": "2V5-301-340",
        "name": "POSICAO"
    },
    {
        "code": "2V5-301-340-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-301-340-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-301-340-L",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-301-340-S",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-858-193-A -82V",
        "name": "COBERTURA"
    },
    {
        "code": "2V5-301-373-B",
        "name": "CARCACA"
    },
    {
        "code": "2V5-301-377",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V5-301-377-A",
        "name": "COTOVELO"
    },
    {
        "code": "2V5-301-403-B",
        "name": "TRAVA"
    },
    {
        "code": "2V5-301-415",
        "name": "ANEL"
    },
    {
        "code": "2V5-301-431-D",
        "name": "PINOESFERI"
    },
    {
        "code": "2V5-905-121",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-905-845",
        "name": "PECABLOQUE"
    },
    {
        "code": "2V5-905-849-A",
        "name": "COMUTADOR"
    },
    {
        "code": "2V5-905-855-B",
        "name": "COMUTADOR"
    },
    {
        "code": "2R2-858-217-A -82V",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-905-855-C",
        "name": "COMUTADOR"
    },
    {
        "code": "2V5-906-005",
        "name": "UNIDADE"
    },
    {
        "code": "2V5-906-131",
        "name": "suporte"
    },
    {
        "code": "2V5-906-559-A",
        "name": "suporte"
    },
    {
        "code": "2V5-906-559-K",
        "name": "suporte"
    },
    {
        "code": "2V5-906-559-R",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-907-500-A",
        "name": "TRAVA"
    },
    {
        "code": "2V5-907-511-A",
        "name": "SERVOMOTOR"
    },
    {
        "code": "2V5-907-555-G",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V5-907-631-D",
        "name": "VALVULA"
    },
    {
        "code": "2R2-858-217-A -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V5-907-808-G",
        "name": "UNIDADE"
    },
    {
        "code": "2V5-907-808-H",
        "name": "UNIDADE"
    },
    {
        "code": "2V5-909-144",
        "name": "PARAFUSO"
    },
    {
        "code": "8X0-971-838",
        "name": "ABRACADEIR"
    },
    {
        "code": "AMV-190-M01",
        "name": "MASSA"
    },
    {
        "code": "APR-000-700-A",
        "name": "FLUIDO FRE"
    },
    {
        "code": "D  -176-501-A1",
        "name": "SILICONE"
    },
    {
        "code": "G  -052-168-Q0",
        "name": "OLEO MOTOR"
    },
    {
        "code": "G  -052-168-Q2",
        "name": "OLEO MOTOR"
    },
    {
        "code": "G  -052-168-Q4",
        "name": "OLEO MOTOR"
    },
    {
        "code": "2V3-321-476-A",
        "name": "chaveta"
    },
    {
        "code": "22B-501-244",
        "name": "PC PRESSAO"
    },
    {
        "code": "2R2-858-217-A -U71",
        "name": "REVESTIMEN"
    },
    {
        "code": "G  -052-168-Q6",
        "name": "OLEO MOTOR"
    },
    {
        "code": "G  -052-168-Q7",
        "name": "OLEO MOTOR"
    },
    {
        "code": "G  -052-385-Q0",
        "name": "ADITIVO"
    },
    {
        "code": "G  -052-739-Q1",
        "name": "GRAXA"
    },
    {
        "code": "G  -052-739-Q2",
        "name": "GRAXA"
    },
    {
        "code": "G  -052-739-Q4",
        "name": "GRAXA"
    },
    {
        "code": "G  -052-743-Q1",
        "name": "graxa"
    },
    {
        "code": "G  -052-809-Q2",
        "name": "OLEO EIXO"
    },
    {
        "code": "G  -052-809-Q4",
        "name": "OLEO EIXO"
    },
    {
        "code": "G  -052-812-Q0",
        "name": "OLEO"
    },
    {
        "code": "2R2-858-217-A -WL7",
        "name": "REVESTIMEN"
    },
    {
        "code": "G  -052-822-Q0",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-822-Q2",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-822-Q4",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-822-Q6",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-822-Q7",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-823-Q0",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-823-Q2",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-823-Q4",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-823-Q6",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-825-Q2",
        "name": "OLEO EIXO"
    },
    {
        "code": "2R2-858-218-A -82V",
        "name": "REVESTIMEN"
    },
    {
        "code": "G  -052-825-Q4",
        "name": "OLEO EIXO"
    },
    {
        "code": "G  -052-826-Q4",
        "name": "OLEO EIXO"
    },
    {
        "code": "G  -052-827-Q4",
        "name": "OLEO"
    },
    {
        "code": "G  -052-829-Q2",
        "name": "OLEO"
    },
    {
        "code": "G  -052-829-Q4",
        "name": "OLEO"
    },
    {
        "code": "G  -052-834-Q0",
        "name": "OLEO"
    },
    {
        "code": "G  -052-834-Q2",
        "name": "OLEO"
    },
    {
        "code": "G  -052-836-Q0",
        "name": "PASTALUBRI"
    },
    {
        "code": "G  -052-839-Q2",
        "name": "OLEO"
    },
    {
        "code": "G  -053-700-Q1",
        "name": "FLUIDO FRE"
    },
    {
        "code": "2R2-858-218-A -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "G  -411-381-B1",
        "name": "ADITIVO"
    },
    {
        "code": "G  -411-381-B4",
        "name": "ADITIVO"
    },
    {
        "code": "G  -411-381-Q0",
        "name": "ADITIVO"
    },
    {
        "code": "G  -411-381-Q1",
        "name": "ADITIVO"
    },
    {
        "code": "G  -419-027-Q2",
        "name": "OLEO LUBR."
    },
    {
        "code": "G  -721-089-Q2",
        "name": "graxa"
    },
    {
        "code": "G  -847-669-Q2",
        "name": "graxa"
    },
    {
        "code": "G  -900-197-Q2",
        "name": "graxa"
    },
    {
        "code": "J0D-201-365",
        "name": "QUADRADA"
    },
    {
        "code": "JZV-127-177-A",
        "name": "FILTR COMB"
    },
    {
        "code": "2R2-858-218-A -U71",
        "name": "REVESTIMEN"
    },
    {
        "code": "JZV-131-391",
        "name": "ELEM FILTR"
    },
    {
        "code": "N  -010-137-1",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-141-5",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-165-3",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-212-32",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-215-13",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-216-8",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-217-10",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-217-23",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-218-7",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-858-218-A -WL7",
        "name": "REVESTIMEN"
    },
    {
        "code": "N  -010-221-3",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-230-5",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-237-14",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-239-0",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-239-11",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-240-11",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-242-12",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-242-32",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-242-34",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-247-7",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-858-227-  -Y20",
        "name": "moldura"
    },
    {
        "code": "N  -010-254-11",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-270-15",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-270-4",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-273-3",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-275-3",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-287-16",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-350-18",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-361-13",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -010-891-1",
        "name": "PORCA"
    },
    {
        "code": "N  -010-893-1",
        "name": "porca"
    },
    {
        "code": "2R2-858-304-A -71N",
        "name": "MOLDURA"
    },
    {
        "code": "N  -011-005-21",
        "name": "porca"
    },
    {
        "code": "N  -011-005-4",
        "name": "porca"
    },
    {
        "code": "N  -011-006-36",
        "name": "porca"
    },
    {
        "code": "N  -011-008-3",
        "name": "porca"
    },
    {
        "code": "N  -011-008-40",
        "name": "porca"
    },
    {
        "code": "N  -011-008-45",
        "name": "porca"
    },
    {
        "code": "N  -011-010-23",
        "name": "porca"
    },
    {
        "code": "N  -011-010-6",
        "name": "porca"
    },
    {
        "code": "N  -011-020-4",
        "name": "porca"
    },
    {
        "code": "N  -011-114-1",
        "name": "porca"
    },
    {
        "code": "2R2-858-304-A -82V",
        "name": "MOLDURA"
    },
    {
        "code": "N  -011-175-7",
        "name": "PORCA"
    },
    {
        "code": "N  -011-183-11",
        "name": "PORCA"
    },
    {
        "code": "N  -011-183-12",
        "name": "PORCA"
    },
    {
        "code": "N  -011-184-10",
        "name": "PORCA"
    },
    {
        "code": "N  -011-184-6",
        "name": "PORCA"
    },
    {
        "code": "N  -011-185-2",
        "name": "PORCA"
    },
    {
        "code": "N  -011-186-2",
        "name": "PORCA"
    },
    {
        "code": "N  -011-511-2",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-522-21",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-524-26",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-858-329-  -71N",
        "name": "PORTAOBJ"
    },
    {
        "code": "N  -011-524-7",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-525-2",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-525-27",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-525-8",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-527-16",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-527-21",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-527-4",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-530-2",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-531-16",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-531-5",
        "name": "ARRUELA"
    },
    {
        "code": "22B-511-329",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-858-329-  -82V",
        "name": "PORTAOBJ"
    },
    {
        "code": "N  -011-534-2",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-534-6",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-547-1",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-560-1",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-560-3",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-560-4",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-665-16",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-666-20",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-666-7",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-670-16",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-858-335-A -71N",
        "name": "COBERTURA"
    },
    {
        "code": "N  -011-670-2",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-670-26",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-670-31",
        "name": "APOIO"
    },
    {
        "code": "N  -011-670-32",
        "name": "APOIO"
    },
    {
        "code": "N  -011-670-6",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-692-15",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-692-9",
        "name": "ARRUELA"
    },
    {
        "code": "N  -011-695-4",
        "name": "ARRUELA"
    },
    {
        "code": "N  -012-006-4",
        "name": "ANEL"
    },
    {
        "code": "N  -012-211-1",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-858-335-A -82V",
        "name": "COBERTURA"
    },
    {
        "code": "N  -012-229-1",
        "name": "arruela"
    },
    {
        "code": "N  -012-229-3",
        "name": "arruela"
    },
    {
        "code": "N  -012-238-1",
        "name": "arruela"
    },
    {
        "code": "N  -012-292-2",
        "name": "ANEL"
    },
    {
        "code": "N  -012-327-3",
        "name": "ARRUELA"
    },
    {
        "code": "N  -013-812-5",
        "name": "ANEL"
    },
    {
        "code": "N  -013-814-1",
        "name": "ANEL"
    },
    {
        "code": "N  -013-814-2",
        "name": "ANEL"
    },
    {
        "code": "N  -013-827-2",
        "name": "ANEL"
    },
    {
        "code": "N  -013-832-2",
        "name": "ANEL"
    },
    {
        "code": "2R2-858-335-A -9B9",
        "name": "COBERTURA"
    },
    {
        "code": "N  -013-844-2",
        "name": "ANEL"
    },
    {
        "code": "N  -013-848-7",
        "name": "ANEL"
    },
    {
        "code": "N  -013-935-1",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -013-935-4",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -013-958-7",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -013-966-11",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -013-967-1",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -014-130-1",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -014-140-8",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -014-714-7",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-858-337-A -71N",
        "name": "PORTAOBJ"
    },
    {
        "code": "N  -014-726-14",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -014-729-6",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -014-735-6",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -015-081-6",
        "name": "PORCA"
    },
    {
        "code": "N  -015-082-10",
        "name": "PORCA"
    },
    {
        "code": "N  -015-083-2",
        "name": "PORCA"
    },
    {
        "code": "N  -015-083-9",
        "name": "PORCA"
    },
    {
        "code": "N  -015-402-7",
        "name": "ARRUELA"
    },
    {
        "code": "N  -016-163-2",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "N  -016-190-1",
        "name": "REB CEGO"
    },
    {
        "code": "2R2-858-337-A -82V",
        "name": "PORTAOBJ"
    },
    {
        "code": "N  -017-131-11",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -017-131-12",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -017-131-13",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -017-131-14",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -017-131-15",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -017-131-16",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -017-131-18",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -017-717-3",
        "name": "LAMPADA"
    },
    {
        "code": "N  -017-719-3",
        "name": "LAMPADA"
    },
    {
        "code": "N  -017-732-3",
        "name": "LAMPADA"
    },
    {
        "code": "2R2-858-547-  -999",
        "name": "CAPA"
    },
    {
        "code": "N  -017-770-4",
        "name": "LAMP.INCAN"
    },
    {
        "code": "N  -018-509-1",
        "name": "ENGRAXADEI"
    },
    {
        "code": "N  -019-502-2",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -019-526-9",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -019-530-7",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -019-530-8",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -019-531-5",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -019-700-6",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -020-602-6",
        "name": "BRACADEIRA"
    },
    {
        "code": "N  -020-616-8",
        "name": "BRACADEIR"
    },
    {
        "code": "2R2-858-559-B",
        "name": "REVESTIMEN"
    },
    {
        "code": "N  -020-624-7",
        "name": "BRACADEIR"
    },
    {
        "code": "N  -020-806-2",
        "name": "BOCAL"
    },
    {
        "code": "N  -020-905-4",
        "name": "ABRACADEIR"
    },
    {
        "code": "N  -020-905-7",
        "name": "ABRACADEIR"
    },
    {
        "code": "N  -021-071-7",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -021-192-1",
        "name": "PORCA"
    },
    {
        "code": "N  -021-196-3",
        "name": "porca"
    },
    {
        "code": "N  -022-141-2",
        "name": "PORCA"
    },
    {
        "code": "N  -022-141-4",
        "name": "PORCA"
    },
    {
        "code": "N  -022-146-1",
        "name": "PORCA"
    },
    {
        "code": "2R2-858-559-B -1NN",
        "name": "REVESTIMEN"
    },
    {
        "code": "N  -022-146-2",
        "name": "porca"
    },
    {
        "code": "N  -022-148-1",
        "name": "PORCA"
    },
    {
        "code": "N  -022-148-13",
        "name": "PORCA"
    },
    {
        "code": "N  -023-003-10",
        "name": "porca"
    },
    {
        "code": "2S2-607-313-E",
        "name": "CONEXAO"
    },
    {
        "code": "2S2-607-313-J",
        "name": "CONEXAO"
    },
    {
        "code": "2S2-607-315-A",
        "name": "PECA EM T"
    },
    {
        "code": "2S2-607-315-B",
        "name": "PECA EM T"
    },
    {
        "code": "2S2-607-315-D",
        "name": "PECA EM T"
    },
    {
        "code": "2S2-607-315-E",
        "name": "conexÆo"
    },
    {
        "code": "2R2-858-559-C",
        "name": "REVESTIMEN"
    },
    {
        "code": "2T2-601-373",
        "name": "VALVULA"
    },
    {
        "code": "2T2-607-079",
        "name": "COTOVELO"
    },
    {
        "code": "2T2-607-085",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-607-098",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-607-251-A",
        "name": "RESERVATOR"
    },
    {
        "code": "2T2-607-251-E",
        "name": "RESERVATOR"
    },
    {
        "code": "N  -023-003-13",
        "name": "PORCA"
    },
    {
        "code": "N  -023-004-11",
        "name": "PORCA"
    },
    {
        "code": "N  -023-205-1",
        "name": "BRACADEIR"
    },
    {
        "code": "N  -024-510-1",
        "name": "BRACADEIRA"
    },
    {
        "code": "22B-517-606",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-858-559-C -1NN",
        "name": "REVESTIMEN"
    },
    {
        "code": "N  -040-188-1",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -040-220-1",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -040-249-2",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -042-122-1",
        "name": "ARRUELA"
    },
    {
        "code": "N  -043-809-4",
        "name": "ANEL"
    },
    {
        "code": "N  -043-936-3",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -043-936-6",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -044-705-1",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -044-706-2",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -090-151-1",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-858-560-A",
        "name": "REVESTIMEN"
    },
    {
        "code": "N  -100-095-06",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -100-418-01",
        "name": "CLIP"
    },
    {
        "code": "N  -100-829-11",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -100-829-12",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -100-883-06",
        "name": "CLIP"
    },
    {
        "code": "N  -101-064-02",
        "name": "PORCA"
    },
    {
        "code": "N  -101-092-08",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-092-10",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-181-04",
        "name": "porca"
    },
    {
        "code": "N  -101-243-06",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-858-833",
        "name": "PLACASUPOR"
    },
    {
        "code": "N  -101-243-10",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-281-10",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-313-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-313-06",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-552-10",
        "name": "porca"
    },
    {
        "code": "N  -101-560-04",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-560-09",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-703-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -101-734-02",
        "name": "PORCA"
    },
    {
        "code": "N  -101-963-03",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-860-173",
        "name": "PRISIONEIR"
    },
    {
        "code": "N  -101-972-10",
        "name": "SEXTAVADO"
    },
    {
        "code": "N  -102-058-02",
        "name": "PORCA"
    },
    {
        "code": "N  -102-089-07",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -102-564-06",
        "name": "LAMP.INCAN"
    },
    {
        "code": "N  -102-613-02",
        "name": "PORCA"
    },
    {
        "code": "N  -102-613-10",
        "name": "PORCA"
    },
    {
        "code": "N  -102-615-01",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -102-615-02",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -102-615-03",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -102-615-07",
        "name": "FUSIVEL"
    },
    {
        "code": "2R2-861-041-  -Y20",
        "name": "TAMPA"
    },
    {
        "code": "N  -102-615-08",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -102-657-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -102-723-02",
        "name": "PORCA"
    },
    {
        "code": "N  -102-861-02",
        "name": "PORCA"
    },
    {
        "code": "N  -102-861-10",
        "name": "PORCA"
    },
    {
        "code": "N  -103-001-06",
        "name": "BRACADEIRA"
    },
    {
        "code": "N  -103-065-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -103-065-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -103-144-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -104-018-01",
        "name": "PORCA"
    },
    {
        "code": "2R2-861-227-  -Y20",
        "name": "PARASOL"
    },
    {
        "code": "N  -104-029-04",
        "name": "PORCA"
    },
    {
        "code": "N  -104-032-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -104-044-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -104-048",
        "name": "ARRUELA"
    },
    {
        "code": "N  -104-061-05",
        "name": "ARRUELA"
    },
    {
        "code": "N  -104-062-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -104-159-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -104-249-05",
        "name": "Fuse"
    },
    {
        "code": "N  -104-249-07",
        "name": "Fuse"
    },
    {
        "code": "N  -104-321-01",
        "name": "suporte"
    },
    {
        "code": "2R2-861-343",
        "name": "FRISOTETO"
    },
    {
        "code": "N  -105-064-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -105-073-01",
        "name": "PORCA"
    },
    {
        "code": "N  -105-255-04",
        "name": "Fuse"
    },
    {
        "code": "N  -105-255-07",
        "name": "Fuse"
    },
    {
        "code": "N  -105-302-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-047-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-073-01",
        "name": "ARRUELA"
    },
    {
        "code": "N  -106-092-04",
        "name": "PORCA"
    },
    {
        "code": "N  -106-185-01",
        "name": "PORCA"
    },
    {
        "code": "N  -106-239-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-861-344",
        "name": "FRISOTETO"
    },
    {
        "code": "N  -106-259-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-284-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-321-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-366-01",
        "name": "SEXTAVADO"
    },
    {
        "code": "N  -106-428-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-434-01",
        "name": "ARRUELA"
    },
    {
        "code": "N  -106-453-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-506-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-533-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-560-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-861-690",
        "name": "REDE"
    },
    {
        "code": "N  -106-562-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-567-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-610-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-663-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-696-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-729-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-768-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -107-023-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -107-105-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -107-148-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-863-368-C -WM8",
        "name": "TAPETE"
    },
    {
        "code": "N  -107-188-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -107-232-01",
        "name": "LAMPADA"
    },
    {
        "code": "N  -107-281-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -107-336-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -107-591-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -107-822-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-214-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-282-01",
        "name": "PORCA"
    },
    {
        "code": "N  -108-736-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -900-333-01",
        "name": "ARRUELA"
    },
    {
        "code": "22B-601-295-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-863-631-C",
        "name": "ISOLANTE"
    },
    {
        "code": "N  -900-333-08",
        "name": "ARRUELA"
    },
    {
        "code": "N  -900-510-01",
        "name": "LAMPADA"
    },
    {
        "code": "N  -900-866-01",
        "name": "LAMPADA"
    },
    {
        "code": "N  -901-076-08",
        "name": "ARRUELA"
    },
    {
        "code": "N  -901-797-04",
        "name": "ARRUELA"
    },
    {
        "code": "N  -901-838-02",
        "name": "PORCA"
    },
    {
        "code": "N  -901-838-03",
        "name": "PORCA"
    },
    {
        "code": "N  -902-076-03",
        "name": "ARRUELA"
    },
    {
        "code": "N  -902-412-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -902-516-02",
        "name": "GRAMPO"
    },
    {
        "code": "2R2-863-632-E",
        "name": "ISOLANTE"
    },
    {
        "code": "N  -903-152-02",
        "name": "ARRUELA"
    },
    {
        "code": "N  -903-385-01",
        "name": "ARRUELA"
    },
    {
        "code": "N  -903-387-01",
        "name": "PORCA"
    },
    {
        "code": "N  -904-537-03",
        "name": "PORCA"
    },
    {
        "code": "N  -904-878-02",
        "name": "PORCA"
    },
    {
        "code": "N  -904-959-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -905-115-07",
        "name": "PORCA"
    },
    {
        "code": "N  -905-330-05",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -905-483-05",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -905-757-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-863-711-D -NA2",
        "name": "TAPETE"
    },
    {
        "code": "N  -906-312-02",
        "name": "PORCA"
    },
    {
        "code": "2V3-607-079",
        "name": "COTOVELO"
    },
    {
        "code": "2V3-607-079-A",
        "name": "COTOVELO"
    },
    {
        "code": "2V3-607-079-E",
        "name": "COTOVELO"
    },
    {
        "code": "2V3-607-085-A",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-085-D",
        "name": "BOCAL"
    },
    {
        "code": "2V3-607-085-E",
        "name": "CONECTOR"
    },
    {
        "code": "2V3-607-085-F",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-085-J",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-110",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-864-884",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2V3-607-112-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-112-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-112-G",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-112-H",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-127",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-607-193-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-193-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-251",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-607-251-B",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-607-251-C",
        "name": "RESERVATOR"
    },
    {
        "code": "2R2-864-931",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2V3-607-251-D",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-607-262",
        "name": "valvula"
    },
    {
        "code": "2V5-803-877-L",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-M",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-N",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-P",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-Q",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-R",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-T",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-878",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-864-935",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2V5-803-878-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-803-878-AA",
        "name": "ARRUELA"
    },
    {
        "code": "N  -906-526-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -906-557-01",
        "name": "BRACADEIRA"
    },
    {
        "code": "N  -906-661-01",
        "name": "ABRACADEIR"
    },
    {
        "code": "N  -906-823-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -906-986-06",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -906-987-03",
        "name": "PORCA"
    },
    {
        "code": "N  -906-988-01",
        "name": "PORCA"
    },
    {
        "code": "N  -907-085-04",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-864-991",
        "name": "ISOLAMENTO"
    },
    {
        "code": "N  -907-124-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -907-321-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -907-473-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -907-611-02",
        "name": "PORCA"
    },
    {
        "code": "N  -907-667-02",
        "name": "PORCA"
    },
    {
        "code": "N  -907-667-03",
        "name": "PORCA"
    },
    {
        "code": "N  -907-965-02",
        "name": "ARRUELA"
    },
    {
        "code": "N  -907-988-05",
        "name": "PORCA"
    },
    {
        "code": "N  -908-005-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -908-047-05",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-867-015-B -CIN",
        "name": "REV.PORTA"
    },
    {
        "code": "N  -908-090-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -908-298-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -908-332-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -908-794-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-059-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-145-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-187-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-514-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-691-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-868-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-867-015-B -NA2",
        "name": "REV.PORTA"
    },
    {
        "code": "N  -909-899-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-900-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-954-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -910-201-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -910-243-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -910-484-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -910-718-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -910-757-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -910-967-03",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -911-161-01",
        "name": "PORCA"
    },
    {
        "code": "2R2-867-016-B -NA2",
        "name": "REV.PORTA"
    },
    {
        "code": "N  -911-323-01",
        "name": "ARRUELA"
    },
    {
        "code": "N  -911-343-01",
        "name": "parafuso"
    },
    {
        "code": "N  -911-447-01",
        "name": "PORCA"
    },
    {
        "code": "N  -911-454-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -912-415-01",
        "name": "PORCA"
    },
    {
        "code": "NF -055-718-AB",
        "name": "porca"
    },
    {
        "code": "NF -055-962-DK",
        "name": "PARAFUSO"
    },
    {
        "code": "NF -072-161-DF",
        "name": "CONTRAPINO"
    },
    {
        "code": "NFE-600-324-AB",
        "name": "PARAFUSO"
    },
    {
        "code": "NFU-350-281-AB",
        "name": "PORCA"
    },
    {
        "code": "22B-614-129-B",
        "name": "RETENTOR"
    },
    {
        "code": "2R2-867-016-B -NNN",
        "name": "REV.PORTA"
    },
    {
        "code": "T00-415-993",
        "name": "porca"
    },
    {
        "code": "T00-607-375",
        "name": "MANGUEIRA"
    },
    {
        "code": "T00-957-040",
        "name": "DISCO"
    },
    {
        "code": "T00-971-848-A",
        "name": "PRESILHA"
    },
    {
        "code": "T06-607-701-A",
        "name": "PRESILHA"
    },
    {
        "code": "T11-407-753",
        "name": "ARRUELA"
    },
    {
        "code": "T11-501-287",
        "name": "CAPA"
    },
    {
        "code": "T11-807-413",
        "name": "PRESILHA"
    },
    {
        "code": "T11-821-189",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "T11-857-600-A",
        "name": "porca"
    },
    {
        "code": "2R2-867-016-C -CIN",
        "name": "REV.PORTA"
    },
    {
        "code": "T12-501-315-A",
        "name": "CAPA"
    },
    {
        "code": "T12-607-053",
        "name": "ARRUELA"
    },
    {
        "code": "T12-607-053-A",
        "name": "ARRUELA"
    },
    {
        "code": "T12-607-057",
        "name": "CAPA COBER"
    },
    {
        "code": "T12-607-063",
        "name": "ARRUELA"
    },
    {
        "code": "T12-607-065",
        "name": "PARAFUSO"
    },
    {
        "code": "T12-607-075",
        "name": "MECANISMO"
    },
    {
        "code": "T12-607-076",
        "name": "MECANISMO"
    },
    {
        "code": "T12-945-185-B",
        "name": "PARAFUSO"
    },
    {
        "code": "T12-945-187",
        "name": "ANEL"
    },
    {
        "code": "2R2-867-016-C -NA2",
        "name": "REV.PORTA"
    },
    {
        "code": "T12-945-223-A",
        "name": "lente"
    },
    {
        "code": "T12-945-411",
        "name": "SUPORTE"
    },
    {
        "code": "T13-407-632",
        "name": "ROLAMROLO"
    },
    {
        "code": "T14-501-273-A",
        "name": "ARRUELA"
    },
    {
        "code": "T14-501-275",
        "name": "PORCA"
    },
    {
        "code": "T14-501-313",
        "name": "CONE"
    },
    {
        "code": "T14-525-195",
        "name": "CONE"
    },
    {
        "code": "T14-525-197",
        "name": "ANEL"
    },
    {
        "code": "T14-599-173",
        "name": "ESTRIBO"
    },
    {
        "code": "T15-507-139",
        "name": "CHAPA"
    },
    {
        "code": "2R2-867-016-C -NNN",
        "name": "REV.PORTA"
    },
    {
        "code": "T16-407-641",
        "name": "RETENTOR"
    },
    {
        "code": "T16-407-679",
        "name": "CALCO"
    },
    {
        "code": "T16-407-679-A",
        "name": "CALCO"
    },
    {
        "code": "T16-407-683",
        "name": "CALCO"
    },
    {
        "code": "T16-407-683-A",
        "name": "CALCO"
    },
    {
        "code": "T16-407-693",
        "name": "PINOAJUSTE"
    },
    {
        "code": "T16-413-431",
        "name": "ARRUELA"
    },
    {
        "code": "T16-501-317",
        "name": "ANEL"
    },
    {
        "code": "T16-501-901",
        "name": "PRISIONEIR"
    },
    {
        "code": "T16-599-171",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-867-035-  -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "T16-599-515",
        "name": "PRATO MOLA"
    },
    {
        "code": "T16-601-139",
        "name": "PARAFUSO"
    },
    {
        "code": "T16-803-731",
        "name": "SUPORTE"
    },
    {
        "code": "T2D-145-405",
        "name": "FUSIVEL"
    },
    {
        "code": "T2D-145-407",
        "name": "TAMPA"
    },
    {
        "code": "T2D-611-727",
        "name": "BRACADEIR"
    },
    {
        "code": "T71-012-505",
        "name": "GRAMPO"
    },
    {
        "code": "TAC-511-515",
        "name": "PINO"
    },
    {
        "code": "TAC-607-103-A",
        "name": "PARAFUSO"
    },
    {
        "code": "TAC-607-589-A",
        "name": "haste"
    },
    {
        "code": "2R2-867-035-B -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "TAC-807-141",
        "name": "BUCHA"
    },
    {
        "code": "TAC-955-996",
        "name": "PECAJUNCAO"
    },
    {
        "code": "TAE-607-067",
        "name": "CABECOTE"
    },
    {
        "code": "TAE-607-113",
        "name": "ARRUELA"
    },
    {
        "code": "TAE-607-115",
        "name": "PORCA"
    },
    {
        "code": "TAE-711-101",
        "name": "PARAFUSO"
    },
    {
        "code": "TAG-607-567",
        "name": "CAMARA DO"
    },
    {
        "code": "TAK-525-197-A",
        "name": "CAPA PROTE"
    },
    {
        "code": "TAK-525-215-A",
        "name": "PORCA"
    },
    {
        "code": "TAK-525-241",
        "name": "CAIXA"
    },
    {
        "code": "2R2-867-036-  -U71",
        "name": "REVESTIMEN"
    },
    {
        "code": "TAK-525-243",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-A",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-B",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-C",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-D",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-E",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-F",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-G",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-H",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-243-J",
        "name": "ANEL"
    },
    {
        "code": "2R2-867-158-A -71N",
        "name": "MOLDURA"
    },
    {
        "code": "TAK-525-243-K",
        "name": "ARRUELA"
    },
    {
        "code": "TAK-525-253",
        "name": "CONE"
    },
    {
        "code": "TAK-525-253-A",
        "name": "CONE"
    },
    {
        "code": "TAK-525-265-A",
        "name": "CAPA PROTE"
    },
    {
        "code": "TAK-525-291",
        "name": "ARRUELA"
    },
    {
        "code": "TAK-525-291-A",
        "name": "ARRUELA"
    },
    {
        "code": "TAK-525-291-B",
        "name": "ARRUELA"
    },
    {
        "code": "TAK-525-409",
        "name": "PARAFUSO"
    },
    {
        "code": "TAK-525-417",
        "name": "CALCO"
    },
    {
        "code": "TAK-525-417-A",
        "name": "CALCO"
    },
    {
        "code": "2R2-867-158-A -82V",
        "name": "MOLDURA"
    },
    {
        "code": "TAK-525-417-B",
        "name": "CALCO"
    },
    {
        "code": "TAK-525-419",
        "name": "ANEL"
    },
    {
        "code": "TAK-525-421",
        "name": "DEFLETOR"
    },
    {
        "code": "TAL-117-231",
        "name": "MANGUEIRA"
    },
    {
        "code": "TAL-511-105",
        "name": "CALCO"
    },
    {
        "code": "TAL-511-151",
        "name": "FEIXE MOLA"
    },
    {
        "code": "TAL-511-163",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-165",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-167",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-169",
        "name": "LAMINA"
    },
    {
        "code": "2R2-867-173-A -71N",
        "name": "COBERTURA"
    },
    {
        "code": "TAL-511-171",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-173",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-175",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-178",
        "name": "CALCO"
    },
    {
        "code": "TAL-511-191",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-193",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-195",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-197",
        "name": "PARAFUSO"
    },
    {
        "code": "TAL-511-207",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-209",
        "name": "LAMINA"
    },
    {
        "code": "22B-616-197",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-867-173-A -82V",
        "name": "COBERTURA"
    },
    {
        "code": "TAL-511-211",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-213",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-225",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-227",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-229",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-231",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-233",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-241",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-243",
        "name": "LAMINA"
    },
    {
        "code": "TAL-511-245",
        "name": "LAMINA"
    },
    {
        "code": "2R2-867-174-A -71N",
        "name": "COBERTURA"
    },
    {
        "code": "TAP-599-177",
        "name": "ARRUELA"
    },
    {
        "code": "TAP-807-801-  -9B9",
        "name": "SUPORTE"
    },
    {
        "code": "TAP-899-329",
        "name": "ARRUELA"
    },
    {
        "code": "TAR-121-619-A",
        "name": "ADAPTADOR"
    },
    {
        "code": "TAR-411-053",
        "name": "BRACADEIRA"
    },
    {
        "code": "TAR-607-105",
        "name": "SUPORTE"
    },
    {
        "code": "TAR-607-105-A",
        "name": "SUPORTE"
    },
    {
        "code": "TAR-607-316",
        "name": "CONEXAO"
    },
    {
        "code": "TAR-698-423-B",
        "name": "JG.PECAS"
    },
    {
        "code": "TAR-915-105",
        "name": "BATERIA"
    },
    {
        "code": "2R2-867-174-A -82V",
        "name": "COBERTURA"
    },
    {
        "code": "TAR-999-001",
        "name": "LAMPADA"
    },
    {
        "code": "TAU-411-281",
        "name": "PECAINTERM"
    },
    {
        "code": "TE3-103-113",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "TE3-103-113-A",
        "name": "BujÆo"
    },
    {
        "code": "TE3-103-113-C",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "TE3-103-113-M",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "TE3-103-119",
        "name": "ANEL"
    },
    {
        "code": "TE3-103-199",
        "name": "ANEL"
    },
    {
        "code": "TE3-103-605",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-103-875",
        "name": "PINO"
    },
    {
        "code": "2R2-867-257-A",
        "name": "ANEL"
    },
    {
        "code": "TE3-103-875-A",
        "name": "PINO"
    },
    {
        "code": "TE3-109-287",
        "name": "ANEL"
    },
    {
        "code": "TE3-109-687",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-109-701",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-115-857",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-121-811",
        "name": "PORCA"
    },
    {
        "code": "TE3-121-819",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-127-245",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-130-115",
        "name": "PORCA"
    },
    {
        "code": "TE3-145-637",
        "name": "ANEL"
    },
    {
        "code": "2R2-867-289",
        "name": "GRAMPO"
    },
    {
        "code": "TE3-145-643",
        "name": "ARRUELA"
    },
    {
        "code": "TE3-145-853",
        "name": "COTOVELO"
    },
    {
        "code": "TE3-199-311",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-525-215-A",
        "name": "PORCA"
    },
    {
        "code": "TE3-525-875",
        "name": "FRICCAO"
    },
    {
        "code": "TE3-599-183-C",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-599-601",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-599-605",
        "name": "JUNTA"
    },
    {
        "code": "TE3-607-027",
        "name": "LUVA"
    },
    {
        "code": "TE3-607-037",
        "name": "ROLO"
    },
    {
        "code": "2R2-867-299",
        "name": "PINO"
    },
    {
        "code": "TE3-607-039",
        "name": "MOLA"
    },
    {
        "code": "TE3-607-043",
        "name": "PINO"
    },
    {
        "code": "TE3-607-053",
        "name": "ARRUELA"
    },
    {
        "code": "TE3-607-077",
        "name": "CONTRAPINO"
    },
    {
        "code": "TE3-607-475",
        "name": "ARRUELA"
    },
    {
        "code": "TE3-607-543",
        "name": "PINO"
    },
    {
        "code": "TE3-803-994",
        "name": "DRENO"
    },
    {
        "code": "TE3-911-901",
        "name": "ARRUELA"
    },
    {
        "code": "TEG-253-143-A",
        "name": "PRESILHA"
    },
    {
        "code": "TEG-607-021",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-867-387-A",
        "name": "GRAMPO"
    },
    {
        "code": "TEG-607-022",
        "name": "SUPORTE"
    },
    {
        "code": "TF3-115-267-A",
        "name": "SUPORTE"
    },
    {
        "code": "TF3-115-283",
        "name": "ARRUELA"
    },
    {
        "code": "TF3-115-473",
        "name": "PARAFUSO"
    },
    {
        "code": "TF3-121-805",
        "name": "PARAFUSO"
    },
    {
        "code": "TF3-145-293",
        "name": "PARAFUSO"
    },
    {
        "code": "TF3-145-667",
        "name": "PARAFUSO"
    },
    {
        "code": "TF3-511-181",
        "name": "LUVA"
    },
    {
        "code": "TGG-411-111",
        "name": "BATENTE"
    },
    {
        "code": "TH5-607-471",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-867-388",
        "name": "GRAMPO"
    },
    {
        "code": "TJ3-607-527",
        "name": "BOCAL"
    },
    {
        "code": "TJG-000-651-B",
        "name": "ETIQUETAID"
    },
    {
        "code": "TJG-103-113",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "TJG-103-113-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "TJG-115-279",
        "name": "porca"
    },
    {
        "code": "TJG-115-311-A",
        "name": "ANEL"
    },
    {
        "code": "TJG-115-415",
        "name": "ANEL"
    },
    {
        "code": "TJG-115-441",
        "name": "VEDACAO"
    },
    {
        "code": "TJG-115-633",
        "name": "CINTA"
    },
    {
        "code": "TJG-121-363-A",
        "name": "MANCAL"
    },
    {
        "code": "2R2-867-393-A -NA2",
        "name": "COBERTURA"
    },
    {
        "code": "TJG-121-375",
        "name": "LUVA"
    },
    {
        "code": "TJG-130-813",
        "name": "PARAFUSO"
    },
    {
        "code": "TJG-145-455",
        "name": "PRISIONEIR"
    },
    {
        "code": "TJG-145-457",
        "name": "PORCA"
    },
    {
        "code": "TJG-411-167-A",
        "name": "JUMELO"
    },
    {
        "code": "TJG-411-173",
        "name": "PINO"
    },
    {
        "code": "TJG-411-175",
        "name": "PINO"
    },
    {
        "code": "TJG-501-471",
        "name": "PORCA"
    },
    {
        "code": "TJG-501-473",
        "name": "ANEL"
    },
    {
        "code": "TJG-511-353",
        "name": "BATENTE"
    },
    {
        "code": "2R2-867-393-A -U71",
        "name": "COBERTURA"
    },
    {
        "code": "TJG-511-367",
        "name": "INSERTO"
    },
    {
        "code": "TJG-525-395",
        "name": "MANGUEIRA"
    },
    {
        "code": "TJG-599-175",
        "name": "placa"
    },
    {
        "code": "TJG-601-027-A -XD6",
        "name": "RODA"
    },
    {
        "code": "TJG-601-215-A",
        "name": "PESO BALAN"
    },
    {
        "code": "TJG-601-231-A",
        "name": "PESO BALAN"
    },
    {
        "code": "TJG-607-055-A",
        "name": "REGULADOR"
    },
    {
        "code": "TJG-607-305",
        "name": "MANGUEIRA"
    },
    {
        "code": "TJG-607-965",
        "name": "MOLA"
    },
    {
        "code": "TJG-803-223-B",
        "name": "SUPORTE"
    },
    {
        "code": "22B-616-197-B",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-867-489-  -82V",
        "name": "CAPA COBER"
    },
    {
        "code": "TJG-803-561",
        "name": "SUPORTE"
    },
    {
        "code": "TJG-803-562",
        "name": "SUPORTE"
    },
    {
        "code": "TJG-807-413",
        "name": "PINO"
    },
    {
        "code": "TJG-821-755",
        "name": "ISOLAMENTO"
    },
    {
        "code": "TJG-837-821",
        "name": "ISOLADOR"
    },
    {
        "code": "TJG-867-651-  -033",
        "name": "CLIP"
    },
    {
        "code": "TJG-867-651-  -Y20",
        "name": "CLIP"
    },
    {
        "code": "TJG-903-809",
        "name": "PARAFUSO"
    },
    {
        "code": "TJG-903-809-A",
        "name": "PARAFUSO"
    },
    {
        "code": "TJG-919-243-A",
        "name": "SOQUETE"
    },
    {
        "code": "2R2-867-490-  -71N",
        "name": "CAPA COBER"
    },
    {
        "code": "TJG-971-911-B",
        "name": "GALAO"
    },
    {
        "code": "TMG-417-151",
        "name": "PORCA"
    },
    {
        "code": "TMJ-407-628",
        "name": "CAPA"
    },
    {
        "code": "TMJ-407-637",
        "name": "CONE"
    },
    {
        "code": "TN4-103-113-E",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "TN4-105-777",
        "name": "CAPA"
    },
    {
        "code": "TN4-109-703",
        "name": "SEXTAVADO"
    },
    {
        "code": "TN4-130-801",
        "name": "PARAFUSO"
    },
    {
        "code": "TN4-145-851",
        "name": "MANGUEIRA"
    },
    {
        "code": "TN4-607-097",
        "name": "porca"
    },
    {
        "code": "2R2-867-490-  -82V",
        "name": "CAPA COBER"
    },
    {
        "code": "TN4-607-963",
        "name": "MEMBRANA"
    },
    {
        "code": "TNQ-201-179",
        "name": "MANGUEIRA"
    },
    {
        "code": "TNR-607-316",
        "name": "VALVULA"
    },
    {
        "code": "TNS-121-741",
        "name": "ETIQUETAID"
    },
    {
        "code": "TPL-411-177",
        "name": "ESPACADOR"
    },
    {
        "code": "TRA-103-113-A",
        "name": "BujÆo"
    },
    {
        "code": "TRA-103-217",
        "name": "PARAFUSO"
    },
    {
        "code": "TRA-109-651",
        "name": "CHAVETA"
    },
    {
        "code": "TRA-109-911",
        "name": "PARAFUSO"
    },
    {
        "code": "TRA-121-110",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R2-867-501-  -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "TRA-121-123",
        "name": "PARAFUSO"
    },
    {
        "code": "TRA-145-453",
        "name": "VEDACAO"
    },
    {
        "code": "TRA-145-903",
        "name": "PORCA"
    },
    {
        "code": "TRA-145-911",
        "name": "CONEXAO"
    },
    {
        "code": "TRA-903-809",
        "name": "PARAFUSO"
    },
    {
        "code": "TRG-105-209",
        "name": "ENGRENAGEM"
    },
    {
        "code": "TRG-130-813",
        "name": "PARAFUSO"
    },
    {
        "code": "TRG-201-171",
        "name": "TRAVESSA"
    },
    {
        "code": "TRG-201-351",
        "name": "DISCO"
    },
    {
        "code": "WHT-000-295",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-867-501-C -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "WHT-000-868",
        "name": "PINO"
    },
    {
        "code": "WHT-002-947",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-004-638",
        "name": "ARRUELA"
    },
    {
        "code": "WHT-005-013",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-014",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-019",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-024",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-025",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-026",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-030",
        "name": "porca"
    },
    {
        "code": "2R2-881-023-  -CIO",
        "name": "ASSENTO"
    },
    {
        "code": "WHT-005-033",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-039",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-044",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-050",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-052",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-057",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-059",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-060",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-067",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-069",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-881-031-E -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-005-070",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-071",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-076",
        "name": "CONTRAPINO"
    },
    {
        "code": "WHT-005-077",
        "name": "CONTRAPINO"
    },
    {
        "code": "WHT-005-078",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-082",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-088",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-092",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-100",
        "name": "porca"
    },
    {
        "code": "WHT-005-102",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-881-031-E -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-005-107",
        "name": "porca"
    },
    {
        "code": "WHT-005-110",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-115",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-118",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-124",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-126",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-132",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-145",
        "name": "porca"
    },
    {
        "code": "WHT-005-834",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-835",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-881-031-G -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-005-844",
        "name": "TAMPA"
    },
    {
        "code": "WHT-005-845",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-846",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-847",
        "name": "porca"
    },
    {
        "code": "WHT-005-895",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-896",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-899",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-903",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-905",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-906",
        "name": "porca"
    },
    {
        "code": "2R2-881-031-G -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-005-907",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-908",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-910",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-917",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-918",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-922",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-924",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-925",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-926",
        "name": "porca"
    },
    {
        "code": "WHT-006-085",
        "name": "BRACADEIR"
    },
    {
        "code": "237-611-987-1",
        "name": "BRACADEIRA"
    },
    {
        "code": "2R2-881-031-H -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-006-086",
        "name": "PINO"
    },
    {
        "code": "WHT-006-166",
        "name": "BujÆo"
    },
    {
        "code": "WHT-006-167",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-232",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-348",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-368",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-392",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-393",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-394",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-461",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-881-031-H -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-006-580",
        "name": "PINOESFERI"
    },
    {
        "code": "WHT-006-593",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-594",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-601",
        "name": "CEGA"
    },
    {
        "code": "WHT-006-608",
        "name": "ARRUELA"
    },
    {
        "code": "WHT-006-609",
        "name": "PINO"
    },
    {
        "code": "WHT-006-610",
        "name": "PINOCILIND"
    },
    {
        "code": "WHT-006-611",
        "name": "PINOCILIND"
    },
    {
        "code": "WHT-006-612",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-613",
        "name": "ROLAMENTO"
    },
    {
        "code": "2R2-881-037-F -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-006-614",
        "name": "ROLAMENTO"
    },
    {
        "code": "WHT-006-615",
        "name": "ROLAMENTO"
    },
    {
        "code": "WHT-006-616",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-617",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-618",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-619",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-674",
        "name": "porca"
    },
    {
        "code": "WHT-006-680",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-681",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "WHT-006-682",
        "name": "ANEL"
    },
    {
        "code": "2R2-881-037-F -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-006-683",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-684",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-688",
        "name": "PINOCILIND"
    },
    {
        "code": "WHT-006-690",
        "name": "TRAVA"
    },
    {
        "code": "WHT-006-691",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "WHT-006-692",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-698",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-729",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-744",
        "name": "porca"
    },
    {
        "code": "WHT-006-748",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-881-037-H -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-006-751",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-759",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-799",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-800",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-801",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-802",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-803",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-804",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-808",
        "name": "porca"
    },
    {
        "code": "WHT-006-811",
        "name": "CEGA"
    },
    {
        "code": "2R2-881-037-H -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "WHT-006-813",
        "name": "PORCA"
    },
    {
        "code": "WHT-006-814",
        "name": "PORCA"
    },
    {
        "code": "WHT-006-815",
        "name": "ARRUELA"
    },
    {
        "code": "WHT-006-816",
        "name": "PINO"
    },
    {
        "code": "WHT-006-818",
        "name": "HASTE"
    },
    {
        "code": "WHT-006-891",
        "name": "MANGUEIRA"
    },
    {
        "code": "WHT-006-976",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-977",
        "name": "NIPLE"
    },
    {
        "code": "WHT-007-049",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-067",
        "name": "PORCA"
    },
    {
        "code": "2R2-881-041-  -CIL",
        "name": "ENCOSTO"
    },
    {
        "code": "WHT-007-076",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-086",
        "name": "TAMPAO"
    },
    {
        "code": "WHT-007-136",
        "name": "ANEL VEDAC"
    },
    {
        "code": "WHT-007-228",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-232",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-326",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-341",
        "name": "PORCA"
    },
    {
        "code": "WHT-007-355",
        "name": "PRESILHA"
    },
    {
        "code": "WHT-007-366",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-440",
        "name": "ACOPLAMENT"
    },
    {
        "code": "2R2-881-041-  -CIO",
        "name": "ENCOSTO"
    },
    {
        "code": "WHT-007-448",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-465",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-466",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-514",
        "name": "TUBO"
    },
    {
        "code": "WHT-007-561",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-562",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-565",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-007-600",
        "name": "QUADRADA"
    },
    {
        "code": "WHT-007-682",
        "name": "BujÆo"
    },
    {
        "code": "WHT-007-688",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-881-041-A -CIL",
        "name": "ENCOSTO"
    },
    {
        "code": "WHT-007-710",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-711",
        "name": "ANEL"
    },
    {
        "code": "WHT-007-791-D",
        "name": "ANEL"
    },
    {
        "code": "WHT-007-791-E",
        "name": "ANEL"
    },
    {
        "code": "WHT-007-791-F",
        "name": "ANEL"
    },
    {
        "code": "WHT-007-791-G",
        "name": "ANEL"
    },
    {
        "code": "WHT-007-791-H",
        "name": "ANEL"
    },
    {
        "code": "WHT-007-898",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-901",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-906",
        "name": "CILINDRICO"
    },
    {
        "code": "2R2-881-041-A -CIO",
        "name": "ENCOSTO"
    },
    {
        "code": "WHT-007-907",
        "name": "CILINDRICO"
    },
    {
        "code": "WHT-007-908",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-909",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-918",
        "name": "PORCA"
    },
    {
        "code": "WHT-007-921",
        "name": "porca"
    },
    {
        "code": "WHT-007-976",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-008-045",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-164",
        "name": "Paraf torx"
    },
    {
        "code": "WHT-008-337",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-404",
        "name": "PORCA"
    },
    {
        "code": "23B-000-911",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-881-045-B",
        "name": "ESTRUTURA"
    },
    {
        "code": "WHT-008-705",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-706",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "WHT-008-709",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "WHT-009-017",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "WHT-009-018",
        "name": "Paraf torx"
    },
    {
        "code": "WHT-009-020",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-009-021",
        "name": "Adapter"
    },
    {
        "code": "WHT-009-022",
        "name": "Adapter"
    },
    {
        "code": "WHT-009-023",
        "name": "PECA EM T"
    },
    {
        "code": "WHT-009-026",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-881-211-A",
        "name": "TRILHO"
    },
    {
        "code": "WHT-009-027",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-028",
        "name": "PARAF.CILI"
    },
    {
        "code": "WHT-009-889",
        "name": "REBITE"
    },
    {
        "code": "WHT-009-920",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-945",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-961",
        "name": "PARAFUSO"
    },
    {
        "code": "ZBA-803-583",
        "name": "TAMPAO"
    },
    {
        "code": "23B-501-123-D",
        "name": "suporte"
    },
    {
        "code": "2V2-311-127-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-311-127-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-881-211-B",
        "name": "TRILHO"
    },
    {
        "code": "2V2-311-143-A",
        "name": "EIXO"
    },
    {
        "code": "2V2-311-146",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V2-311-167",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V2-311-167-A",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V2-311-183",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-311-187",
        "name": "ANEL"
    },
    {
        "code": "2V2-311-242",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V2-311-242-A",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V2-311-269",
        "name": "ANEL"
    },
    {
        "code": "2V2-311-280",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-881-251-A",
        "name": "BOTAO"
    },
    {
        "code": "2V2-311-285",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V2-311-285-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V2-311-285-B",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V2-311-294",
        "name": "CORPOSINCR"
    },
    {
        "code": "2V2-311-294-A",
        "name": "CORPOSINCR"
    },
    {
        "code": "2V2-311-294-B",
        "name": "CORPOSINCR"
    },
    {
        "code": "2V2-311-294-C",
        "name": "CORPOSINCR"
    },
    {
        "code": "2V2-311-295",
        "name": "ANEL"
    },
    {
        "code": "2V2-311-375",
        "name": "GAIOLA"
    },
    {
        "code": "2V2-311-381",
        "name": "ANEL"
    },
    {
        "code": "2R2-881-252",
        "name": "TECLAPRESS"
    },
    {
        "code": "2V2-311-381-B",
        "name": "ANEL"
    },
    {
        "code": "2V2-311-381-C",
        "name": "ANEL"
    },
    {
        "code": "2V2-311-381-D",
        "name": "ANEL"
    },
    {
        "code": "2V2-311-381-E",
        "name": "ANEL"
    },
    {
        "code": "2V2-311-460",
        "name": "RODA"
    },
    {
        "code": "2S2-862-628",
        "name": "BUCHA"
    },
    {
        "code": "2S2-862-755-  -WG5",
        "name": "CORTINA"
    },
    {
        "code": "2S2-862-755-A -WG5",
        "name": "CORTINA"
    },
    {
        "code": "2S2-862-757-  -WG5",
        "name": "CORTINA"
    },
    {
        "code": "2S2-862-757-A -WG5",
        "name": "CORTINA"
    },
    {
        "code": "2R2-881-252-A",
        "name": "TECLAPRESS"
    },
    {
        "code": "2V2-325-057",
        "name": "ATUADOR"
    },
    {
        "code": "2V2-325-057-B",
        "name": "ATUADOR"
    },
    {
        "code": "2V2-325-057-C",
        "name": "ATUADOR"
    },
    {
        "code": "2V2-325-057-D",
        "name": "ATUADOR"
    },
    {
        "code": "2V2-398-747",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V2-398-747-A",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V2-398-747-B",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V2-398-747-C",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V2-398-941",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V2-398-941-A",
        "name": "CONJUNTO"
    },
    {
        "code": "2R2-881-439-A",
        "name": "BASE"
    },
    {
        "code": "2V2-411-025",
        "name": "BARRA"
    },
    {
        "code": "2V2-412-259",
        "name": "VALVULA"
    },
    {
        "code": "2V2-419-049",
        "name": "ESPACADOR"
    },
    {
        "code": "2V2-422-859",
        "name": "TUBO"
    },
    {
        "code": "2V2-500-051-DT",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V2-500-061-AB",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V2-501-023",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V2-501-023-B",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V2-501-085",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-A",
        "name": "CORPOEIXO"
    },
    {
        "code": "2R2-881-479-E",
        "name": "COBERTURA"
    },
    {
        "code": "2V2-501-085-AA",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-AB",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-AC",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-AD",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-AE",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-AF",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-AG",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-AL",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-B",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-C",
        "name": "CORPOEIXO"
    },
    {
        "code": "2R2-881-493",
        "name": "ANEL"
    },
    {
        "code": "2V2-501-085-F",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-G",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-H",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-J",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-K",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-L",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-M",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-N",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-P",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V2-501-085-Q",
        "name": "CORPOEIXO"
    },
    {
        "code": "2R2-881-547",
        "name": "MOLDURA"
    },
    {
        "code": "2V2-501-085-R",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V5-145-371",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V5-145-467",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V5-145-475",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-145-475-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-145-670",
        "name": "TUBO ADMIS"
    },
    {
        "code": "2V5-145-915",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-198-049",
        "name": "RETENTOR"
    },
    {
        "code": "2V5-199-093",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-199-094",
        "name": "SUPORTE"
    },
    {
        "code": "23B-109-375",
        "name": "DEFLETOR"
    },
    {
        "code": "2R2-881-777-A",
        "name": "ESPUMA"
    },
    {
        "code": "2V5-199-119",
        "name": "PINO ROSCA"
    },
    {
        "code": "2V5-199-208",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-199-208-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-199-382-B",
        "name": "COXIM"
    },
    {
        "code": "2V5-199-382-C",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-905-849",
        "name": "COMUTADOR"
    },
    {
        "code": "2S2-905-851",
        "name": "COMUTADOR"
    },
    {
        "code": "2S2-906-028",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-906-028-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-525-345",
        "name": "ANEL"
    },
    {
        "code": "2R2-881-901-  -CIL",
        "name": "APOIO"
    },
    {
        "code": "2V3-311-521",
        "name": "ESFERA"
    },
    {
        "code": "2V3-311-531",
        "name": "RODA"
    },
    {
        "code": "2V3-311-531-A",
        "name": "RODA"
    },
    {
        "code": "2V3-311-533",
        "name": "LUVA"
    },
    {
        "code": "2V3-311-533-A",
        "name": "LUVA"
    },
    {
        "code": "2V3-311-542",
        "name": "HASTE"
    },
    {
        "code": "2V3-311-542-A",
        "name": "HASTE"
    },
    {
        "code": "2V3-311-542-B",
        "name": "HASTE"
    },
    {
        "code": "2V3-311-547",
        "name": "MOLA"
    },
    {
        "code": "2V3-311-549",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2R2-881-901-  -CIO",
        "name": "APOIO"
    },
    {
        "code": "2V3-311-562",
        "name": "BARRA"
    },
    {
        "code": "2V3-311-562-A",
        "name": "BARRA"
    },
    {
        "code": "2V3-311-582",
        "name": "grmapo"
    },
    {
        "code": "2V3-311-585",
        "name": "LUVA"
    },
    {
        "code": "2V3-311-585-A",
        "name": "SEGMENTO"
    },
    {
        "code": "2V3-311-585-B",
        "name": "SEGMENTO"
    },
    {
        "code": "2W0-501-319-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2W0-501-810",
        "name": "MANCAL"
    },
    {
        "code": "2W0-507-141",
        "name": "CONECTOR"
    },
    {
        "code": "2U2-711-485-H",
        "name": "MECANISMO"
    },
    {
        "code": "2R2-881-966",
        "name": "CINTA"
    },
    {
        "code": "2U2-711-855-B",
        "name": "ALAVMUDANC"
    },
    {
        "code": "2U2-711-855-C",
        "name": "ALAVMUDANC"
    },
    {
        "code": "2U2-711-855-E",
        "name": "ALAVMUDANC"
    },
    {
        "code": "2U2-711-862",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-711-862-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-253-101-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-253-143-B",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-253-144",
        "name": "BATENTE"
    },
    {
        "code": "2V5-261-583-A",
        "name": "SENSOR"
    },
    {
        "code": "2V3-301-211",
        "name": "TAMPA"
    },
    {
        "code": "2R2-883-319",
        "name": "RETENTOR"
    },
    {
        "code": "2V3-301-211-A",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-211-B",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-211-C",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-211-D",
        "name": "TAMPA"
    },
    {
        "code": "2V3-301-215",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-301-215-A",
        "name": "VEDACAO"
    },
    {
        "code": "2Z0-253-725-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V2-899-541",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-899-542",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-903-137-A",
        "name": "correia"
    },
    {
        "code": "2R2-885-161",
        "name": "DOBRADICA"
    },
    {
        "code": "2V2-905-367-B",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V2-905-367-E",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V2-907-571",
        "name": "SENSOR"
    },
    {
        "code": "2V2-907-657",
        "name": "SENSOR"
    },
    {
        "code": "2V2-919-183",
        "name": "SENSOR"
    },
    {
        "code": "2V2-919-183-B",
        "name": "SENSOR"
    },
    {
        "code": "2V2-919-183-D",
        "name": "SENSOR"
    },
    {
        "code": "2V2-919-183-F",
        "name": "SENSOR"
    },
    {
        "code": "2V2-919-733",
        "name": "suporte"
    },
    {
        "code": "2V2-920-807",
        "name": "INSTRUMENT"
    },
    {
        "code": "2R2-885-319",
        "name": "CALCO"
    },
    {
        "code": "2V2-920-807-A",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-B",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-C",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-D",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-E",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-G",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-H",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-J",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-K",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V2-920-807-R",
        "name": "INSTRUMENT"
    },
    {
        "code": "2R2-898-337-D",
        "name": "COIFA"
    },
    {
        "code": "2V2-927-103",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V3-311-187-E",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-187-F",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-189",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-189-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-205",
        "name": "EIXO INTER"
    },
    {
        "code": "2V3-311-205-A",
        "name": "EIXO INTER"
    },
    {
        "code": "2V3-311-205-B",
        "name": "EIXO INTER"
    },
    {
        "code": "2V3-311-205-C",
        "name": "EIXO INTER"
    },
    {
        "code": "2V3-311-205-D",
        "name": "EIXO INTER"
    },
    {
        "code": "2R2-898-337-E",
        "name": "PECA FIXAC"
    },
    {
        "code": "2V3-311-205-E",
        "name": "EIXO INTER"
    },
    {
        "code": "2V3-311-205-F",
        "name": "EIXO INTER"
    },
    {
        "code": "2V3-311-205-G",
        "name": "EIXO INTER"
    },
    {
        "code": "2V3-845-042",
        "name": "VIDRO LAT."
    },
    {
        "code": "2V3-845-042-  -NVB",
        "name": "VIDRO LAT."
    },
    {
        "code": "2V3-845-101",
        "name": "PARABRISA"
    },
    {
        "code": "2V3-845-101-  -NVB",
        "name": "PARABRISA"
    },
    {
        "code": "2V3-845-149",
        "name": "CANALETA"
    },
    {
        "code": "2V3-845-149-A",
        "name": "CANALETA"
    },
    {
        "code": "2V3-845-201",
        "name": "VIDRO"
    },
    {
        "code": "2R2-898-337-F",
        "name": "PECA FIXAC"
    },
    {
        "code": "2V3-845-202",
        "name": "VIDRO"
    },
    {
        "code": "2V3-845-437",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-845-437-B",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-853-053-  -69D",
        "name": "FRISO"
    },
    {
        "code": "2V3-853-054-  -69D",
        "name": "FRISO"
    },
    {
        "code": "2V3-853-057-  -69D",
        "name": "FRISO"
    },
    {
        "code": "2V3-853-058-  -69D",
        "name": "FRISO"
    },
    {
        "code": "2V3-853-261-  -69D",
        "name": "FRISO"
    },
    {
        "code": "2V3-853-261-A -69D",
        "name": "FRISO"
    },
    {
        "code": "2V3-853-261-B -69D",
        "name": "FRISO"
    },
    {
        "code": "2V3-323-121",
        "name": "PISTAO"
    },
    {
        "code": "23B-115-279-A",
        "name": "PORCA"
    },
    {
        "code": "2R2-899-329",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-853-307",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-853-421-  -61V",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-853-421-  -MX1",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-853-619",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-853-730",
        "name": "FRISORETEN"
    },
    {
        "code": "2V3-853-945",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-853-946",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-854-431",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-854-431-  -2ZZ",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-854-431-A",
        "name": "LOGOTIPO"
    },
    {
        "code": "2R2-899-371",
        "name": "PLACA FECH"
    },
    {
        "code": "2V3-854-431-A -2ZZ",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-854-431-C",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-854-431-C -2ZZ",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-854-431-D -2ZZ",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-854-431-E -2ZZ",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-854-517",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-854-518",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-854-533",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-854-533-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-854-534",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-899-387",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-854-534-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-854-749-B",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-854-750-B",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-941-006",
        "name": "FAROL"
    },
    {
        "code": "2V3-941-031",
        "name": "FAROL"
    },
    {
        "code": "2V3-941-032",
        "name": "FAROL"
    },
    {
        "code": "2V3-941-334",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-941-334-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-941-553",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-945-095-B",
        "name": "LANTERNA"
    },
    {
        "code": "2R2-899-388",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-945-095-D",
        "name": "LANTERNA"
    },
    {
        "code": "2V3-945-096-B",
        "name": "LANTERNA"
    },
    {
        "code": "2V3-945-096-D",
        "name": "LANTERNA"
    },
    {
        "code": "2V3-945-505",
        "name": "TOMADA"
    },
    {
        "code": "2V3-945-505-A",
        "name": "TOMADA"
    },
    {
        "code": "2V3-947-105",
        "name": "LUZ INTERN"
    },
    {
        "code": "2V3-947-315-C",
        "name": "interrupt."
    },
    {
        "code": "2V3-947-315-E",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-947-315-F",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-947-315-K",
        "name": "interrupt."
    },
    {
        "code": "2R2-899-397-B",
        "name": "COXIM"
    },
    {
        "code": "2V3-951-161",
        "name": "sensor"
    },
    {
        "code": "2V3-951-183",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-951-209",
        "name": "BUZINA"
    },
    {
        "code": "2V3-951-297",
        "name": "BOTAO"
    },
    {
        "code": "2V3-951-307",
        "name": "ALARME SON"
    },
    {
        "code": "2V3-953-235-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-953-541",
        "name": "ANEL"
    },
    {
        "code": "2V3-955-023",
        "name": "SIST.LAVAG"
    },
    {
        "code": "2V3-955-113",
        "name": "MOTOR"
    },
    {
        "code": "2V3-955-169",
        "name": "CAPA"
    },
    {
        "code": "2R2-899-397-C",
        "name": "AMORTECIME"
    },
    {
        "code": "2V3-955-205",
        "name": "CAPA"
    },
    {
        "code": "2V3-955-409",
        "name": "BRACO"
    },
    {
        "code": "2V3-955-453",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-955-463",
        "name": "TUBO"
    },
    {
        "code": "N  -912-774-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -909-377-02",
        "name": "ABRACADEIR"
    },
    {
        "code": "WHT-007-410",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-425",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-131-185-A",
        "name": "CONECTOR"
    },
    {
        "code": "2Z0-131-245",
        "name": "CONECTOR"
    },
    {
        "code": "2R2-899-397-D",
        "name": "AMORTECIME"
    },
    {
        "code": "2Z0-131-245-A",
        "name": "CONECTOR"
    },
    {
        "code": "2Z0-131-371",
        "name": "MANGUEIRA"
    },
    {
        "code": "2Z0-131-371-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2Z0-131-371-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2Z0-131-483",
        "name": "BRACADEIR"
    },
    {
        "code": "2Z0-131-585",
        "name": "CONECTOR"
    },
    {
        "code": "2Z0-131-585-A",
        "name": "CONECTOR"
    },
    {
        "code": "2Z0-133-150",
        "name": "porca"
    },
    {
        "code": "2Z0-133-319",
        "name": "distribuid"
    },
    {
        "code": "2Z0-145-293",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-899-505",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2Z0-145-367-F",
        "name": "TUBO"
    },
    {
        "code": "2Z0-145-667",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-237",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-446",
        "name": "PINO"
    },
    {
        "code": "WHT-008-465",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-468",
        "name": "PINOESFERI"
    },
    {
        "code": "2T2-607-303",
        "name": "TUBO"
    },
    {
        "code": "2T2-607-312-AS",
        "name": "TUBO"
    },
    {
        "code": "2T2-607-312-BL",
        "name": "TUBO"
    },
    {
        "code": "2T2-607-312-CH",
        "name": "TUBO"
    },
    {
        "code": "2R2-899-505-B",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2T2-607-313-E",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-607-315",
        "name": "CONEXAO"
    },
    {
        "code": "2W0-607-263",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-607-263-B",
        "name": "APOIO"
    },
    {
        "code": "2W0-607-263-C",
        "name": "APOIO"
    },
    {
        "code": "2W0-607-273-A",
        "name": "REBITE"
    },
    {
        "code": "2W0-607-279",
        "name": "ADAPTADOR"
    },
    {
        "code": "2W0-607-307-A",
        "name": "BUCHA"
    },
    {
        "code": "2S2-607-079-A",
        "name": "CONEXAO"
    },
    {
        "code": "2S2-607-079-D",
        "name": "CONEXAO"
    },
    {
        "code": "2R2-899-505-C",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2S2-607-079-E",
        "name": "COTOVELO"
    },
    {
        "code": "2V5-071-731",
        "name": "GUARNICAO"
    },
    {
        "code": "2V5-088-431",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-100-015-F",
        "name": "MOTOR COMP"
    },
    {
        "code": "2V5-103-103-A",
        "name": "CHAPA"
    },
    {
        "code": "2V5-103-113",
        "name": "SELO"
    },
    {
        "code": "2V5-103-113-A",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-103-113-B",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-103-113-D",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V5-103-179",
        "name": "VEDACAO"
    },
    {
        "code": "23B-130-758-A",
        "name": "SENSOR"
    },
    {
        "code": "2R2-899-505-E",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2V5-103-179-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-103-179-B",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-103-179-C",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-103-179-D",
        "name": "Pea fixa."
    },
    {
        "code": "2V5-103-181",
        "name": "JUNTA"
    },
    {
        "code": "2V5-103-182",
        "name": "TAMPA"
    },
    {
        "code": "2V5-103-196",
        "name": "ANEL"
    },
    {
        "code": "2V5-423-951",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-498-619-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-501-021-H",
        "name": "CORPOEIXO"
    },
    {
        "code": "2R2-899-507",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-501-091-H",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V5-501-091-J",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V5-501-119-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-501-123",
        "name": "suporte"
    },
    {
        "code": "2V5-501-126",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-501-183-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-501-183-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-501-205-H",
        "name": "SEMI EIXO"
    },
    {
        "code": "2V5-501-205-J",
        "name": "SEMI EIXO"
    },
    {
        "code": "2V5-501-215-C",
        "name": "PORCA"
    },
    {
        "code": "2R2-899-508",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-501-225-G",
        "name": "CALCO"
    },
    {
        "code": "2V5-501-225-H",
        "name": "CALCO"
    },
    {
        "code": "2V5-501-225-J",
        "name": "CALCO"
    },
    {
        "code": "2V5-501-225-K",
        "name": "CALCO"
    },
    {
        "code": "2V5-501-225-L",
        "name": "CALCO"
    },
    {
        "code": "2S2-609-467",
        "name": "ALOJAMENTO"
    },
    {
        "code": "2V5-513-031-C",
        "name": "AMORTECIME"
    },
    {
        "code": "2V5-513-661",
        "name": "PINO"
    },
    {
        "code": "2V5-513-661-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-521-291-A",
        "name": "CRUZETA"
    },
    {
        "code": "2R2-899-512-A",
        "name": "BUCHA"
    },
    {
        "code": "2V5-525-077-M",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V5-525-083-D",
        "name": "CAIXA"
    },
    {
        "code": "2V5-525-089",
        "name": "JUNTA"
    },
    {
        "code": "2V5-525-121-B",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-525-121-L",
        "name": "CAIXA"
    },
    {
        "code": "2V5-525-163",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V5-525-163-A",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V5-525-163-C",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V5-525-163-J",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V5-525-223-B",
        "name": "CAIXA"
    },
    {
        "code": "2R2-899-549",
        "name": "LUVA"
    },
    {
        "code": "2V5-525-223-C",
        "name": "CAIXA"
    },
    {
        "code": "2V5-525-253",
        "name": "CONE"
    },
    {
        "code": "2V5-525-267",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-AA",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-881-041-L -QFE",
        "name": "ENCOSTO"
    },
    {
        "code": "2T2-881-041-L -QFF",
        "name": "ENCOSTO"
    },
    {
        "code": "2T2-881-901-  -QFE",
        "name": "APOIO"
    },
    {
        "code": "2T2-881-901-  -QFF",
        "name": "APOIO"
    },
    {
        "code": "2T2-885-711",
        "name": "CHAPA"
    },
    {
        "code": "2R2-899-563",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-899-361",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-899-362",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-899-365-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-607-325",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-607-329-C",
        "name": "VALVULA"
    },
    {
        "code": "2V5-607-337",
        "name": "VALVULA"
    },
    {
        "code": "2V5-607-337-A",
        "name": "VALVULA"
    },
    {
        "code": "2V5-607-355",
        "name": "VALVULA"
    },
    {
        "code": "2V5-607-361",
        "name": "valvula"
    },
    {
        "code": "2V5-607-363-C",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-899-565",
        "name": "BUCHA"
    },
    {
        "code": "2V5-607-363-J",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-607-367",
        "name": "CONEXAO"
    },
    {
        "code": "2V5-607-389",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-609-623",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-609-719",
        "name": "BRACADEIR"
    },
    {
        "code": "2V5-609-737",
        "name": "FLANGEISOL"
    },
    {
        "code": "2V5-609-746-B",
        "name": "suporte"
    },
    {
        "code": "2V5-609-747-AB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-609-747-AC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-609-747-AD",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-899-567",
        "name": "BUCHA"
    },
    {
        "code": "2V5-609-747-P",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-609-747-Q",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-609-753",
        "name": "VALVULA"
    },
    {
        "code": "2V5-609-765",
        "name": "suporte"
    },
    {
        "code": "WHT-009-576",
        "name": "TAMPAO"
    },
    {
        "code": "WHT-009-623",
        "name": "PORCA"
    },
    {
        "code": "WHT-009-636",
        "name": "ANEL VEDAC"
    },
    {
        "code": "WHT-009-648",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V5-611-819",
        "name": "MANG APOIO"
    },
    {
        "code": "2V5-611-820-C",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-899-592",
        "name": "DISCO"
    },
    {
        "code": "2V5-611-820-D",
        "name": "suporte"
    },
    {
        "code": "2V5-611-841",
        "name": "suporte"
    },
    {
        "code": "2V5-611-850",
        "name": "ARTICULA."
    },
    {
        "code": "2V5-611-851",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-611-909-B",
        "name": "CONECTOR"
    },
    {
        "code": "2V5-612-109",
        "name": "ANEL"
    },
    {
        "code": "2V5-612-109-C",
        "name": "ANEL"
    },
    {
        "code": "2V5-614-150-C",
        "name": "RODAPULSO"
    },
    {
        "code": "2V5-614-167-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-614-173-A",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2R2-907-291-B",
        "name": "CONTROLE"
    },
    {
        "code": "2V5-614-173-B",
        "name": "LUVA"
    },
    {
        "code": "2V5-614-173-C",
        "name": "LUVA"
    },
    {
        "code": "2V5-614-193-A",
        "name": "suporte"
    },
    {
        "code": "2V5-614-227",
        "name": "HASTE"
    },
    {
        "code": "N  -011-531-1",
        "name": "ARRUELA"
    },
    {
        "code": "WHT-009-176",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-834",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-837",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-838",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-855",
        "name": "HASTE"
    },
    {
        "code": "23B-131-131",
        "name": "ESPACADOR"
    },
    {
        "code": "2R2-907-333",
        "name": "suporte"
    },
    {
        "code": "WHT-006-871",
        "name": "porca"
    },
    {
        "code": "2V5-971-004-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-971-004-D",
        "name": "suporte"
    },
    {
        "code": "2V5-971-048",
        "name": "CONDUTOR"
    },
    {
        "code": "2V3-121-301",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-121-301-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-121-313",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-121-313-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-121-313-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-121-313-D",
        "name": "suporte"
    },
    {
        "code": "2R2-920-806-Q",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V3-121-313-G",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-121-313-H",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-121-313-J",
        "name": "suporte"
    },
    {
        "code": "2V3-121-321",
        "name": "TAMPA"
    },
    {
        "code": "2V3-121-327-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-121-405-B",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-121-405-C",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-121-405-D",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-121-477-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-121-523-A",
        "name": "ADAPTADOR"
    },
    {
        "code": "2R2-920-807-  -1NN",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V3-121-523-B",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V3-121-549",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-121-589",
        "name": "VALVULA"
    },
    {
        "code": "2V3-121-625",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-121-625-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-121-625-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-121-651",
        "name": "DEFLETOR"
    },
    {
        "code": "2V3-121-651-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V3-121-955",
        "name": "DRENO AGUA"
    },
    {
        "code": "2V3-127-177",
        "name": "ELEM FILTR"
    },
    {
        "code": "2R2-927-103",
        "name": "RELE"
    },
    {
        "code": "2V3-127-177-B",
        "name": "ELEM FILTR"
    },
    {
        "code": "2V3-127-182",
        "name": "ANEL"
    },
    {
        "code": "2V3-127-401-A",
        "name": "FILTR COMB"
    },
    {
        "code": "2V3-127-505",
        "name": "TUBO"
    },
    {
        "code": "2V3-127-505-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-129-051",
        "name": "TUBO"
    },
    {
        "code": "2V3-129-119",
        "name": "ANEL"
    },
    {
        "code": "2V3-129-119-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-129-119-B",
        "name": "ANEL"
    },
    {
        "code": "2V3-129-142",
        "name": "BRACADEIR"
    },
    {
        "code": "2R2-937-548",
        "name": "CAIXA"
    },
    {
        "code": "2V3-129-321",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-129-321-A",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-129-367",
        "name": "TUBO"
    },
    {
        "code": "2V3-129-367-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-609-736",
        "name": "suporte"
    },
    {
        "code": "2V3-609-745",
        "name": "suporte"
    },
    {
        "code": "2V3-609-745-A",
        "name": "suporte"
    },
    {
        "code": "2V3-609-746",
        "name": "suporte"
    },
    {
        "code": "2V3-609-765-A",
        "name": "suporte"
    },
    {
        "code": "2V3-609-853",
        "name": "REGULADOR"
    },
    {
        "code": "2R2-937-565",
        "name": "TAMPA"
    },
    {
        "code": "2V3-609-853-A",
        "name": "REGULADOR"
    },
    {
        "code": "2V3-609-854",
        "name": "REGULADOR"
    },
    {
        "code": "2V3-609-854-A",
        "name": "REGULADOR"
    },
    {
        "code": "2V3-611-320",
        "name": "suporte"
    },
    {
        "code": "2V3-611-403",
        "name": "PRESILHA"
    },
    {
        "code": "2V3-611-755",
        "name": "DISTRIBUID"
    },
    {
        "code": "2V3-611-757-A",
        "name": "suporte"
    },
    {
        "code": "2V3-611-758-A",
        "name": "suporte"
    },
    {
        "code": "2V3-611-793",
        "name": "suporte"
    },
    {
        "code": "2V3-611-798",
        "name": "suporte"
    },
    {
        "code": "2R2-941-031",
        "name": "FAROL"
    },
    {
        "code": "2V3-611-820",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-611-820-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-611-820-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-611-820-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-611-841",
        "name": "suporte"
    },
    {
        "code": "2V3-612-074",
        "name": "TUBO"
    },
    {
        "code": "2V3-612-074-A",
        "name": "TUBO"
    },
    {
        "code": "07W-109-345",
        "name": "O ring"
    },
    {
        "code": "07W-115-427-M",
        "name": "ANEL"
    },
    {
        "code": "07W-115-427-N",
        "name": "ANEL"
    },
    {
        "code": "2R2-941-032",
        "name": "FAROL"
    },
    {
        "code": "WHT-007-034",
        "name": "BRACADEIRA"
    },
    {
        "code": "WHT-007-910",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-912",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-881-023-B -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2T2-881-023-D -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2T2-881-023-D -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2T2-881-023-E -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "WHT-007-266",
        "name": "porca"
    },
    {
        "code": "WHT-007-297",
        "name": "conexÆo"
    },
    {
        "code": "111-837-941",
        "name": "MOLA DISCO"
    },
    {
        "code": "2R2-941-075",
        "name": "PROTECAO"
    },
    {
        "code": "WHT-005-852",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-854",
        "name": "porca"
    },
    {
        "code": "WHT-005-860",
        "name": "porca"
    },
    {
        "code": "WHT-005-863",
        "name": "BOCAL"
    },
    {
        "code": "WHT-005-864",
        "name": "ENGRAXADEI"
    },
    {
        "code": "WHT-005-868",
        "name": "REBITE"
    },
    {
        "code": "WHT-005-875",
        "name": "EIXO ENGRE"
    },
    {
        "code": "N  -907-011-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-971-739",
        "name": "CINTA"
    },
    {
        "code": "N  -108-211-01",
        "name": "PORCA"
    },
    {
        "code": "2R2-945-341-D -1NN",
        "name": "LUZ PISCA"
    },
    {
        "code": "2Z0-129-642",
        "name": "BRACADEIRA"
    },
    {
        "code": "2Z0-129-688",
        "name": "ESPACADOR"
    },
    {
        "code": "2Z0-129-716-D",
        "name": "TUBO"
    },
    {
        "code": "2Z0-129-717",
        "name": "JUNTA"
    },
    {
        "code": "2Z0-129-720",
        "name": "COLETOR"
    },
    {
        "code": "2Z0-129-817",
        "name": "CARCACA"
    },
    {
        "code": "2Z0-129-817-A",
        "name": "CARCACA"
    },
    {
        "code": "2Z0-129-817-B",
        "name": "CARCACA"
    },
    {
        "code": "2Z0-129-817-C",
        "name": "CARCACA"
    },
    {
        "code": "2Z0-129-877",
        "name": "PARAFUSO"
    },
    {
        "code": "23B-253-143-P",
        "name": "Bracadeira"
    },
    {
        "code": "2R2-945-341-E -1NN",
        "name": "LUZ PISCA"
    },
    {
        "code": "2Z0-129-877-A",
        "name": "TAMPA"
    },
    {
        "code": "2Z0-130-085",
        "name": "TUBO"
    },
    {
        "code": "2Z0-130-085-A",
        "name": "TUBO"
    },
    {
        "code": "2Z0-130-118-B",
        "name": "AMORTECEDO"
    },
    {
        "code": "2Z0-130-120",
        "name": "ANEL"
    },
    {
        "code": "2Z0-130-120-A",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2Z0-130-139",
        "name": "ANEL"
    },
    {
        "code": "N  -108-631-01",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-953-037-A",
        "name": "LUZ"
    },
    {
        "code": "23K-953-223",
        "name": "PLACA"
    },
    {
        "code": "2R2-945-511",
        "name": "SENSOR"
    },
    {
        "code": "23K-955-431",
        "name": "COIFA"
    },
    {
        "code": "23K-955-451",
        "name": "RESERVATOR"
    },
    {
        "code": "23K-955-451-B",
        "name": "RESERVATOR"
    },
    {
        "code": "23K-955-463",
        "name": "TUBO"
    },
    {
        "code": "23K-955-463-A",
        "name": "TUBO"
    },
    {
        "code": "23K-955-853",
        "name": "ADAPTADOR"
    },
    {
        "code": "23K-971-003-A",
        "name": "suporte"
    },
    {
        "code": "23K-971-003-C",
        "name": "suporte"
    },
    {
        "code": "23K-971-004-B",
        "name": "suporte"
    },
    {
        "code": "23K-971-004-C",
        "name": "suporte"
    },
    {
        "code": "2R2-947-105",
        "name": "LUZ INTERN"
    },
    {
        "code": "23K-971-004-D",
        "name": "suporte"
    },
    {
        "code": "23K-971-015-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-015-L",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-015-M",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-051-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-051-AE",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-051-AG",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-051-AH",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-051-AJ",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-073",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-947-105-  -U71",
        "name": "LUZ INTERN"
    },
    {
        "code": "23K-971-073-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-073-C",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-073-D",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-113",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-113-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-118",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-118-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-169-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-169-G",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-169-H",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-947-105-  -Y20",
        "name": "LUZ INTERN"
    },
    {
        "code": "23K-971-311",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-311-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-311-D",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-312",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-312-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-312-C",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-641-A",
        "name": "CHICOTE"
    },
    {
        "code": "23K-971-819",
        "name": "CHICOTE"
    },
    {
        "code": "23L-010-039",
        "name": "ETIQUETA"
    },
    {
        "code": "23L-100-015-C",
        "name": "MOTOR COMP"
    },
    {
        "code": "2R2-947-105-A",
        "name": "LUZ INTERN"
    },
    {
        "code": "23L-100-015-D",
        "name": "MOTOR COMP"
    },
    {
        "code": "23L-103-011",
        "name": "BLOCO"
    },
    {
        "code": "23L-103-037",
        "name": "TAMPAO"
    },
    {
        "code": "23L-103-085",
        "name": "RETENTOR"
    },
    {
        "code": "23L-103-113",
        "name": "BujÆo"
    },
    {
        "code": "23L-103-113-A",
        "name": "BujÆo"
    },
    {
        "code": "23L-103-113-B",
        "name": "BujÆo"
    },
    {
        "code": "23L-103-113-C",
        "name": "BujÆo"
    },
    {
        "code": "23L-103-261",
        "name": "SUPORTE"
    },
    {
        "code": "23L-103-321",
        "name": "CAMISA"
    },
    {
        "code": "2R2-951-209-A",
        "name": "BUZINA"
    },
    {
        "code": "23L-103-351",
        "name": "CABECOTE"
    },
    {
        "code": "23L-103-351-A",
        "name": "CABECOTE"
    },
    {
        "code": "23L-103-401",
        "name": "GUIA"
    },
    {
        "code": "23L-103-448",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-103-448-A",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-103-875",
        "name": "PINO"
    },
    {
        "code": "23L-103-875-A",
        "name": "PINO"
    },
    {
        "code": "23L-105-311",
        "name": "CASQUILHO"
    },
    {
        "code": "23L-105-387",
        "name": "CUBO"
    },
    {
        "code": "23L-105-701",
        "name": "CASQUILHO"
    },
    {
        "code": "2R2-953-037",
        "name": "LUZ"
    },
    {
        "code": "23L-105-701-A",
        "name": "CASQUILHO"
    },
    {
        "code": "23L-105-701-B",
        "name": "CASQUILHO"
    },
    {
        "code": "23L-105-701-C",
        "name": "CASQUILHO"
    },
    {
        "code": "23L-107-067",
        "name": "PISTAO"
    },
    {
        "code": "23L-107-067-A",
        "name": "PISTAO"
    },
    {
        "code": "N  -912-893-01",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-006-716",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-006-717",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-398-747-C",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2V3-398-747-D",
        "name": "JG.MONTAGE"
    },
    {
        "code": "2R2-953-513",
        "name": "COMUTADOR"
    },
    {
        "code": "2V3-399-243",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-A",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-B",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-C",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-D",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-F",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-H",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-J",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-M",
        "name": "suporte"
    },
    {
        "code": "2V3-399-243-N",
        "name": "suporte"
    },
    {
        "code": "2R2-953-561-  -999",
        "name": "CAPA COBER"
    },
    {
        "code": "2V3-401-055",
        "name": "CORPO EIXO"
    },
    {
        "code": "2V3-407-021",
        "name": "ALAVANCA"
    },
    {
        "code": "2V3-407-022",
        "name": "ALAVANCA"
    },
    {
        "code": "2V3-407-403",
        "name": "MANG EIXO"
    },
    {
        "code": "2V3-407-404",
        "name": "MANG EIXO"
    },
    {
        "code": "2V3-407-443",
        "name": "PINO"
    },
    {
        "code": "2V3-407-717",
        "name": "ALAVANCA"
    },
    {
        "code": "2V3-409-270",
        "name": "SENSOR"
    },
    {
        "code": "2V3-409-270-A",
        "name": "SENSOR"
    },
    {
        "code": "2V3-409-270-B",
        "name": "SENSOR"
    },
    {
        "code": "23B-298-013-A",
        "name": "SENSOR DE"
    },
    {
        "code": "2R2-955-023-A",
        "name": "SIST.LAVAG"
    },
    {
        "code": "2V3-409-270-D",
        "name": "SENSOR"
    },
    {
        "code": "2W0-609-525-A",
        "name": "SAPATA"
    },
    {
        "code": "2W0-609-525-C",
        "name": "SAPATA"
    },
    {
        "code": "2W0-609-561",
        "name": "ROLETE"
    },
    {
        "code": "2W0-609-727-A",
        "name": "PINO"
    },
    {
        "code": "2W0-609-853",
        "name": "REGULADOR"
    },
    {
        "code": "2W0-609-854",
        "name": "REGULADOR"
    },
    {
        "code": "5G0-959-855-P -WHS",
        "name": "INTERRUPTO"
    },
    {
        "code": "07W-019-873-CF",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-CH",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-955-409",
        "name": "BRACO"
    },
    {
        "code": "07W-019-873-D",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-E",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-F",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-G",
        "name": "PARAFUSO"
    },
    {
        "code": "G  -052-823-Q7",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-824-Q2",
        "name": "LUBRIFICAN"
    },
    {
        "code": "G  -052-824-Q4",
        "name": "LUBRIFICAN"
    },
    {
        "code": "N  -912-454-01",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-103-085",
        "name": "RETENTOR"
    },
    {
        "code": "2P0-000-367",
        "name": "ADESIVO"
    },
    {
        "code": "2R2-955-425",
        "name": "PALHETA"
    },
    {
        "code": "WHT-008-215",
        "name": "porca"
    },
    {
        "code": "WHT-008-216",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -912-303-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-438-01",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-539",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-008-891",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -107-998-01",
        "name": "APERTO"
    },
    {
        "code": "WHT-008-574",
        "name": "PARAFUSO"
    },
    {
        "code": "2R0-000-294",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R0-000-294-B",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R2-955-453",
        "name": "RESERVATOR"
    },
    {
        "code": "2R0-000-294-D",
        "name": "ETIQUETAID"
    },
    {
        "code": "2T2-612-406-A",
        "name": "suporte"
    },
    {
        "code": "2T2-615-331",
        "name": "CAMARA DO"
    },
    {
        "code": "2T2-615-331-J",
        "name": "CAMARA DO"
    },
    {
        "code": "2T2-615-332",
        "name": "CAMARA DO"
    },
    {
        "code": "2T2-615-332-K",
        "name": "CAMARA DO"
    },
    {
        "code": "2T2-616-015",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2T2-616-039",
        "name": "MOLA"
    },
    {
        "code": "2T2-616-787",
        "name": "FILTRO"
    },
    {
        "code": "23K-201-512",
        "name": "FILTR COMB"
    },
    {
        "code": "2R2-955-475",
        "name": "suporte"
    },
    {
        "code": "23K-201-512-A",
        "name": "FILTR COMB"
    },
    {
        "code": "23K-201-561",
        "name": "SUPORTE"
    },
    {
        "code": "23K-201-561-A",
        "name": "PLACA"
    },
    {
        "code": "23K-201-562",
        "name": "SUPORTE"
    },
    {
        "code": "23K-201-722-B",
        "name": "SUPORTE"
    },
    {
        "code": "23K-201-722-D",
        "name": "SUPORTE"
    },
    {
        "code": "23K-201-923-E",
        "name": "SUPORTE"
    },
    {
        "code": "23K-201-958-A",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-251-228",
        "name": "suporte"
    },
    {
        "code": "23K-251-228-A",
        "name": "suporte"
    },
    {
        "code": "2R2-955-529",
        "name": "RELE"
    },
    {
        "code": "23K-251-279",
        "name": "suporte"
    },
    {
        "code": "23K-253-037-B",
        "name": "DEFLETOR"
    },
    {
        "code": "23K-253-037-E",
        "name": "DEFLETOR"
    },
    {
        "code": "23K-253-075-A",
        "name": "TUBO"
    },
    {
        "code": "23K-253-173-C",
        "name": "TUBO"
    },
    {
        "code": "23K-253-319-K",
        "name": "suporte"
    },
    {
        "code": "23K-253-319-L",
        "name": "suporte"
    },
    {
        "code": "23K-253-319-M",
        "name": "suporte"
    },
    {
        "code": "23K-253-683",
        "name": "PONT.ESCAP"
    },
    {
        "code": "23K-253-683-A",
        "name": "TUBO"
    },
    {
        "code": "2R2-955-962",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-253-843-A",
        "name": "Mangueira"
    },
    {
        "code": "23K-253-843-B",
        "name": "Mangueira"
    },
    {
        "code": "23K-254-253",
        "name": "CATALISADO"
    },
    {
        "code": "23K-254-253-B",
        "name": "CATALISADO"
    },
    {
        "code": "23K-265-053",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-300-027-J",
        "name": "CX.MUDANCA"
    },
    {
        "code": "23K-300-027-K",
        "name": "CX.MUDANCA"
    },
    {
        "code": "23K-300-057",
        "name": "TRANSMIS."
    },
    {
        "code": "23K-300-057-C",
        "name": "TRANSMIS."
    },
    {
        "code": "23K-300-057-D",
        "name": "TRANSMIS."
    },
    {
        "code": "2R2-955-962-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-300-057-E",
        "name": "TRANSMIS."
    },
    {
        "code": "23K-300-057-F",
        "name": "TRANSMIS."
    },
    {
        "code": "23K-300-057-G",
        "name": "TRANSMIS."
    },
    {
        "code": "23K-300-057-H",
        "name": "TRANSMIS."
    },
    {
        "code": "23K-300-057-J",
        "name": "TRANSMIS."
    },
    {
        "code": "23K-301-293",
        "name": "PLACAINTER"
    },
    {
        "code": "23K-301-293-A",
        "name": "PLACAINTER"
    },
    {
        "code": "23K-311-381",
        "name": "ANEL"
    },
    {
        "code": "23K-311-499",
        "name": "ANEL"
    },
    {
        "code": "2V1-701-185",
        "name": "suporte"
    },
    {
        "code": "2R2-955-962-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V1-701-186",
        "name": "suporte"
    },
    {
        "code": "2V1-701-273",
        "name": "CHAPA"
    },
    {
        "code": "2V1-701-441",
        "name": "LONGARINA"
    },
    {
        "code": "2V1-701-441-A",
        "name": "LONGARINA"
    },
    {
        "code": "2V1-701-442",
        "name": "LONGARINA"
    },
    {
        "code": "2V1-701-442-A",
        "name": "LONGARINA"
    },
    {
        "code": "2V1-701-479",
        "name": "ANGULO"
    },
    {
        "code": "2V1-701-479-A",
        "name": "ANGULO"
    },
    {
        "code": "2V1-701-480",
        "name": "ANGULO"
    },
    {
        "code": "2V1-701-480-A",
        "name": "ANGULO"
    },
    {
        "code": "2R2-955-962-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V1-701-487",
        "name": "CONSOLE"
    },
    {
        "code": "2V1-701-575",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V1-701-576",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V1-711-895",
        "name": "PLACA"
    },
    {
        "code": "2V1-803-185",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-803-186",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-803-249",
        "name": "HASTE"
    },
    {
        "code": "2V1-803-571",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-803-572",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-803-573",
        "name": "SUPORTE"
    },
    {
        "code": "23B-298-021",
        "name": "ADAPTADOR"
    },
    {
        "code": "2R2-957-039-B",
        "name": "TACOGRAFO"
    },
    {
        "code": "2V1-803-573-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-804-195",
        "name": "suporte"
    },
    {
        "code": "2V1-804-571",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-804-572",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-804-591",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-804-633",
        "name": "suporte"
    },
    {
        "code": "2V1-804-637",
        "name": "PLACA"
    },
    {
        "code": "2V1-804-883",
        "name": "PLACA"
    },
    {
        "code": "2V1-807-401",
        "name": "PINO"
    },
    {
        "code": "2V1-809-100",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-957-039-S",
        "name": "TACOGRAFO"
    },
    {
        "code": "N  -105-255-09",
        "name": "Fuse"
    },
    {
        "code": "N  -905-606-02",
        "name": "ARRUELA"
    },
    {
        "code": "N  -106-320-03",
        "name": "PARAFUSO"
    },
    {
        "code": "23B-941-333-  -9B9",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-334-B -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-334-E -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-435-B -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-531",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-941-531-  -TKK",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-911-251",
        "name": "RELE"
    },
    {
        "code": "2R2-957-039-T",
        "name": "TACOGRAFO"
    },
    {
        "code": "23B-915-516",
        "name": "SUPORTE"
    },
    {
        "code": "23B-915-521",
        "name": "PROTETOR"
    },
    {
        "code": "23B-915-522",
        "name": "PROTETOR"
    },
    {
        "code": "2T2-422-069-A",
        "name": "CAIXA"
    },
    {
        "code": "2T2-422-156-H",
        "name": "BOMBA"
    },
    {
        "code": "2T2-422-335",
        "name": "BARRA DIR"
    },
    {
        "code": "2T2-422-335-Q",
        "name": "BARRA DIR"
    },
    {
        "code": "2T2-422-547-A",
        "name": "BRAO"
    },
    {
        "code": "2T2-422-553",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-422-753",
        "name": "Eixo inte."
    },
    {
        "code": "2R2-959-263",
        "name": "PRE RESIST"
    },
    {
        "code": "N  -102-615-14",
        "name": "FUSIVEL"
    },
    {
        "code": "2S2-907-333",
        "name": "suporte"
    },
    {
        "code": "2S2-907-631",
        "name": "VALVULA"
    },
    {
        "code": "2S2-915-403",
        "name": "TRAVESSA"
    },
    {
        "code": "2S2-915-516-A",
        "name": "REGUA"
    },
    {
        "code": "2S2-919-040-B",
        "name": "LAMPADA"
    },
    {
        "code": "2S2-919-183",
        "name": "SENSOR"
    },
    {
        "code": "2T2-607-335",
        "name": "AMORTECEDO"
    },
    {
        "code": "2T2-607-355",
        "name": "VALVULA"
    },
    {
        "code": "2T2-607-363-L",
        "name": "suporte"
    },
    {
        "code": "2R2-959-565-  -01C",
        "name": "INTERRUPTO"
    },
    {
        "code": "07W-103-419-A",
        "name": "GUIA"
    },
    {
        "code": "07W-103-431-B",
        "name": "ANEL"
    },
    {
        "code": "07W-103-431-C",
        "name": "ANEL"
    },
    {
        "code": "N  -106-531-02",
        "name": "PARAFUSO"
    },
    {
        "code": "23F-129-153",
        "name": "sensor"
    },
    {
        "code": "07W-145-820-T",
        "name": "TUBO"
    },
    {
        "code": "WHT-006-951",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-953",
        "name": "CONEXAO"
    },
    {
        "code": "WHT-006-963",
        "name": "PINO"
    },
    {
        "code": "WHT-007-171",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2R2-971-050-AF",
        "name": "CHICOTE"
    },
    {
        "code": "WHT-007-182",
        "name": "ROLAMENTO"
    },
    {
        "code": "WHT-007-187",
        "name": "ROLAMENTO"
    },
    {
        "code": "WHT-007-191",
        "name": "ROLAMENTO"
    },
    {
        "code": "WHT-007-196",
        "name": "PORCA"
    },
    {
        "code": "WHT-007-203",
        "name": "PARAFUSO"
    },
    {
        "code": "23M-607-361",
        "name": "VALVULA"
    },
    {
        "code": "WHT-007-945",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-947",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-949",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-950",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-971-050-AG",
        "name": "CHICOTE"
    },
    {
        "code": "23B-517-606-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-000-401-D",
        "name": "ETIQUETA"
    },
    {
        "code": "2S2-000-401-E",
        "name": "ETIQUETA"
    },
    {
        "code": "2S2-000-401-F",
        "name": "ETIQUETA"
    },
    {
        "code": "2S2-000-401-G",
        "name": "ETIQUETA"
    },
    {
        "code": "2S2-010-010",
        "name": "ETIQUETA"
    },
    {
        "code": "2S2-010-010-A",
        "name": "ETIQUETA"
    },
    {
        "code": "23M-937-046",
        "name": "CONTROLE"
    },
    {
        "code": "23M-945-095",
        "name": "LANTERNA"
    },
    {
        "code": "23M-945-096",
        "name": "LANTERNA"
    },
    {
        "code": "2R2-971-161-B",
        "name": "CHICOTE P"
    },
    {
        "code": "23M-945-509",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-201-392-D",
        "name": "CINTA"
    },
    {
        "code": "2V5-201-427",
        "name": "CONTRAPINO"
    },
    {
        "code": "2V5-201-433-A",
        "name": "TAMPA"
    },
    {
        "code": "2V5-201-495-A",
        "name": "TUBO ADMIS"
    },
    {
        "code": "2V5-201-512-J",
        "name": "FILTR COMB"
    },
    {
        "code": "N  -906-969-01",
        "name": "CLIP"
    },
    {
        "code": "2P0-419-669",
        "name": "TECLA"
    },
    {
        "code": "2P0-419-669-  -9B9",
        "name": "TECLA"
    },
    {
        "code": "N  -106-756-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-971-161-C",
        "name": "CHICOTE P"
    },
    {
        "code": "WHT-007-486",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-007-493",
        "name": "PORCA"
    },
    {
        "code": "WHT-007-994",
        "name": "PARAFUSO"
    },
    {
        "code": "23B-971-014-B",
        "name": "CHICOTE"
    },
    {
        "code": "N  -022-149-1",
        "name": "PORCA"
    },
    {
        "code": "N  -022-149-2",
        "name": "PORCA"
    },
    {
        "code": "2V3-701-617",
        "name": "TRAVESSA"
    },
    {
        "code": "2V3-701-687",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V3-701-687-A",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V3-701-688",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2R2-971-162-A",
        "name": "CHICOTE P"
    },
    {
        "code": "2V3-701-688-A",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V3-701-693",
        "name": "CHAPA"
    },
    {
        "code": "2V3-703-627",
        "name": "REFORCO"
    },
    {
        "code": "2V3-703-628",
        "name": "REFORCO"
    },
    {
        "code": "2V3-703-795",
        "name": "REFORCO"
    },
    {
        "code": "2V3-703-796",
        "name": "REFORCO"
    },
    {
        "code": "2V3-705-583",
        "name": "suporte"
    },
    {
        "code": "2V3-705-583-A",
        "name": "suporte"
    },
    {
        "code": "2V3-711-895",
        "name": "PLACA"
    },
    {
        "code": "2V3-721-029",
        "name": "Pedaleira"
    },
    {
        "code": "23B-298-021-A",
        "name": "COLETOR"
    },
    {
        "code": "2R2-971-531",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-721-029-A",
        "name": "Pedaleira"
    },
    {
        "code": "2V3-721-381",
        "name": "BATENTE"
    },
    {
        "code": "2V3-721-382",
        "name": "BATENTE"
    },
    {
        "code": "2V3-798-261",
        "name": "Repair set"
    },
    {
        "code": "2V3-798-261-A",
        "name": "Repair set"
    },
    {
        "code": "2V3-800-049-A -I7N",
        "name": "Cabina"
    },
    {
        "code": "2V3-800-049-A -I9A",
        "name": "Cabina"
    },
    {
        "code": "2V3-800-375-B",
        "name": "JG.CILINDR"
    },
    {
        "code": "2V3-800-375-C",
        "name": "JG.CILINDR"
    },
    {
        "code": "2V3-800-375-D",
        "name": "JG.CILINDR"
    },
    {
        "code": "2R2-971-561",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-802-209",
        "name": "CHAPA"
    },
    {
        "code": "2V3-802-210",
        "name": "CHAPA"
    },
    {
        "code": "2V3-802-645-B",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-802-646-B",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-802-646-C",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-802-646-D",
        "name": "DEGRAU"
    },
    {
        "code": "2W0-422-705",
        "name": "PRESILHA"
    },
    {
        "code": "N  -910-489-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2P0-298-013",
        "name": "SENSOR DE"
    },
    {
        "code": "2T2-130-744-A",
        "name": "BOMBA COMB"
    },
    {
        "code": "2R2-971-593",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-130-764-A",
        "name": "VALVULA"
    },
    {
        "code": "2T2-130-813",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-131-063",
        "name": "VALVULA"
    },
    {
        "code": "2T2-131-113-B",
        "name": "UNIDADE"
    },
    {
        "code": "2T2-131-121",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-131-121-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-131-159-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-131-347",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-131-371",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-131-371-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R2-972-067-A",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-131-523",
        "name": "MEMBRANA"
    },
    {
        "code": "2T2-131-583",
        "name": "TUBULACAO"
    },
    {
        "code": "2T2-131-584",
        "name": "TUBULACAO"
    },
    {
        "code": "2T2-131-585",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-131-585-A",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-131-585-C",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-131-585-D",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-131-980",
        "name": "TAMPA"
    },
    {
        "code": "2VC-608-795-A",
        "name": "ANEL"
    },
    {
        "code": "2VC-608-797",
        "name": "ANEL"
    },
    {
        "code": "2R2-972-840",
        "name": "TAMPAO"
    },
    {
        "code": "23B-607-085-AH",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-B",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-C",
        "name": "CONECTOR"
    },
    {
        "code": "2W0-614-129",
        "name": "RETENTOR"
    },
    {
        "code": "2W0-614-150",
        "name": "RODAPULSO"
    },
    {
        "code": "2W0-703-529",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-806-155",
        "name": "AMORTECIME"
    },
    {
        "code": "2W0-825-455-A",
        "name": "REB CEGO"
    },
    {
        "code": "2T2-407-517",
        "name": "JUNTA"
    },
    {
        "code": "2T2-407-989",
        "name": "PORCA"
    },
    {
        "code": "2R2-998-003",
        "name": "MOTOR"
    },
    {
        "code": "2T2-411-025-A",
        "name": "BARRA"
    },
    {
        "code": "2T2-411-041",
        "name": "MANCAL"
    },
    {
        "code": "2T2-411-047",
        "name": "TUBO"
    },
    {
        "code": "2T2-937-115-B",
        "name": "TAMPAO"
    },
    {
        "code": "2T2-937-115-D",
        "name": "TAMPAO"
    },
    {
        "code": "2T2-941-365-A",
        "name": "TAMPA"
    },
    {
        "code": "2T2-941-365-A -4M2",
        "name": "TAMPA"
    },
    {
        "code": "2T2-941-365-A -WJ1",
        "name": "TAMPA"
    },
    {
        "code": "2T2-947-171",
        "name": "LAMPADA"
    },
    {
        "code": "2T2-971-003",
        "name": "suporte"
    },
    {
        "code": "2R4-601-373",
        "name": "TUBO"
    },
    {
        "code": "2T2-971-003-C",
        "name": "suporte"
    },
    {
        "code": "2W0-129-620-A",
        "name": "ELEMENTO"
    },
    {
        "code": "2P0-599-505",
        "name": "PORCA"
    },
    {
        "code": "2P0-599-505-A",
        "name": "PORCA"
    },
    {
        "code": "WHT-008-380",
        "name": "CONTRAPINO"
    },
    {
        "code": "N  -106-209-01",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-007-791-B",
        "name": "ANEL"
    },
    {
        "code": "WHT-007-791-C",
        "name": "ANEL"
    },
    {
        "code": "N  -106-331-02",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-130-789-C",
        "name": "VALVULA"
    },
    {
        "code": "2R4-831-444",
        "name": "PLACASUPOR"
    },
    {
        "code": "2V3-501-810",
        "name": "MANCAL"
    },
    {
        "code": "2V3-501-810-A",
        "name": "MANCAL"
    },
    {
        "code": "2V3-501-810-B",
        "name": "MANCAL"
    },
    {
        "code": "2V3-501-810-C",
        "name": "MANCAL"
    },
    {
        "code": "2V3-505-085",
        "name": "suporte"
    },
    {
        "code": "2V3-505-085-A",
        "name": "suporte"
    },
    {
        "code": "2V3-505-179",
        "name": "BUCHA"
    },
    {
        "code": "2V3-505-179-A",
        "name": "BUCHA"
    },
    {
        "code": "2V3-505-179-B",
        "name": "BUCHA"
    },
    {
        "code": "2V3-505-189-A",
        "name": "BATENTE"
    },
    {
        "code": "2R4-881-439",
        "name": "BASE"
    },
    {
        "code": "2V3-505-189-B",
        "name": "CHAPA"
    },
    {
        "code": "2V3-505-423",
        "name": "TRAVESSA"
    },
    {
        "code": "2V3-505-424",
        "name": "TRAVESSA"
    },
    {
        "code": "2V3-505-475",
        "name": "CHP UNIAO"
    },
    {
        "code": "2V3-505-577-A",
        "name": "suporte"
    },
    {
        "code": "2V3-511-025",
        "name": "BARRA"
    },
    {
        "code": "2V3-511-149",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-511-149-A",
        "name": "APOIO"
    },
    {
        "code": "2V3-511-151-A",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V3-511-199",
        "name": "PORCA"
    },
    {
        "code": "2R4-898-337",
        "name": "PECA FIXAC"
    },
    {
        "code": "2V3-511-285",
        "name": "TRAVA"
    },
    {
        "code": "2V3-511-285-A",
        "name": "TRAVA"
    },
    {
        "code": "2V3-511-329-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-511-339",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-511-339-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-511-339-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-511-415",
        "name": "BUCHA"
    },
    {
        "code": "2V3-511-417-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-511-441",
        "name": "TIRANTE"
    },
    {
        "code": "2V3-511-441-A",
        "name": "TIRANTE"
    },
    {
        "code": "23B-407-644",
        "name": "porca"
    },
    {
        "code": "2RD-016-985",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-511-535",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-513-031",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-513-031-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-513-031-C",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-513-662",
        "name": "PINO"
    },
    {
        "code": "2V3-513-662-A",
        "name": "PINO"
    },
    {
        "code": "2V3-521-107",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-107-A",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-107-B",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-107-C",
        "name": "EIXO"
    },
    {
        "code": "2RD-034-987",
        "name": "PORCA"
    },
    {
        "code": "2V3-521-107-D",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-107-E",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-110",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-110-C",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-115",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-115-B",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-115-C",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-115-D",
        "name": "EIXO"
    },
    {
        "code": "2V3-863-294",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-863-294-A",
        "name": "COBERTURA"
    },
    {
        "code": "2RD-044-877",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-863-367-  -9KO",
        "name": "TAPETE"
    },
    {
        "code": "2V3-863-367-A -9KO",
        "name": "TAPETE"
    },
    {
        "code": "2V3-863-367-B -9KO",
        "name": "TAPETE"
    },
    {
        "code": "2V3-863-368-  -9KO",
        "name": "TAPETE"
    },
    {
        "code": "2V3-863-368-A -9KO",
        "name": "TAPETE"
    },
    {
        "code": "2V3-863-711-  -9KO",
        "name": "TAPETE"
    },
    {
        "code": "2V3-863-711-A -9KO",
        "name": "TAPETE"
    },
    {
        "code": "2V3-863-832",
        "name": "CHAPA"
    },
    {
        "code": "2V3-864-933",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2V3-867-015-A",
        "name": "REV.PORTA"
    },
    {
        "code": "2RD-058-638",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-867-016-A",
        "name": "REV.PORTA"
    },
    {
        "code": "2V3-867-035-  -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-035-A -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-035-B -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-035-C -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-036-  -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-036-A -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-141",
        "name": "FOLHA"
    },
    {
        "code": "2V3-867-142",
        "name": "FOLHA"
    },
    {
        "code": "2V3-867-151",
        "name": "PUXADOR"
    },
    {
        "code": "2RD-100-179",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-867-152",
        "name": "PUXADOR"
    },
    {
        "code": "2V3-867-173",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-867-174",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-867-360-  -9KO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-360-A -9KO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-360-B -9KO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-360-C -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-360-C -9KO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-361-  -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-361-A -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2RD-115-311-  -999",
        "name": "TAMPAO"
    },
    {
        "code": "2V3-867-361-B -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-361-C -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-471",
        "name": "ANEL"
    },
    {
        "code": "2V3-867-485-  -8EO",
        "name": "moldura"
    },
    {
        "code": "2V3-867-485-A -8EO",
        "name": "moldura"
    },
    {
        "code": "23B-201-589-A",
        "name": "COLETOR"
    },
    {
        "code": "WHT-006-761",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-521-171",
        "name": "PINO"
    },
    {
        "code": "2V2-521-171-A",
        "name": "CONTRAPINO"
    },
    {
        "code": "2V2-521-177",
        "name": "MANCAL"
    },
    {
        "code": "2RD-115-657",
        "name": "BRACADEIR"
    },
    {
        "code": "2V2-521-177-A",
        "name": "MANCALDESL"
    },
    {
        "code": "2V2-521-291",
        "name": "CRUZETA"
    },
    {
        "code": "2V2-521-443-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V2-521-525",
        "name": "TIRANTE"
    },
    {
        "code": "2V2-525-021-D",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V2-525-021-G",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V2-525-021-H",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V2-525-021-J",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V2-525-021-K",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V2-525-021-L",
        "name": "DIFERENCIA"
    },
    {
        "code": "2RD-115-657-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V2-525-021-M",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V2-525-021-N",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V2-525-021-Q",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V2-525-059",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-525-089",
        "name": "ANEL"
    },
    {
        "code": "2V2-525-109",
        "name": "CAIXA"
    },
    {
        "code": "2V2-525-121",
        "name": "CAIXA"
    },
    {
        "code": "2V2-525-126",
        "name": "ANEL"
    },
    {
        "code": "2V2-525-143-A",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V2-525-143-B",
        "name": "PINHAOCORO"
    },
    {
        "code": "2RD-129-660",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V2-525-143-C",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V2-525-155",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V2-525-155-A",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V2-525-155-B",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V2-525-155-C",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V2-525-155-D",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V2-525-221",
        "name": "CAIXA"
    },
    {
        "code": "2V2-525-267",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-525-267-B",
        "name": "ARRUELA"
    },
    {
        "code": "2RD-145-457",
        "name": "PORCA"
    },
    {
        "code": "2V2-525-267-C",
        "name": "ARRUELA"
    },
    {
        "code": "2Z0-906-088",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-906-145",
        "name": "ANEL"
    },
    {
        "code": "2Z0-906-261-A",
        "name": "SENSOR"
    },
    {
        "code": "N  -907-611-03",
        "name": "PORCA"
    },
    {
        "code": "2V2-607-091",
        "name": "CAPA"
    },
    {
        "code": "2V2-607-251-A",
        "name": "RESERVATOR"
    },
    {
        "code": "2V2-607-251-B",
        "name": "RESERVATOR"
    },
    {
        "code": "2V2-607-261",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-313",
        "name": "CONEXAO"
    },
    {
        "code": "23B-407-661",
        "name": "APOIO"
    },
    {
        "code": "2RD-199-110-AR",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-607-337",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-355",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-359",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-359-A",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-359-B",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-359-C",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-359-D",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-361",
        "name": "VALVULA"
    },
    {
        "code": "2V2-607-373-C",
        "name": "SECADOR"
    },
    {
        "code": "2V2-607-815",
        "name": "ADAPTADOR"
    },
    {
        "code": "2RD-199-110-AS",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-607-891-B",
        "name": "SUPORTE"
    },
    {
        "code": "WHT-006-264",
        "name": "porca"
    },
    {
        "code": "WHT-006-268",
        "name": "APOIO"
    },
    {
        "code": "WHT-006-275",
        "name": "PINO"
    },
    {
        "code": "2T2-511-169-A",
        "name": "LAMINA"
    },
    {
        "code": "2T2-511-170-A",
        "name": "LAMINA"
    },
    {
        "code": "2T2-511-180-A",
        "name": "LAMINA"
    },
    {
        "code": "2T2-511-187-A",
        "name": "LAMINA"
    },
    {
        "code": "2T2-511-188-A",
        "name": "LAMINA"
    },
    {
        "code": "2T2-511-193-A",
        "name": "LAMINA"
    },
    {
        "code": "2RD-199-110-BF",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-511-194-A",
        "name": "LAMINA"
    },
    {
        "code": "2T2-511-196-A",
        "name": "LAMINA"
    },
    {
        "code": "2T2-511-201",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-511-439",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T2-511-439-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "07W-130-233",
        "name": "ARRUELA"
    },
    {
        "code": "07W-130-233-B",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-131-438-A",
        "name": "DISCO"
    },
    {
        "code": "2W0-131-973",
        "name": "TAMPAO"
    },
    {
        "code": "2V2-616-015",
        "name": "PRATO MOLA"
    },
    {
        "code": "2RD-199-120-AA",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-616-016",
        "name": "PRATO MOLA"
    },
    {
        "code": "2V2-616-039",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V2-616-041",
        "name": "MOLA"
    },
    {
        "code": "2V2-616-402-A",
        "name": "TUBO"
    },
    {
        "code": "2V2-701-765",
        "name": "TRAVESSA"
    },
    {
        "code": "2V2-711-265",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-265-B",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-265-C",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-266",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-266-B",
        "name": "CABO COMAN"
    },
    {
        "code": "2RD-199-120-AB",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-711-266-C",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-266-D",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-266-E",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-267",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-267-B",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-267-C",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-267-D",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-267-E",
        "name": "CABO COMAN"
    },
    {
        "code": "2V2-711-390",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-721-029-A",
        "name": "Pedaleira"
    },
    {
        "code": "2RD-199-120-AC",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-721-029-C",
        "name": "MECANISMO"
    },
    {
        "code": "2V2-721-135",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-721-261",
        "name": "CILINDRO"
    },
    {
        "code": "2V2-721-482-C",
        "name": "TUBO"
    },
    {
        "code": "2V2-721-482-D",
        "name": "TUBO"
    },
    {
        "code": "2V2-721-482-F",
        "name": "TUBO"
    },
    {
        "code": "2V2-721-482-G",
        "name": "TUBO"
    },
    {
        "code": "2V2-801-213",
        "name": "PRESILHA"
    },
    {
        "code": "2V2-803-051-AA",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AB",
        "name": "CHASSI"
    },
    {
        "code": "2RD-199-120-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-803-051-AC",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AE",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AF",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AJ",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AL",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AN",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AP",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AQ",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AS",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-AT",
        "name": "CHASSI"
    },
    {
        "code": "2RD-199-120-BB",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-803-051-R",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-051-S",
        "name": "CHASSI"
    },
    {
        "code": "2V2-803-134",
        "name": "TIRANTE"
    },
    {
        "code": "23C-201-132",
        "name": "VALVULA"
    },
    {
        "code": "N  -913-033-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -913-035-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-857-513-C -999",
        "name": "CARCACA"
    },
    {
        "code": "2R2-857-513-H -999",
        "name": "CARCACA"
    },
    {
        "code": "2R2-857-513-J -999",
        "name": "CARCACA"
    },
    {
        "code": "2R2-857-514-D -999",
        "name": "CARCACA"
    },
    {
        "code": "2RD-199-120-BH",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-857-514-E -999",
        "name": "CARCACA"
    },
    {
        "code": "2S2-413-031",
        "name": "AMORTECEDO"
    },
    {
        "code": "81A-035-727",
        "name": "INTERFACE"
    },
    {
        "code": "2T0-804-960",
        "name": "TRAVA"
    },
    {
        "code": "2T0-804-966",
        "name": "TUBO"
    },
    {
        "code": "2T0-804-967",
        "name": "PINO"
    },
    {
        "code": "2T0-804-968",
        "name": "ALAVANCA"
    },
    {
        "code": "2T0-804-974",
        "name": "MOLA"
    },
    {
        "code": "2T0-804-974-A",
        "name": "MOLA"
    },
    {
        "code": "2T0-804-988",
        "name": "PARAF.CILI"
    },
    {
        "code": "2RD-199-220-C",
        "name": "PORCA"
    },
    {
        "code": "2T0-804-997",
        "name": "BUCHA"
    },
    {
        "code": "2T0-805-831",
        "name": "porca"
    },
    {
        "code": "2V4-521-177",
        "name": "MANCAL"
    },
    {
        "code": "2V4-525-121",
        "name": "CAIXA"
    },
    {
        "code": "2V4-525-270",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V4-525-271",
        "name": "ANEL"
    },
    {
        "code": "2V4-525-631",
        "name": "ACIONAMENT"
    },
    {
        "code": "2V4-525-728",
        "name": "MOLA"
    },
    {
        "code": "2V4-598-081",
        "name": "JG.DIFEREN"
    },
    {
        "code": "2V4-598-149",
        "name": "JG.PECAS"
    },
    {
        "code": "23B-521-577",
        "name": "CINTA"
    },
    {
        "code": "2RD-199-320-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V4-711-390",
        "name": "SUPORTE"
    },
    {
        "code": "2V4-821-927",
        "name": "paralama"
    },
    {
        "code": "2V4-821-927-A",
        "name": "paralama"
    },
    {
        "code": "2V4-863-615",
        "name": "CHAPA"
    },
    {
        "code": "2V4-863-615-A",
        "name": "CHAPA"
    },
    {
        "code": "2V5-000-294",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V5-000-901-DD",
        "name": "BATENTE"
    },
    {
        "code": "2V5-010-782-S",
        "name": "ETIQUETA"
    },
    {
        "code": "2W0-117-413-F",
        "name": "MANGUEIRA"
    },
    {
        "code": "2W0-521-525-A",
        "name": "TIRANTE"
    },
    {
        "code": "2RD-201-737",
        "name": "TUBO"
    },
    {
        "code": "N  -909-446-04",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-957-549-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2V2-971-015-AF",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-AG",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-AH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-AJ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-AT",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BA",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BB",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-407-751-B",
        "name": "PORCA"
    },
    {
        "code": "2V2-971-015-BC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BL",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BM",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BN",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BP",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BQ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BS",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-BT",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CA",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-411-322-H",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-971-015-CB",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CD",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CE",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CF",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CG",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CM",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CN",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CP",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-419-635",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-971-015-CQ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CS",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-CT",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-D",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DA",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DD",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DE",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DF",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DG",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-501-295",
        "name": "porca"
    },
    {
        "code": "2V2-971-015-DH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DJ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DK",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DL",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DP",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-DR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-E",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-EC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-FD",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-FF",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-507-141",
        "name": "TUBO RESPI"
    },
    {
        "code": "2V2-971-015-FG",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-GD",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-GH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-GK",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-GP",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-GS",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-HA",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-HC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-HE",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-M",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-511-295",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-971-015-N",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-P",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-015-Q",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-028",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HD",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HE",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HF",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HG",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HJ",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-599-179",
        "name": "porca"
    },
    {
        "code": "2V2-971-051-HK",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HL",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HM",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HN",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HQ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HS",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-HT",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JA",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JB",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-601-373",
        "name": "VALVULA"
    },
    {
        "code": "2V2-971-051-JC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JD",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JE",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JF",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JG",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JJ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JK",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JL",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JM",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-323-121-A",
        "name": "PISTAO"
    },
    {
        "code": "23B-607-085",
        "name": "CONECTOR"
    },
    {
        "code": "2RD-607-051",
        "name": "NIPLE"
    },
    {
        "code": "2V2-971-051-JN",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JP",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JQ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JS",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-JT",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KA",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KB",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KD",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-607-053",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-971-051-KF",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KG",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KH",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KJ",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KN",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-KS",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-LC",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-LM",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-LR",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-MB",
        "name": "CHICOTE"
    },
    {
        "code": "2RD-607-068",
        "name": "TAMPA"
    },
    {
        "code": "2V2-971-051-MF",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-051-ML",
        "name": "CHICOTE"
    },
    {
        "code": "2V2-971-057-A",
        "name": "CHIC MOTOR"
    },
    {
        "code": "2V2-971-057-C",
        "name": "CHIC MOTOR"
    },
    {
        "code": "2V3-253-137",
        "name": "ANEL"
    },
    {
        "code": "2V3-253-137-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-253-137-B",
        "name": "ANEL"
    },
    {
        "code": "2V3-253-143",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-253-143-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-253-144",
        "name": "suporte"
    },
    {
        "code": "2RD-607-107",
        "name": "ANEL"
    },
    {
        "code": "2V3-253-144-A",
        "name": "suporte"
    },
    {
        "code": "2V3-253-144-B",
        "name": "suporte"
    },
    {
        "code": "2V3-253-144-C",
        "name": "suporte"
    },
    {
        "code": "2V3-253-144-D",
        "name": "suporte"
    },
    {
        "code": "2V3-253-173-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-253-197",
        "name": "CHAPA"
    },
    {
        "code": "2V3-253-198-A",
        "name": "CHAPA"
    },
    {
        "code": "2V3-253-198-C",
        "name": "suporte"
    },
    {
        "code": "2V3-253-269",
        "name": "TRAVA"
    },
    {
        "code": "2V3-253-319-B",
        "name": "SUPORTE"
    },
    {
        "code": "2RD-607-153",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-253-319-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-253-319-E",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-253-319-F",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-253-319-G",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-253-319-N",
        "name": "CHAPA"
    },
    {
        "code": "2V3-253-505-C",
        "name": "suporte"
    },
    {
        "code": "2V3-253-694",
        "name": "TAMPA"
    },
    {
        "code": "2V3-253-694-A",
        "name": "TAMPA"
    },
    {
        "code": "2V3-254-253",
        "name": "CATALISADO"
    },
    {
        "code": "2V3-254-253-F",
        "name": "CATALISADO"
    },
    {
        "code": "2RD-607-383",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V3-254-253-G",
        "name": "CATALISADO"
    },
    {
        "code": "2V3-265-053-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-265-053-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-265-335",
        "name": "suporte"
    },
    {
        "code": "2V3-265-391-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-265-391-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-300-057",
        "name": "TRANSMIS."
    },
    {
        "code": "2V3-300-057-A",
        "name": "TRANSMIS."
    },
    {
        "code": "2V3-300-057-B",
        "name": "TRANSMIS."
    },
    {
        "code": "2V3-300-057-C",
        "name": "TRANSMIS."
    },
    {
        "code": "2RD-607-700-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-300-057-D",
        "name": "TRANSMIS."
    },
    {
        "code": "2V3-300-057-E",
        "name": "TRANSMIS."
    },
    {
        "code": "2V3-300-093",
        "name": "TOMADA"
    },
    {
        "code": "2V3-300-093-A",
        "name": "TOMADA"
    },
    {
        "code": "T2D-145-409",
        "name": "ANEL"
    },
    {
        "code": "2V2-501-319",
        "name": "CONE"
    },
    {
        "code": "2V2-501-319-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-501-319-C",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-501-319-D",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V2-501-319-F",
        "name": "ROLAMENTO"
    },
    {
        "code": "2RD-607-704",
        "name": "TUBO"
    },
    {
        "code": "2V2-501-321",
        "name": "CAPA"
    },
    {
        "code": "2V2-501-549",
        "name": "TAMPAO"
    },
    {
        "code": "2V2-501-549-A",
        "name": "TAMPAO"
    },
    {
        "code": "2V2-501-653",
        "name": "CUBO RODA"
    },
    {
        "code": "2V2-505-469-D",
        "name": "TIRANTE"
    },
    {
        "code": "2V2-505-469-E",
        "name": "TIRANTE"
    },
    {
        "code": "2V2-507-147",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-507-147-A",
        "name": "TUBO"
    },
    {
        "code": "2V2-511-051",
        "name": "haste"
    },
    {
        "code": "2V2-511-139-A",
        "name": "BASE"
    },
    {
        "code": "2RD-607-853",
        "name": "TUBO"
    },
    {
        "code": "2V2-511-139-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-511-139-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-511-149",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-511-151-F",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V2-511-151-G",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2V2-511-163",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-163-A",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-163-B",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-163-C",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-163-D",
        "name": "LAMINA"
    },
    {
        "code": "2RD-607-855-B",
        "name": "TUBO"
    },
    {
        "code": "2V2-511-163-E",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-A",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-B",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-C",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-D",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-E",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-F",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-G",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-H",
        "name": "LAMINA"
    },
    {
        "code": "23B-867-299",
        "name": "PINO"
    },
    {
        "code": "2RD-607-999",
        "name": "ANEL"
    },
    {
        "code": "2V2-511-167-J",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-K",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-L",
        "name": "LAMINA"
    },
    {
        "code": "2V2-511-167-M",
        "name": "LAMINA"
    },
    {
        "code": "23B-105-933",
        "name": "PARAFUSO"
    },
    {
        "code": "23B-105-933-A",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-662",
        "name": "BRACADEIRA"
    },
    {
        "code": "07W-103-548-A",
        "name": "ANEL"
    },
    {
        "code": "2Z0-405-615-A",
        "name": "TAMBOR"
    },
    {
        "code": "2Z0-407-393-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2RD-609-281-A",
        "name": "PINO"
    },
    {
        "code": "2S2-821-331-  -54V",
        "name": "TAPETE"
    },
    {
        "code": "2S2-821-331-  -9B9",
        "name": "TAPETE"
    },
    {
        "code": "2S2-821-647",
        "name": "estribo"
    },
    {
        "code": "23B-947-315-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-947-315-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T2-311-247-E",
        "name": "ANEL"
    },
    {
        "code": "N  -105-255-06",
        "name": "Fuse"
    },
    {
        "code": "07W-117-013-D",
        "name": "FILTRO OLE"
    },
    {
        "code": "2T0-525-231",
        "name": "FRICCAO"
    },
    {
        "code": "2T0-525-241",
        "name": "FRICCAO"
    },
    {
        "code": "2RD-609-285",
        "name": "PINO"
    },
    {
        "code": "2T0-525-241-A",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-525-251",
        "name": "CAPA"
    },
    {
        "code": "2T0-525-251-A",
        "name": "CAPA"
    },
    {
        "code": "23G-906-295",
        "name": "CAIXA"
    },
    {
        "code": "23G-907-631",
        "name": "VALVULA"
    },
    {
        "code": "23G-907-703-  -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23G-927-127-  -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23G-937-025",
        "name": "CENTRAL EL"
    },
    {
        "code": "23G-937-548",
        "name": "CAIXA"
    },
    {
        "code": "23G-937-574",
        "name": "TAMPA"
    },
    {
        "code": "2RD-609-297-A",
        "name": "PISTAO"
    },
    {
        "code": "23G-937-574-  -999",
        "name": "TAMPA"
    },
    {
        "code": "23G-941-205",
        "name": "Farol de n"
    },
    {
        "code": "23G-945-095",
        "name": "LANTERNA"
    },
    {
        "code": "23G-945-096",
        "name": "LANTERNA"
    },
    {
        "code": "23G-945-096-A",
        "name": "LANTERNA"
    },
    {
        "code": "23G-953-037",
        "name": "LUZ"
    },
    {
        "code": "23G-953-037-A",
        "name": "LUZ"
    },
    {
        "code": "23G-953-513",
        "name": "COMUTADOR"
    },
    {
        "code": "23G-953-544",
        "name": "INTERRUPTO"
    },
    {
        "code": "23G-971-003-C",
        "name": "suporte"
    },
    {
        "code": "2RD-609-299",
        "name": "POSICIONAD"
    },
    {
        "code": "23G-971-003-D",
        "name": "suporte"
    },
    {
        "code": "07W-121-050-H",
        "name": "TUBO"
    },
    {
        "code": "07W-121-050-K",
        "name": "TUBO"
    },
    {
        "code": "07W-121-066-E",
        "name": "suporte"
    },
    {
        "code": "N  -907-732-01-B41",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-607-315-B",
        "name": "VALVULA"
    },
    {
        "code": "2T0-607-315-E",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-607-329-B",
        "name": "VALVULA"
    },
    {
        "code": "2T0-607-329-C",
        "name": "VALVULA"
    },
    {
        "code": "2T0-607-337",
        "name": "VALVULA"
    },
    {
        "code": "2RD-609-303",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2R2-941-509",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R2-941-509-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R2-945-095",
        "name": "LANTERNA"
    },
    {
        "code": "2R2-945-096",
        "name": "LANTERNA"
    },
    {
        "code": "2R2-945-341-B",
        "name": "LUZ PISCA"
    },
    {
        "code": "2R2-945-341-B -1NN",
        "name": "LUZ PISCA"
    },
    {
        "code": "1J0-971-260-E",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-301-340-S",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-301-377-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-301-507",
        "name": "TUBO"
    },
    {
        "code": "2RD-699-611-A",
        "name": "CONTRAPINO"
    },
    {
        "code": "2T2-301-507-A",
        "name": "TUBO"
    },
    {
        "code": "2R2-947-105-A -Y20",
        "name": "LUZ INTERN"
    },
    {
        "code": "2R2-947-561-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R2-949-101-A",
        "name": "LUZ"
    },
    {
        "code": "2R2-949-101-B",
        "name": "LANTERNA"
    },
    {
        "code": "2R2-949-102-A",
        "name": "LUZ"
    },
    {
        "code": "2S0-501-319-AE",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S0-501-319-AG",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S0-501-319-F",
        "name": "ROLAMENTO"
    },
    {
        "code": "2R2-803-877-AF",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-721-173",
        "name": "CAPA"
    },
    {
        "code": "2R2-803-877-AG",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-AH",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-721-199-G",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-317-065",
        "name": "TUBO"
    },
    {
        "code": "2T2-317-489",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-317-752-B",
        "name": "TUBO OLEO"
    },
    {
        "code": "2T2-323-174-A",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-301-285-A",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-201-847",
        "name": "ELEM FILTR"
    },
    {
        "code": "2T2-201-883",
        "name": "COTOVELO"
    },
    {
        "code": "2RD-799-127",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-251-277",
        "name": "suporte"
    },
    {
        "code": "2T2-251-718",
        "name": "CATALISADO"
    },
    {
        "code": "2T2-251-718-B",
        "name": "CATALISADO"
    },
    {
        "code": "2T2-251-718-D",
        "name": "CATALISADO"
    },
    {
        "code": "2T2-253-037",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-253-037-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-253-037-B",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-253-037-C",
        "name": "DEFLETOR"
    },
    {
        "code": "113-919-131-A",
        "name": "ANEL VEDAC"
    },
    {
        "code": "N  -106-455-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-799-131",
        "name": "PRISIONEIR"
    },
    {
        "code": "2T2-906-145",
        "name": "ANEL"
    },
    {
        "code": "2T2-906-145-A",
        "name": "ANEL"
    },
    {
        "code": "2T2-906-145-B",
        "name": "ANEL"
    },
    {
        "code": "2T2-906-217-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-906-273",
        "name": "AMORTECEDO"
    },
    {
        "code": "2T2-906-273-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2T2-906-508",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-401-055",
        "name": "CORPO EIXO"
    },
    {
        "code": "2T2-401-161",
        "name": "ENGRAXADEI"
    },
    {
        "code": "2T2-405-311-A",
        "name": "MANG EIXO"
    },
    {
        "code": "23B-903-165-A",
        "name": "POLIA"
    },
    {
        "code": "2RD-805-137",
        "name": "TAMPAO"
    },
    {
        "code": "2T2-405-312-A",
        "name": "MANG EIXO"
    },
    {
        "code": "2Z0-599-111-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-599-111-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-601-025",
        "name": "RODA"
    },
    {
        "code": "2Z0-601-025-B",
        "name": "RODA"
    },
    {
        "code": "2Z0-601-181",
        "name": "PESO BALAN"
    },
    {
        "code": "2T2-821-306-A",
        "name": "paralama"
    },
    {
        "code": "2T2-821-306-A -54V",
        "name": "paralama"
    },
    {
        "code": "2T2-821-306-A -I9A",
        "name": "paralama"
    },
    {
        "code": "2T2-821-306-A -N28",
        "name": "paralama"
    },
    {
        "code": "2RD-807-889",
        "name": "BUCHA"
    },
    {
        "code": "2T2-821-306-B -1NN",
        "name": "paralama"
    },
    {
        "code": "2T2-821-647",
        "name": "estribo"
    },
    {
        "code": "2T2-821-647-  -54V",
        "name": "estribo"
    },
    {
        "code": "2T2-821-648",
        "name": "estribo"
    },
    {
        "code": "2T2-821-648-  -54V",
        "name": "estribo"
    },
    {
        "code": "2T2-821-681-  -9B9",
        "name": "estribo"
    },
    {
        "code": "2T2-821-682-  -9B9",
        "name": "estribo"
    },
    {
        "code": "07W-837-991-E",
        "name": "MAT.ADESIV"
    },
    {
        "code": "07W-880-243",
        "name": "porca"
    },
    {
        "code": "2U2-265-053-D",
        "name": "MANGUEIRA"
    },
    {
        "code": "2RD-857-554-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-090",
        "name": "PINO"
    },
    {
        "code": "2U2-301-101-A",
        "name": "CARCACA"
    },
    {
        "code": "2U2-301-103-A",
        "name": "CARCACA"
    },
    {
        "code": "2U2-301-103-B",
        "name": "CARCACA"
    },
    {
        "code": "2U2-301-103-C",
        "name": "CARCACA"
    },
    {
        "code": "2U2-301-105",
        "name": "PINOESFERI"
    },
    {
        "code": "2U2-301-125",
        "name": "TAMPA"
    },
    {
        "code": "2U2-301-141",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-301-141-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-301-141-C",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2RD-857-605",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-141-E",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "23G-607-879",
        "name": "CHAPA"
    },
    {
        "code": "23G-607-891-B",
        "name": "SUPORTE"
    },
    {
        "code": "23G-607-897-A",
        "name": "ANEL"
    },
    {
        "code": "2V2-103-448",
        "name": "PORCA"
    },
    {
        "code": "2V2-105-233",
        "name": "MOLA"
    },
    {
        "code": "2V2-105-233-A",
        "name": "CHAPA"
    },
    {
        "code": "2V2-105-387",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V2-109-164",
        "name": "DEFLETOR"
    },
    {
        "code": "2V2-109-164-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2RD-857-605-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-109-177",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-109-177-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-109-291",
        "name": "CAPA PROTE"
    },
    {
        "code": "2V2-115-611-A",
        "name": "VARETA"
    },
    {
        "code": "2V2-121-003",
        "name": "VENTILADOR"
    },
    {
        "code": "2V2-121-051-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-121-071",
        "name": "TUBO"
    },
    {
        "code": "2V2-121-094-C",
        "name": "suporte"
    },
    {
        "code": "2V2-121-101",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-121-113",
        "name": "TERMOSTATO"
    },
    {
        "code": "2RD-863-719",
        "name": "PARAFUSO"
    },
    {
        "code": "2V2-121-113-A",
        "name": "TERMOSTATO"
    },
    {
        "code": "2V2-121-113-B",
        "name": "TERMOSTATO"
    },
    {
        "code": "2V2-121-126",
        "name": "suporte"
    },
    {
        "code": "2V2-121-251",
        "name": "RADIADOR"
    },
    {
        "code": "2V2-121-301-B",
        "name": "HELICE"
    },
    {
        "code": "2V2-121-302-B",
        "name": "EMBREAGEM"
    },
    {
        "code": "2V2-121-303",
        "name": "HELICE"
    },
    {
        "code": "2V2-121-473",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-121-477",
        "name": "BRACADEIR"
    },
    {
        "code": "23H-701-025-M",
        "name": "CHASSI"
    },
    {
        "code": "2RD-867-651-A",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-701-025-N",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-NA",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-NB",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-NC",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-ND",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-NE",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-NF",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-NG",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-NH",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-P",
        "name": "CHASSI"
    },
    {
        "code": "2RD-899-949",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-701-025-PA",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-PB",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-PC",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-PD",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-Q",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-R",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-S",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-479",
        "name": "SUPORTE"
    },
    {
        "code": "23H-701-480",
        "name": "SUPORTE"
    },
    {
        "code": "23H-701-693",
        "name": "CHAPA"
    },
    {
        "code": "2RD-919-121",
        "name": "SUPORTE"
    },
    {
        "code": "23H-803-347",
        "name": "PLATAFORMA"
    },
    {
        "code": "23H-803-431",
        "name": "SUPORTE"
    },
    {
        "code": "23H-803-465-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-803-465-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-803-609-A",
        "name": "suporte"
    },
    {
        "code": "23H-803-610-A",
        "name": "suporte"
    },
    {
        "code": "23H-803-875",
        "name": "SUPORTE"
    },
    {
        "code": "2VC-608-791",
        "name": "TUBO"
    },
    {
        "code": "2R2-711-603",
        "name": "BRACADEIR"
    },
    {
        "code": "2R2-711-603-A",
        "name": "ABRACADEIR"
    },
    {
        "code": "2RD-941-555-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R2-711-693-  -999",
        "name": "LUVA"
    },
    {
        "code": "2R2-711-695",
        "name": "PINO"
    },
    {
        "code": "2R2-711-847-  -NA2",
        "name": "CAPA COBER"
    },
    {
        "code": "23H-899-515-E",
        "name": "AMORTECEDO"
    },
    {
        "code": "23H-899-515-F",
        "name": "AMORTECEDO"
    },
    {
        "code": "23H-907-104-C",
        "name": "MODULO"
    },
    {
        "code": "23H-915-345",
        "name": "Bracket"
    },
    {
        "code": "23H-937-025",
        "name": "CAIXA"
    },
    {
        "code": "23H-937-149",
        "name": "suporte"
    },
    {
        "code": "23H-937-149-A",
        "name": "suporte"
    },
    {
        "code": "23B-903-165-E",
        "name": "POLIA"
    },
    {
        "code": "2RD-998-919",
        "name": "TRAVA"
    },
    {
        "code": "23H-945-403",
        "name": "SUPORTE"
    },
    {
        "code": "2Z0-121-269",
        "name": "DEFLETOR"
    },
    {
        "code": "2Z0-121-269-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2R2-905-851",
        "name": "COMUTADOR"
    },
    {
        "code": "2R2-905-867-  -999",
        "name": "ANEL"
    },
    {
        "code": "2R2-906-507",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-906-508",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-907-156-H",
        "name": "UNIDADE"
    },
    {
        "code": "2R2-907-156-J",
        "name": "UNIDADE"
    },
    {
        "code": "2R2-907-156-M",
        "name": "UNIDADE"
    },
    {
        "code": "2RE-121-255-D",
        "name": "BRACADEIR"
    },
    {
        "code": "TE3-607-029",
        "name": "ANEL"
    },
    {
        "code": "TE3-607-031",
        "name": "ANEL"
    },
    {
        "code": "2R2-803-875-J",
        "name": "PORCA"
    },
    {
        "code": "2R2-803-875-L",
        "name": "porca"
    },
    {
        "code": "2R2-803-875-M",
        "name": "porca"
    },
    {
        "code": "2R2-803-875-N",
        "name": "PORCA"
    },
    {
        "code": "2R2-803-875-P",
        "name": "PORCA"
    },
    {
        "code": "2R2-803-875-Q",
        "name": "PORCA"
    },
    {
        "code": "2R2-803-877",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-607-045",
        "name": "FRICCAO"
    },
    {
        "code": "2RE-145-425",
        "name": "BRACADEIRA"
    },
    {
        "code": "TE3-607-051",
        "name": "NIPLE"
    },
    {
        "code": "07W-419-325",
        "name": "TRAVA"
    },
    {
        "code": "2RE-121-255-E",
        "name": "BRACADEIR"
    },
    {
        "code": "2RE-121-255-F",
        "name": "BRACADEIR"
    },
    {
        "code": "07W-061-795",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-061-795-B",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-067-255",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-067-255-B",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-068-271-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-607-461",
        "name": "APOIO"
    },
    {
        "code": "2RE-145-425-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T2-607-862-E",
        "name": "TUBO FREIO"
    },
    {
        "code": "2T2-607-862-F",
        "name": "TUBO FREIO"
    },
    {
        "code": "2T2-607-862-J",
        "name": "TUBO FREIO"
    },
    {
        "code": "2T2-607-862-N",
        "name": "TUBO FREIO"
    },
    {
        "code": "2T2-607-881",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-607-891-AM",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-525-291",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-525-291-A",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-525-735",
        "name": "VALVULA"
    },
    {
        "code": "2T0-598-081",
        "name": "CRUZETA"
    },
    {
        "code": "2RE-201-511",
        "name": "BRACADEIRA"
    },
    {
        "code": "2R2-820-803-C",
        "name": "compressor"
    },
    {
        "code": "2R2-821-245",
        "name": "TAMPAO"
    },
    {
        "code": "2R2-821-719",
        "name": "PLACA"
    },
    {
        "code": "2R2-823-301",
        "name": "DOBRADICA"
    },
    {
        "code": "2R2-823-302",
        "name": "DOBRADICA"
    },
    {
        "code": "2R2-823-359",
        "name": "AMORTECEDO"
    },
    {
        "code": "2R2-823-505",
        "name": "TRAVA"
    },
    {
        "code": "23H-129-141-A",
        "name": "suporte"
    },
    {
        "code": "23H-129-141-B",
        "name": "suporte"
    },
    {
        "code": "23H-129-601",
        "name": "FILTRO AR"
    },
    {
        "code": "2RE-265-381-A",
        "name": "BRACADEIR"
    },
    {
        "code": "23H-129-621",
        "name": "TUBO"
    },
    {
        "code": "23H-129-671",
        "name": "SUPORTE"
    },
    {
        "code": "23H-129-857-F",
        "name": "TUBO"
    },
    {
        "code": "23H-129-973-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-131-157-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-131-157-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-131-832-A",
        "name": "SENSOR"
    },
    {
        "code": "23H-131-983-B",
        "name": "TUBULACAO"
    },
    {
        "code": "23H-131-984-D",
        "name": "TUBULACAO"
    },
    {
        "code": "23H-131-984-E",
        "name": "TUBULACAO"
    },
    {
        "code": "2RE-607-668",
        "name": "SUPORTE"
    },
    {
        "code": "23H-145-317",
        "name": "SUPORTE"
    },
    {
        "code": "23H-145-594",
        "name": "TUBO"
    },
    {
        "code": "23H-145-594-A",
        "name": "TUBO"
    },
    {
        "code": "2T2-711-224-B",
        "name": "TAMPA"
    },
    {
        "code": "2T2-711-224-D",
        "name": "TAMPA"
    },
    {
        "code": "2T2-711-263-  -999",
        "name": "CAPA COBER"
    },
    {
        "code": "2T2-711-452",
        "name": "PECA ARTIC"
    },
    {
        "code": "2R2-955-529-A",
        "name": "RELE"
    },
    {
        "code": "2R2-955-529-B",
        "name": "RELE"
    },
    {
        "code": "2R2-955-603-A",
        "name": "SUPORTE"
    },
    {
        "code": "2RF-511-199",
        "name": "PORCA"
    },
    {
        "code": "2R2-955-651",
        "name": "BOMBA"
    },
    {
        "code": "2R2-955-705",
        "name": "SIST.LAVAG"
    },
    {
        "code": "2R2-955-751",
        "name": "MANGUEIRA"
    },
    {
        "code": "WHT-006-157",
        "name": "porca"
    },
    {
        "code": "WHT-006-158",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-161",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-162",
        "name": "PARAFUSO"
    },
    {
        "code": "2S0-201-179-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2S0-201-291",
        "name": "BujÆo"
    },
    {
        "code": "23H-422-069",
        "name": "CAIXA"
    },
    {
        "code": "2RG-016-207",
        "name": "MANGUEIRA"
    },
    {
        "code": "23H-422-156",
        "name": "BOMBA"
    },
    {
        "code": "23H-422-335-A",
        "name": "BARRA DIR"
    },
    {
        "code": "23H-422-849",
        "name": "SUPORTE"
    },
    {
        "code": "23H-422-897",
        "name": "TUBO"
    },
    {
        "code": "23H-422-913-B",
        "name": "CONEXAO"
    },
    {
        "code": "23H-422-913-C",
        "name": "CONEXAO"
    },
    {
        "code": "23H-422-913-D",
        "name": "CONEXAO"
    },
    {
        "code": "23H-422-913-E",
        "name": "CONEXAO"
    },
    {
        "code": "23H-422-921-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-422-926-A",
        "name": "SUPORTE"
    },
    {
        "code": "2RG-100-179",
        "name": "ETIQUETAID"
    },
    {
        "code": "23H-501-091",
        "name": "CORPOEIXO"
    },
    {
        "code": "23H-501-091-A",
        "name": "CORPOEIXO"
    },
    {
        "code": "2S2-817-017",
        "name": "TETO"
    },
    {
        "code": "2S2-817-205",
        "name": "TAMPA"
    },
    {
        "code": "2S2-817-387",
        "name": "suporte"
    },
    {
        "code": "2S2-817-388",
        "name": "suporte"
    },
    {
        "code": "2S2-817-550-A",
        "name": "suporte"
    },
    {
        "code": "WHT-007-696",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-499-151-A",
        "name": "PORCA"
    },
    {
        "code": "2TB-501-203",
        "name": "SEMI EIXO"
    },
    {
        "code": "23B-903-221",
        "name": "ROLAMENTO"
    },
    {
        "code": "2RG-415-899",
        "name": "BRACADEIRA"
    },
    {
        "code": "2TB-501-204",
        "name": "SEMI EIXO"
    },
    {
        "code": "2R2-819-015",
        "name": "VENTILADOR"
    },
    {
        "code": "2R2-819-031",
        "name": "AQUECEDOR"
    },
    {
        "code": "2R2-819-031-A",
        "name": "AQUECEDOR"
    },
    {
        "code": "2R2-819-151",
        "name": "CONDUTOR A"
    },
    {
        "code": "2R2-819-152",
        "name": "CONDUTOR A"
    },
    {
        "code": "23K-858-249-  -HP5",
        "name": "MOLDURA"
    },
    {
        "code": "23K-858-339-  -1NN",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-858-339-A -9B9",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-858-407-  -NA2",
        "name": "CONSOLE"
    },
    {
        "code": "2RG-607-041",
        "name": "MOLA RETEN"
    },
    {
        "code": "23K-858-559-  -9B9",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-858-559-B -9B9",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-858-562-A",
        "name": "ESPELHO"
    },
    {
        "code": "2T2-806-155",
        "name": "AMORTECIME"
    },
    {
        "code": "2T2-807-071-A",
        "name": "parachoque"
    },
    {
        "code": "2T2-807-071-A -54V",
        "name": "parachoque"
    },
    {
        "code": "2T2-807-075-C",
        "name": "parachoque"
    },
    {
        "code": "2T2-807-075-C -54V",
        "name": "parachoque"
    },
    {
        "code": "2T2-807-076-C",
        "name": "parachoque"
    },
    {
        "code": "2T2-807-076-C -54V",
        "name": "parachoque"
    },
    {
        "code": "2RG-607-731",
        "name": "VEDACAO"
    },
    {
        "code": "2T2-807-111",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-809-031-A",
        "name": "painel"
    },
    {
        "code": "2TJ-127-489",
        "name": "DRENO"
    },
    {
        "code": "2R2-819-429",
        "name": "ELEM FILTR"
    },
    {
        "code": "2R2-819-639",
        "name": "TAMPA"
    },
    {
        "code": "2R2-819-691",
        "name": "CONDUTOR A"
    },
    {
        "code": "2R2-819-692",
        "name": "CONDUTOR A"
    },
    {
        "code": "2T2-809-226-A",
        "name": "COLUNA A"
    },
    {
        "code": "2T2-809-226-A -PAC",
        "name": "COLUNA A"
    },
    {
        "code": "2T2-809-343",
        "name": "SUPORTE"
    },
    {
        "code": "2RG-607-943",
        "name": "CINT FREIO"
    },
    {
        "code": "2T2-809-344",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-813-193",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-817-017-A",
        "name": "TETO"
    },
    {
        "code": "2T2-817-017-A -041",
        "name": "TETO"
    },
    {
        "code": "2T2-817-017-A -E3D",
        "name": "TETO"
    },
    {
        "code": "2U2-857-611",
        "name": "APOIO"
    },
    {
        "code": "2U2-857-611-  -1NN",
        "name": "APOIO"
    },
    {
        "code": "2U2-861-281",
        "name": "PROTETOR"
    },
    {
        "code": "2U2-899-365",
        "name": "MANGUEIRA"
    },
    {
        "code": "2U2-906-051-D",
        "name": "SENSOR"
    },
    {
        "code": "2RG-609-273",
        "name": "REBITE"
    },
    {
        "code": "2U2-906-051-E",
        "name": "SENSOR"
    },
    {
        "code": "2U2-906-051-F",
        "name": "SENSOR"
    },
    {
        "code": "2U2-915-516",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-915-516-F",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-820-071-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R2-820-197",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-820-295",
        "name": "TERMOSTATO"
    },
    {
        "code": "2R2-820-407",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-820-408",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-820-413-B",
        "name": "CONDENSADO"
    },
    {
        "code": "2RG-698-025",
        "name": "JG.PECAS"
    },
    {
        "code": "2R2-820-439-B",
        "name": "AMORTECEDO"
    },
    {
        "code": "2R2-820-439-C",
        "name": "AMORTECEDO"
    },
    {
        "code": "WHT-009-228",
        "name": "PARAFUSO"
    },
    {
        "code": "2T4-609-819",
        "name": "MECANISMO"
    },
    {
        "code": "2T4-609-820",
        "name": "MECANISMO"
    },
    {
        "code": "2T4-612-405-A",
        "name": "suporte"
    },
    {
        "code": "2T4-612-405-B",
        "name": "suporte"
    },
    {
        "code": "2T4-612-405-D",
        "name": "suporte"
    },
    {
        "code": "2T4-612-406-A",
        "name": "suporte"
    },
    {
        "code": "2T4-612-406-B",
        "name": "suporte"
    },
    {
        "code": "2RG-867-235-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2T4-612-406-D",
        "name": "suporte"
    },
    {
        "code": "2T4-615-155",
        "name": "haste"
    },
    {
        "code": "2U2-971-227",
        "name": "CHICOTE"
    },
    {
        "code": "2U2-971-235",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-906-529",
        "name": "SENSOR"
    },
    {
        "code": "2V3-906-529-A",
        "name": "SENSOR"
    },
    {
        "code": "2V3-906-559-A",
        "name": "suporte"
    },
    {
        "code": "2V3-906-559-AC",
        "name": "suporte"
    },
    {
        "code": "2V3-906-559-AD",
        "name": "suporte"
    },
    {
        "code": "2V3-906-559-G",
        "name": "suporte"
    },
    {
        "code": "2RH-129-723",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V3-906-559-J",
        "name": "suporte"
    },
    {
        "code": "2V3-906-559-K",
        "name": "suporte"
    },
    {
        "code": "2V3-906-559-L",
        "name": "suporte"
    },
    {
        "code": "2V3-906-559-M",
        "name": "suporte"
    },
    {
        "code": "2V3-906-559-N",
        "name": "suporte"
    },
    {
        "code": "2V3-906-625",
        "name": "BLOCO VALV"
    },
    {
        "code": "2V3-907-104",
        "name": "MODULO"
    },
    {
        "code": "2V3-907-104-A",
        "name": "MODULO"
    },
    {
        "code": "2V3-907-104-C",
        "name": "MODULO"
    },
    {
        "code": "2V3-907-171-A",
        "name": "CONVERSOR"
    },
    {
        "code": "2RH-129-723-B",
        "name": "BRACADEIRA"
    },
    {
        "code": "2U2-609-225",
        "name": "PINHAO"
    },
    {
        "code": "2U2-609-225-A",
        "name": "PINHAO"
    },
    {
        "code": "2U2-609-237",
        "name": "SAPATA"
    },
    {
        "code": "2U2-609-237-A",
        "name": "SAPATA"
    },
    {
        "code": "2U2-609-423",
        "name": "SUP FREIO"
    },
    {
        "code": "2U2-609-424",
        "name": "SUP FREIO"
    },
    {
        "code": "2U2-609-583",
        "name": "MOLA"
    },
    {
        "code": "2U2-609-583-A",
        "name": "MOLA"
    },
    {
        "code": "2U2-609-617",
        "name": "TAMBOR"
    },
    {
        "code": "2U2-609-649",
        "name": "TAMPAO"
    },
    {
        "code": "2RH-498-628",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-609-649-B",
        "name": "TAMPAO"
    },
    {
        "code": "2U2-609-657",
        "name": "MOLA"
    },
    {
        "code": "2U2-609-743",
        "name": "COIFA"
    },
    {
        "code": "2U2-609-745",
        "name": "suporte"
    },
    {
        "code": "2U2-609-745-A",
        "name": "suporte"
    },
    {
        "code": "2U2-609-745-B",
        "name": "suporte"
    },
    {
        "code": "2U2-609-746",
        "name": "suporte"
    },
    {
        "code": "2U2-609-746-A",
        "name": "suporte"
    },
    {
        "code": "2U2-609-746-C",
        "name": "suporte"
    },
    {
        "code": "2U2-609-791",
        "name": "JUNTA"
    },
    {
        "code": "23B-905-287",
        "name": "TAMPA"
    },
    {
        "code": "2RH-598-313-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-611-461",
        "name": "CAPA PROTE"
    },
    {
        "code": "2U2-612-063",
        "name": "AJUSTE"
    },
    {
        "code": "2U2-612-129",
        "name": "CABECOTE"
    },
    {
        "code": "2V2-145-317-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-145-487",
        "name": "ANEL"
    },
    {
        "code": "2V2-145-813-A",
        "name": "suporte"
    },
    {
        "code": "2V2-145-844-C",
        "name": "TUBO"
    },
    {
        "code": "2V2-145-877",
        "name": "TUBO"
    },
    {
        "code": "2V2-198-149-A",
        "name": "JG.EMBREAG"
    },
    {
        "code": "2V2-198-229",
        "name": "CONJUNTO"
    },
    {
        "code": "2RH-601-151",
        "name": "COBERTURA"
    },
    {
        "code": "2V2-198-229-A",
        "name": "CONJUNTO"
    },
    {
        "code": "2V2-198-229-B",
        "name": "CONJUNTO"
    },
    {
        "code": "2V2-198-229-C",
        "name": "CONJUNTO"
    },
    {
        "code": "2V2-199-221",
        "name": "COXIM"
    },
    {
        "code": "2V2-199-255",
        "name": "COXIM"
    },
    {
        "code": "2V2-199-320",
        "name": "ARRUELA"
    },
    {
        "code": "2V2-201-044",
        "name": "NIPLE"
    },
    {
        "code": "2V2-201-050",
        "name": "VALVULA"
    },
    {
        "code": "2V2-201-060-B",
        "name": "RESERVATOR"
    },
    {
        "code": "2V2-201-060-C",
        "name": "RESERVATOR"
    },
    {
        "code": "2RH-601-151-  -Z31",
        "name": "COBERTURA"
    },
    {
        "code": "2V2-201-060-D",
        "name": "RESERVATOR"
    },
    {
        "code": "2V2-201-171",
        "name": "TRAVESSA"
    },
    {
        "code": "2V2-201-173-D",
        "name": "TUBO"
    },
    {
        "code": "2V2-201-173-E",
        "name": "TUBO"
    },
    {
        "code": "2V2-201-173-F",
        "name": "TUBO"
    },
    {
        "code": "2Z0-614-173",
        "name": "LUVA"
    },
    {
        "code": "07W-127-621-F",
        "name": "SUPORTE"
    },
    {
        "code": "07W-127-621-G",
        "name": "SUPORTE"
    },
    {
        "code": "07W-127-621-M",
        "name": "BRACADEIR"
    },
    {
        "code": "2R0-012-239",
        "name": "HASTE"
    },
    {
        "code": "2RH-607-025",
        "name": "BOCAL"
    },
    {
        "code": "2R0-012-239-B",
        "name": "HASTE"
    },
    {
        "code": "2P0-501-291-A",
        "name": "COLA SILI"
    },
    {
        "code": "N  -906-988-03",
        "name": "PORCA"
    },
    {
        "code": "23B-411-239",
        "name": "BRACADEIRA"
    },
    {
        "code": "23B-411-346",
        "name": "BUCHA"
    },
    {
        "code": "07W-971-918",
        "name": "TAMPAO"
    },
    {
        "code": "07W-971-918-A",
        "name": "CONECTOR"
    },
    {
        "code": "07W-971-989",
        "name": "CONECTOR"
    },
    {
        "code": "2R2-803-877-E",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2RK-105-393",
        "name": "BUCHA"
    },
    {
        "code": "2R2-803-877-G",
        "name": "PARAFUSO"
    },
    {
        "code": "23G-010-039",
        "name": "ETIQUETA"
    },
    {
        "code": "23G-035-605-  -82V",
        "name": "PROTECAO"
    },
    {
        "code": "2R2-971-641-C",
        "name": "CHICOTE"
    },
    {
        "code": "2R2-971-838",
        "name": "ABRACADEIR"
    },
    {
        "code": "2R2-971-896",
        "name": "GUIA"
    },
    {
        "code": "2R2-971-903-C",
        "name": "BUCHA"
    },
    {
        "code": "2R2-971-903-E",
        "name": "BUCHA"
    },
    {
        "code": "2R2-971-963",
        "name": "RECEPTACUL"
    },
    {
        "code": "2V3-131-065-C",
        "name": "VALVULA"
    },
    {
        "code": "2RK-105-394",
        "name": "LUVA"
    },
    {
        "code": "2V3-131-095-A",
        "name": "INJETOR"
    },
    {
        "code": "2V3-131-113",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-131-121-C",
        "name": "suporte"
    },
    {
        "code": "2V3-131-121-D",
        "name": "suporte"
    },
    {
        "code": "2V3-131-121-E",
        "name": "suporte"
    },
    {
        "code": "2V3-131-121-F",
        "name": "suporte"
    },
    {
        "code": "2V3-131-121-H",
        "name": "suporte"
    },
    {
        "code": "2V3-131-157-A",
        "name": "suporte"
    },
    {
        "code": "2V3-131-157-C",
        "name": "suporte"
    },
    {
        "code": "2V3-131-170",
        "name": "TUBO"
    },
    {
        "code": "2RK-107-119",
        "name": "CALCO"
    },
    {
        "code": "2V3-131-185",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-131-185-A",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-131-185-B",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-131-185-C",
        "name": "CONEXAO"
    },
    {
        "code": "2S2-861-225-  -WJ1",
        "name": "PROTETOR"
    },
    {
        "code": "2S2-861-225-B",
        "name": "PROTETOR"
    },
    {
        "code": "2S2-861-305-  -Y20",
        "name": "FRISOTETO"
    },
    {
        "code": "2S2-861-305-B -Y20",
        "name": "COBERTURA"
    },
    {
        "code": "2S2-861-306-  -Y20",
        "name": "FRISOTETO"
    },
    {
        "code": "2S2-861-351",
        "name": "suporte"
    },
    {
        "code": "2RK-107-121",
        "name": "CALCO"
    },
    {
        "code": "2S2-861-607",
        "name": "FRISOTETO"
    },
    {
        "code": "TJG-601-233-A",
        "name": "PESO BALAN"
    },
    {
        "code": "TJG-601-237-A",
        "name": "PESO BALAN"
    },
    {
        "code": "2Z0-301-729-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T0-907-631",
        "name": "VALVULA"
    },
    {
        "code": "2T0-907-631-A",
        "name": "VALVULA"
    },
    {
        "code": "2R2-803-877-S",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-T",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-805-025",
        "name": "PAINEL"
    },
    {
        "code": "2R2-805-323",
        "name": "SUPORTE"
    },
    {
        "code": "2RK-107-123",
        "name": "CALCO"
    },
    {
        "code": "07W-109-445",
        "name": "ANEL"
    },
    {
        "code": "07W-109-447-C",
        "name": "BALANCIM"
    },
    {
        "code": "07W-109-447-D",
        "name": "BALANCIM"
    },
    {
        "code": "2T2-971-561-J",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-641",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-641-C",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-641-N",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-759",
        "name": "SENSOR"
    },
    {
        "code": "2T2-971-771-B",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-771-G",
        "name": "CHICOTE"
    },
    {
        "code": "2RK-115-441-A",
        "name": "COIFA"
    },
    {
        "code": "2T2-971-838",
        "name": "ABRACADEIR"
    },
    {
        "code": "2T2-971-843",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-973-503",
        "name": "RELE"
    },
    {
        "code": "2R2-809-047",
        "name": "painel"
    },
    {
        "code": "2R2-809-048",
        "name": "painel"
    },
    {
        "code": "2R2-809-055-A",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-809-055-B",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-809-056-A",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-809-056-B",
        "name": "COBERTURA"
    },
    {
        "code": "T12-607-061",
        "name": "ANEL"
    },
    {
        "code": "23B-905-367-G",
        "name": "UNI.COMAND"
    },
    {
        "code": "2RK-127-697",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-703-529-D",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-809-206-A",
        "name": "COLUNA A"
    },
    {
        "code": "2R2-809-225",
        "name": "COLUNA A"
    },
    {
        "code": "2R2-809-225-  -PAC",
        "name": "COLUNA A"
    },
    {
        "code": "2R2-809-226",
        "name": "COLUNA A"
    },
    {
        "code": "2R2-809-226-  -PAC",
        "name": "COLUNA A"
    },
    {
        "code": "2R2-809-231",
        "name": "REFORCO"
    },
    {
        "code": "TE3-607-461",
        "name": "ARRUELA"
    },
    {
        "code": "TE3-607-473",
        "name": "porca"
    },
    {
        "code": "2R2-831-443",
        "name": "PLACASUPOR"
    },
    {
        "code": "2RK-511-181",
        "name": "LUVA"
    },
    {
        "code": "2R2-831-443-A",
        "name": "PLACASUPOR"
    },
    {
        "code": "2R2-831-444-A",
        "name": "PLACASUPOR"
    },
    {
        "code": "2R2-831-449",
        "name": "TAMPAO"
    },
    {
        "code": "2R2-831-575",
        "name": "TIRAS"
    },
    {
        "code": "2R2-831-575-A",
        "name": "TIRAS"
    },
    {
        "code": "2RD-607-062",
        "name": "TAMPA"
    },
    {
        "code": "N  -906-987-01",
        "name": "PORCA"
    },
    {
        "code": "N  -106-610-02",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -106-611-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-699-069",
        "name": "BRACADEIRA"
    },
    {
        "code": "2RL-103-157",
        "name": "TAMPA"
    },
    {
        "code": "2RD-699-107",
        "name": "BORRACHA"
    },
    {
        "code": "N  -910-423-01",
        "name": "PARAFUSO"
    },
    {
        "code": "JZV-607-615-A",
        "name": "TAMBOR"
    },
    {
        "code": "JZV-616-787",
        "name": "FILTRO"
    },
    {
        "code": "2S2-145-687",
        "name": "BRACADEIRA"
    },
    {
        "code": "07W-019-873-AD",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-AH",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-AL",
        "name": "PARAFUSO"
    },
    {
        "code": "2VC-608-797-C",
        "name": "ANEL"
    },
    {
        "code": "07W-019-873-AT",
        "name": "PARAFUSO"
    },
    {
        "code": "2RL-109-705",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-B",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-BA",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-BB",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-BC",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-903-221-C",
        "name": "ROLAMENTO"
    },
    {
        "code": "2Z0-903-343-A",
        "name": "PROTECAO"
    },
    {
        "code": "2Z0-903-357-A",
        "name": "PLACDIODOS"
    },
    {
        "code": "2Z0-905-051",
        "name": "PRE RESIST"
    },
    {
        "code": "2RD-609-281",
        "name": "PINO"
    },
    {
        "code": "07W-103-351-M",
        "name": "CABECOTE"
    },
    {
        "code": "2RL-115-419",
        "name": "VALVULA"
    },
    {
        "code": "07W-103-351-Q",
        "name": "CABECOTE"
    },
    {
        "code": "WHT-010-295",
        "name": "BOCAL"
    },
    {
        "code": "WHT-010-296",
        "name": "BOCAL"
    },
    {
        "code": "G  -105-159-Q2",
        "name": "graxa"
    },
    {
        "code": "07W-109-616-D",
        "name": "RODA"
    },
    {
        "code": "07W-109-616-E",
        "name": "RODA"
    },
    {
        "code": "07W-109-641",
        "name": "PRATO MOLA"
    },
    {
        "code": "07W-109-659",
        "name": "PONTE"
    },
    {
        "code": "07W-109-675",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-109-675-A",
        "name": "VEDACAO"
    },
    {
        "code": "2RL-201-385",
        "name": "GUARNICAO"
    },
    {
        "code": "2S2-711-452",
        "name": "PECA ARTIC"
    },
    {
        "code": "07W-199-382",
        "name": "SUPORTE"
    },
    {
        "code": "07W-201-254",
        "name": "BujÆo"
    },
    {
        "code": "2R2-803-875-A",
        "name": "PORCA"
    },
    {
        "code": "2R2-803-875-B",
        "name": "PORCA"
    },
    {
        "code": "2U2-422-156",
        "name": "BOMBA"
    },
    {
        "code": "2U2-422-335",
        "name": "BARRA DIR"
    },
    {
        "code": "2U2-422-335-G",
        "name": "BARRA DIR"
    },
    {
        "code": "2U2-422-335-T",
        "name": "BARRA DIR"
    },
    {
        "code": "2U2-422-897-B",
        "name": "TUBO"
    },
    {
        "code": "2RL-411-213-B",
        "name": "LAMINA"
    },
    {
        "code": "2U2-501-101",
        "name": "CARCACA"
    },
    {
        "code": "2U2-501-101-A",
        "name": "CARCACA"
    },
    {
        "code": "2U2-501-118",
        "name": "PINO"
    },
    {
        "code": "2U2-501-183",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-501-215",
        "name": "ANEL"
    },
    {
        "code": "2U2-501-216",
        "name": "ANEL"
    },
    {
        "code": "2U2-501-225",
        "name": "CALCO"
    },
    {
        "code": "2U2-501-225-A",
        "name": "CALCO"
    },
    {
        "code": "2U2-501-225-B",
        "name": "CALCO"
    },
    {
        "code": "2U2-501-225-C",
        "name": "CALCO"
    },
    {
        "code": "2RL-411-215-B",
        "name": "LAMINA"
    },
    {
        "code": "N  -107-174-02",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-103-683-L",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R0-607-367-M",
        "name": "ADAPTADOR"
    },
    {
        "code": "22B-201-100",
        "name": "CONEXAO"
    },
    {
        "code": "22B-201-100-A",
        "name": "CONEXAO"
    },
    {
        "code": "22B-201-100-B",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-857-617-  -9KO",
        "name": "TAMPAO"
    },
    {
        "code": "2V3-857-684",
        "name": "fecho"
    },
    {
        "code": "2V3-857-684-A",
        "name": "fecho"
    },
    {
        "code": "2V3-857-715",
        "name": "SUPORTE"
    },
    {
        "code": "2RL-411-217-B",
        "name": "LAMINA"
    },
    {
        "code": "2V3-857-715-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-857-715-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-857-719-  -8EO",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-857-725",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-857-815",
        "name": "CINTO 3 PT"
    },
    {
        "code": "2V3-857-911-A -9KO",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-857-911-B -9KO",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-857-923-A",
        "name": "CONSOLE TE"
    },
    {
        "code": "2V3-858-039",
        "name": "PAINEL"
    },
    {
        "code": "2V3-858-045",
        "name": "PAINEL"
    },
    {
        "code": "2RL-411-219-B",
        "name": "LAMINA"
    },
    {
        "code": "2V3-858-045-A",
        "name": "PAINEL"
    },
    {
        "code": "2V3-858-169-  -9B9",
        "name": "TAPETE"
    },
    {
        "code": "2V3-858-169-A -9B9",
        "name": "TAPETE"
    },
    {
        "code": "2V3-858-178-  -9KO",
        "name": "PORTA OBJE"
    },
    {
        "code": "2V3-858-178-A -9KO",
        "name": "PORTA OBJE"
    },
    {
        "code": "2V3-858-179",
        "name": "TAMPAO"
    },
    {
        "code": "2V3-858-193",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-858-193-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-858-217-  -9KO",
        "name": "PORTA OBJE"
    },
    {
        "code": "2V3-858-217-A -9KO",
        "name": "REVESTIMEN"
    },
    {
        "code": "23B-906-028-B -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "2RL-411-221-B",
        "name": "LAMINA"
    },
    {
        "code": "2V3-858-217-B -9KO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-858-262",
        "name": "CHAPA"
    },
    {
        "code": "2V3-858-274-  -IJM",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-858-274-A -IJM",
        "name": "CONSOLE"
    },
    {
        "code": "2V3-858-274-B -9KO",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-858-325",
        "name": "TAMPA"
    },
    {
        "code": "2S2-809-024",
        "name": "COBERTURA"
    },
    {
        "code": "2W0-407-517-A",
        "name": "JUNTA"
    },
    {
        "code": "2W0-407-689",
        "name": "PARAFUSO"
    },
    {
        "code": "2P0-103-035-A",
        "name": "CONECTOR"
    },
    {
        "code": "2RL-411-223-B",
        "name": "LAMINA"
    },
    {
        "code": "2V3-311-842",
        "name": "BUCHA"
    },
    {
        "code": "2V3-311-862",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-311-862-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-311-868",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V3-311-868-A",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V3-311-868-B",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V3-311-868-C",
        "name": "GARFOCAIXA"
    },
    {
        "code": "2V3-311-893",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V3-311-919",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-919-A",
        "name": "ARRUELA"
    },
    {
        "code": "2RL-411-225-B",
        "name": "LAMINA"
    },
    {
        "code": "2V3-311-919-B",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-919-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-919-D",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-919-E",
        "name": "ARRUELA"
    },
    {
        "code": "2S2-857-597",
        "name": "ANEL"
    },
    {
        "code": "2S2-857-815-  -1NN",
        "name": "CINTO 3 PT"
    },
    {
        "code": "2S2-858-045",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-858-045-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-858-562",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-858-562-B",
        "name": "ESPELHO"
    },
    {
        "code": "2RL-411-233-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-858-627",
        "name": "BASE"
    },
    {
        "code": "2S2-861-031-B -81U",
        "name": "CAMA"
    },
    {
        "code": "2S2-861-031-C -81U",
        "name": "CAMA"
    },
    {
        "code": "2S2-945-415",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-947-315",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-947-315-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-947-561",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-953-037",
        "name": "LUZ"
    },
    {
        "code": "2S2-953-513",
        "name": "COMUTADOR"
    },
    {
        "code": "2S2-953-544-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2RL-411-253",
        "name": "LAMINA"
    },
    {
        "code": "2S2-955-529",
        "name": "RELE"
    },
    {
        "code": "2T0-501-291",
        "name": "PAST VEDAC"
    },
    {
        "code": "2T0-501-317-A",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-501-317-B",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-501-317-C",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-501-317-D",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-501-317-E",
        "name": "RETENTOR"
    },
    {
        "code": "2Z0-803-877-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-815-813",
        "name": "ANEL"
    },
    {
        "code": "2T2-713-141",
        "name": "MECANISMO"
    },
    {
        "code": "2RL-411-275-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T2-713-141-A",
        "name": "MECANISMO"
    },
    {
        "code": "2T2-721-029-C",
        "name": "MECANISMO"
    },
    {
        "code": "2T2-721-029-G",
        "name": "Pedaleira"
    },
    {
        "code": "2T2-721-029-L",
        "name": "Pedaleira"
    },
    {
        "code": "2T2-721-029-M",
        "name": "MECANISMO"
    },
    {
        "code": "2T2-721-205",
        "name": "HASTE"
    },
    {
        "code": "23B-607-359-A",
        "name": "VALVULA"
    },
    {
        "code": "23B-607-815",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V3-010-001",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-001-A",
        "name": "ETIQUETA"
    },
    {
        "code": "2RL-411-281",
        "name": "PECAINTERM"
    },
    {
        "code": "2V3-010-039",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-A",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-AF",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-B",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-C",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-D",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-K",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-L",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-N",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-039-P",
        "name": "ETIQUETA"
    },
    {
        "code": "2RL-511-219-C",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V3-010-039-Q",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-538-D",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-010-538-E",
        "name": "ETIQUETAID"
    },
    {
        "code": "2V3-010-571",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-010-571-A",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-011-023",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-012-115",
        "name": "BOLSA"
    },
    {
        "code": "2V3-012-219",
        "name": "CHAVE"
    },
    {
        "code": "2V3-012-233",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-012-239",
        "name": "HASTE"
    },
    {
        "code": "2RL-607-071",
        "name": "CAPA"
    },
    {
        "code": "2V3-012-760",
        "name": "LITERATURA"
    },
    {
        "code": "2V3-012-766-A",
        "name": "LITERATURA"
    },
    {
        "code": "2V3-012-766-AF",
        "name": "MANUAL DE"
    },
    {
        "code": "2V3-012-766-F",
        "name": "MANUAL DE"
    },
    {
        "code": "2V3-012-766-L",
        "name": "MANUAL DE"
    },
    {
        "code": "2V3-012-766-T",
        "name": "LITERATURA"
    },
    {
        "code": "07W-127-182",
        "name": "ANEL"
    },
    {
        "code": "2T2-525-121",
        "name": "CAIXA"
    },
    {
        "code": "2T2-525-142",
        "name": "PINHAOCORO"
    },
    {
        "code": "2T2-525-143",
        "name": "PINHAOCORO"
    },
    {
        "code": "2RL-607-909",
        "name": "suporte"
    },
    {
        "code": "2T2-525-143-B",
        "name": "PINHAOCORO"
    },
    {
        "code": "2T2-525-283-A",
        "name": "FLANGE"
    },
    {
        "code": "2T2-525-459-C",
        "name": "CABECOTE"
    },
    {
        "code": "2T2-599-173",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-599-173-A",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-599-173-B",
        "name": "GRAMPO"
    },
    {
        "code": "2T2-599-183-A",
        "name": "COTOVELO"
    },
    {
        "code": "2V3-971-161",
        "name": "CHICOTE P"
    },
    {
        "code": "2V3-971-161-B",
        "name": "CHICOTE P"
    },
    {
        "code": "2V3-971-161-C",
        "name": "CHICOTE P"
    },
    {
        "code": "23B-906-051-A",
        "name": "SENSOR"
    },
    {
        "code": "2RL-607-910",
        "name": "suporte"
    },
    {
        "code": "2V3-971-162",
        "name": "CHICOTE P"
    },
    {
        "code": "2V3-971-162-B",
        "name": "CHICOTE P"
    },
    {
        "code": "2V3-971-162-C",
        "name": "CHICOTE P"
    },
    {
        "code": "2V3-971-169",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-169-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-169-D",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-169-E",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-228-C",
        "name": "CHICOTE P"
    },
    {
        "code": "2V3-971-228-D",
        "name": "CABO"
    },
    {
        "code": "2V3-971-228-E",
        "name": "CABO"
    },
    {
        "code": "2RL-698-093",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-971-235-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-235-C",
        "name": "CABO MASSA"
    },
    {
        "code": "2V3-971-311-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-311-H",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-312-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-312-F",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-312-G",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-312-H",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-335",
        "name": "suporte"
    },
    {
        "code": "2V3-971-531",
        "name": "CHICOTE"
    },
    {
        "code": "2RL-698-096",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-971-531-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-AE",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-AF",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-AG",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-AH",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-AJ",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-AK",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-AM",
        "name": "CHICOTE"
    },
    {
        "code": "2RL-698-431",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-971-561-AN",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-BD",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-F",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-G",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-J",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-K",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-L",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-M",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-561-P",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-971-562",
        "name": "CHICOTE"
    },
    {
        "code": "2RL-915-105",
        "name": "BATERIA"
    },
    {
        "code": "2V3-971-562-A",
        "name": "CHICOTE"
    },
    {
        "code": "2R0-609-853-B",
        "name": "REGULADOR"
    },
    {
        "code": "2R0-609-854-A",
        "name": "REGULADOR"
    },
    {
        "code": "2RD-607-030",
        "name": "PORCA"
    },
    {
        "code": "2T2-103-383-C",
        "name": "JUNTA CABE"
    },
    {
        "code": "2T2-103-392-B",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-103-392-C",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-103-396-A",
        "name": "BUCHA"
    },
    {
        "code": "2T2-103-396-B",
        "name": "BUCHA"
    },
    {
        "code": "2T2-103-448-AA",
        "name": "PARAFUSO"
    },
    {
        "code": "2RP-127-487",
        "name": "COLETOR"
    },
    {
        "code": "2T2-103-448-AB",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-103-448-AK",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-957-039-C",
        "name": "TACOGRAFO"
    },
    {
        "code": "2R2-957-039-L",
        "name": "TACOGRAFO"
    },
    {
        "code": "2R2-957-039-M",
        "name": "TACOGRAFO"
    },
    {
        "code": "23B-927-127-A -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-927-127-C -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-927-143",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-927-191-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-927-192-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2RP-415-712",
        "name": "TERMINAL"
    },
    {
        "code": "23B-927-225-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-927-263",
        "name": "SENSOR"
    },
    {
        "code": "23B-927-325-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-927-451-A -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-927-521-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2W0-401-161-A",
        "name": "ENGRAXADEI"
    },
    {
        "code": "2W0-405-311",
        "name": "MANG EIXO"
    },
    {
        "code": "2W0-405-312",
        "name": "MANG EIXO"
    },
    {
        "code": "2T0-599-111-J",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-599-111-K",
        "name": "PARAFUSO"
    },
    {
        "code": "2RP-499-065",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-599-173",
        "name": "GRAMPO"
    },
    {
        "code": "2T0-599-173-A",
        "name": "GRAMPO"
    },
    {
        "code": "2T0-599-173-D",
        "name": "GRAMPO"
    },
    {
        "code": "2T0-599-175-B",
        "name": "GUIA"
    },
    {
        "code": "2T0-599-309",
        "name": "TRAVESSA"
    },
    {
        "code": "2T0-599-309-A",
        "name": "suporte"
    },
    {
        "code": "2T0-599-325",
        "name": "ARRUELA"
    },
    {
        "code": "2S2-881-041-  -CIO",
        "name": "ENCOSTO"
    },
    {
        "code": "2S2-881-041-A -CIL",
        "name": "ENCOSTO"
    },
    {
        "code": "2S2-881-041-A -CIO",
        "name": "ENCOSTO"
    },
    {
        "code": "2RP-607-039-A",
        "name": "MOLA"
    },
    {
        "code": "2S2-881-053",
        "name": "ELEMENTO"
    },
    {
        "code": "23L-201-156",
        "name": "CONECTOR"
    },
    {
        "code": "23L-201-257",
        "name": "INJETOR"
    },
    {
        "code": "23L-201-351-C",
        "name": "TUBO"
    },
    {
        "code": "23L-201-386",
        "name": "TUBULACAO"
    },
    {
        "code": "23L-201-386-A",
        "name": "TUBULACAO"
    },
    {
        "code": "23L-201-722-A",
        "name": "SUPORTE"
    },
    {
        "code": "23L-253-047",
        "name": "SUPORTE"
    },
    {
        "code": "23L-253-058",
        "name": "CATALISADO"
    },
    {
        "code": "23L-253-058-A",
        "name": "FILTRO"
    },
    {
        "code": "2RP-607-313",
        "name": "TUBO FREIO"
    },
    {
        "code": "23L-253-058-B",
        "name": "CATALISADO"
    },
    {
        "code": "23L-253-115",
        "name": "ANEL"
    },
    {
        "code": "23L-253-143",
        "name": "BRACADEIR"
    },
    {
        "code": "23L-253-143-A",
        "name": "BRACADEIR"
    },
    {
        "code": "23L-253-173",
        "name": "TUBO"
    },
    {
        "code": "23L-253-319",
        "name": "SUPORTE"
    },
    {
        "code": "23L-253-319-C",
        "name": "SUPORTE"
    },
    {
        "code": "23L-253-319-D",
        "name": "SUPORTE"
    },
    {
        "code": "23L-253-319-E",
        "name": "SUPORTE"
    },
    {
        "code": "23L-253-319-F",
        "name": "SUPORTE"
    },
    {
        "code": "23B-906-051-C",
        "name": "SENSOR"
    },
    {
        "code": "2RP-609-291",
        "name": "BUCHA"
    },
    {
        "code": "23L-253-359",
        "name": "MISTURADOR"
    },
    {
        "code": "23L-253-679",
        "name": "suporte"
    },
    {
        "code": "23L-253-679-A",
        "name": "suporte"
    },
    {
        "code": "23L-254-253",
        "name": "SILENCIOSO"
    },
    {
        "code": "23L-301-331",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-607-315",
        "name": "CONEXAO"
    },
    {
        "code": "2Z0-607-348",
        "name": "HASTE"
    },
    {
        "code": "N  -105-540-03",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-647",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-648",
        "name": "PARAFUSO"
    },
    {
        "code": "2RP-609-293",
        "name": "ENGRENAGEM"
    },
    {
        "code": "WHT-006-650",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "WHT-006-651",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-652",
        "name": "porca"
    },
    {
        "code": "WHT-006-653",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-654",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-655",
        "name": "ARRUELA"
    },
    {
        "code": "23G-298-021",
        "name": "ADAPTADOR"
    },
    {
        "code": "23G-407-303",
        "name": "MANG EIXO"
    },
    {
        "code": "23G-407-304",
        "name": "MANG EIXO"
    },
    {
        "code": "23G-419-251",
        "name": "SUPORTE"
    },
    {
        "code": "2RP-698-093",
        "name": "JG. LONA"
    },
    {
        "code": "23G-422-067-B",
        "name": "COLUNA DIR"
    },
    {
        "code": "23G-422-067-E",
        "name": "COLUNA DIR"
    },
    {
        "code": "23G-422-069-A",
        "name": "CAIXA"
    },
    {
        "code": "23G-422-515",
        "name": "COBERTURA"
    },
    {
        "code": "23G-422-547",
        "name": "BRACO"
    },
    {
        "code": "2S2-881-405-A -CIL",
        "name": "REVESTIME."
    },
    {
        "code": "2S2-881-405-A -CIO",
        "name": "REVESTIME."
    },
    {
        "code": "2S2-881-478-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2S2-881-479",
        "name": "COBERTURA"
    },
    {
        "code": "2S2-201-063-B",
        "name": "JG.CILINDR"
    },
    {
        "code": "2RP-698-096",
        "name": "JG. LONA"
    },
    {
        "code": "23P-698-459",
        "name": "JG.PECAS"
    },
    {
        "code": "2T0-971-231",
        "name": "CHICOTE"
    },
    {
        "code": "N  -108-900-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-901-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-916-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-934-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-937-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-938-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-939-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-940-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2RP-698-431",
        "name": "JG. LONA"
    },
    {
        "code": "N  -108-941-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -108-945-01",
        "name": "porca"
    },
    {
        "code": "N  -108-946-01",
        "name": "porca"
    },
    {
        "code": "22B-611-787",
        "name": "ARRUELA"
    },
    {
        "code": "22B-611-787-B",
        "name": "APOIO"
    },
    {
        "code": "2T2-121-477-A",
        "name": "PRESILHA"
    },
    {
        "code": "2T2-121-477-B",
        "name": "PRESILHA"
    },
    {
        "code": "2T2-121-651",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-121-688",
        "name": "JUNTA"
    },
    {
        "code": "2T2-121-688-A",
        "name": "JUNTA"
    },
    {
        "code": "2RR-411-919",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -040-293-7",
        "name": "PARAFUSO"
    },
    {
        "code": "T12-607-461",
        "name": "ARRUELA"
    },
    {
        "code": "07W-019-873-BJ",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-BK",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-BM",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-881-023-E -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2T2-881-023-H -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2T2-881-023-H -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "23K-800-401-T -I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-T -I9A",
        "name": "Cabina"
    },
    {
        "code": "2RR-411-921",
        "name": "PORCA"
    },
    {
        "code": "23K-800-701",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-B",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-C",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-D",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-E",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-F",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-G",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-H",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-J",
        "name": "Cabina"
    },
    {
        "code": "2RR-512-173",
        "name": "JUNTA"
    },
    {
        "code": "23K-800-701-K",
        "name": "Cabina"
    },
    {
        "code": "23K-800-701-L",
        "name": "Cabina"
    },
    {
        "code": "23K-802-013",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-013-A",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-013-D",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-013-E",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-013-F",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-013-G",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-013-H",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-013-J",
        "name": "CHAPA"
    },
    {
        "code": "2RR-512-398-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-129-591-C",
        "name": "COLETOR"
    },
    {
        "code": "2T2-129-601-A",
        "name": "FILTRO AR"
    },
    {
        "code": "2T2-129-601-E",
        "name": "FILTRO AR"
    },
    {
        "code": "2T2-129-633",
        "name": "CAIXA"
    },
    {
        "code": "2T2-129-633-A",
        "name": "CAIXA"
    },
    {
        "code": "2T2-129-642-B",
        "name": "BRACADEIR"
    },
    {
        "code": "2T2-129-642-C",
        "name": "BRACADEIRA"
    },
    {
        "code": "N  -102-856-01",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -102-856-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-899-565",
        "name": "ESPACADOR"
    },
    {
        "code": "2RR-525-215-A",
        "name": "PORCA"
    },
    {
        "code": "2T2-903-135-A",
        "name": "TIRANTE"
    },
    {
        "code": "2T2-903-137-F",
        "name": "correia"
    },
    {
        "code": "2T2-903-141-B",
        "name": "suporte"
    },
    {
        "code": "2T2-903-144",
        "name": "CHAPA"
    },
    {
        "code": "WHT-005-023",
        "name": "porca"
    },
    {
        "code": "2T2-121-313-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-121-313-J",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-121-313-K",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-121-333-D",
        "name": "DEFLET AR"
    },
    {
        "code": "2T2-121-333-J",
        "name": "DEFLET AR"
    },
    {
        "code": "2V5-129-463",
        "name": "distribuid"
    },
    {
        "code": "23B-937-197",
        "name": "INTERRUPTO"
    },
    {
        "code": "2RR-525-241",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-121-393-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-129-971-G",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-129-971-H",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-129-973-AL",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-129-973-F",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-130-085-C",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-085-D",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-085-E",
        "name": "TUBO"
    },
    {
        "code": "2S2-821-173",
        "name": "PARA BARRO"
    },
    {
        "code": "2S2-821-173-B",
        "name": "PARA BARRO"
    },
    {
        "code": "2RR-525-258",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-821-173-C",
        "name": "PARA BARRO"
    },
    {
        "code": "2S2-821-216",
        "name": "ADAPTADOR"
    },
    {
        "code": "2S2-821-216-  -54V",
        "name": "ADAPTADOR"
    },
    {
        "code": "2S2-821-216-  -I9A",
        "name": "ADAPTADOR"
    },
    {
        "code": "2S2-821-216-  -N28",
        "name": "ADAPTADOR"
    },
    {
        "code": "2S2-821-245",
        "name": "TAMPAO"
    },
    {
        "code": "WHT-005-085",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-087",
        "name": "PORCA"
    },
    {
        "code": "2T2-253-143-J",
        "name": "BRACADEIR"
    },
    {
        "code": "2T2-253-143-M",
        "name": "BRACADEIR"
    },
    {
        "code": "2RR-599-603",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-253-191",
        "name": "CINTA"
    },
    {
        "code": "2T2-253-191-A",
        "name": "CINTA"
    },
    {
        "code": "2T2-253-191-B",
        "name": "CINTA"
    },
    {
        "code": "2T2-253-193",
        "name": "PINO"
    },
    {
        "code": "2T2-253-193-A",
        "name": "PINO"
    },
    {
        "code": "2T2-253-193-C",
        "name": "PINO"
    },
    {
        "code": "2T2-253-193-D",
        "name": "PINO"
    },
    {
        "code": "2T2-253-221",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-253-227",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-323-121-B",
        "name": "PISTAO"
    },
    {
        "code": "2RR-607-025",
        "name": "LUVA"
    },
    {
        "code": "2V3-323-121-C",
        "name": "PISTAO"
    },
    {
        "code": "2V3-323-121-D",
        "name": "PISTAO"
    },
    {
        "code": "2V3-323-121-E",
        "name": "PISTAO"
    },
    {
        "code": "2V3-323-121-F",
        "name": "PISTAO"
    },
    {
        "code": "2V3-323-121-G",
        "name": "PISTAO"
    },
    {
        "code": "2V3-323-319",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-323-571",
        "name": "CONVERSOR"
    },
    {
        "code": "2V3-325-025",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-325-025-A",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-325-025-C",
        "name": "UNIDADE"
    },
    {
        "code": "2RR-607-025-A",
        "name": "BOCAL"
    },
    {
        "code": "2V3-325-057",
        "name": "ATUADOR"
    },
    {
        "code": "2V3-325-057-A",
        "name": "ATUADOR"
    },
    {
        "code": "2P0-915-089",
        "name": "BATERIA"
    },
    {
        "code": "2T2-701-149-K",
        "name": "CONSOLE"
    },
    {
        "code": "2T2-701-150-K",
        "name": "CONSOLE"
    },
    {
        "code": "2T2-703-529",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-703-529-B",
        "name": "ARRUELA"
    },
    {
        "code": "2T2-703-767",
        "name": "DOBRADICA"
    },
    {
        "code": "2T2-703-768",
        "name": "DOBRADICA"
    },
    {
        "code": "2T2-711-025",
        "name": "MECANISMO"
    },
    {
        "code": "2RR-607-029",
        "name": "ANEL"
    },
    {
        "code": "2T2-711-025-G",
        "name": "MECANISMO"
    },
    {
        "code": "2T2-711-025-H",
        "name": "MECANISMO"
    },
    {
        "code": "2V3-129-455",
        "name": "VALVULA"
    },
    {
        "code": "2V3-129-589",
        "name": "PEC VEDAC"
    },
    {
        "code": "2V3-129-591",
        "name": "COLETOR"
    },
    {
        "code": "2V3-129-591-A",
        "name": "COLETOR"
    },
    {
        "code": "2V3-129-591-B",
        "name": "COLETOR"
    },
    {
        "code": "2V3-129-591-C",
        "name": "COLETOR"
    },
    {
        "code": "2V3-129-591-D",
        "name": "COLETOR"
    },
    {
        "code": "2V3-129-591-G",
        "name": "COLETOR"
    },
    {
        "code": "2RR-607-458",
        "name": "CHAPA"
    },
    {
        "code": "2V3-129-601",
        "name": "FILTRO AR"
    },
    {
        "code": "2V3-129-601-A",
        "name": "FILTRO AR"
    },
    {
        "code": "2V3-129-601-B",
        "name": "FILTRO AR"
    },
    {
        "code": "2V3-129-601-E",
        "name": "FILTRO AR"
    },
    {
        "code": "2V3-129-620",
        "name": "ELEMENTO"
    },
    {
        "code": "2V3-129-620-A",
        "name": "ELEMENTO"
    },
    {
        "code": "2V3-129-620-D",
        "name": "ELEMENTO"
    },
    {
        "code": "2V3-129-620-E",
        "name": "ELEMENTO"
    },
    {
        "code": "2V3-129-620-J",
        "name": "ELEMENTO"
    },
    {
        "code": "2V3-129-620-K",
        "name": "ELEMENTO"
    },
    {
        "code": "2RR-609-753",
        "name": "VALVULA"
    },
    {
        "code": "2V3-129-621",
        "name": "CONDUTOR A"
    },
    {
        "code": "2V3-129-642-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V3-129-644",
        "name": "LUVA"
    },
    {
        "code": "2V3-129-716",
        "name": "TUBO"
    },
    {
        "code": "2V3-129-716-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-129-716-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-129-716-D",
        "name": "TUBO"
    },
    {
        "code": "2U2-301-483",
        "name": "MOLA"
    },
    {
        "code": "2U2-301-519",
        "name": "FILTRO OLE"
    },
    {
        "code": "2U2-301-523-A",
        "name": "PROTECAO"
    },
    {
        "code": "2RR-609-909",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-301-533",
        "name": "TUBO"
    },
    {
        "code": "2U2-301-567",
        "name": "Isolamento"
    },
    {
        "code": "2U2-301-580",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-301-580-A",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-301-675",
        "name": "MANGUEIRA"
    },
    {
        "code": "2U2-301-685",
        "name": "TUBO"
    },
    {
        "code": "2U2-301-685-A",
        "name": "TUBO OLEO"
    },
    {
        "code": "2U2-301-685-B",
        "name": "TUBO OLEO"
    },
    {
        "code": "2U2-301-685-C",
        "name": "TUBO OLEO"
    },
    {
        "code": "2U2-301-685-D",
        "name": "TUBO OLEO"
    },
    {
        "code": "2RR-698-805",
        "name": "JG.PECAS"
    },
    {
        "code": "2U2-301-685-E",
        "name": "TUBO OLEO"
    },
    {
        "code": "2U2-301-685-F",
        "name": "TUBO OLEO"
    },
    {
        "code": "2U2-301-729-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-301-803",
        "name": "TAMPA"
    },
    {
        "code": "2R0-698-459-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2U0-611-909-A",
        "name": "COTOVELO"
    },
    {
        "code": "2V5-109-499",
        "name": "CASQUILHO"
    },
    {
        "code": "2V5-109-601-F",
        "name": "VALVULA"
    },
    {
        "code": "2V5-109-601-G",
        "name": "VALVULA"
    },
    {
        "code": "2V5-109-623-A",
        "name": "MOLA VALV."
    },
    {
        "code": "23B-937-199-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2RT-607-109",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-109-651",
        "name": "CHAVETA CO"
    },
    {
        "code": "2V5-115-119",
        "name": "cardan"
    },
    {
        "code": "2V5-115-185",
        "name": "TAMPA"
    },
    {
        "code": "2V5-115-223-B",
        "name": "TUBO"
    },
    {
        "code": "2V5-115-223-C",
        "name": "TUBO"
    },
    {
        "code": "2V5-115-250",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-115-255-A",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V5-115-257",
        "name": "VEDACAO"
    },
    {
        "code": "2V5-115-308",
        "name": "TUBO"
    },
    {
        "code": "2V5-115-311-A",
        "name": "TAMPAO"
    },
    {
        "code": "2S0-103-321",
        "name": "CAMISA"
    },
    {
        "code": "2V5-115-311-B",
        "name": "TAMPAO"
    },
    {
        "code": "2V5-115-315",
        "name": "ANEL"
    },
    {
        "code": "2V5-115-315-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-115-315-B",
        "name": "ANEL"
    },
    {
        "code": "2V5-115-315-C",
        "name": "ANEL"
    },
    {
        "code": "2V5-115-318",
        "name": "suporte"
    },
    {
        "code": "2V5-115-451-A",
        "name": "RESFRIADOR"
    },
    {
        "code": "2V5-311-213",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-311-213-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-311-213-E",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S0-105-701",
        "name": "CASQUILHO"
    },
    {
        "code": "2V5-311-213-G",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-311-213-H",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V5-311-230-AA",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AH",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AJ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AK",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AL",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AM",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-AN",
        "name": "ARRUELA"
    },
    {
        "code": "2R2-858-339",
        "name": "REVESTIMEN"
    },
    {
        "code": "2S0-105-707",
        "name": "CASQUILHO"
    },
    {
        "code": "2R2-858-339-  -1NN",
        "name": "REVESTIMEN"
    },
    {
        "code": "2R2-858-349-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2R2-858-407-A -9B9",
        "name": "CONSOLE"
    },
    {
        "code": "2V3-301-293-C",
        "name": "PLACAINTER"
    },
    {
        "code": "2V3-301-293-D",
        "name": "PLACAINTER"
    },
    {
        "code": "2V3-301-293-E",
        "name": "Flange"
    },
    {
        "code": "2V3-301-293-F",
        "name": "PLACAINTER"
    },
    {
        "code": "2V3-301-293-G",
        "name": "PLACAINTER"
    },
    {
        "code": "2V3-301-293-J",
        "name": "PLACAINTER"
    },
    {
        "code": "2V3-301-293-K",
        "name": "PLACAINTER"
    },
    {
        "code": "2S0-105-713",
        "name": "CASQUILHO"
    },
    {
        "code": "2V3-301-331",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-331-A",
        "name": "Parafuso"
    },
    {
        "code": "2V3-301-331-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-331-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-331-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-301-331-E",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-422-751",
        "name": "HASTE"
    },
    {
        "code": "2V5-422-817-C",
        "name": "TERMINAL"
    },
    {
        "code": "2V5-422-817-D",
        "name": "TERMINAL"
    },
    {
        "code": "2V5-422-847-B",
        "name": "suporte"
    },
    {
        "code": "2S0-105-719",
        "name": "CASQUILHO"
    },
    {
        "code": "2V5-422-847-C",
        "name": "suporte"
    },
    {
        "code": "2V5-422-848",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-422-849",
        "name": "suporte"
    },
    {
        "code": "2V5-422-891",
        "name": "TUBO"
    },
    {
        "code": "2V5-422-891-A",
        "name": "PECAMOLDAD"
    },
    {
        "code": "2V5-422-892",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V5-422-897-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-422-963-A",
        "name": "TUBO"
    },
    {
        "code": "2V5-422-973",
        "name": "TUBO"
    },
    {
        "code": "2V5-423-359",
        "name": "CAPA COBER"
    },
    {
        "code": "2S0-105-725",
        "name": "CASQUILHO"
    },
    {
        "code": "2V5-423-360",
        "name": "CAPA COBER"
    },
    {
        "code": "2V5-423-376",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V5-423-510-B",
        "name": "REVESTIMEN"
    },
    {
        "code": "23G-971-561",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-561-A",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-641",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-641-A",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-911",
        "name": "GALAO"
    },
    {
        "code": "23G-971-963",
        "name": "RECEPTACUL"
    },
    {
        "code": "23G-971-963-A",
        "name": "TAMPAO"
    },
    {
        "code": "2S0-109-291",
        "name": "CAPA COBER"
    },
    {
        "code": "23G-972-067",
        "name": "CHICOTE"
    },
    {
        "code": "23H-012-766-G",
        "name": "MANUAL DE"
    },
    {
        "code": "23H-035-936-  -82V",
        "name": "HALTER"
    },
    {
        "code": "2V5-311-230-BG",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BH",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BJ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BK",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BL",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-BM",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-230-CS",
        "name": "FRICCAO"
    },
    {
        "code": "2S0-115-327",
        "name": "VALVULA"
    },
    {
        "code": "2V5-311-242-A",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V5-311-243-B",
        "name": "CORPOSINCR"
    },
    {
        "code": "2V5-311-245",
        "name": "PINO ARRAS"
    },
    {
        "code": "2V5-311-245-A",
        "name": "PECABLOQUE"
    },
    {
        "code": "2V5-311-245-B",
        "name": "PINO ARRAS"
    },
    {
        "code": "2V5-311-247-B",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-285-E",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2R2-863-711-D -WM8",
        "name": "TAPETE"
    },
    {
        "code": "2R2-863-711-E -NA2",
        "name": "TAPETE"
    },
    {
        "code": "2R2-863-831-D",
        "name": "ISOLANTE"
    },
    {
        "code": "2S0-115-645",
        "name": "BRACADEIRA"
    },
    {
        "code": "2R2-864-834",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2R2-864-882-A",
        "name": "ISOLAMENTO"
    },
    {
        "code": "2V3-311-103-A",
        "name": "Eixo princ"
    },
    {
        "code": "2V3-311-113",
        "name": "DEFLETOR"
    },
    {
        "code": "2V3-311-123",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-311-123-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-311-123-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-311-123-C",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-311-123-D",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-311-137",
        "name": "CAPA"
    },
    {
        "code": "23B-955-451-A",
        "name": "RESERVATOR"
    },
    {
        "code": "2S0-129-149",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-311-143",
        "name": "EIXO"
    },
    {
        "code": "2V3-311-143-A",
        "name": "EIXO"
    },
    {
        "code": "2V3-311-146",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V3-311-165",
        "name": "PROTECAO"
    },
    {
        "code": "2V3-311-167",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-167-A",
        "name": "ANEL"
    },
    {
        "code": "2V5-525-267-BE",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BF",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BG",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BH",
        "name": "ARRUELA"
    },
    {
        "code": "2S0-129-289",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-525-267-BJ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BK",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BL",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BM",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BN",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BP",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BQ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BR",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BS",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-BT",
        "name": "ARRUELA"
    },
    {
        "code": "2S0-129-620-B",
        "name": "ELEMENTO"
    },
    {
        "code": "2V5-525-267-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CA",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CD",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CE",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CF",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CG",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CH",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CJ",
        "name": "ARRUELA"
    },
    {
        "code": "2S0-129-620-C",
        "name": "ELEMENTO"
    },
    {
        "code": "2V5-525-267-CK",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CL",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CM",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CN",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CP",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CQ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-CS",
        "name": "ARRUELA"
    },
    {
        "code": "23H-858-520",
        "name": "SUPORTE"
    },
    {
        "code": "23H-858-562",
        "name": "ESPELHO"
    },
    {
        "code": "23H-863-367-  -NA2",
        "name": "TAPETE"
    },
    {
        "code": "2S0-130-421-B",
        "name": "BRACADEIRA"
    },
    {
        "code": "23H-863-367-A -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23H-863-368-B -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23H-863-368-E -NA2",
        "name": "TAPETE"
    },
    {
        "code": "23H-863-631",
        "name": "ISOLANTE"
    },
    {
        "code": "23H-863-884-A",
        "name": "ISOLANTE"
    },
    {
        "code": "23H-863-895",
        "name": "ISOLANTE"
    },
    {
        "code": "23H-863-896",
        "name": "ISOLANTE"
    },
    {
        "code": "23H-864-919",
        "name": "ISOLANTE"
    },
    {
        "code": "2V5-311-381-AB",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-AC",
        "name": "ANEL"
    },
    {
        "code": "2S0-130-421-C",
        "name": "BRACADEIRA"
    },
    {
        "code": "2V5-311-381-AD",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-G",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-H",
        "name": "ANEL"
    },
    {
        "code": "2V5-311-381-J",
        "name": "ANEL"
    },
    {
        "code": "2R2-881-053-C",
        "name": "ELEMENTO"
    },
    {
        "code": "2R2-881-053-D",
        "name": "ELEMENTO"
    },
    {
        "code": "2R2-881-053-E",
        "name": "ELEMENTO"
    },
    {
        "code": "07W-145-617-G",
        "name": "CONEXAO"
    },
    {
        "code": "07W-145-617-K",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-109-224",
        "name": "PINO"
    },
    {
        "code": "2S0-145-487",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2T2-109-242",
        "name": "suporte"
    },
    {
        "code": "2T2-109-284-A",
        "name": "CAIXA"
    },
    {
        "code": "2T2-109-285",
        "name": "CARCACA"
    },
    {
        "code": "2T2-109-293",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-109-301",
        "name": "HASTE"
    },
    {
        "code": "2T2-109-309",
        "name": "TUCHO"
    },
    {
        "code": "2T2-109-309-B",
        "name": "GUIA"
    },
    {
        "code": "2T2-109-375",
        "name": "PRATO MOLA"
    },
    {
        "code": "2T2-109-375-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2T2-109-407",
        "name": "EIXO"
    },
    {
        "code": "2S0-145-687",
        "name": "BRACADEIRA"
    },
    {
        "code": "07W-109-383",
        "name": "PORCA"
    },
    {
        "code": "07W-109-395",
        "name": "PLACAPRESS"
    },
    {
        "code": "07W-109-401",
        "name": "EIXO"
    },
    {
        "code": "2V3-311-251",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-251-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-261",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-261-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-261-B",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-265",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-311-277",
        "name": "ANEL"
    },
    {
        "code": "2S0-145-863",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V3-311-279",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-279-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-285",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-285-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V5-525-267-EM",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EN",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EP",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-EQ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-ER",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-ES",
        "name": "ARRUELA"
    },
    {
        "code": "2S0-145-863-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V5-525-267-ET",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-F",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FA",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FD",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FE",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FF",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FG",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FH",
        "name": "ARRUELA"
    },
    {
        "code": "23B-955-455",
        "name": "TAMPA"
    },
    {
        "code": "2S0-201-021-D",
        "name": "RESERVATOR"
    },
    {
        "code": "2V5-525-267-FJ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FK",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FL",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FM",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FN",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FP",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FQ",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FR",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FS",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-FT",
        "name": "ARRUELA"
    },
    {
        "code": "2S0-201-021-E",
        "name": "RESERVATOR"
    },
    {
        "code": "2V5-525-267-G",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-GA",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-GB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-GC",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-GD",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-525-267-GE",
        "name": "ARRUELA"
    },
    {
        "code": "23K-899-329",
        "name": "SUPORTE"
    },
    {
        "code": "23K-899-330",
        "name": "SUPORTE"
    },
    {
        "code": "23K-899-381",
        "name": "suporte"
    },
    {
        "code": "23K-899-381-C",
        "name": "suporte"
    },
    {
        "code": "2S0-201-021-F",
        "name": "RESERVATOR"
    },
    {
        "code": "23K-899-382",
        "name": "suporte"
    },
    {
        "code": "23K-899-382-C",
        "name": "suporte"
    },
    {
        "code": "23K-899-383",
        "name": "suporte"
    },
    {
        "code": "23K-899-387",
        "name": "suporte"
    },
    {
        "code": "23K-899-388",
        "name": "suporte"
    },
    {
        "code": "23K-899-501-A",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "23K-899-501-C",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "23K-899-501-E",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "23K-899-505-A",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "23K-899-505-C",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2S0-201-021-L",
        "name": "RESERVATOR"
    },
    {
        "code": "23K-899-515",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-E",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-F",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-G",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-H",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-J",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-K",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-L",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-M",
        "name": "AMORTECEDO"
    },
    {
        "code": "2S0-201-179",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-899-515-N",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-P",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-515-Q",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-899-521-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-905-367-A",
        "name": "UNIDAD COM"
    },
    {
        "code": "23K-905-367-B",
        "name": "UNIDAD COM"
    },
    {
        "code": "23K-905-367-D",
        "name": "UNI.COMAND"
    },
    {
        "code": "23K-906-048-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-906-048-C",
        "name": "INTERRUPTO"
    },
    {
        "code": "23K-906-625",
        "name": "BLOCO VALV"
    },
    {
        "code": "2S0-407-021-A",
        "name": "ALAVANCA"
    },
    {
        "code": "23K-907-104",
        "name": "MODULO"
    },
    {
        "code": "23K-907-291",
        "name": "SUPORTE"
    },
    {
        "code": "23K-907-571",
        "name": "SENSOR"
    },
    {
        "code": "23K-907-571-A",
        "name": "SENSOR"
    },
    {
        "code": "23K-911-023",
        "name": "MOTOR"
    },
    {
        "code": "23K-911-251",
        "name": "RELE"
    },
    {
        "code": "23K-915-516",
        "name": "suporte"
    },
    {
        "code": "23K-915-516-B",
        "name": "suporte"
    },
    {
        "code": "2V5-311-978-P",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-Q",
        "name": "ARRUELA"
    },
    {
        "code": "2S0-407-022-A",
        "name": "ALAVANCA"
    },
    {
        "code": "2V5-311-978-R",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-S",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-T",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-315-141",
        "name": "TAMPA"
    },
    {
        "code": "2V5-317-021-A",
        "name": "trocador"
    },
    {
        "code": "2V5-317-021-B",
        "name": "trocador"
    },
    {
        "code": "2V5-317-039",
        "name": "ESPACADOR"
    },
    {
        "code": "2V5-321-005",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-321-476",
        "name": "chaveta"
    },
    {
        "code": "2V5-323-157-A",
        "name": "ANEL"
    },
    {
        "code": "2S0-407-071-C",
        "name": "CALCO"
    },
    {
        "code": "2V5-323-157-B",
        "name": "ANEL"
    },
    {
        "code": "2V5-323-157-C",
        "name": "ANEL"
    },
    {
        "code": "2R2-881-557-A",
        "name": "MOLA"
    },
    {
        "code": "2R2-881-681-C",
        "name": "ASSENTO"
    },
    {
        "code": "2R2-881-708-C",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-117-021-A",
        "name": "RESFRIADOR"
    },
    {
        "code": "2T2-121-004",
        "name": "bomba agua"
    },
    {
        "code": "2T2-121-031",
        "name": "POLIA"
    },
    {
        "code": "2T2-121-031-A",
        "name": "POLIA"
    },
    {
        "code": "2T2-121-041",
        "name": "ANEL"
    },
    {
        "code": "2S0-407-171-A",
        "name": "LUVA"
    },
    {
        "code": "2T2-121-051-AF",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-121-071",
        "name": "TUBO"
    },
    {
        "code": "2T2-121-101-G",
        "name": "MANGUEIRA"
    },
    {
        "code": "07W-511-149",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-490",
        "name": "HASTE"
    },
    {
        "code": "2V3-311-490-A",
        "name": "HASTE"
    },
    {
        "code": "2V3-311-493",
        "name": "DISCO"
    },
    {
        "code": "2V3-311-499",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-A",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-AB",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2S0-407-375-A",
        "name": "CAPA COBER"
    },
    {
        "code": "2V3-311-499-AC",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-AD",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-499-AE",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-AF",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-B",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-C",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-D",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2V3-311-499-E",
        "name": "ANEL"
    },
    {
        "code": "2R2-607-269",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-607-367",
        "name": "CONEXAO"
    },
    {
        "code": "23K-800-401-E -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S0-407-375-B",
        "name": "CAPA COBER"
    },
    {
        "code": "2R2-607-367-A",
        "name": "CONEXAO"
    },
    {
        "code": "2R2-607-861",
        "name": "TUBO"
    },
    {
        "code": "2R2-611-819",
        "name": "ANEL"
    },
    {
        "code": "2R2-881-901-A -CIL",
        "name": "APOIO"
    },
    {
        "code": "2R2-881-920",
        "name": "GUIA"
    },
    {
        "code": "2Z0-115-310-A",
        "name": "TUBO"
    },
    {
        "code": "2Z0-115-467",
        "name": "RESPIRO"
    },
    {
        "code": "2W0-703-529-P",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-Q",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-R",
        "name": "ARRUELA"
    },
    {
        "code": "2S0-407-617-D",
        "name": "CUBO RODA"
    },
    {
        "code": "T16-601-141",
        "name": "porca"
    },
    {
        "code": "T16-601-161",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-127-577",
        "name": "ANEL"
    },
    {
        "code": "2R2-803-877-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-CA",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-CE",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-CG",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-CH",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-CJ",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-803-877-CK",
        "name": "PARAFUSO"
    },
    {
        "code": "2S0-407-617-E",
        "name": "CUBO RODA"
    },
    {
        "code": "2S2-857-501-G -1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2S2-857-501-H -1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-857-501-J -1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2S2-857-501-K -1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-857-501-Q -1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-857-501-R -1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-857-502-AK-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "07W-145-723",
        "name": "VEDACAO"
    },
    {
        "code": "T16-511-347",
        "name": "suporte"
    },
    {
        "code": "2R2-899-399",
        "name": "MANCAL"
    },
    {
        "code": "2S0-419-548",
        "name": "PINO"
    },
    {
        "code": "2R2-899-445",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-899-501",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2R2-899-501-A",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2R2-899-501-B",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2R2-899-501-C",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2S2-863-368-B -WM8",
        "name": "TAPETE"
    },
    {
        "code": "2S2-863-368-C -NA2",
        "name": "TAPETE"
    },
    {
        "code": "2S2-863-368-C -WM8",
        "name": "TAPETE"
    },
    {
        "code": "2S2-863-368-D -NA2",
        "name": "TAPETE"
    },
    {
        "code": "2S2-863-368-D -WM8",
        "name": "TAPETE"
    },
    {
        "code": "2S0-419-548-A",
        "name": "PINO"
    },
    {
        "code": "2S2-863-368-F -NA2",
        "name": "TAPETE"
    },
    {
        "code": "2S2-863-368-G -NA2",
        "name": "TAPETE"
    },
    {
        "code": "WHT-005-134",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-137",
        "name": "PORCA"
    },
    {
        "code": "WHT-005-144",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-899-515",
        "name": "AMORTECEDO"
    },
    {
        "code": "2R2-899-521-A",
        "name": "BARRA"
    },
    {
        "code": "2R2-899-523-A",
        "name": "BARRA"
    },
    {
        "code": "2R2-899-541",
        "name": "COXIM"
    },
    {
        "code": "2R2-899-541-A",
        "name": "COXIM"
    },
    {
        "code": "2S0-422-335-A",
        "name": "BARRA DIR"
    },
    {
        "code": "2R2-899-542",
        "name": "COXIM"
    },
    {
        "code": "2R2-899-542-A",
        "name": "COXIM"
    },
    {
        "code": "23B-607-085-A",
        "name": "CONECTOR"
    },
    {
        "code": "23B-607-085-AA",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-AB",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-AF",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-AG",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-599-547-A",
        "name": "PORCA"
    },
    {
        "code": "2T0-511-150-A",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-511-150-B",
        "name": "SUPORTE"
    },
    {
        "code": "2S0-422-817",
        "name": "TERMINAL"
    },
    {
        "code": "2T0-511-151",
        "name": "MOLA"
    },
    {
        "code": "2T0-511-151-B",
        "name": "MOLA"
    },
    {
        "code": "2T0-511-151-G",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2T0-511-157-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-511-160",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-511-167-A",
        "name": "LAMINA"
    },
    {
        "code": "2RD-998-919-A",
        "name": "TRAVA"
    },
    {
        "code": "2R2-867-036-  -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2R2-867-157-B -71N",
        "name": "MOLDURA"
    },
    {
        "code": "2R2-867-157-B -82V",
        "name": "MOLDURA"
    },
    {
        "code": "2S0-422-818",
        "name": "TERMINAL"
    },
    {
        "code": "2R2-867-157-C -71N",
        "name": "MOLDURA"
    },
    {
        "code": "2R2-867-157-C -82V",
        "name": "MOLDURA"
    },
    {
        "code": "23G-857-005-A -82V",
        "name": "PAINEL"
    },
    {
        "code": "23G-857-005-E -82V",
        "name": "PAINEL"
    },
    {
        "code": "23G-857-005-F -82V",
        "name": "PAINEL"
    },
    {
        "code": "23G-857-007-  -82V",
        "name": "PAINEL"
    },
    {
        "code": "2R2-867-393-A -WL7",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-867-394-A -NA2",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-867-394-A -U71",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-867-394-A -WL7",
        "name": "COBERTURA"
    },
    {
        "code": "2S0-501-225",
        "name": "FRICCAO"
    },
    {
        "code": "2R2-867-485-A -Y20",
        "name": "QUADRO"
    },
    {
        "code": "2R2-867-489-  -71N",
        "name": "CAPA COBER"
    },
    {
        "code": "2R0-857-767",
        "name": "ESPACADOR"
    },
    {
        "code": "2R0-857-771",
        "name": "DISCO"
    },
    {
        "code": "2T0-803-875",
        "name": "porca"
    },
    {
        "code": "2T0-803-895-A",
        "name": "TRAVESSA"
    },
    {
        "code": "2T0-803-895-B",
        "name": "TRAVESSA"
    },
    {
        "code": "2T0-803-948",
        "name": "PORCA"
    },
    {
        "code": "2T0-803-948-A",
        "name": "PORCA"
    },
    {
        "code": "2T0-803-955",
        "name": "CHAPA"
    },
    {
        "code": "2S0-501-317-A",
        "name": "RETENTOR"
    },
    {
        "code": "2T0-803-991",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-804-407",
        "name": "TRAVA"
    },
    {
        "code": "2R2-898-402-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2R2-898-870",
        "name": "JG. BUCHA"
    },
    {
        "code": "2R2-899-103",
        "name": "TAMPA"
    },
    {
        "code": "2R2-899-177",
        "name": "BATENTE"
    },
    {
        "code": "2R2-399-417-A",
        "name": "CONEXAO"
    },
    {
        "code": "2R2-415-607",
        "name": "GUARNICAO"
    },
    {
        "code": "2R2-419-655",
        "name": "VOLANTE"
    },
    {
        "code": "2R2-419-655-  -999",
        "name": "VOLANTE"
    },
    {
        "code": "23K-800-401-F -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S0-501-653-C",
        "name": "CUBO RODA"
    },
    {
        "code": "2TA-422-397",
        "name": "VARETA"
    },
    {
        "code": "2T2-141-197",
        "name": "BUCHA"
    },
    {
        "code": "2R0-906-088",
        "name": "SENSOR"
    },
    {
        "code": "TJ3-607-483",
        "name": "CONECTOR"
    },
    {
        "code": "TJ3-607-525",
        "name": "BOCAL"
    },
    {
        "code": "2T2-115-105-C",
        "name": "BOMBA OLEO"
    },
    {
        "code": "2T2-115-199",
        "name": "MOLA"
    },
    {
        "code": "2T2-115-253",
        "name": "TUBO"
    },
    {
        "code": "2T2-115-308-P",
        "name": "TUBO"
    },
    {
        "code": "2T2-115-308-R",
        "name": "TUBO"
    },
    {
        "code": "2S0-609-237-A",
        "name": "SAPATA"
    },
    {
        "code": "2T2-115-310",
        "name": "RESPIRO"
    },
    {
        "code": "2T2-115-313",
        "name": "DRENO"
    },
    {
        "code": "2T2-115-315",
        "name": "ANEL"
    },
    {
        "code": "2T2-115-315-A",
        "name": "ANEL"
    },
    {
        "code": "2T2-115-406-A",
        "name": "CONECTOR"
    },
    {
        "code": "2R2-955-113-B",
        "name": "MOTOR"
    },
    {
        "code": "2R2-955-138",
        "name": "BASE"
    },
    {
        "code": "2R2-955-325-A",
        "name": "HASTE"
    },
    {
        "code": "2R2-955-326",
        "name": "HASTE"
    },
    {
        "code": "2R2-955-401",
        "name": "BRACO"
    },
    {
        "code": "2S0-609-523",
        "name": "SAPATA"
    },
    {
        "code": "2R2-858-637-  -999",
        "name": "PUXADOR"
    },
    {
        "code": "2R2-858-638-  -999",
        "name": "PUXADOR"
    },
    {
        "code": "2R2-858-639-  -999",
        "name": "PUXADOR"
    },
    {
        "code": "2R2-858-793-C -1NN",
        "name": "REVESTIMEN"
    },
    {
        "code": "2U2-401-161-C",
        "name": "ENGRAXADEI"
    },
    {
        "code": "2U2-407-021",
        "name": "ALAVANCA"
    },
    {
        "code": "2U2-407-519",
        "name": "APOIO"
    },
    {
        "code": "JZV-501-287",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-501-319-AA",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-501-319-AC",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S0-698-075-A",
        "name": "JG. LONA"
    },
    {
        "code": "2TB-607-463",
        "name": "suporte"
    },
    {
        "code": "2TB-607-464",
        "name": "suporte"
    },
    {
        "code": "WHT-006-781",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-783",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-784",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-785",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-837-323-A",
        "name": "INVOLUCRO"
    },
    {
        "code": "2S2-837-571",
        "name": "TRILHO"
    },
    {
        "code": "2S2-837-707",
        "name": "MANGUEIRA"
    },
    {
        "code": "2S2-837-707-A",
        "name": "MANG APOIO"
    },
    {
        "code": "2S0-698-075-B",
        "name": "JG. LONA"
    },
    {
        "code": "2S2-853-601",
        "name": "EMBLEMA VW"
    },
    {
        "code": "2V1-853-900",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V1-853-903",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V1-853-904",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V1-857-007",
        "name": "COBERTURA"
    },
    {
        "code": "2V1-857-101",
        "name": "TAPETE"
    },
    {
        "code": "2V1-857-543",
        "name": "TAPETE"
    },
    {
        "code": "2V1-857-543-A",
        "name": "TAPETE"
    },
    {
        "code": "2V1-858-165",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V1-858-166",
        "name": "REVESTIMEN"
    },
    {
        "code": "2S0-698-075-M",
        "name": "JG. LONA"
    },
    {
        "code": "2V1-858-170",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V1-858-719",
        "name": "CAMA"
    },
    {
        "code": "2V1-860-939",
        "name": "DEFLETOR"
    },
    {
        "code": "2V1-860-939-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V1-860-939-B",
        "name": "DEFLETOR"
    },
    {
        "code": "2V1-863-183",
        "name": "suporte"
    },
    {
        "code": "2V1-863-184",
        "name": "suporte"
    },
    {
        "code": "2V1-863-254",
        "name": "suporte"
    },
    {
        "code": "2V1-863-441",
        "name": "suporte"
    },
    {
        "code": "2V1-863-531-A",
        "name": "suporte"
    },
    {
        "code": "2S0-698-075-N",
        "name": "JG. LONA"
    },
    {
        "code": "2V1-864-943",
        "name": "SILENCIADO"
    },
    {
        "code": "2V1-864-943-A",
        "name": "SILENCIADO"
    },
    {
        "code": "2V1-864-944",
        "name": "SILENCIADO"
    },
    {
        "code": "2V1-864-944-A",
        "name": "SILENCIADO"
    },
    {
        "code": "2V1-867-015-  -OXY",
        "name": "REV.PORTA"
    },
    {
        "code": "2V1-867-016-  -OXY",
        "name": "REV.PORTA"
    },
    {
        "code": "2V1-867-141",
        "name": "CAPA"
    },
    {
        "code": "2V1-867-142",
        "name": "CAPA"
    },
    {
        "code": "2V1-867-157-A -9KO",
        "name": "MOLDURA"
    },
    {
        "code": "2V1-867-158-A -9KO",
        "name": "MOLDURA"
    },
    {
        "code": "2S0-698-093-A",
        "name": "JG. LONA"
    },
    {
        "code": "2V1-867-173-  -9KO",
        "name": "COBERTURA"
    },
    {
        "code": "2V1-867-174-  -9KO",
        "name": "COBERTURA"
    },
    {
        "code": "2V1-867-489-  -9KO",
        "name": "CAPA COBER"
    },
    {
        "code": "2V1-867-490-  -9KO",
        "name": "CAPA COBER"
    },
    {
        "code": "2V1-868-903-  -9KO",
        "name": "DIFUSOR"
    },
    {
        "code": "2V1-898-025",
        "name": "CONJUNTO"
    },
    {
        "code": "2V1-898-025-A",
        "name": "CONJUNTO"
    },
    {
        "code": "2V1-898-099",
        "name": "CONJUNTO"
    },
    {
        "code": "2V1-898-099-A",
        "name": "CONJUNTO"
    },
    {
        "code": "2V1-898-100",
        "name": "CONJUNTO"
    },
    {
        "code": "2S0-698-093-B",
        "name": "JG. LONA"
    },
    {
        "code": "2V1-898-100-A",
        "name": "CONJUNTO"
    },
    {
        "code": "JZV-501-319-AD",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-501-319-G",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-501-319-J",
        "name": "ROLAMENTO"
    },
    {
        "code": "2RP-607-383",
        "name": "conexÆo"
    },
    {
        "code": "2RP-607-431",
        "name": "SAPATA"
    },
    {
        "code": "2S2-971-050",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-971-050-A",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-498-506",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-501-023-B",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2S0-698-093-M",
        "name": "JG. LONA"
    },
    {
        "code": "2T2-501-085-A",
        "name": "CORPOEIXO"
    },
    {
        "code": "2T2-501-091-AD",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V3-803-979",
        "name": "BATENTE"
    },
    {
        "code": "2V3-804-186",
        "name": "suporte"
    },
    {
        "code": "2V3-804-186-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-804-261",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-804-261-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-804-475",
        "name": "CHAPA"
    },
    {
        "code": "2V3-804-476",
        "name": "CHAPA"
    },
    {
        "code": "2V3-804-584",
        "name": "REFORCO"
    },
    {
        "code": "23K-800-401-F -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S0-698-093-N",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-804-679-A",
        "name": "DEGRAU"
    },
    {
        "code": "2V3-804-889",
        "name": "DISCO"
    },
    {
        "code": "2V3-807-005-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-006-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-071-F -999",
        "name": "parachoque"
    },
    {
        "code": "2V3-807-071-G",
        "name": "parachoque"
    },
    {
        "code": "2V3-807-071-G -999",
        "name": "parachoque"
    },
    {
        "code": "2V3-807-071-J -999",
        "name": "parachoque"
    },
    {
        "code": "2V3-807-071-K -999",
        "name": "parachoque"
    },
    {
        "code": "2V3-807-091",
        "name": "COBERTURA"
    },
    {
        "code": "2S0-698-096-A",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-807-091-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-173",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-173-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-174",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-174-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-181",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-181-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-182",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-182-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-225",
        "name": "COBERTURA"
    },
    {
        "code": "2S0-698-096-B",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-807-225-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-226",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-226-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-349-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-350-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-461",
        "name": "PLACAROSCA"
    },
    {
        "code": "2V3-807-677",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-677-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-678",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-807-678-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S0-698-096-M",
        "name": "JG. LONA"
    },
    {
        "code": "2V3-807-937",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-937-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-937-A -999",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-938-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-938-A -999",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-807-938-C",
        "name": "COBERTURA"
    },
    {
        "code": "2TA-608-751-A",
        "name": "CONECTOR"
    },
    {
        "code": "2TA-609-295",
        "name": "ANEL"
    },
    {
        "code": "07W-103-232-F",
        "name": "BOCAL"
    },
    {
        "code": "2P0-407-261",
        "name": "CONTRAPINO"
    },
    {
        "code": "2S0-698-096-N",
        "name": "JG. LONA"
    },
    {
        "code": "2T0-616-015",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2T0-616-016",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2T0-616-039",
        "name": "MOLA"
    },
    {
        "code": "2T0-616-041",
        "name": "MOLA"
    },
    {
        "code": "2T0-616-041-A",
        "name": "MOLA"
    },
    {
        "code": "2T0-616-237",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-616-402",
        "name": "TUBO"
    },
    {
        "code": "2U2-525-343",
        "name": "TAMPA"
    },
    {
        "code": "2U2-525-345",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2U2-525-345-A",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2S0-800-375-B",
        "name": "JG.CILINDR"
    },
    {
        "code": "2U2-525-345-B",
        "name": "ISOLANTE"
    },
    {
        "code": "2U2-525-355",
        "name": "EIXO INTER"
    },
    {
        "code": "2U2-525-389",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-525-389-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-525-389-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-525-389-C",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2U2-525-401",
        "name": "EIXO"
    },
    {
        "code": "2U2-525-583",
        "name": "RETENTOR"
    },
    {
        "code": "2U2-525-583-A",
        "name": "RETENTOR"
    },
    {
        "code": "2U2-525-589",
        "name": "FRICCAO"
    },
    {
        "code": "2S0-803-199",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-525-589-A",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-525-615",
        "name": "MAGNETO"
    },
    {
        "code": "2U2-525-691",
        "name": "BRACADEIRA"
    },
    {
        "code": "2U2-525-717",
        "name": "CRUZETA"
    },
    {
        "code": "2U2-525-717-A",
        "name": "CRUZETA"
    },
    {
        "code": "2V3-820-721",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-721-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-721-C",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-722",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-722-A",
        "name": "TUBO"
    },
    {
        "code": "2S0-803-199-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-820-742",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-742-D",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-742-E",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-742-F",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-742-G",
        "name": "TUBO"
    },
    {
        "code": "2V3-820-803",
        "name": "compressor"
    },
    {
        "code": "2V3-820-803-A",
        "name": "COMPRESSOR"
    },
    {
        "code": "2V3-821-103",
        "name": "paralama"
    },
    {
        "code": "2V3-821-104",
        "name": "paralama"
    },
    {
        "code": "2V3-821-107",
        "name": "GUARNICAO"
    },
    {
        "code": "2S0-803-299",
        "name": "porca"
    },
    {
        "code": "2V3-821-108",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-821-151",
        "name": "suporte"
    },
    {
        "code": "2V3-821-152",
        "name": "suporte"
    },
    {
        "code": "2V3-821-176",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-821-653",
        "name": "CAPA"
    },
    {
        "code": "2V3-823-021",
        "name": "TAMPA"
    },
    {
        "code": "2V3-823-021-  -I9A",
        "name": "TAMPA"
    },
    {
        "code": "2V3-823-127",
        "name": "DOBRADICA"
    },
    {
        "code": "2V3-823-147",
        "name": "TRAVESSA"
    },
    {
        "code": "2V3-823-301-B",
        "name": "PINO"
    },
    {
        "code": "2S0-803-399",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-823-302-B",
        "name": "PINO"
    },
    {
        "code": "2V3-823-359-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-823-401",
        "name": "DOBRADICA"
    },
    {
        "code": "2V3-823-402",
        "name": "DOBRADICA"
    },
    {
        "code": "2V3-823-506",
        "name": "Trava da t"
    },
    {
        "code": "2V3-823-507",
        "name": "TRAVA"
    },
    {
        "code": "2V3-201-100-C",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-201-100-D",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-201-100-F",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-201-173",
        "name": "TUBO"
    },
    {
        "code": "23K-800-401-G -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S0-804-943",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-201-173-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-260",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-201-260-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-201-341",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-341-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-341-C",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-341-D",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-341-E",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-341-F",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-351",
        "name": "tubulacao"
    },
    {
        "code": "2S0-805-679",
        "name": "EIXOSUPORT"
    },
    {
        "code": "2V3-201-353",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-353-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-201-392",
        "name": "CINTA"
    },
    {
        "code": "2V3-201-392-A",
        "name": "CINTA"
    },
    {
        "code": "2V3-201-433",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V3-201-433-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V3-201-433-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V3-201-512",
        "name": "FILTR COMB"
    },
    {
        "code": "2V3-201-513-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-201-722-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S0-862-789",
        "name": "CORDAO"
    },
    {
        "code": "2V3-201-722-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-201-883",
        "name": "CONECTOR"
    },
    {
        "code": "2V3-201-923-D",
        "name": "PLACA"
    },
    {
        "code": "2V3-201-923-E",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-201-923-F",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-201-923-G",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-201-958",
        "name": "PLACA"
    },
    {
        "code": "2V3-201-958-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-253-037-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2V3-253-037-B",
        "name": "DEFLETOR"
    },
    {
        "code": "2S0-907-156",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-253-058",
        "name": "FILTRO"
    },
    {
        "code": "2V3-253-075",
        "name": "TUBO"
    },
    {
        "code": "2V3-253-091-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-253-091-B",
        "name": "TUBO"
    },
    {
        "code": "2T2-199-299",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-201-050-C",
        "name": "VALVULA"
    },
    {
        "code": "2T2-201-132",
        "name": "VALVULA"
    },
    {
        "code": "2T2-201-136",
        "name": "VALVULA"
    },
    {
        "code": "2V2-253-143-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V2-253-198",
        "name": "SUPORTE"
    },
    {
        "code": "2S0-907-156-B",
        "name": "UNIDADE"
    },
    {
        "code": "2V2-253-319-B",
        "name": "suporte"
    },
    {
        "code": "2V2-253-683-D",
        "name": "PONT.ESCAP"
    },
    {
        "code": "2V2-253-683-E",
        "name": "PONT.ESCAP"
    },
    {
        "code": "2V2-253-683-F",
        "name": "PONT.ESCAP"
    },
    {
        "code": "2V2-253-683-G",
        "name": "PONT.ESCAP"
    },
    {
        "code": "2V2-254-253-B",
        "name": "CATALISADO"
    },
    {
        "code": "2V2-265-053-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V2-300-041",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-041-A",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-041-F",
        "name": "CAIXA"
    },
    {
        "code": "2S0-907-156-F",
        "name": "UNIDADE"
    },
    {
        "code": "2V2-300-041-H",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-041-K",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-041-L",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-041-N",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-041-P",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057",
        "name": "TRANSMIS."
    },
    {
        "code": "2V2-300-057-A",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-B",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-C",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-D",
        "name": "CAIXA"
    },
    {
        "code": "2S0-911-209-A",
        "name": "PLACA"
    },
    {
        "code": "2V2-300-057-E",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-F",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-G",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-H",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-J",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-K",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-057-L",
        "name": "CAIXA"
    },
    {
        "code": "2V2-300-058-F",
        "name": "TRANSMIS."
    },
    {
        "code": "2V2-301-051",
        "name": "CARCACA"
    },
    {
        "code": "2V2-301-101",
        "name": "CARCACA"
    },
    {
        "code": "2S0-911-209-B",
        "name": "PLACA"
    },
    {
        "code": "2V2-301-101-A",
        "name": "CARCACA"
    },
    {
        "code": "2V3-955-475",
        "name": "suporte"
    },
    {
        "code": "2V3-955-705",
        "name": "SIST.LAVAG"
    },
    {
        "code": "2V3-955-962",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-955-962-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-955-962-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-955-985",
        "name": "BICO EJETO"
    },
    {
        "code": "2V3-957-039",
        "name": "TACOGRAFO"
    },
    {
        "code": "2V3-957-039-A",
        "name": "TACOGRAFO"
    },
    {
        "code": "2V3-957-039-C",
        "name": "TACOGRAFO"
    },
    {
        "code": "2S0-911-215",
        "name": "JG.ESCOVA"
    },
    {
        "code": "2V3-858-433",
        "name": "TAMPA"
    },
    {
        "code": "2V3-858-434",
        "name": "TAMPA"
    },
    {
        "code": "2V3-858-547-B -9KO",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-858-581-E",
        "name": "CAIXA"
    },
    {
        "code": "2V3-858-581-F",
        "name": "CAIXA"
    },
    {
        "code": "2V3-858-637",
        "name": "Alca de se"
    },
    {
        "code": "2V3-858-637-A",
        "name": "Alca de se"
    },
    {
        "code": "2V3-858-661-A -9KO",
        "name": "PECAINTERM"
    },
    {
        "code": "2V3-858-719-  -9KO",
        "name": "PORTA OBJE"
    },
    {
        "code": "2V3-858-719-A -9KO",
        "name": "PORTAOBJET"
    },
    {
        "code": "2S0-911-287-B",
        "name": "SOLENOIDE"
    },
    {
        "code": "2V3-858-763",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-858-833",
        "name": "PLACASUPOR"
    },
    {
        "code": "2V3-858-833-A",
        "name": "PLACASUPOR"
    },
    {
        "code": "2V3-858-905",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-858-906",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-860-219-A",
        "name": "TAMPA"
    },
    {
        "code": "2V3-860-939",
        "name": "DEFLETOR"
    },
    {
        "code": "2V3-861-031-  -9DO",
        "name": "CAMA"
    },
    {
        "code": "2V3-861-031-A -9DO",
        "name": "CAMA"
    },
    {
        "code": "2V3-861-119-A",
        "name": "ALMOFADA"
    },
    {
        "code": "23K-800-401-G -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S0-911-303-A",
        "name": "EIXO"
    },
    {
        "code": "2V3-861-226",
        "name": "PROTETOR"
    },
    {
        "code": "2V3-861-479",
        "name": "TRILHO"
    },
    {
        "code": "2V3-861-709",
        "name": "TELA"
    },
    {
        "code": "2V3-862-143-A",
        "name": "GELADEIRA"
    },
    {
        "code": "2V3-862-291",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-862-291-A",
        "name": "Recipiente"
    },
    {
        "code": "2V3-862-291-B",
        "name": "GAVETA"
    },
    {
        "code": "2V3-862-291-C",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-862-291-D",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-862-291-E",
        "name": "COBERTURA"
    },
    {
        "code": "2S0-911-303-C",
        "name": "EIXO"
    },
    {
        "code": "2V3-862-379",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-862-533",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-862-543",
        "name": "TAMPA"
    },
    {
        "code": "2V3-862-656",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-862-755-  -OGG",
        "name": "CORTINA"
    },
    {
        "code": "2V3-862-755-A -OGG",
        "name": "CORTINA"
    },
    {
        "code": "2V3-862-757-  -OGG",
        "name": "CORTINA"
    },
    {
        "code": "2V3-862-758-  -OGG",
        "name": "CORTINA"
    },
    {
        "code": "JZV-501-319-N",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-501-319-P",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S0-911-309",
        "name": "REDUTOR"
    },
    {
        "code": "JZV-501-319-Q",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-501-319-R",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-501-319-T",
        "name": "ROLAMENTO"
    },
    {
        "code": "JZV-525-059",
        "name": "ROLAMENTO"
    },
    {
        "code": "2P0-607-315-A",
        "name": "CONEXAO"
    },
    {
        "code": "2P0-607-315-D",
        "name": "conexÆo"
    },
    {
        "code": "2R0-103-113-B",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2R0-103-113-C",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-300-093",
        "name": "TOMADA"
    },
    {
        "code": "2T2-300-093-A",
        "name": "TOMADA"
    },
    {
        "code": "2S0-911-311-A",
        "name": "INDUZIDO"
    },
    {
        "code": "2T2-300-093-B",
        "name": "TOMADA"
    },
    {
        "code": "2T2-300-093-C",
        "name": "TOMADA"
    },
    {
        "code": "N  -011-183-16",
        "name": "PORCA"
    },
    {
        "code": "07W-906-529-A",
        "name": "TRANSMISS"
    },
    {
        "code": "2V3-881-081",
        "name": "APOIO BRAC"
    },
    {
        "code": "2V3-881-082-  -9PY",
        "name": "APOIO BRAC"
    },
    {
        "code": "2V3-881-100",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-881-211",
        "name": "TRILHO"
    },
    {
        "code": "2V3-881-231",
        "name": "MANOPLA"
    },
    {
        "code": "2V3-881-231-A",
        "name": "MANOPLA"
    },
    {
        "code": "2S0-911-311-B",
        "name": "INDUZIDO"
    },
    {
        "code": "2V3-881-252",
        "name": "TECLAPRESS"
    },
    {
        "code": "2V3-881-311",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-881-311-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2V3-881-371",
        "name": "MOLA"
    },
    {
        "code": "2RD-201-735",
        "name": "TUBO"
    },
    {
        "code": "2TA-525-181-A",
        "name": "PINO"
    },
    {
        "code": "2TB-698-423",
        "name": "JG.PECAS"
    },
    {
        "code": "23B-607-085-F",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-G",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-H",
        "name": "CONEXAO"
    },
    {
        "code": "2S0-911-334",
        "name": "VEDACAO"
    },
    {
        "code": "23B-607-085-J",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-K",
        "name": "CONECTOR"
    },
    {
        "code": "23B-607-085-L",
        "name": "CONEXAO"
    },
    {
        "code": "23B-607-085-M",
        "name": "CONECTOR"
    },
    {
        "code": "23B-607-085-N",
        "name": "TRAVA"
    },
    {
        "code": "23B-607-085-P",
        "name": "CONECTOR"
    },
    {
        "code": "2R2-837-115-B -9B9",
        "name": "MACANETA"
    },
    {
        "code": "2R2-837-116-B -71N",
        "name": "MACANETA"
    },
    {
        "code": "2R2-837-116-B -9B9",
        "name": "MACANETA"
    },
    {
        "code": "2R2-837-189",
        "name": "PINO"
    },
    {
        "code": "2S0-915-403",
        "name": "TRAVESSA"
    },
    {
        "code": "2R2-837-193-A",
        "name": "haste"
    },
    {
        "code": "2R2-837-206-A",
        "name": "MACANETA"
    },
    {
        "code": "2R2-837-219",
        "name": "CHAVE"
    },
    {
        "code": "2R2-837-249-A",
        "name": "LIMITADOR"
    },
    {
        "code": "2R2-837-250-A",
        "name": "LIMITADOR"
    },
    {
        "code": "2R2-837-275",
        "name": "PRESILHA"
    },
    {
        "code": "2Z0-103-448-K",
        "name": "PORCA"
    },
    {
        "code": "2Z0-103-448-M",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-103-487",
        "name": "ANEL"
    },
    {
        "code": "2Z0-103-609",
        "name": "VEDACAO"
    },
    {
        "code": "2S0-919-183-A",
        "name": "SENSOR"
    },
    {
        "code": "2Z0-105-021",
        "name": "VIRABREQUI"
    },
    {
        "code": "2Z0-105-243-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2Z0-105-255-F",
        "name": "POLIA"
    },
    {
        "code": "2Z0-105-263",
        "name": "PARAFUSO"
    },
    {
        "code": "2Z0-105-313",
        "name": "ROLAMENTO"
    },
    {
        "code": "2Z0-105-379-A",
        "name": "BICO EJETO"
    },
    {
        "code": "2Z0-105-379-B",
        "name": "BICO EJETO"
    },
    {
        "code": "2R2-837-398",
        "name": "ACIONAMETO"
    },
    {
        "code": "2R2-837-399",
        "name": "MECANISMO"
    },
    {
        "code": "2R2-837-400",
        "name": "MECANISMO"
    },
    {
        "code": "2S0-941-334",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R2-837-577",
        "name": "GUIA"
    },
    {
        "code": "2R2-837-707",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R2-845-121",
        "name": "VEDACAO"
    },
    {
        "code": "2R2-845-121-A",
        "name": "VEDACAO"
    },
    {
        "code": "2R2-845-149",
        "name": "CANALETA"
    },
    {
        "code": "2R2-845-149-A",
        "name": "CANALETA"
    },
    {
        "code": "2R2-845-150",
        "name": "CANALETA"
    },
    {
        "code": "N  -909-752-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-845-342",
        "name": "VEDACAO"
    },
    {
        "code": "2R2-845-437",
        "name": "GUARNICAO"
    },
    {
        "code": "2S0-998-589",
        "name": "JG.PECAS"
    },
    {
        "code": "2R2-845-501",
        "name": "vidro"
    },
    {
        "code": "2R2-845-521",
        "name": "VEDACAO"
    },
    {
        "code": "2R2-847-781",
        "name": "ACIONAMENT"
    },
    {
        "code": "23B-937-629-E",
        "name": "FERRAMENTA"
    },
    {
        "code": "2R2-867-015-B -NNN",
        "name": "REV.PORTA"
    },
    {
        "code": "2R2-867-015-C -CIN",
        "name": "REV.PORTA"
    },
    {
        "code": "2R2-867-015-C -NA2",
        "name": "REV.PORTA"
    },
    {
        "code": "2R2-867-015-C -NNN",
        "name": "REV.PORTA"
    },
    {
        "code": "2R2-867-016-B -CIN",
        "name": "REV.PORTA"
    },
    {
        "code": "23F-607-085-A",
        "name": "CONEXAO"
    },
    {
        "code": "23K-800-401-H -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S0-998-711",
        "name": "JG.PECAS"
    },
    {
        "code": "23P-607-085-A",
        "name": "CONEXAO"
    },
    {
        "code": "23P-607-367",
        "name": "CONEXAO"
    },
    {
        "code": "23P-607-879-B",
        "name": "CHAPA"
    },
    {
        "code": "2T2-100-025-C",
        "name": "MOTOR BAS."
    },
    {
        "code": "2T2-100-035-C",
        "name": "MOTOR"
    },
    {
        "code": "2T2-100-103-G",
        "name": "MOTOR"
    },
    {
        "code": "2T2-101-451",
        "name": "INSERTO"
    },
    {
        "code": "2T2-101-451-A",
        "name": "INSERTO"
    },
    {
        "code": "2T2-101-451-B",
        "name": "INSERTO"
    },
    {
        "code": "2T2-103-011-G",
        "name": "BLOCO"
    },
    {
        "code": "2S0-998-754",
        "name": "JG.GRAMPO"
    },
    {
        "code": "2T2-103-035-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T2-103-085-A",
        "name": "RETENTOR"
    },
    {
        "code": "2T2-103-113-A",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "3G5-035-954",
        "name": "USB port"
    },
    {
        "code": "2T2-817-130",
        "name": "PECA DE FE"
    },
    {
        "code": "2T2-817-172-  -Y20",
        "name": "MOLDURA"
    },
    {
        "code": "2T2-817-172-A -Y20",
        "name": "MOLDURA"
    },
    {
        "code": "2T2-817-173-  -Y20",
        "name": "MOLDURA"
    },
    {
        "code": "2T2-817-173-A -Y20",
        "name": "MOLDURA"
    },
    {
        "code": "2T2-817-174-  -Y20",
        "name": "MOLDURA"
    },
    {
        "code": "2S0-998-761",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-857-133",
        "name": "FECHO"
    },
    {
        "code": "2T2-857-151-  -Y20",
        "name": "TAMPA"
    },
    {
        "code": "2T2-857-192-A -Y20",
        "name": "CAPA"
    },
    {
        "code": "2T2-857-213",
        "name": "DOBRADICA"
    },
    {
        "code": "2T2-857-215",
        "name": "CLIP"
    },
    {
        "code": "2T2-857-237-A -Y20",
        "name": "COBERTURA"
    },
    {
        "code": "N  -913-096-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-862-131",
        "name": "HASTE"
    },
    {
        "code": "2T2-863-421-B",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-863-584",
        "name": "suporte"
    },
    {
        "code": "2S2-000-322-A",
        "name": "EMBLEMA"
    },
    {
        "code": "2T2-863-717-B -NA2",
        "name": "TAPETE"
    },
    {
        "code": "2T2-863-717-B -WM8",
        "name": "TAPETE"
    },
    {
        "code": "2V3-607-359-A",
        "name": "PLACA"
    },
    {
        "code": "2V3-607-359-B",
        "name": "PLACASUPOR"
    },
    {
        "code": "2V3-607-359-C",
        "name": "VALVULA"
    },
    {
        "code": "2V3-607-363",
        "name": "suporte"
    },
    {
        "code": "2V3-607-363-B",
        "name": "suporte"
    },
    {
        "code": "2V3-607-363-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-367",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V3-607-373-A",
        "name": "SECADOR"
    },
    {
        "code": "2S2-000-401",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-607-373-B",
        "name": "SECADOR"
    },
    {
        "code": "2V3-607-403",
        "name": "ALAVANCA"
    },
    {
        "code": "2V3-607-441",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-787-A",
        "name": "suporte"
    },
    {
        "code": "2V3-607-815",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V3-607-815-C",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-815-D",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-607-861",
        "name": "TUBO"
    },
    {
        "code": "2V3-607-861-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-607-862",
        "name": "TUBO"
    },
    {
        "code": "2S2-000-401-A",
        "name": "ETIQUETA"
    },
    {
        "code": "2V3-607-862-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-607-862-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-607-879",
        "name": "CHAPA"
    },
    {
        "code": "2V3-607-881-A",
        "name": "suporte"
    },
    {
        "code": "2V3-607-891-E",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-894",
        "name": "ANEL"
    },
    {
        "code": "2V3-607-900",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-607-900-A",
        "name": "SUPORTE"
    },
    {
        "code": "WHT-009-031",
        "name": "ANEL VEDAC"
    },
    {
        "code": "WHT-009-032",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-000-401-B",
        "name": "ETIQUETA"
    },
    {
        "code": "WHT-009-033",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-034",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-035",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-038",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-041",
        "name": "PINOCILIND"
    },
    {
        "code": "23K-607-289",
        "name": "TUBO"
    },
    {
        "code": "23K-607-307",
        "name": "BUCHA"
    },
    {
        "code": "23K-607-312",
        "name": "TUBO"
    },
    {
        "code": "23K-607-315",
        "name": "PECA EM T"
    },
    {
        "code": "23K-607-315-A",
        "name": "CONEXAO"
    },
    {
        "code": "2S2-000-401-C",
        "name": "ETIQUETA"
    },
    {
        "code": "23K-607-315-B",
        "name": "PECA EM T"
    },
    {
        "code": "23K-607-325",
        "name": "SUPORTE"
    },
    {
        "code": "23K-607-329",
        "name": "valvula"
    },
    {
        "code": "23K-607-329-A",
        "name": "VALVULA"
    },
    {
        "code": "23K-607-335",
        "name": "SUPORTE"
    },
    {
        "code": "23K-607-335-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-607-355",
        "name": "VALVULA"
    },
    {
        "code": "23K-607-359",
        "name": "SUPORTE"
    },
    {
        "code": "23K-607-359-B",
        "name": "SUPORTE"
    },
    {
        "code": "23K-607-361",
        "name": "VALVULA"
    },
    {
        "code": "2S2-035-505",
        "name": "ANTENA"
    },
    {
        "code": "23K-607-363",
        "name": "suporte"
    },
    {
        "code": "23K-607-861",
        "name": "TUBO"
    },
    {
        "code": "23K-607-862",
        "name": "TUBO"
    },
    {
        "code": "23K-607-891-F",
        "name": "suporte"
    },
    {
        "code": "23K-607-891-L",
        "name": "suporte"
    },
    {
        "code": "23K-609-423",
        "name": "SUPORTE"
    },
    {
        "code": "23K-609-425",
        "name": "SUPORTE"
    },
    {
        "code": "23K-609-426",
        "name": "SUPORTE"
    },
    {
        "code": "23K-609-457",
        "name": "MECANISMO"
    },
    {
        "code": "23K-609-457-A",
        "name": "MECANISMO"
    },
    {
        "code": "2S2-121-473-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-609-458",
        "name": "MECANISMO"
    },
    {
        "code": "23K-609-458-A",
        "name": "MECANISMO"
    },
    {
        "code": "23K-609-523",
        "name": "SAPATA"
    },
    {
        "code": "23K-609-523-A",
        "name": "SAPATA"
    },
    {
        "code": "23K-609-561",
        "name": "ROLETE"
    },
    {
        "code": "23H-400-019-A",
        "name": "EIXODIANTE"
    },
    {
        "code": "23H-401-031",
        "name": "CORPO EIXO"
    },
    {
        "code": "23H-407-171",
        "name": "BUCHA"
    },
    {
        "code": "23H-407-717",
        "name": "ALAVANCA"
    },
    {
        "code": "23H-411-025",
        "name": "ESTABILIZA"
    },
    {
        "code": "2V5-129-559",
        "name": "SUPORTE"
    },
    {
        "code": "23K-800-401-H -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-201-733",
        "name": "SENSOR DE"
    },
    {
        "code": "23H-411-049",
        "name": "APOIO"
    },
    {
        "code": "23H-411-057",
        "name": "APOIO"
    },
    {
        "code": "23H-411-077",
        "name": "suporte"
    },
    {
        "code": "23H-411-101",
        "name": "FEIXE MOLA"
    },
    {
        "code": "23H-411-101-C",
        "name": "FEIXE MOLA"
    },
    {
        "code": "23H-411-102",
        "name": "FEIXE MOLA"
    },
    {
        "code": "23H-411-102-C",
        "name": "FEIXE MOLA"
    },
    {
        "code": "23H-411-111",
        "name": "BATENTE"
    },
    {
        "code": "23H-411-127-A",
        "name": "JUMELO"
    },
    {
        "code": "2V5-701-041-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-253-037",
        "name": "DEFLETOR"
    },
    {
        "code": "2V5-701-042-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-701-123",
        "name": "PLACA"
    },
    {
        "code": "2V5-701-138-C",
        "name": "TRAVESSA"
    },
    {
        "code": "2V5-701-151-D",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V5-701-153-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-701-273",
        "name": "CHAPA"
    },
    {
        "code": "2RD-199-120-J",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-L",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-M",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-N",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-253-037-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2RD-199-120-P",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-Q",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-S",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-T",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-121-207",
        "name": "DEFLET AR"
    },
    {
        "code": "23K-121-233",
        "name": "suporte"
    },
    {
        "code": "23K-121-251",
        "name": "RADIADOR"
    },
    {
        "code": "23K-121-275",
        "name": "COXIM"
    },
    {
        "code": "23K-121-275-A",
        "name": "COXIM"
    },
    {
        "code": "23K-121-275-B",
        "name": "COXIM"
    },
    {
        "code": "2S2-253-853-B",
        "name": "FREIO MOT"
    },
    {
        "code": "23K-121-302",
        "name": "EMBREAGEM"
    },
    {
        "code": "23K-121-303",
        "name": "HELICE"
    },
    {
        "code": "23K-121-373",
        "name": "PROTETOR"
    },
    {
        "code": "23K-121-373-A",
        "name": "PROTETOR"
    },
    {
        "code": "23K-121-377",
        "name": "TIRANTE"
    },
    {
        "code": "23K-121-383-C",
        "name": "SUPORTE"
    },
    {
        "code": "23K-121-384",
        "name": "SUPORTE"
    },
    {
        "code": "23K-121-384-C",
        "name": "SUPORTE"
    },
    {
        "code": "23K-121-393",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-393-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "2S2-265-053-D",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-455-B",
        "name": "TUBO"
    },
    {
        "code": "23K-121-473-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-473-B",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-481",
        "name": "TUBO"
    },
    {
        "code": "23K-121-481-A",
        "name": "TUBO"
    },
    {
        "code": "23K-121-625",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-121-625-A",
        "name": "MANGUEIRA"
    },
    {
        "code": "23K-129-044",
        "name": "CHP COBERT"
    },
    {
        "code": "23K-129-141-C",
        "name": "suporte"
    },
    {
        "code": "23K-129-141-D",
        "name": "suporte"
    },
    {
        "code": "2S2-422-335-J",
        "name": "BARRA DIR"
    },
    {
        "code": "23K-129-573",
        "name": "TUBO ASPI."
    },
    {
        "code": "23K-129-573-D",
        "name": "TUBO ASPI."
    },
    {
        "code": "23K-129-607",
        "name": "FILTRO AR"
    },
    {
        "code": "23K-129-607-E",
        "name": "FILTRO AR"
    },
    {
        "code": "23K-129-607-G",
        "name": "FILTRO AR"
    },
    {
        "code": "23K-129-621",
        "name": "TUBO"
    },
    {
        "code": "23K-129-621-A",
        "name": "TUBO"
    },
    {
        "code": "23K-129-621-G",
        "name": "TUBO"
    },
    {
        "code": "23K-129-621-H",
        "name": "TUBO"
    },
    {
        "code": "23K-129-642",
        "name": "BRACADEIRA"
    },
    {
        "code": "2S2-422-553",
        "name": "suporte"
    },
    {
        "code": "23K-129-642-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "23K-129-644",
        "name": "CONECTOR"
    },
    {
        "code": "23K-129-687",
        "name": "SUPORTE"
    },
    {
        "code": "23K-129-687-A",
        "name": "COXIM"
    },
    {
        "code": "23K-129-778",
        "name": "BRACADEIR"
    },
    {
        "code": "23K-129-857",
        "name": "TUBO ASPI."
    },
    {
        "code": "07W-971-303-AC",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-035-550-B",
        "name": "CABO ANTEN"
    },
    {
        "code": "2R2-121-168",
        "name": "TAMPA"
    },
    {
        "code": "2R2-129-573-B",
        "name": "CONDUTOR A"
    },
    {
        "code": "2S2-422-891",
        "name": "MANGUEIRA"
    },
    {
        "code": "2R2-129-687",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-129-739",
        "name": "TUBO ASPI."
    },
    {
        "code": "2R2-129-763",
        "name": "COXIM"
    },
    {
        "code": "2S0-198-049-B",
        "name": "RETENTOR"
    },
    {
        "code": "2S0-198-049-C",
        "name": "RETENTOR"
    },
    {
        "code": "2R2-857-905-  -NA2",
        "name": "SOLEIRA"
    },
    {
        "code": "2R2-857-905-  -WL7",
        "name": "SOLEIRA"
    },
    {
        "code": "2R2-857-906-  -NA2",
        "name": "SOLEIRA"
    },
    {
        "code": "23B-616-885",
        "name": "PARAFUSO"
    },
    {
        "code": "23B-698-459",
        "name": "JG.PECAS"
    },
    {
        "code": "2S2-607-079",
        "name": "COTOVELO"
    },
    {
        "code": "2T2-103-485-A",
        "name": "TAMPA"
    },
    {
        "code": "2T2-103-487",
        "name": "SILENCIADO"
    },
    {
        "code": "2T2-103-601-D",
        "name": "CARTER"
    },
    {
        "code": "2T2-103-635-B",
        "name": "TUBO"
    },
    {
        "code": "2T2-103-683",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-103-689",
        "name": "LUVA"
    },
    {
        "code": "2T2-103-705",
        "name": "PINO"
    },
    {
        "code": "2T2-105-257",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-105-257-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-105-269-E",
        "name": "VOLANTE"
    },
    {
        "code": "2S2-607-263",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T2-105-275",
        "name": "COROA DENT"
    },
    {
        "code": "2RH-607-458",
        "name": "CHAPA"
    },
    {
        "code": "TF3-103-113-B",
        "name": "TAMPAO"
    },
    {
        "code": "TF3-103-211",
        "name": "ANEL"
    },
    {
        "code": "TF3-103-221",
        "name": "ANEL"
    },
    {
        "code": "23B-820-803",
        "name": "compressor"
    },
    {
        "code": "23B-820-803-E",
        "name": "compressor"
    },
    {
        "code": "2T2-857-551-  -Y20",
        "name": "PARASOL"
    },
    {
        "code": "2T2-857-552-  -Y20",
        "name": "PARASOL"
    },
    {
        "code": "2T2-857-609-  -Y20",
        "name": "PARASOL"
    },
    {
        "code": "23K-800-401-J -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-607-263-A",
        "name": "ADAPTADOR"
    },
    {
        "code": "2P0-803-877-H",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-131-503",
        "name": "VALVULA"
    },
    {
        "code": "2V3-131-510",
        "name": "TAMPA"
    },
    {
        "code": "2V3-131-639-A",
        "name": "CINTATENSO"
    },
    {
        "code": "2V3-131-662",
        "name": "BOCAL"
    },
    {
        "code": "2V3-131-674",
        "name": "TUBO"
    },
    {
        "code": "2V3-131-674-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-131-674-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-131-674-C",
        "name": "TUBO"
    },
    {
        "code": "2V3-131-677",
        "name": "TUBO"
    },
    {
        "code": "2S2-607-265",
        "name": "conexÆo"
    },
    {
        "code": "2V3-131-677-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-131-677-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-131-747",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-131-759",
        "name": "FILTRO"
    },
    {
        "code": "2V3-131-759-A",
        "name": "FILTRO"
    },
    {
        "code": "2V3-131-793",
        "name": "Rins. sys."
    },
    {
        "code": "2V3-131-797-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-131-832",
        "name": "SENSOR"
    },
    {
        "code": "2V3-131-877",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-131-978",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-607-265-A",
        "name": "COTOVELO"
    },
    {
        "code": "2V3-131-980",
        "name": "TAMPA"
    },
    {
        "code": "2V3-131-983",
        "name": "TUBULACAO"
    },
    {
        "code": "2V3-131-984",
        "name": "TUBULACAO"
    },
    {
        "code": "2V3-131-984-A",
        "name": "TUBULACAO"
    },
    {
        "code": "2V3-131-984-B",
        "name": "TUBULACAO"
    },
    {
        "code": "2V3-109-641",
        "name": "PRATO MOLA"
    },
    {
        "code": "2V3-109-659",
        "name": "PONTE"
    },
    {
        "code": "2V3-109-659-A",
        "name": "PONTE"
    },
    {
        "code": "2V3-115-141",
        "name": "TAMPA"
    },
    {
        "code": "2V3-115-223-A",
        "name": "TUBO"
    },
    {
        "code": "2S2-607-312-S",
        "name": "TUBO"
    },
    {
        "code": "2V3-115-223-B",
        "name": "TUBO"
    },
    {
        "code": "2V3-115-252",
        "name": "TUBO ASPI."
    },
    {
        "code": "2V3-115-255-C",
        "name": "FLANGE"
    },
    {
        "code": "2V3-115-611",
        "name": "VARETA"
    },
    {
        "code": "2V3-115-611-A",
        "name": "VARETA"
    },
    {
        "code": "2V3-115-629",
        "name": "TUBO"
    },
    {
        "code": "2V3-115-645",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-115-685",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-115-685-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-115-685-C",
        "name": "ANEL"
    },
    {
        "code": "2S2-607-313",
        "name": "PECAJUNCAO"
    },
    {
        "code": "2V3-117-013",
        "name": "FILTRO OLE"
    },
    {
        "code": "2V3-117-013-A",
        "name": "FILTRO OLE"
    },
    {
        "code": "2V3-121-010",
        "name": "bomba agua"
    },
    {
        "code": "2V3-121-010-B",
        "name": "bomba agua"
    },
    {
        "code": "2V3-121-010-C",
        "name": "bomba agua"
    },
    {
        "code": "2V3-121-031",
        "name": "POLIA"
    },
    {
        "code": "2V3-121-037-A",
        "name": "CARCACA"
    },
    {
        "code": "2V3-121-037-B",
        "name": "CARCACA"
    },
    {
        "code": "2V3-121-045",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-050",
        "name": "TUBO"
    },
    {
        "code": "2S2-607-313-A",
        "name": "CONEXAO"
    },
    {
        "code": "2V3-121-050-A",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-050-E",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-050-F",
        "name": "DISTRIBUID"
    },
    {
        "code": "2V3-121-050-G",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-050-H",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-050-J",
        "name": "TUBO"
    },
    {
        "code": "2V3-121-050-L",
        "name": "TUBO"
    },
    {
        "code": "2V3-301-035",
        "name": "RETARDER"
    },
    {
        "code": "2V3-301-051",
        "name": "CARCACA"
    },
    {
        "code": "2V3-301-051-A",
        "name": "CARCACA"
    },
    {
        "code": "2S2-607-316-A",
        "name": "PECA EM T"
    },
    {
        "code": "2V3-301-051-B",
        "name": "CARCACA"
    },
    {
        "code": "2V3-301-051-C",
        "name": "CARCACA"
    },
    {
        "code": "2V3-301-051-D",
        "name": "CARCACA"
    },
    {
        "code": "2V3-301-090",
        "name": "PINOCILIND"
    },
    {
        "code": "2V3-301-090-A",
        "name": "PINOCILIND"
    },
    {
        "code": "2V3-301-090-B",
        "name": "PINOCILIND"
    },
    {
        "code": "2V3-301-090-C",
        "name": "PINOCILIND"
    },
    {
        "code": "2V3-301-090-D",
        "name": "PINOCILIND"
    },
    {
        "code": "2V3-301-090-F",
        "name": "PINOCILIND"
    },
    {
        "code": "2V3-301-090-G",
        "name": "PINOCILIND"
    },
    {
        "code": "2S2-607-367-B",
        "name": "CONECTOR"
    },
    {
        "code": "2V3-301-141",
        "name": "BUJAO"
    },
    {
        "code": "2V3-301-141-A",
        "name": "BUJAO"
    },
    {
        "code": "2V3-301-141-B",
        "name": "BUJAO"
    },
    {
        "code": "2V3-301-141-C",
        "name": "BUJAO"
    },
    {
        "code": "2V3-301-141-D",
        "name": "BUJAO"
    },
    {
        "code": "2V3-301-141-E",
        "name": "BUJAO"
    },
    {
        "code": "2V3-301-141-F",
        "name": "BUJAO"
    },
    {
        "code": "2V3-301-141-G",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V3-301-141-H",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2V3-301-141-J",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2S2-607-367-C",
        "name": "CONEXAO"
    },
    {
        "code": "2R2-857-301-A -WL7",
        "name": "CINZEIRO"
    },
    {
        "code": "2R2-857-331-  -999",
        "name": "CINZEIRO"
    },
    {
        "code": "2R2-857-489-  -033",
        "name": "TAMPAO"
    },
    {
        "code": "2R2-857-489-  -9B9",
        "name": "TAMPAO"
    },
    {
        "code": "2R2-857-489-  -NA2",
        "name": "TAMPAO"
    },
    {
        "code": "2R2-857-503-A -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "N  -100-173-04",
        "name": "PORCA"
    },
    {
        "code": "TE3-525-225",
        "name": "PINO"
    },
    {
        "code": "TE3-525-225-A",
        "name": "SEXTAVADO"
    },
    {
        "code": "2V5-803-875-N",
        "name": "porca"
    },
    {
        "code": "2S2-607-373-A",
        "name": "SECADOR"
    },
    {
        "code": "2V5-803-875-P",
        "name": "porca"
    },
    {
        "code": "2V5-803-875-Q",
        "name": "porca"
    },
    {
        "code": "2V5-803-875-R",
        "name": "porca"
    },
    {
        "code": "2V5-803-875-S",
        "name": "PORCA DE C"
    },
    {
        "code": "2V5-803-877",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AB",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AD",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AE",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AF",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-800-401-J -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-607-815",
        "name": "ADAPTADOR"
    },
    {
        "code": "2V5-803-877-AG",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AH",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AJ",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AL",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-AM",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-857-684-A -1NN",
        "name": "CINTO"
    },
    {
        "code": "2R2-857-725-A -1NN",
        "name": "GUARNICAO"
    },
    {
        "code": "2R2-857-725-A -9B9",
        "name": "GUARNICAO"
    },
    {
        "code": "N  -905-113-04",
        "name": "REB CEGO"
    },
    {
        "code": "07W-115-423",
        "name": "TAMPA"
    },
    {
        "code": "2S2-607-815-B",
        "name": "ADAPTADOR"
    },
    {
        "code": "07W-115-427",
        "name": "ANEL"
    },
    {
        "code": "N  -106-408-03",
        "name": "PARAFUSO"
    },
    {
        "code": "23B-407-493",
        "name": "CINTA"
    },
    {
        "code": "2R2-858-079-  -71N",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-858-079-  -82V",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-858-131-A",
        "name": "BRACO"
    },
    {
        "code": "2R2-858-132-A",
        "name": "BRACO"
    },
    {
        "code": "2R2-858-193-A -71N",
        "name": "COBERTURA"
    },
    {
        "code": "23L-109-101",
        "name": "COMANDO"
    },
    {
        "code": "23L-109-157",
        "name": "CARCACA"
    },
    {
        "code": "2S2-607-815-E",
        "name": "ADAPTADOR"
    },
    {
        "code": "23L-109-164",
        "name": "DEFLETOR"
    },
    {
        "code": "23L-109-183",
        "name": "suporte"
    },
    {
        "code": "23L-109-183-A",
        "name": "suporte"
    },
    {
        "code": "23L-109-183-B",
        "name": "suporte"
    },
    {
        "code": "23L-109-284",
        "name": "CAIXA"
    },
    {
        "code": "23L-109-293",
        "name": "ANEL"
    },
    {
        "code": "23L-109-293-A",
        "name": "RETENTOR"
    },
    {
        "code": "23L-109-309",
        "name": "TUCHO"
    },
    {
        "code": "23L-109-337",
        "name": "BALANCIM"
    },
    {
        "code": "23L-109-338",
        "name": "BALANCIM"
    },
    {
        "code": "2S2-607-815-G",
        "name": "ADAPTADOR"
    },
    {
        "code": "23L-109-407",
        "name": "EIXO"
    },
    {
        "code": "23L-109-407-A",
        "name": "EIXO"
    },
    {
        "code": "23L-109-447",
        "name": "BALANCIM"
    },
    {
        "code": "23L-109-659",
        "name": "CRUZETA"
    },
    {
        "code": "23L-109-675",
        "name": "VEDACAO"
    },
    {
        "code": "23L-115-105",
        "name": "BOMBA OLEO"
    },
    {
        "code": "23L-115-253",
        "name": "TUBO ASPI."
    },
    {
        "code": "23L-115-403",
        "name": "FILTRO OLE"
    },
    {
        "code": "23L-115-441",
        "name": "JUNTA"
    },
    {
        "code": "23L-115-467",
        "name": "TUBO OLEO"
    },
    {
        "code": "2S2-607-815-H",
        "name": "PECAJUNCAO"
    },
    {
        "code": "23L-121-004",
        "name": "bomba agua"
    },
    {
        "code": "23L-121-123",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-121-123-A",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-121-123-B",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-121-123-C",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-121-123-D",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-121-123-E",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-121-123-F",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-121-123-G",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-121-123-L",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-607-815-J",
        "name": "ADAPTADOR"
    },
    {
        "code": "23L-121-179",
        "name": "TUBO"
    },
    {
        "code": "23L-121-233",
        "name": "suporte"
    },
    {
        "code": "23L-121-239",
        "name": "suporte"
    },
    {
        "code": "23L-121-301-A",
        "name": "HELICE"
    },
    {
        "code": "23L-121-302-A",
        "name": "EMBREAGEM"
    },
    {
        "code": "23L-121-375",
        "name": "ESPACADOR"
    },
    {
        "code": "23L-121-473",
        "name": "MANGUEIRA"
    },
    {
        "code": "23L-121-477-A",
        "name": "BRACADEIR"
    },
    {
        "code": "23L-121-805",
        "name": "PRISIONEIR"
    },
    {
        "code": "23L-121-805-A",
        "name": "PRISIONEIR"
    },
    {
        "code": "2S2-607-891-F",
        "name": "SUPORTE"
    },
    {
        "code": "23L-121-805-B",
        "name": "PRISIONEIR"
    },
    {
        "code": "23L-127-177",
        "name": "FILTR COMB"
    },
    {
        "code": "23L-127-177-A",
        "name": "ELEM FILTR"
    },
    {
        "code": "23L-127-250",
        "name": "suporte"
    },
    {
        "code": "23L-127-507",
        "name": "TUBO"
    },
    {
        "code": "2R2-867-597",
        "name": "TAMPAO"
    },
    {
        "code": "2R2-867-599",
        "name": "REFORCO"
    },
    {
        "code": "2R2-868-563",
        "name": "CLIP"
    },
    {
        "code": "2R2-881-023-  -CIL",
        "name": "ASSENTO"
    },
    {
        "code": "WHT-006-375",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S2-721-269",
        "name": "PROTECAO"
    },
    {
        "code": "WHT-006-376",
        "name": "ROLAMENTO"
    },
    {
        "code": "WHT-006-379",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-384",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-006-385",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-006-388",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-389",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-609-287-A",
        "name": "CABECOTE"
    },
    {
        "code": "2RD-609-295",
        "name": "ANEL"
    },
    {
        "code": "2S2-867-035-B -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2S2-867-036-A -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2S2-721-269-A",
        "name": "PROTECAO"
    },
    {
        "code": "2S2-867-361-  -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2S2-867-361-A -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2S2-867-361-B -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "N  -107-023-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-885-319-A",
        "name": "CALCO"
    },
    {
        "code": "2R2-885-595",
        "name": "CABO"
    },
    {
        "code": "2R2-887-271",
        "name": "PINO"
    },
    {
        "code": "2R2-898-035",
        "name": "REPARO"
    },
    {
        "code": "2S2-881-032-F -QFF",
        "name": "BANCO"
    },
    {
        "code": "2S2-881-037-A -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2S2-721-303",
        "name": "BATENTE"
    },
    {
        "code": "2S2-881-037-A -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2S2-881-038-  -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2S2-885-271",
        "name": "AMORTECEDO"
    },
    {
        "code": "2S2-885-711",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-887-271",
        "name": "PINO"
    },
    {
        "code": "2S2-898-015",
        "name": "JG.PECAS"
    },
    {
        "code": "2S2-898-016",
        "name": "JG.PECAS"
    },
    {
        "code": "2R2-810-773",
        "name": "batente"
    },
    {
        "code": "2R2-810-773-B",
        "name": "batente"
    },
    {
        "code": "2R2-815-681-  -71N",
        "name": "CANAL AR"
    },
    {
        "code": "23K-800-401-K -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-777-515",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-815-681-  -82V",
        "name": "CANAL AR"
    },
    {
        "code": "2S2-867-645-  -Y20",
        "name": "PINO RETEN"
    },
    {
        "code": "2S2-881-019-  -CIL",
        "name": "BANCO"
    },
    {
        "code": "2S2-881-019-  -CIO",
        "name": "BANCO"
    },
    {
        "code": "2S2-881-019-C -QFE",
        "name": "BANCO"
    },
    {
        "code": "2S2-881-019-C -QFF",
        "name": "BANCO"
    },
    {
        "code": "2S2-881-023-  -CIL",
        "name": "ASSENTO"
    },
    {
        "code": "2S4-881-557",
        "name": "MOLA"
    },
    {
        "code": "WHT-005-106",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-115-111-A",
        "name": "PEC VEDAC"
    },
    {
        "code": "2S2-800-401-D -I7N",
        "name": "CABINA"
    },
    {
        "code": "07W-115-111-B",
        "name": "PEC VEDAC"
    },
    {
        "code": "07W-115-149-C",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "07W-115-175",
        "name": "PENEIRA DE"
    },
    {
        "code": "07W-115-194-A",
        "name": "PINHAO"
    },
    {
        "code": "2T0-513-479-A",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-515-135",
        "name": "suporte"
    },
    {
        "code": "2T0-517-157",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2T0-521-339-A",
        "name": "DEFLETOR"
    },
    {
        "code": "2T0-521-525",
        "name": "TIRANTE"
    },
    {
        "code": "2TE-121-255-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2S2-800-401-D -I9A",
        "name": "CABINA"
    },
    {
        "code": "N  -104-525-02",
        "name": "CLIP"
    },
    {
        "code": "07W-019-873-N",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-P",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-019-873-S",
        "name": "PARAFUSO"
    },
    {
        "code": "23B-906-051-G",
        "name": "SENSOR"
    },
    {
        "code": "23B-906-051-J",
        "name": "SENSOR"
    },
    {
        "code": "23B-906-051-K",
        "name": "SENSOR"
    },
    {
        "code": "23B-906-145-A",
        "name": "ANEL"
    },
    {
        "code": "23B-907-156-G",
        "name": "UNIDADE"
    },
    {
        "code": "23B-907-156-J",
        "name": "UNIDADE"
    },
    {
        "code": "2S2-800-401-E -I7N",
        "name": "CABINA"
    },
    {
        "code": "23B-907-171",
        "name": "CONVERSOR"
    },
    {
        "code": "23B-907-631-F",
        "name": "VALVULA"
    },
    {
        "code": "2TJ-698-093",
        "name": "JG. LONA"
    },
    {
        "code": "23G-971-003-L",
        "name": "suporte"
    },
    {
        "code": "23G-971-003-M",
        "name": "suporte"
    },
    {
        "code": "23G-971-003-N",
        "name": "suporte"
    },
    {
        "code": "23G-971-051-AA",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-051-AB",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-051-D",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-051-J",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-800-401-E -I9A",
        "name": "CABINA"
    },
    {
        "code": "23G-971-051-P",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-113",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-113-A",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-113-B",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-113-C",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-118",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-118-A",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-118-B",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-118-C",
        "name": "CHICOTE"
    },
    {
        "code": "23G-971-118-D",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-800-401-F -I7N",
        "name": "CABINA"
    },
    {
        "code": "07W-101-125",
        "name": "ANEL"
    },
    {
        "code": "07W-103-189",
        "name": "TAMPA"
    },
    {
        "code": "23H-253-319-B",
        "name": "suporte"
    },
    {
        "code": "23H-253-319-L",
        "name": "suporte"
    },
    {
        "code": "23H-253-319-P",
        "name": "suporte"
    },
    {
        "code": "23H-253-505-A",
        "name": "suporte"
    },
    {
        "code": "23H-253-683",
        "name": "TUBO"
    },
    {
        "code": "23H-253-683-A",
        "name": "TUBO"
    },
    {
        "code": "2U0-501-319-N",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U0-501-319-Q",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S2-800-401-F -I9A",
        "name": "CABINA"
    },
    {
        "code": "2U0-501-457-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2U0-505-179",
        "name": "BUCHA"
    },
    {
        "code": "2U0-505-179-A",
        "name": "BUCHA"
    },
    {
        "code": "2U0-505-469-B",
        "name": "TIRANTE"
    },
    {
        "code": "2U0-505-469-C",
        "name": "TIRANTE"
    },
    {
        "code": "23H-804-185-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-804-186-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-804-261",
        "name": "SUPORTE"
    },
    {
        "code": "23H-804-261-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-804-591-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-800-401-G -I7N",
        "name": "CABINA"
    },
    {
        "code": "23H-804-679",
        "name": "APOIO"
    },
    {
        "code": "23H-804-755-A",
        "name": "suporte"
    },
    {
        "code": "23H-804-756-A",
        "name": "suporte"
    },
    {
        "code": "23H-809-343-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-809-344-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-817-017-  -I7N",
        "name": "TETO"
    },
    {
        "code": "23H-817-017-  -I9A",
        "name": "TETO"
    },
    {
        "code": "23H-817-017-A",
        "name": "TETO"
    },
    {
        "code": "23H-817-017-B",
        "name": "TETO"
    },
    {
        "code": "2R2-823-663",
        "name": "CANTONEIRA"
    },
    {
        "code": "2S2-800-401-G -I9A",
        "name": "CABINA"
    },
    {
        "code": "2R2-831-051-A",
        "name": "PORTA"
    },
    {
        "code": "2R2-831-051-B",
        "name": "PORTA"
    },
    {
        "code": "2R2-831-052-A",
        "name": "PORTA"
    },
    {
        "code": "2R2-831-052-B",
        "name": "PORTA"
    },
    {
        "code": "2R2-831-111-A",
        "name": "CHAPA EXT."
    },
    {
        "code": "2R2-831-111-A -PAC",
        "name": "CHAPA EXT."
    },
    {
        "code": "23H-607-891-E",
        "name": "SUPORTE"
    },
    {
        "code": "23H-607-891-F",
        "name": "SUPORTE"
    },
    {
        "code": "23H-607-891-G",
        "name": "SUPORTE"
    },
    {
        "code": "23H-607-891-H",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-800-701-C",
        "name": "CABINA"
    },
    {
        "code": "23H-607-891-J",
        "name": "SUPORTE"
    },
    {
        "code": "23H-607-891-K",
        "name": "SUPORTE"
    },
    {
        "code": "23H-607-891-L",
        "name": "SUPORTE"
    },
    {
        "code": "23H-609-425",
        "name": "SUPORTE"
    },
    {
        "code": "23H-609-426",
        "name": "SUPORTE"
    },
    {
        "code": "23H-611-757",
        "name": "suporte"
    },
    {
        "code": "23H-611-757-A",
        "name": "suporte"
    },
    {
        "code": "23H-611-757-B",
        "name": "suporte"
    },
    {
        "code": "23H-611-798-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-611-819-A",
        "name": "TUBO"
    },
    {
        "code": "23K-800-401-K -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-800-701-D",
        "name": "CABINA"
    },
    {
        "code": "23H-611-819-B",
        "name": "TUBO"
    },
    {
        "code": "23H-615-171",
        "name": "BUCHA"
    },
    {
        "code": "23H-615-171-A",
        "name": "BUCHA"
    },
    {
        "code": "23H-615-331",
        "name": "CAMARA DO"
    },
    {
        "code": "23H-615-332",
        "name": "CAMARA DO"
    },
    {
        "code": "23H-616-263-A",
        "name": "HASTE"
    },
    {
        "code": "23H-616-263-B",
        "name": "HASTE"
    },
    {
        "code": "23H-616-288",
        "name": "CHAPAFECHA"
    },
    {
        "code": "23H-616-847",
        "name": "BASE"
    },
    {
        "code": "23H-616-848",
        "name": "CINTA"
    },
    {
        "code": "2S2-800-701-J",
        "name": "CABINA"
    },
    {
        "code": "23H-701-025-AA",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-AB",
        "name": "CHASSI"
    },
    {
        "code": "2V3-881-031-B -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-031-B -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-031-D -ZDY",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-031-E -9PY",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-031-E -BJH",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-031-F -ZDY",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-031-G -9PY",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-038-  -ZDY",
        "name": "BANCO"
    },
    {
        "code": "2S2-800-701-K",
        "name": "CABINA"
    },
    {
        "code": "2V3-881-038-A -QFE",
        "name": "BANCO"
    },
    {
        "code": "2V3-881-038-A -QFF",
        "name": "BANCO"
    },
    {
        "code": "2V3-881-038-B -9PY",
        "name": "BANCO"
    },
    {
        "code": "2V3-881-038-B -BJH",
        "name": "BANCO"
    },
    {
        "code": "2V3-881-041-  -QFE",
        "name": "ENCOSTO"
    },
    {
        "code": "N  -909-428-03",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-701-197",
        "name": "DEFLETOR"
    },
    {
        "code": "23K-701-197-A",
        "name": "DEFLETOR"
    },
    {
        "code": "23K-701-197-D",
        "name": "DEFLETOR"
    },
    {
        "code": "23K-701-479",
        "name": "ANGULO"
    },
    {
        "code": "2S2-802-215-A",
        "name": "CHAPA"
    },
    {
        "code": "23K-701-480",
        "name": "ANGULO"
    },
    {
        "code": "23K-701-575",
        "name": "PLACAUNIAO"
    },
    {
        "code": "23K-701-575-B",
        "name": "PLACAUNIAO"
    },
    {
        "code": "23K-701-575-E",
        "name": "REFORCO"
    },
    {
        "code": "23K-701-576",
        "name": "PLACAUNIAO"
    },
    {
        "code": "23K-701-576-A",
        "name": "PLACAUNIAO"
    },
    {
        "code": "23K-701-576-E",
        "name": "REFORCO"
    },
    {
        "code": "23K-701-687-C",
        "name": "BRACING"
    },
    {
        "code": "23K-701-688-C",
        "name": "BRACING"
    },
    {
        "code": "23K-703-795-C",
        "name": "REFORCO"
    },
    {
        "code": "2S2-803-561",
        "name": "REFORCO"
    },
    {
        "code": "23K-703-796-C",
        "name": "REFORCO"
    },
    {
        "code": "23K-711-769-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-711-769-B",
        "name": "SUPORTE"
    },
    {
        "code": "23K-711-769-C",
        "name": "suporte"
    },
    {
        "code": "23K-721-029-A",
        "name": "Pedaleira"
    },
    {
        "code": "23K-798-041",
        "name": "Adapter"
    },
    {
        "code": "23K-800-401-  -I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-  -I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-A -I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-A -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-803-562",
        "name": "REFORCO"
    },
    {
        "code": "23K-800-401-AA-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AA-I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AB-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AB-I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AC-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AC-I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AD-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AD-I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AE-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AE-I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-803-829",
        "name": "suporte"
    },
    {
        "code": "23K-800-401-AF-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AF-I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AG-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AG-I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AH-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AH-I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AJ-I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-AJ-I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-B -I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-B -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-803-830",
        "name": "suporte"
    },
    {
        "code": "23K-800-401-C -I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-C -I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-D -I7N",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-D -I9A",
        "name": "Cabina"
    },
    {
        "code": "23K-800-401-E -I7N",
        "name": "Cabina"
    },
    {
        "code": "2R2-857-552-  -Y20",
        "name": "PARASOL"
    },
    {
        "code": "2R2-857-552-A -Y20",
        "name": "PARASOL"
    },
    {
        "code": "2R2-857-555",
        "name": "VEDACAO"
    },
    {
        "code": "2R2-857-556",
        "name": "VEDACAO"
    },
    {
        "code": "2R2-857-565-A -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "2S2-807-401",
        "name": "PINO"
    },
    {
        "code": "TJG-199-807",
        "name": "PARAFUSO"
    },
    {
        "code": "TJG-201-281-A",
        "name": "suporte"
    },
    {
        "code": "TJG-253-167",
        "name": "MOLA"
    },
    {
        "code": "2R2-862-656",
        "name": "PARAFUSO"
    },
    {
        "code": "2R2-863-197",
        "name": "TIRAS"
    },
    {
        "code": "2R2-863-294",
        "name": "TIRAS"
    },
    {
        "code": "2R2-863-368-  -WM8",
        "name": "TAPETE"
    },
    {
        "code": "2R2-863-368-A -WM8",
        "name": "TAPETE"
    },
    {
        "code": "2R2-867-233-A -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2R2-867-234-A -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2S2-809-023",
        "name": "COBERTURA"
    },
    {
        "code": "2R2-867-255-  -71N",
        "name": "CAPA COBER"
    },
    {
        "code": "2R2-867-255-  -82V",
        "name": "CAPA COBER"
    },
    {
        "code": "07W-131-662-B",
        "name": "BOCAL"
    },
    {
        "code": "07W-131-662-G",
        "name": "BOCAL"
    },
    {
        "code": "07W-131-797",
        "name": "VEDACAO"
    },
    {
        "code": "2RD-525-455-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2RE-121-255",
        "name": "BRACADEIR"
    },
    {
        "code": "2RE-121-255-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2TJ-525-059",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S2-854-434-A",
        "name": "LOGOTIPO"
    },
    {
        "code": "23K-800-401-L -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-809-245-A",
        "name": "COBERTURA"
    },
    {
        "code": "2S2-854-521",
        "name": "Soleira"
    },
    {
        "code": "2S2-854-521-  -54V",
        "name": "Soleira"
    },
    {
        "code": "2S2-854-522",
        "name": "Soleira"
    },
    {
        "code": "2S2-854-522-  -54V",
        "name": "Soleira"
    },
    {
        "code": "N  -101-586-02",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-857-007-A -8EO",
        "name": "PAINEL"
    },
    {
        "code": "2V3-857-007-E -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-857-007-F -9KO",
        "name": "PORTAOBJ"
    },
    {
        "code": "2V3-857-007-G -8EO",
        "name": "MOLDURA"
    },
    {
        "code": "2V3-857-007-G -IJM",
        "name": "MOLDURA"
    },
    {
        "code": "2S2-809-246-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-857-019",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-857-019-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-857-037",
        "name": "TAMPA"
    },
    {
        "code": "2V3-857-057",
        "name": "TAMPA"
    },
    {
        "code": "2V3-857-085",
        "name": "CAPA COBER"
    },
    {
        "code": "2V3-857-086",
        "name": "CAPA COBER"
    },
    {
        "code": "2V3-857-115-  -9KO",
        "name": "CAPA COBER"
    },
    {
        "code": "2V3-857-142",
        "name": "GAVETA"
    },
    {
        "code": "2V3-857-151-  -8EO",
        "name": "suporte"
    },
    {
        "code": "2V3-857-152-  -8EO",
        "name": "suporte"
    },
    {
        "code": "2S2-810-065-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-857-192",
        "name": "CAPA COBER"
    },
    {
        "code": "2V3-857-192-C",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-857-192-D",
        "name": "MOLDURA"
    },
    {
        "code": "2V3-857-192-E",
        "name": "MOLDURA"
    },
    {
        "code": "2V3-857-192-F",
        "name": "PORTAOBJ"
    },
    {
        "code": "2V3-857-192-G",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-857-192-H",
        "name": "REFORCO"
    },
    {
        "code": "2V3-857-192-J",
        "name": "CHAPA"
    },
    {
        "code": "2V3-857-213-A",
        "name": "DOBRADICA"
    },
    {
        "code": "2V3-857-265",
        "name": "REFORCO"
    },
    {
        "code": "2S2-810-066-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-857-265-A",
        "name": "CHAPA"
    },
    {
        "code": "2V3-857-265-C",
        "name": "CHAPA"
    },
    {
        "code": "2V3-857-266-C",
        "name": "CHAPA"
    },
    {
        "code": "2V3-857-291",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-857-291-A",
        "name": "VEDACAO"
    },
    {
        "code": "2V3-857-525-A",
        "name": "suporte"
    },
    {
        "code": "2V3-857-527",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-857-588",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-857-281",
        "name": "PROTECAO"
    },
    {
        "code": "2S2-857-281-A",
        "name": "PROTECAO"
    },
    {
        "code": "2S2-813-103-A",
        "name": "PAINEL"
    },
    {
        "code": "2S2-857-481",
        "name": "CAPA COBER"
    },
    {
        "code": "2S2-857-482",
        "name": "CAPA COBER"
    },
    {
        "code": "2S2-857-501-AE-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2V3-919-670",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-919-670-A",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-919-670-B",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-919-670-C",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-919-733-A",
        "name": "suporte"
    },
    {
        "code": "2V3-919-733-C",
        "name": "TAMPAO"
    },
    {
        "code": "2V3-920-807",
        "name": "INSTRUMENT"
    },
    {
        "code": "2S2-813-103-B",
        "name": "PAINEL"
    },
    {
        "code": "2V3-920-807-C",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V3-920-807-E",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V3-927-103",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V3-927-103-B",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V3-927-138",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-138-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-138-C",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-143",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-143-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-143-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-817-899-A",
        "name": "suporte"
    },
    {
        "code": "2V3-927-143-C",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-191-A",
        "name": "Switch"
    },
    {
        "code": "2V3-927-357",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-927-357-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V3-927-451",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-451-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-451-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-521",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-521-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-521-D",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-817-900-A",
        "name": "suporte"
    },
    {
        "code": "2V3-927-529",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-927-735",
        "name": "SENSOR"
    },
    {
        "code": "2V3-927-735-A",
        "name": "SENSOR"
    },
    {
        "code": "2V3-937-046",
        "name": "CONTROLE"
    },
    {
        "code": "2V3-937-099",
        "name": "RELE"
    },
    {
        "code": "2V3-937-149",
        "name": "suporte"
    },
    {
        "code": "2V3-937-197",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-937-197-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-937-197-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-937-199",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-820-761",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-937-548",
        "name": "CAIXA"
    },
    {
        "code": "2V3-937-589-A",
        "name": "suporte"
    },
    {
        "code": "2V3-937-589-B",
        "name": "suporte"
    },
    {
        "code": "2V3-937-589-C",
        "name": "suporte"
    },
    {
        "code": "2V3-937-589-D",
        "name": "suporte"
    },
    {
        "code": "2V3-937-629",
        "name": "FUSIVEL"
    },
    {
        "code": "07W-088-375-B",
        "name": "PORCA"
    },
    {
        "code": "07W-088-375-C",
        "name": "porca"
    },
    {
        "code": "07W-088-431-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2VC-607-862",
        "name": "TUBO"
    },
    {
        "code": "2S2-821-305-A",
        "name": "paralama"
    },
    {
        "code": "2VC-607-998",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2VC-608-713",
        "name": "conexÆo"
    },
    {
        "code": "2R2-881-231-B",
        "name": "MANOPLA"
    },
    {
        "code": "2R2-881-246",
        "name": "ANEL"
    },
    {
        "code": "2R2-881-249",
        "name": "BATENTE"
    },
    {
        "code": "23K-802-014",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-014-A",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-014-B",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-014-C",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-209-B",
        "name": "CHAPA"
    },
    {
        "code": "23K-800-401-L -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-821-306",
        "name": "paralama"
    },
    {
        "code": "23K-802-209-C",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-215",
        "name": "CHAPA"
    },
    {
        "code": "23K-802-215-A",
        "name": "CHAPA"
    },
    {
        "code": "23K-803-245",
        "name": "SUPORTE"
    },
    {
        "code": "23K-803-246",
        "name": "SUPORTE"
    },
    {
        "code": "23K-803-561-A",
        "name": "REFORCO"
    },
    {
        "code": "23K-803-561-B",
        "name": "REFORCO"
    },
    {
        "code": "23K-803-562-A",
        "name": "REFORCO"
    },
    {
        "code": "23K-803-562-B",
        "name": "REFORCO"
    },
    {
        "code": "23K-803-877",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-821-306-A",
        "name": "paralama"
    },
    {
        "code": "23K-803-877-A",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-804-185",
        "name": "SUPORTE"
    },
    {
        "code": "23K-804-185-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-804-186",
        "name": "suporte"
    },
    {
        "code": "23K-804-186-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-804-261",
        "name": "SUPORTE"
    },
    {
        "code": "23K-804-407",
        "name": "TRAVA"
    },
    {
        "code": "23K-804-591",
        "name": "SUPORTE"
    },
    {
        "code": "23K-804-679-B",
        "name": "SUPORTE"
    },
    {
        "code": "23K-804-679-D",
        "name": "APOIO"
    },
    {
        "code": "2S2-821-681-  -9B9",
        "name": "estribo"
    },
    {
        "code": "23K-804-679-F",
        "name": "APOIO"
    },
    {
        "code": "23K-804-755",
        "name": "suporte"
    },
    {
        "code": "23K-804-756",
        "name": "suporte"
    },
    {
        "code": "23K-804-883",
        "name": "PLACA"
    },
    {
        "code": "23K-804-889",
        "name": "DISCO"
    },
    {
        "code": "23K-804-889-A",
        "name": "DISCO"
    },
    {
        "code": "23K-804-947",
        "name": "PINO"
    },
    {
        "code": "23K-804-968",
        "name": "PINO"
    },
    {
        "code": "23K-804-974",
        "name": "MOLA"
    },
    {
        "code": "23K-807-071",
        "name": "parachoque"
    },
    {
        "code": "2S2-821-682-  -9B9",
        "name": "estribo"
    },
    {
        "code": "23K-807-071-  -54V",
        "name": "parachoque"
    },
    {
        "code": "23K-807-071-D",
        "name": "parachoque"
    },
    {
        "code": "23K-807-071-E -54V",
        "name": "parachoque"
    },
    {
        "code": "23K-807-125",
        "name": "SUPORTE"
    },
    {
        "code": "23K-807-125-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-807-125-C",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-000-013-A",
        "name": "CABINA"
    },
    {
        "code": "2T2-000-013-A -I9A",
        "name": "CABINA"
    },
    {
        "code": "2T2-000-013-B -I9A",
        "name": "CABINA"
    },
    {
        "code": "2V5-803-877-CD",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-821-685-  -9B9",
        "name": "estribo"
    },
    {
        "code": "2V5-803-877-CE",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CF",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CG",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CH",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CL",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CM",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CN",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CP",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CS",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-CT",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-823-483",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-803-877-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-DA",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-DB",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-DC",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-DD",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-803-877-DE",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-130-758-G",
        "name": "SENSOR"
    },
    {
        "code": "07W-130-758-H",
        "name": "SENSOR"
    },
    {
        "code": "23B-201-100-E",
        "name": "CONEXAO"
    },
    {
        "code": "23B-201-136-B",
        "name": "VALVULA"
    },
    {
        "code": "2S2-831-333",
        "name": "PLACASUPOR"
    },
    {
        "code": "2R2-881-311",
        "name": "AMORTECEDO"
    },
    {
        "code": "2R2-881-311-A",
        "name": "AMORTECEDO"
    },
    {
        "code": "2R2-881-371",
        "name": "MOLA"
    },
    {
        "code": "2R2-881-375-A",
        "name": "ASSENTO"
    },
    {
        "code": "2S0-803-431-C",
        "name": "SUPORTE"
    },
    {
        "code": "2S0-803-656",
        "name": "PINO"
    },
    {
        "code": "2V1-607-097",
        "name": "TUBO FREIO"
    },
    {
        "code": "2V1-607-098",
        "name": "TUBO FREIO"
    },
    {
        "code": "2V1-607-262",
        "name": "valvula"
    },
    {
        "code": "2V1-607-312",
        "name": "TUBO"
    },
    {
        "code": "2S2-831-333-A",
        "name": "PLACASUPOR"
    },
    {
        "code": "2V1-607-325",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-607-359-G",
        "name": "VALVULA"
    },
    {
        "code": "2V1-607-363-B",
        "name": "suporte"
    },
    {
        "code": "2V1-607-373",
        "name": "SECADOR"
    },
    {
        "code": "2V1-607-811",
        "name": "TUBO"
    },
    {
        "code": "2V1-607-891",
        "name": "suporte"
    },
    {
        "code": "2V1-607-891-B",
        "name": "suporte"
    },
    {
        "code": "07W-103-480-B",
        "name": "ANEL"
    },
    {
        "code": "2R2-881-478-C",
        "name": "CAPA COBER"
    },
    {
        "code": "2R2-881-479-C",
        "name": "COBERTURA"
    },
    {
        "code": "2S2-831-334",
        "name": "PLACASUPOR"
    },
    {
        "code": "2R2-881-479-D",
        "name": "CAPA COBER"
    },
    {
        "code": "2S2-821-686-  -9B9",
        "name": "estribo"
    },
    {
        "code": "2S2-821-701",
        "name": "GALAO"
    },
    {
        "code": "2S2-821-719",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2S2-821-719-B",
        "name": "PC.FIXACAO"
    },
    {
        "code": "23H-701-025-K",
        "name": "CHASSI"
    },
    {
        "code": "23H-701-025-L",
        "name": "CHASSI"
    },
    {
        "code": "TAR-511-381-A",
        "name": "CHAPACALCO"
    },
    {
        "code": "2T0-103-038",
        "name": "JUNTA"
    },
    {
        "code": "2RD-407-751-C",
        "name": "PORCA"
    },
    {
        "code": "2S2-831-334-A",
        "name": "PLACASUPOR"
    },
    {
        "code": "TE3-253-135-A",
        "name": "VEDACAO"
    },
    {
        "code": "TE3-253-143-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "TE3-253-881",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-311-230-M",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-N",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-P",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-Q",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-R",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-S",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-T",
        "name": "FRICCAO"
    },
    {
        "code": "23K-800-401-M -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-837-193",
        "name": "haste"
    },
    {
        "code": "2U2-311-243",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-311-244",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-311-244-A",
        "name": "CORPOSINCR"
    },
    {
        "code": "2U2-311-247",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-251",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-311-269",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-281",
        "name": "RETENTOR"
    },
    {
        "code": "2U2-311-281-A",
        "name": "RETENTOR"
    },
    {
        "code": "2U2-311-285-B",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-311-285-C",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2S2-837-296",
        "name": "ALAVANCA"
    },
    {
        "code": "2T0-501-023",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2T0-501-091-A",
        "name": "CARCACA"
    },
    {
        "code": "2T0-501-179",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-501-205",
        "name": "SEMI EIXO"
    },
    {
        "code": "2T0-501-209",
        "name": "ANEL"
    },
    {
        "code": "2T0-501-215",
        "name": "PORCA"
    },
    {
        "code": "TJG-601-027-A -Z31",
        "name": "RODA"
    },
    {
        "code": "TJG-601-201-A",
        "name": "PESO BALAN"
    },
    {
        "code": "2U0-525-267-S",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-T",
        "name": "DISCO"
    },
    {
        "code": "2S2-853-679",
        "name": "EMBLEMA"
    },
    {
        "code": "2U0-525-305-A",
        "name": "FRICCAO"
    },
    {
        "code": "2U0-525-307",
        "name": "CAIXA"
    },
    {
        "code": "2U0-525-355",
        "name": "EIXO INTER"
    },
    {
        "code": "2U0-525-401",
        "name": "EIXO"
    },
    {
        "code": "2U0-525-421",
        "name": "ANEL"
    },
    {
        "code": "2U0-525-447",
        "name": "TRAVA"
    },
    {
        "code": "2U0-525-717-B",
        "name": "CRUZETA"
    },
    {
        "code": "2U0-525-777",
        "name": "ROLAMROLO"
    },
    {
        "code": "23K-863-831",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-863-831-A",
        "name": "ISOLANTE"
    },
    {
        "code": "2S2-853-679-A",
        "name": "EMBLEMA"
    },
    {
        "code": "23K-863-835",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-863-835-A",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-864-943",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-864-943-A",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-864-944-E",
        "name": "SILENCIADO"
    },
    {
        "code": "23K-864-944-F",
        "name": "SILENCIADO"
    },
    {
        "code": "23K-867-035-C -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-867-035-D -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-867-485-  -Y20",
        "name": "moldura"
    },
    {
        "code": "23K-867-485-A -Y20",
        "name": "moldura"
    },
    {
        "code": "2S2-853-679-P",
        "name": "FAIXA"
    },
    {
        "code": "23K-877-559",
        "name": "COXIM"
    },
    {
        "code": "23K-877-559-A",
        "name": "COXIM"
    },
    {
        "code": "23K-881-023-  -9PY",
        "name": "ASSENTO"
    },
    {
        "code": "23K-881-023-A -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "23K-881-023-B -9PY",
        "name": "ASSENTO"
    },
    {
        "code": "23K-881-031-  -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "23K-881-031-  -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "23K-881-031-C -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "23K-881-031-D -9PY",
        "name": "ASSENTO"
    },
    {
        "code": "23K-881-033",
        "name": "PROLONGAME"
    },
    {
        "code": "2S2-853-680",
        "name": "EMBLEMA"
    },
    {
        "code": "23K-881-033-A",
        "name": "PROLONGAME"
    },
    {
        "code": "2V3-521-115-E",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-115-F",
        "name": "EIXO"
    },
    {
        "code": "2V3-521-131-A",
        "name": "CRUZETA"
    },
    {
        "code": "2V3-521-131-B",
        "name": "CRUZETA"
    },
    {
        "code": "2V3-521-171",
        "name": "CONTRAPINO"
    },
    {
        "code": "2V3-521-171-A",
        "name": "CONTRAPINO"
    },
    {
        "code": "2V3-525-021",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V3-525-021-A",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V3-525-021-B",
        "name": "DIFERENCIA"
    },
    {
        "code": "2S2-853-680-A",
        "name": "EMBLEMA"
    },
    {
        "code": "2V3-525-021-C",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V3-525-077",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V3-525-077-A",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V3-525-077-B",
        "name": "PINHAOCORO"
    },
    {
        "code": "2V3-525-083",
        "name": "CAIXA"
    },
    {
        "code": "2V3-525-107-B",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V3-525-107-C",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V3-525-107-D",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V3-525-107-E",
        "name": "DIFERENCIA"
    },
    {
        "code": "2V3-525-107-F",
        "name": "DIFERENCIA"
    },
    {
        "code": "2S2-853-685",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-525-289",
        "name": "FLANGE"
    },
    {
        "code": "2V3-598-081",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-598-081-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-598-082",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-598-287-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2V3-598-998",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-598-998-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-598-998-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-599-109",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-599-173",
        "name": "GRAMPO"
    },
    {
        "code": "2S2-853-685-A",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-599-173-A",
        "name": "GRAMPO"
    },
    {
        "code": "2V3-599-173-B",
        "name": "GRAMPO"
    },
    {
        "code": "2V3-599-173-C",
        "name": "GRAMPO"
    },
    {
        "code": "2V3-599-175-A",
        "name": "APOIO"
    },
    {
        "code": "2V3-599-175-B",
        "name": "GUIA"
    },
    {
        "code": "2V3-599-175-C",
        "name": "GUIA"
    },
    {
        "code": "2V3-599-183",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-599-183-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-599-183-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-599-183-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-853-685-B",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V3-599-183-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-599-183-E",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-599-183-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-600-061",
        "name": "TUBO"
    },
    {
        "code": "2V3-601-160",
        "name": "PROTECAO"
    },
    {
        "code": "WHT-005-053",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-054",
        "name": "PARAFUSO"
    },
    {
        "code": "2TJ-803-165-B",
        "name": "suporte"
    },
    {
        "code": "2TJ-803-165-C",
        "name": "suporte"
    },
    {
        "code": "WHT-005-073",
        "name": "CONTRAPINO"
    },
    {
        "code": "23K-800-401-M -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-853-685-C",
        "name": "LOGOTIPO"
    },
    {
        "code": "2U2-311-613-B",
        "name": "PINO"
    },
    {
        "code": "2U2-311-613-C",
        "name": "PINOCILIND"
    },
    {
        "code": "2U2-311-623",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-311-623-A",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-311-623-B",
        "name": "VEDACAO"
    },
    {
        "code": "2U2-311-657",
        "name": "CILINDRO"
    },
    {
        "code": "2U2-311-675-A",
        "name": "CILINDRO"
    },
    {
        "code": "2U2-311-675-B",
        "name": "CILINDRO"
    },
    {
        "code": "2U2-311-713-A",
        "name": "CAPA PROTE"
    },
    {
        "code": "2U2-311-719",
        "name": "ANEL"
    },
    {
        "code": "2S2-853-689",
        "name": "LOGOTIPO"
    },
    {
        "code": "2U2-311-738",
        "name": "PISTAO"
    },
    {
        "code": "2U2-311-761",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-311-761-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2W0-703-529-AH",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-AJ",
        "name": "ARRUELA"
    },
    {
        "code": "23P-927-745",
        "name": "SENSOR"
    },
    {
        "code": "23P-927-745-A",
        "name": "SENSOR"
    },
    {
        "code": "23P-927-748",
        "name": "SENSOR"
    },
    {
        "code": "23P-927-748-A",
        "name": "SENSOR"
    },
    {
        "code": "23P-927-753",
        "name": "SENSOR"
    },
    {
        "code": "2S2-853-689-B",
        "name": "LOGOTIPO"
    },
    {
        "code": "23P-927-753-A",
        "name": "SENSOR"
    },
    {
        "code": "23P-927-754",
        "name": "SENSOR"
    },
    {
        "code": "23P-927-754-A",
        "name": "SENSOR"
    },
    {
        "code": "WHT-010-484",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-129-141-A",
        "name": "suporte"
    },
    {
        "code": "T11-145-397",
        "name": "FILTRO OLE"
    },
    {
        "code": "2P0-616-237-A",
        "name": "PARAFUSO"
    },
    {
        "code": "T16-407-685",
        "name": "VEDACAO"
    },
    {
        "code": "T16-407-689",
        "name": "PINOAJUSTE"
    },
    {
        "code": "2P0-131-585-C",
        "name": "CONECTOR"
    },
    {
        "code": "2S2-854-433-A",
        "name": "LOGOTIPO"
    },
    {
        "code": "2P0-131-585-D",
        "name": "CONECTOR"
    },
    {
        "code": "WHT-003-925",
        "name": "CEGA"
    },
    {
        "code": "2VG-121-741",
        "name": "MAT.ADESIV"
    },
    {
        "code": "2VG-129-723",
        "name": "BRACADEIRA"
    },
    {
        "code": "2RR-525-895",
        "name": "batente"
    },
    {
        "code": "2RR-598-321",
        "name": "JG.PECAS"
    },
    {
        "code": "2RR-599-207",
        "name": "PARAFUSO"
    },
    {
        "code": "2RR-607-051",
        "name": "ENGRAXADEI"
    },
    {
        "code": "2RR-607-061",
        "name": "ANEL"
    },
    {
        "code": "2RR-607-159",
        "name": "ANEL"
    },
    {
        "code": "2S2-857-005-  -71N",
        "name": "PAINEL"
    },
    {
        "code": "23H-525-021-Q",
        "name": "DIFERENCIA"
    },
    {
        "code": "23H-525-021-R",
        "name": "DIFERENCIA"
    },
    {
        "code": "23H-525-041-A",
        "name": "CARCACA"
    },
    {
        "code": "23H-525-121-A",
        "name": "CAIXA"
    },
    {
        "code": "23H-525-121-B",
        "name": "CAIXA"
    },
    {
        "code": "23H-525-143",
        "name": "PINHAOCORO"
    },
    {
        "code": "23H-525-155",
        "name": "PINHAOCORO"
    },
    {
        "code": "23H-525-267",
        "name": "ANEL"
    },
    {
        "code": "23H-525-267-A",
        "name": "ANEL"
    },
    {
        "code": "23H-525-267-B",
        "name": "ANEL"
    },
    {
        "code": "2S2-857-005-  -82V",
        "name": "PAINEL"
    },
    {
        "code": "23H-525-267-C",
        "name": "ANEL"
    },
    {
        "code": "23H-525-717-A",
        "name": "CRUZETA"
    },
    {
        "code": "23H-525-728",
        "name": "FRICCAO"
    },
    {
        "code": "2T2-419-548",
        "name": "PINO RETEN"
    },
    {
        "code": "2T2-419-548-A",
        "name": "PINO RETEN"
    },
    {
        "code": "N  -913-072-01",
        "name": "PARAFUSO"
    },
    {
        "code": "23L-701-061",
        "name": "SUPORTE"
    },
    {
        "code": "23L-701-105-A",
        "name": "TRAVESSA"
    },
    {
        "code": "23L-701-157",
        "name": "SUPORTE"
    },
    {
        "code": "23L-701-157-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-857-005-A -71N",
        "name": "PAINEL"
    },
    {
        "code": "23L-701-592",
        "name": "TRAVESSA"
    },
    {
        "code": "23L-721-029-A",
        "name": "Pedaleira"
    },
    {
        "code": "23L-803-139",
        "name": "REFORCO"
    },
    {
        "code": "23L-803-140",
        "name": "REFORCO"
    },
    {
        "code": "23L-803-399",
        "name": "SUPORTE"
    },
    {
        "code": "23L-807-111-A",
        "name": "SUPORTE"
    },
    {
        "code": "23L-807-223",
        "name": "GRADEPROTE"
    },
    {
        "code": "23L-807-223-A",
        "name": "GRADEPROTE"
    },
    {
        "code": "23L-807-224",
        "name": "GRADEPROTE"
    },
    {
        "code": "23L-807-224-A",
        "name": "GRADEPROTE"
    },
    {
        "code": "2S2-857-005-A -82V",
        "name": "PAINEL"
    },
    {
        "code": "23L-853-601",
        "name": "EMBLEMA VW"
    },
    {
        "code": "23L-906-012-A",
        "name": "UNID.COMAN"
    },
    {
        "code": "23L-906-051-A",
        "name": "SENSOR"
    },
    {
        "code": "23L-906-051-B",
        "name": "HALL"
    },
    {
        "code": "23L-906-097",
        "name": "suporte"
    },
    {
        "code": "23L-906-207-B",
        "name": "SENSOR"
    },
    {
        "code": "23L-906-207-C",
        "name": "SENSOR"
    },
    {
        "code": "23L-906-261-B",
        "name": "Sensor NOx"
    },
    {
        "code": "23L-906-261-C",
        "name": "Sensor NOx"
    },
    {
        "code": "23L-907-631",
        "name": "SOLENOIDE"
    },
    {
        "code": "2S2-857-085-  -999",
        "name": "CAPA"
    },
    {
        "code": "23L-911-023",
        "name": "MOTOR"
    },
    {
        "code": "23L-971-003-A",
        "name": "suporte"
    },
    {
        "code": "23L-971-003-E",
        "name": "suporte"
    },
    {
        "code": "23L-971-003-G",
        "name": "suporte"
    },
    {
        "code": "23L-971-003-H",
        "name": "suporte"
    },
    {
        "code": "23L-971-015-A",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-015-B",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-015-C",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-015-D",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-051-C",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-857-086-  -999",
        "name": "CAPA"
    },
    {
        "code": "23L-971-051-D",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-051-E",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-051-F",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-073",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-079",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-079-A",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-079-B",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-079-C",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-087",
        "name": "CHIC MOTOR"
    },
    {
        "code": "23L-971-087-A",
        "name": "CHIC MOTOR"
    },
    {
        "code": "23K-800-401-N -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-857-161",
        "name": "COBERTURA"
    },
    {
        "code": "23L-971-087-D",
        "name": "CHIC MOTOR"
    },
    {
        "code": "23L-971-088",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-561",
        "name": "CHICOTE"
    },
    {
        "code": "23L-971-739",
        "name": "CINTA"
    },
    {
        "code": "2TB-145-171",
        "name": "RESERVATOR"
    },
    {
        "code": "N  -040-108-2",
        "name": "PARAFUSO"
    },
    {
        "code": "N  -040-181-1",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-145-844-AN",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-145-846-C",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-145-856-AC",
        "name": "MANGUEIRA"
    },
    {
        "code": "2S2-857-501-AF-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2T2-145-856-G",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-145-871",
        "name": "TUBO"
    },
    {
        "code": "2T2-145-877-A",
        "name": "TUBO"
    },
    {
        "code": "2T2-145-877-C",
        "name": "COND ESCAP"
    },
    {
        "code": "2T2-145-877-D",
        "name": "COND ESCAP"
    },
    {
        "code": "2U2-521-131",
        "name": "CABECOTE"
    },
    {
        "code": "2U2-521-145",
        "name": "FLANGE"
    },
    {
        "code": "2U2-521-145-A",
        "name": "FLANGE"
    },
    {
        "code": "2U2-521-177",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2U2-521-177-A",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2S2-857-501-AG-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2U2-521-291",
        "name": "CRUZETA"
    },
    {
        "code": "2U2-521-291-A",
        "name": "CRUZETA"
    },
    {
        "code": "2U2-521-293",
        "name": "porca"
    },
    {
        "code": "2U2-521-293-A",
        "name": "porca"
    },
    {
        "code": "2U2-521-443",
        "name": "DEFLETOR"
    },
    {
        "code": "2U2-525-021-L",
        "name": "DIFERENCIA"
    },
    {
        "code": "2U2-525-073",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-A",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-B",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-C",
        "name": "ESPACADOR"
    },
    {
        "code": "2S2-857-501-AH-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2U2-525-073-D",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-E",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-F",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-G",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-H",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-J",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-073-K",
        "name": "ESPACADOR"
    },
    {
        "code": "2U2-525-089",
        "name": "DIAFRAGMA"
    },
    {
        "code": "2U2-525-095",
        "name": "LUVA"
    },
    {
        "code": "2U2-525-095-A",
        "name": "LUVA"
    },
    {
        "code": "2S2-857-501-AK-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2U2-525-095-B",
        "name": "LUVA"
    },
    {
        "code": "2U2-525-105",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-525-105-A",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U2-525-121",
        "name": "CAIXA"
    },
    {
        "code": "2U2-525-121-A",
        "name": "CAIXA"
    },
    {
        "code": "2U2-525-121-B",
        "name": "CAIXA"
    },
    {
        "code": "2V2-804-261-B",
        "name": "PRESILHA"
    },
    {
        "code": "2V2-804-311-C",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2V2-804-311-D",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2V2-804-591-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-857-501-AL-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2V2-804-591-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-804-679",
        "name": "DEGRAU"
    },
    {
        "code": "2V2-804-875-A",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V2-804-875-B",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V2-807-071",
        "name": "parachoque"
    },
    {
        "code": "2V2-821-119-A",
        "name": "REFORCO"
    },
    {
        "code": "2V2-821-119-C",
        "name": "REFORCO"
    },
    {
        "code": "2V2-821-119-D",
        "name": "REFORCO"
    },
    {
        "code": "2V2-821-120-A",
        "name": "REFORCO"
    },
    {
        "code": "2V2-821-120-C",
        "name": "REFORCO"
    },
    {
        "code": "2S2-857-502-AM-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2V2-821-120-D",
        "name": "REFORCO"
    },
    {
        "code": "2V2-821-151",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-821-173",
        "name": "DEFLETOR"
    },
    {
        "code": "2V2-821-175-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-821-175-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-821-175-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-821-176-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-821-176-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-821-176-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V2-821-455",
        "name": "COBERTURA"
    },
    {
        "code": "2S2-857-502-AP-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2V2-821-541",
        "name": "ANEL"
    },
    {
        "code": "2V2-854-431-AA",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V2-854-431-AB",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V2-854-431-AC",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V2-854-431-AD",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V2-854-431-AE",
        "name": "LOGOTIPO"
    },
    {
        "code": "2V2-854-431-H",
        "name": "LOGOTIPO"
    },
    {
        "code": "2W0-703-529-H",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-703-529-J",
        "name": "ARRUELA"
    },
    {
        "code": "TJG-511-205",
        "name": "TUBO"
    },
    {
        "code": "2S2-857-502-AR-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "TJG-511-219",
        "name": "BRACADEIRA"
    },
    {
        "code": "TJG-511-219-A",
        "name": "BRACADEIRA"
    },
    {
        "code": "TJG-511-341",
        "name": "PINO"
    },
    {
        "code": "23G-422-553-D",
        "name": "SUPORTE"
    },
    {
        "code": "23G-422-553-E",
        "name": "SUPORTE"
    },
    {
        "code": "23G-422-567-  -999",
        "name": "REVESTIMEN"
    },
    {
        "code": "23G-422-753",
        "name": "Eixo inte."
    },
    {
        "code": "23G-422-753-A",
        "name": "Eixo inte."
    },
    {
        "code": "23G-422-891",
        "name": "MANGUEIRA"
    },
    {
        "code": "23G-422-963-A",
        "name": "TUBO OLEO"
    },
    {
        "code": "2S2-857-502-BC-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "23G-498-506",
        "name": "JG.PECAS"
    },
    {
        "code": "23G-501-123",
        "name": "suporte"
    },
    {
        "code": "23G-501-123-A",
        "name": "suporte"
    },
    {
        "code": "2R2-721-395-B",
        "name": "ANEL VEDAC"
    },
    {
        "code": "2R2-721-407",
        "name": "RESERVATOR"
    },
    {
        "code": "2R2-721-437",
        "name": "PROTECAO"
    },
    {
        "code": "2R2-721-507",
        "name": "PEDAL DO A"
    },
    {
        "code": "2R2-798-435-E",
        "name": "JG.PECAS"
    },
    {
        "code": "2TK-507-515",
        "name": "TUBO"
    },
    {
        "code": "2T2-121-179-L",
        "name": "TUBO"
    },
    {
        "code": "2V5-129-589",
        "name": "FLAN VEDAC"
    },
    {
        "code": "23K-800-401-N -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-857-502-BD-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2T2-121-207-AC",
        "name": "DEFLET AR"
    },
    {
        "code": "2T2-121-207-AD",
        "name": "DEFLET AR"
    },
    {
        "code": "2T2-121-215",
        "name": "COXIM"
    },
    {
        "code": "2T2-121-228-A",
        "name": "VEDACAO"
    },
    {
        "code": "2T2-121-251",
        "name": "RADIADOR"
    },
    {
        "code": "2U2-301-340-C",
        "name": "porca"
    },
    {
        "code": "2U2-301-340-CF",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-CJ",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-F",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-340-P",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-857-502-BE-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2U2-301-340-S",
        "name": "PARAFUSO"
    },
    {
        "code": "23H-201-511",
        "name": "BRACADEIRA"
    },
    {
        "code": "23H-201-512-A",
        "name": "FILTR COMB"
    },
    {
        "code": "23H-201-722-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-201-722-H",
        "name": "SUPORTE"
    },
    {
        "code": "23H-201-722-J",
        "name": "SUPORTE"
    },
    {
        "code": "23H-251-523",
        "name": "CINTA"
    },
    {
        "code": "23H-251-523-A",
        "name": "CINTA"
    },
    {
        "code": "23H-253-037-C",
        "name": "DEFLETOR"
    },
    {
        "code": "23H-253-037-F",
        "name": "DEFLETOR"
    },
    {
        "code": "2S2-857-502-BF-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "23H-253-037-G",
        "name": "DEFLETOR"
    },
    {
        "code": "23H-253-037-J",
        "name": "DEFLETOR"
    },
    {
        "code": "23H-253-047-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-253-047-F",
        "name": "SUPORTE"
    },
    {
        "code": "23H-253-047-M",
        "name": "SUPORTE"
    },
    {
        "code": "23H-253-091-B",
        "name": "TUBO"
    },
    {
        "code": "23H-253-099",
        "name": "SUPORTE"
    },
    {
        "code": "23H-253-099-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-253-137",
        "name": "ANEL"
    },
    {
        "code": "23H-253-143",
        "name": "BRACADEIR"
    },
    {
        "code": "2S2-857-502-BG-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "23H-253-143-A",
        "name": "BRACADEIR"
    },
    {
        "code": "23H-253-143-D",
        "name": "BRACADEIR"
    },
    {
        "code": "23H-253-173-A",
        "name": "TUBO"
    },
    {
        "code": "23H-253-198",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-857-103-  -71N",
        "name": "PORTA LUVA"
    },
    {
        "code": "2R2-857-103-  -82V",
        "name": "PORTA LUVA"
    },
    {
        "code": "2R2-857-121-A -71N",
        "name": "TAMPA"
    },
    {
        "code": "2R2-857-121-A -82V",
        "name": "TAMPA"
    },
    {
        "code": "2R2-857-131-  -71N",
        "name": "FECHADURA"
    },
    {
        "code": "2U0-415-741",
        "name": "HASTE"
    },
    {
        "code": "2S2-857-502-BH-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2U0-415-741-A",
        "name": "HASTE"
    },
    {
        "code": "2U0-415-742",
        "name": "HASTE"
    },
    {
        "code": "2U0-415-742-A",
        "name": "HASTE"
    },
    {
        "code": "2R2-857-521-E",
        "name": "VIDRO ESPE"
    },
    {
        "code": "2R2-857-521-F",
        "name": "VIDRO ESPE"
    },
    {
        "code": "2R2-857-521-G",
        "name": "VIDRO ESPE"
    },
    {
        "code": "2R2-857-521-K",
        "name": "VIDRO ESPE"
    },
    {
        "code": "2R2-857-521-L",
        "name": "VIDRO ESPE"
    },
    {
        "code": "2Z0-611-227-A",
        "name": "porca"
    },
    {
        "code": "2Z0-611-229",
        "name": "BATENTE"
    },
    {
        "code": "2S2-857-502-BJ-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2RD-857-576",
        "name": "ARRUELA"
    },
    {
        "code": "2RD-857-586-A",
        "name": "PORCA"
    },
    {
        "code": "2Z0-971-079",
        "name": "CHICOTE"
    },
    {
        "code": "2Z0-971-079-A",
        "name": "CHICOTE"
    },
    {
        "code": "2Z0-971-279",
        "name": "CHICOTE"
    },
    {
        "code": "2Z0-971-279-A",
        "name": "CHICOTE"
    },
    {
        "code": "2Z0-971-279-B",
        "name": "CHICOTE"
    },
    {
        "code": "2RK-109-215",
        "name": "ANEL"
    },
    {
        "code": "2RK-109-453",
        "name": "PORCA"
    },
    {
        "code": "2RK-109-687",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-857-502-BK-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2RK-109-687-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2RK-109-703",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-034",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-036",
        "name": "PARAFUSO"
    },
    {
        "code": "2S0-501-615-A",
        "name": "TAMBOR"
    },
    {
        "code": "2S0-501-653-A",
        "name": "CUBO RODA"
    },
    {
        "code": "2S0-129-620",
        "name": "ELEMENTO"
    },
    {
        "code": "2S0-129-620-A",
        "name": "ELEMENTO"
    },
    {
        "code": "2R2-853-653-A",
        "name": "GRADE"
    },
    {
        "code": "2R2-853-675",
        "name": "LOGOTIPO"
    },
    {
        "code": "2S2-857-502-BL-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2R2-853-957",
        "name": "suporte"
    },
    {
        "code": "2R2-857-005-K",
        "name": "PAINEL"
    },
    {
        "code": "2R2-857-005-K -71N",
        "name": "PAINEL"
    },
    {
        "code": "2S0-407-186-D",
        "name": "PAST VEDAC"
    },
    {
        "code": "WHT-009-352",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-009-353",
        "name": "BRACADEIR"
    },
    {
        "code": "WHT-009-359",
        "name": "PARAFUSO"
    },
    {
        "code": "2T2-145-162",
        "name": "suporte"
    },
    {
        "code": "2T2-145-175-F",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T2-145-198-A",
        "name": "ESPACADOR"
    },
    {
        "code": "2S2-857-502-BM-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2T2-145-299-A",
        "name": "TENSOR"
    },
    {
        "code": "2T2-145-299-C",
        "name": "TENSOR"
    },
    {
        "code": "2T2-145-317",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-145-367-F",
        "name": "TUBO"
    },
    {
        "code": "2T2-145-367-G",
        "name": "TUBO"
    },
    {
        "code": "2T2-145-367-H",
        "name": "TUBO"
    },
    {
        "code": "2T2-145-367-J",
        "name": "TUBO"
    },
    {
        "code": "2T2-145-475",
        "name": "BRACADEIR"
    },
    {
        "code": "2T2-145-531",
        "name": "PRISIONEIR"
    },
    {
        "code": "2T2-145-531-A",
        "name": "PRISIONEIR"
    },
    {
        "code": "2S2-857-502-BN-1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2T2-145-531-B",
        "name": "PRISIONEIR"
    },
    {
        "code": "WHT-009-303",
        "name": "PRISIONEIR"
    },
    {
        "code": "WHT-009-304",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-305",
        "name": "ARRUELA"
    },
    {
        "code": "2S2-857-502-J -1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2S2-857-502-K -1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-857-502-L -1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2S2-857-502-M -1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-857-502-N -1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "2S2-857-502-P -1NN",
        "name": "ESPELHO"
    },
    {
        "code": "23K-800-401-P -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-857-502-BP-1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2S2-857-518",
        "name": "ANEL"
    },
    {
        "code": "T14-501-271-A",
        "name": "ADAPTADOR"
    },
    {
        "code": "2T2-130-139-A",
        "name": "ANEL"
    },
    {
        "code": "2T2-130-139-B",
        "name": "ANEL"
    },
    {
        "code": "2T2-130-139-D",
        "name": "ANEL"
    },
    {
        "code": "2T2-130-240",
        "name": "CONEXAO"
    },
    {
        "code": "2T2-130-291",
        "name": "CONECTOR"
    },
    {
        "code": "2T2-130-305",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-305-A",
        "name": "TUBO"
    },
    {
        "code": "2T2-130-305-B",
        "name": "TUBO"
    },
    {
        "code": "2S2-857-502-G -1NN",
        "name": "RETROVISOR"
    },
    {
        "code": "T15-415-801-B",
        "name": "BARRA"
    },
    {
        "code": "2T2-198-119",
        "name": "JG. MODULO"
    },
    {
        "code": "2T2-198-119-A",
        "name": "JG. MODULO"
    },
    {
        "code": "2T2-198-119-B",
        "name": "JG. MODULO"
    },
    {
        "code": "2T2-198-119-C",
        "name": "JG. MODULO"
    },
    {
        "code": "2T2-198-151",
        "name": "JG. ANEL"
    },
    {
        "code": "2T2-198-202",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-198-202-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-198-202-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-198-202-C",
        "name": "JG.PECAS"
    },
    {
        "code": "2S2-857-502-H -1NN",
        "name": "ESPELHO"
    },
    {
        "code": "2T2-198-229-A",
        "name": "CONJUNTO"
    },
    {
        "code": "2T2-198-229-B",
        "name": "CONJUNTO"
    },
    {
        "code": "2T2-198-229-C",
        "name": "CONJUNTO"
    },
    {
        "code": "TAK-525-439",
        "name": "PARAFUSO"
    },
    {
        "code": "TAK-525-439-A",
        "name": "PARAFUSO"
    },
    {
        "code": "TAK-525-441",
        "name": "PORCA"
    },
    {
        "code": "TAK-525-443",
        "name": "MOLA"
    },
    {
        "code": "TAK-525-449",
        "name": "ARRUELA"
    },
    {
        "code": "TAK-525-451",
        "name": "TAMPA"
    },
    {
        "code": "TAK-525-453",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-857-518-A",
        "name": "APOIO"
    },
    {
        "code": "TAK-599-183-A",
        "name": "PARAFUSO"
    },
    {
        "code": "TAK-607-105",
        "name": "SUPORTE"
    },
    {
        "code": "N  -102-615-15",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -102-615-16",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -102-615-17",
        "name": "FUSIVEL"
    },
    {
        "code": "N  -102-615-18",
        "name": "FUSIVEL"
    },
    {
        "code": "2T2-411-101-A",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2T2-411-101-F",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2T2-411-102-F",
        "name": "FEIXE MOLA"
    },
    {
        "code": "2T2-411-129",
        "name": "ESTRIBO"
    },
    {
        "code": "2S2-857-539",
        "name": "suporte"
    },
    {
        "code": "2T2-411-141",
        "name": "LAMINA"
    },
    {
        "code": "2T2-411-141-D",
        "name": "LAMINA"
    },
    {
        "code": "2T2-411-145",
        "name": "LAMINA"
    },
    {
        "code": "2T2-411-145-D",
        "name": "LAMINA"
    },
    {
        "code": "2T2-411-147",
        "name": "LAMINA"
    },
    {
        "code": "TE3-105-389",
        "name": "ARRUELA"
    },
    {
        "code": "TE3-105-775",
        "name": "PINO"
    },
    {
        "code": "TE3-107-125",
        "name": "ANEL"
    },
    {
        "code": "2T2-721-633-C",
        "name": "SUPORTE"
    },
    {
        "code": "2T2-798-041",
        "name": "JG.PECAS"
    },
    {
        "code": "2S2-857-540",
        "name": "suporte"
    },
    {
        "code": "2T2-798-041-A",
        "name": "JG.PECAS"
    },
    {
        "code": "2T2-798-135",
        "name": "JG.CILINDR"
    },
    {
        "code": "2T2-798-135-A",
        "name": "JG.CILINDR"
    },
    {
        "code": "2T2-798-435",
        "name": "JG.PECAS"
    },
    {
        "code": "TE3-109-703",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-109-705",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-115-263",
        "name": "PARAFUSO"
    },
    {
        "code": "TE3-115-279",
        "name": "porca"
    },
    {
        "code": "2R0-422-705-C",
        "name": "PRESILHA"
    },
    {
        "code": "2TB-601-027-A -Z31",
        "name": "RODA"
    },
    {
        "code": "2S2-857-543",
        "name": "suporte"
    },
    {
        "code": "2TB-601-139",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-601-161",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-601-239",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-607-047",
        "name": "MECANISMO"
    },
    {
        "code": "TF3-145-667-A",
        "name": "PARAFUSO"
    },
    {
        "code": "TF3-145-907-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2R0-857-655",
        "name": "PARAFUSO"
    },
    {
        "code": "2R0-857-657",
        "name": "PARAFUSO"
    },
    {
        "code": "2R0-857-659",
        "name": "PARAFUSO"
    },
    {
        "code": "2TB-607-957",
        "name": "MEMBRANA"
    },
    {
        "code": "2S2-857-564",
        "name": "MOLA"
    },
    {
        "code": "2TB-608-717",
        "name": "CONEXAO"
    },
    {
        "code": "2TB-608-719",
        "name": "CONEXAO"
    },
    {
        "code": "2T0-511-215-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-511-339",
        "name": "PARAFUSO"
    },
    {
        "code": "2T0-511-341",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-511-347",
        "name": "PROTECAO"
    },
    {
        "code": "2T0-511-419",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-511-420",
        "name": "SUPORTE"
    },
    {
        "code": "2T0-511-465",
        "name": "TUBO"
    },
    {
        "code": "2T0-511-535",
        "name": "APOIO"
    },
    {
        "code": "2S2-857-579",
        "name": "arruela"
    },
    {
        "code": "2T0-511-535-A",
        "name": "suporte"
    },
    {
        "code": "2T0-301-865",
        "name": "JUNTA"
    },
    {
        "code": "2T0-305-101",
        "name": "ANEL"
    },
    {
        "code": "2T0-311-091-F",
        "name": "ANEL"
    },
    {
        "code": "2T0-311-091-H",
        "name": "ANEL"
    },
    {
        "code": "2W0-311-127-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-311-978-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-AA",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-AB",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-AC",
        "name": "ARRUELA"
    },
    {
        "code": "2S2-861-031-D -81U",
        "name": "CAMA"
    },
    {
        "code": "2V5-311-978-AD",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-AE",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-978-B",
        "name": "ARRUELA"
    },
    {
        "code": "2S2-945-095-B",
        "name": "LANTERNA"
    },
    {
        "code": "2S2-945-096",
        "name": "LANTERNA"
    },
    {
        "code": "2S2-945-096-B",
        "name": "LANTERNA"
    },
    {
        "code": "2S2-945-341-C",
        "name": "LUZ PISCA"
    },
    {
        "code": "2T2-863-896-B",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-863-896-D",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-863-909-C",
        "name": "ISOLANTE"
    },
    {
        "code": "23K-800-401-P -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-861-221",
        "name": "CHAPA"
    },
    {
        "code": "2T2-864-919-D",
        "name": "ISOLANTE"
    },
    {
        "code": "2T2-867-035-  -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2T2-867-035-C -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2T2-867-036-A -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2T2-867-361-  -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-501-213",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-501-213-A",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-501-213-B",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-501-215",
        "name": "PORCA"
    },
    {
        "code": "23K-501-244",
        "name": "haste"
    },
    {
        "code": "2S2-861-221-A",
        "name": "CHAPA"
    },
    {
        "code": "23K-501-809",
        "name": "MANCAL"
    },
    {
        "code": "23K-501-810",
        "name": "HASTE"
    },
    {
        "code": "23K-501-811",
        "name": "HASTE"
    },
    {
        "code": "23K-505-085",
        "name": "suporte"
    },
    {
        "code": "23K-505-179",
        "name": "BUCHA"
    },
    {
        "code": "23K-505-189-D",
        "name": "BATENTE"
    },
    {
        "code": "23K-505-189-F",
        "name": "BATENTE"
    },
    {
        "code": "23K-505-189-G",
        "name": "BATENTE"
    },
    {
        "code": "23K-505-475",
        "name": "TIRANTE"
    },
    {
        "code": "23K-511-025-A",
        "name": "BARRA"
    },
    {
        "code": "2S2-861-221-B",
        "name": "CHAPA"
    },
    {
        "code": "23K-513-031-D",
        "name": "AMORTECEDO"
    },
    {
        "code": "23K-513-059",
        "name": "PISTAO"
    },
    {
        "code": "23K-521-110",
        "name": "EIXO"
    },
    {
        "code": "23K-521-115-B",
        "name": "EIXO"
    },
    {
        "code": "23K-521-115-C",
        "name": "EIXO"
    },
    {
        "code": "23K-521-171",
        "name": "PINO"
    },
    {
        "code": "23K-521-177",
        "name": "MANCALDESL"
    },
    {
        "code": "23K-521-177-A",
        "name": "MANCALDESL"
    },
    {
        "code": "23K-521-525-A",
        "name": "CINTA"
    },
    {
        "code": "23K-521-525-C",
        "name": "CINTA"
    },
    {
        "code": "2S2-861-224-A",
        "name": "CINTA"
    },
    {
        "code": "23K-525-021",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-021-A",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-021-B",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-021-C",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-021-D",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-021-E",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-041",
        "name": "CARCACA"
    },
    {
        "code": "23K-525-077",
        "name": "PINHAOCORO"
    },
    {
        "code": "23K-525-077-A",
        "name": "PINHAOCORO"
    },
    {
        "code": "23K-525-107-A",
        "name": "DIFERENCIA"
    },
    {
        "code": "2S2-861-225",
        "name": "PROTETOR"
    },
    {
        "code": "23K-525-107-B",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-C",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-D",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-E",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-F",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-G",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-H",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-J",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-K",
        "name": "DIFERENCIA"
    },
    {
        "code": "23K-525-107-L",
        "name": "DIFERENCIA"
    },
    {
        "code": "2S2-861-607-A",
        "name": "FRISOTETO"
    },
    {
        "code": "23K-525-155",
        "name": "PINHAOCORO"
    },
    {
        "code": "23K-525-155-B",
        "name": "PINHAOCORO"
    },
    {
        "code": "23K-525-270",
        "name": "PINO"
    },
    {
        "code": "23K-525-289",
        "name": "FLANGE"
    },
    {
        "code": "23K-525-345",
        "name": "ANEL VEDAC"
    },
    {
        "code": "23K-525-529",
        "name": "CHAPA"
    },
    {
        "code": "23K-525-631",
        "name": "ACIONAMENT"
    },
    {
        "code": "23K-525-777",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-103-351-B",
        "name": "CABECOTE"
    },
    {
        "code": "2U2-103-351-C",
        "name": "CABECOTE"
    },
    {
        "code": "2S2-861-608",
        "name": "FRISOTETO"
    },
    {
        "code": "2U2-103-351-D",
        "name": "CABECOTE"
    },
    {
        "code": "2U2-103-351-E",
        "name": "CABECOTE"
    },
    {
        "code": "2U2-103-351-F",
        "name": "CABECOTE"
    },
    {
        "code": "2U2-103-351-G",
        "name": "CABECOTE"
    },
    {
        "code": "2W0-311-514",
        "name": "ARRUELA"
    },
    {
        "code": "23B-998-003-C",
        "name": "BOMBA"
    },
    {
        "code": "2RG-525-389",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2RG-607-033",
        "name": "PRESILHA"
    },
    {
        "code": "2S2-881-032-  -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2S2-881-032-A -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2S2-861-608-A",
        "name": "FRISOTETO"
    },
    {
        "code": "2S2-881-032-A -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2S2-881-032-B -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2S2-881-032-B -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2S2-881-032-C -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2R0-599-269-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2R0-599-269-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2R0-607-091",
        "name": "CAPA COBER"
    },
    {
        "code": "2U2-311-152",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-160",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2U2-311-163",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2S2-861-609",
        "name": "BATENTE"
    },
    {
        "code": "2U2-311-167",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2U2-311-167-A",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2U2-311-167-C",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2U2-311-168",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-168-A",
        "name": "ARRUELA"
    },
    {
        "code": "2U2-311-168-B",
        "name": "TUCHO"
    },
    {
        "code": "2U2-311-189",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-189-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-189-B",
        "name": "PLA CONEX"
    },
    {
        "code": "2U2-311-189-C",
        "name": "ANEL"
    },
    {
        "code": "2S2-861-609-B",
        "name": "BATENTE"
    },
    {
        "code": "2U2-311-213",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-213-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-213-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-213-C",
        "name": "ROLAMENTO"
    },
    {
        "code": "2RD-199-120-AE",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-AF",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-AG",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-AH",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-AJ",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-AL",
        "name": "PARAFUSO"
    },
    {
        "code": "23K-800-401-Q -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-861-701",
        "name": "SUPORTE"
    },
    {
        "code": "2RD-199-120-AN",
        "name": "PARAFUSO"
    },
    {
        "code": "2RD-199-120-AP",
        "name": "PARAFUSO"
    },
    {
        "code": "2T4-511-331-A",
        "name": "PORCA"
    },
    {
        "code": "2T4-521-443",
        "name": "DEFLETOR"
    },
    {
        "code": "2T4-525-729",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "2T4-601-027-  -XD6",
        "name": "RODA"
    },
    {
        "code": "2T4-601-027-  -Z31",
        "name": "RODA"
    },
    {
        "code": "2U2-311-944-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-944-B",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-965",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S2-861-707",
        "name": "SUPORTE"
    },
    {
        "code": "2U2-311-965-A",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-965-B",
        "name": "ROLAMENTO"
    },
    {
        "code": "2U2-311-968",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-B",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-C",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-D",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-E",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-F",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-G",
        "name": "ANEL"
    },
    {
        "code": "2S2-862-758-  -WG5",
        "name": "CORTINA"
    },
    {
        "code": "2U2-311-968-H",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-J",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-K",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-968-L",
        "name": "ANEL"
    },
    {
        "code": "2U2-311-993",
        "name": "ALAVANCA"
    },
    {
        "code": "2U2-311-993-A",
        "name": "ALAVANCA"
    },
    {
        "code": "2U0-525-267-A",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-AA",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-AB",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-AC",
        "name": "DISCO"
    },
    {
        "code": "2S2-862-758-A -WG5",
        "name": "CORTINA"
    },
    {
        "code": "2U0-525-267-AD",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-AE",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-AF",
        "name": "DISCO"
    },
    {
        "code": "2U0-525-267-AL",
        "name": "DISCO"
    },
    {
        "code": "2V3-867-501-  -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-501-A -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-506-  -8EO",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-867-585",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-867-586-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-867-632",
        "name": "CLIP"
    },
    {
        "code": "2S2-863-159",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-867-926",
        "name": "TAMPA"
    },
    {
        "code": "2V3-868-071",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-868-071-A",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-868-072-C",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-868-072-D",
        "name": "GUARNICAO"
    },
    {
        "code": "2V3-868-280",
        "name": "GRAMPO"
    },
    {
        "code": "2V3-881-010",
        "name": "PC.FIXACAO"
    },
    {
        "code": "2V3-881-023-  -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-023-  -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-023-A -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2S2-863-197",
        "name": "TIRAS"
    },
    {
        "code": "2V3-881-023-A -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-023-B -ZDY",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-023-C -ZDY",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-023-D -9PY",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-881-023-E -9PY",
        "name": "ASSENTO"
    },
    {
        "code": "2U0-511-441-B",
        "name": "TIRANTE"
    },
    {
        "code": "2U0-512-332",
        "name": "PINO"
    },
    {
        "code": "2U0-525-105",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2U0-525-107",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-881-479",
        "name": "COBERTURA"
    },
    {
        "code": "2S2-863-197-A",
        "name": "TIRAS"
    },
    {
        "code": "2V3-881-479-A",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-881-479-B",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-881-479-C",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-881-479-D",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-881-479-E",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-881-479-F",
        "name": "COBERTURA"
    },
    {
        "code": "2V3-881-708",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V3-311-613",
        "name": "PINOCILIND"
    },
    {
        "code": "2V3-311-657",
        "name": "MANCALDESL"
    },
    {
        "code": "2V3-311-708",
        "name": "ROTOR"
    },
    {
        "code": "2S2-863-368-B -NA2",
        "name": "TAPETE"
    },
    {
        "code": "2V3-311-708-A",
        "name": "ROTOR"
    },
    {
        "code": "2V3-311-708-B",
        "name": "ROTOR"
    },
    {
        "code": "2V3-311-708-C",
        "name": "ROTOR"
    },
    {
        "code": "2V3-311-708-D",
        "name": "ROTOR"
    },
    {
        "code": "2V3-311-738",
        "name": "PISTAO"
    },
    {
        "code": "2V3-311-738-A",
        "name": "PISTAO"
    },
    {
        "code": "2V3-311-738-B",
        "name": "PISTAO"
    },
    {
        "code": "2V3-311-738-C",
        "name": "PISTAO"
    },
    {
        "code": "2V3-311-738-D",
        "name": "PISTAO"
    },
    {
        "code": "2V3-311-738-E",
        "name": "PISTAO"
    },
    {
        "code": "2S2-863-835-A",
        "name": "ISOLANTE"
    },
    {
        "code": "2V3-311-738-F",
        "name": "PISTAO"
    },
    {
        "code": "2V3-899-365-H",
        "name": "TUBO"
    },
    {
        "code": "2V3-899-383",
        "name": "suporte"
    },
    {
        "code": "2V3-899-411",
        "name": "suporte"
    },
    {
        "code": "2V3-899-501-B",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2V3-899-501-C",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2V3-899-501-D",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2V3-899-501-G",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2V3-899-501-L",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2V3-899-501-M",
        "name": "BOMBAHIDRA"
    },
    {
        "code": "2S2-863-883-C",
        "name": "ISOLANTE"
    },
    {
        "code": "2V3-899-505-A",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2V3-899-505-B",
        "name": "CIL.HIDRAU"
    },
    {
        "code": "2V3-899-507",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-899-508",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-899-515",
        "name": "MOLA"
    },
    {
        "code": "2V3-899-515-A",
        "name": "MOLA"
    },
    {
        "code": "2V3-899-515-E",
        "name": "MOLA"
    },
    {
        "code": "2V3-899-515-F",
        "name": "MOLA"
    },
    {
        "code": "2V3-899-521-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-899-541",
        "name": "BUCHA"
    },
    {
        "code": "23K-800-401-Q -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-863-884-A",
        "name": "ISOLANTE"
    },
    {
        "code": "2V3-899-563",
        "name": "CHAPA"
    },
    {
        "code": "2V3-903-015-A",
        "name": "ALTERNADOR"
    },
    {
        "code": "2V3-903-015-B",
        "name": "ALTERNADOR"
    },
    {
        "code": "2V3-903-137",
        "name": "correia"
    },
    {
        "code": "2V3-903-260",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-905-367",
        "name": "UNIDAD COM"
    },
    {
        "code": "2V3-905-367-A",
        "name": "UNIDAD COM"
    },
    {
        "code": "2V3-906-012-A",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-906-012-B",
        "name": "UNIDADE"
    },
    {
        "code": "2V3-906-012-C",
        "name": "UNIDADE"
    },
    {
        "code": "2S2-863-885-A",
        "name": "ISOLANTE"
    },
    {
        "code": "2V3-906-131",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-906-207",
        "name": "SENSOR"
    },
    {
        "code": "2V3-906-261",
        "name": "Sensor NOx"
    },
    {
        "code": "2V3-906-261-B",
        "name": "Sensor NOx"
    },
    {
        "code": "2V3-422-517",
        "name": "conexÆo"
    },
    {
        "code": "2V3-422-517-A",
        "name": "conexÆo"
    },
    {
        "code": "2V3-422-517-B",
        "name": "conexÆo"
    },
    {
        "code": "2V3-422-553",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-422-553-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-422-705",
        "name": "PRESILHA"
    },
    {
        "code": "2S2-863-885-D",
        "name": "ISOLANTE"
    },
    {
        "code": "2V3-422-705-A",
        "name": "PRESILHA"
    },
    {
        "code": "2V3-422-759",
        "name": "HASTE"
    },
    {
        "code": "2V3-422-843",
        "name": "TUBO ASPI."
    },
    {
        "code": "2V3-422-847",
        "name": "suporte"
    },
    {
        "code": "2V3-422-963-C",
        "name": "TUBO"
    },
    {
        "code": "2V3-500-051",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-500-051-AB",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-500-051-AC",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-500-051-AD",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-500-051-AE",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2S2-863-886",
        "name": "ISOLANTE"
    },
    {
        "code": "2V3-500-051-F",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-500-051-G",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-500-051-H",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-500-051-J",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-500-053",
        "name": "EIXOTRASEI"
    },
    {
        "code": "2V3-501-021-D",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V3-501-023",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V3-501-023-A",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V3-501-023-B",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V3-501-023-C",
        "name": "CORPOEIXO"
    },
    {
        "code": "2S2-863-886-C",
        "name": "ISOLANTE"
    },
    {
        "code": "2V3-501-023-D",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V3-501-091",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V3-501-091-A",
        "name": "CORPOEIXO"
    },
    {
        "code": "2V3-501-139",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-501-139-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-501-139-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-501-139-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-501-139-D",
        "name": "SUPPORT"
    },
    {
        "code": "2V3-501-139-E",
        "name": "SUPPORT"
    },
    {
        "code": "2V3-501-140",
        "name": "suporte"
    },
    {
        "code": "2S2-863-895",
        "name": "ISOLANTE"
    },
    {
        "code": "2V3-501-141",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-501-183-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-501-183-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-501-221",
        "name": "PORCA"
    },
    {
        "code": "2V3-501-221-A",
        "name": "PORCA"
    },
    {
        "code": "2V3-501-221-B",
        "name": "PORCA"
    },
    {
        "code": "2V3-501-221-C",
        "name": "PORCA"
    },
    {
        "code": "2V3-501-221-D",
        "name": "PORCA"
    },
    {
        "code": "2V3-501-244",
        "name": "haste"
    },
    {
        "code": "2V3-501-299",
        "name": "porca"
    },
    {
        "code": "2S2-867-035-A -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-501-395",
        "name": "CHAPA"
    },
    {
        "code": "2V3-501-771-A",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-253-185-A",
        "name": "ANEL"
    },
    {
        "code": "2U2-301-223",
        "name": "TRAVA"
    },
    {
        "code": "2U2-301-227-A",
        "name": "RETENTOR"
    },
    {
        "code": "2U2-301-233-A",
        "name": "EIXOMUDANC"
    },
    {
        "code": "2U2-301-252-A",
        "name": "TAMPA"
    },
    {
        "code": "2U2-301-252-B",
        "name": "TAMPA"
    },
    {
        "code": "2U2-301-262",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-262-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-867-361-C -WH6",
        "name": "REVESTIMEN"
    },
    {
        "code": "2U2-301-262-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2U2-301-287-B",
        "name": "TUBO"
    },
    {
        "code": "2U2-301-287-C",
        "name": "TUBO"
    },
    {
        "code": "2U2-301-287-D",
        "name": "TUBO"
    },
    {
        "code": "2V3-701-021",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-A",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-B",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-C",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-D",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-E",
        "name": "CHASSI"
    },
    {
        "code": "2S2-867-501-  -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-701-021-F",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-G",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-H",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-J",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-K",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-L",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-021-M",
        "name": "CHASSI"
    },
    {
        "code": "2V3-701-061",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-701-062",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-701-102",
        "name": "TRAVESSA"
    },
    {
        "code": "2S2-867-506-  -Y20",
        "name": "REVESTIMEN"
    },
    {
        "code": "2V3-701-131",
        "name": "TRAVESSA"
    },
    {
        "code": "2V3-701-141-B",
        "name": "LONGARINA"
    },
    {
        "code": "2V3-701-142-B",
        "name": "LONGARINA"
    },
    {
        "code": "2V3-701-149",
        "name": "suporte"
    },
    {
        "code": "2V3-701-150",
        "name": "suporte"
    },
    {
        "code": "2V3-701-151",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V3-701-151-C",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V3-701-151-E",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V3-701-151-G",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V3-701-151-L",
        "name": "QUINTA ROD"
    },
    {
        "code": "23K-800-401-R -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-867-645-  -033",
        "name": "PINO RETEN"
    },
    {
        "code": "2V3-701-151-M",
        "name": "QUINTA ROD"
    },
    {
        "code": "2V3-701-153",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-701-169-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-701-169-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-701-199-A",
        "name": "TRAVESSA"
    },
    {
        "code": "2V3-701-199-B",
        "name": "TRAVESSA"
    },
    {
        "code": "2V3-701-218-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-701-219",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-701-219-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-701-337",
        "name": "TRAVESSA"
    },
    {
        "code": "2S2-881-023-  -CIO",
        "name": "ASSENTO"
    },
    {
        "code": "2V3-701-441-A",
        "name": "LONGARINA"
    },
    {
        "code": "2V3-701-442-A",
        "name": "LONGARINA"
    },
    {
        "code": "2V3-701-487-A",
        "name": "APOIO"
    },
    {
        "code": "2V3-701-524",
        "name": "APOIO"
    },
    {
        "code": "2V3-701-575",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V3-701-575-A",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V3-701-576",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V3-701-576-A",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2V3-701-576-B",
        "name": "PLACAUNIAO"
    },
    {
        "code": "2U2-311-230-AS",
        "name": "FRICCAO"
    },
    {
        "code": "2S2-881-023-A -CIL",
        "name": "ASSENTO"
    },
    {
        "code": "2U2-311-230-AT",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-B",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BA",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BB",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BC",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BD",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BE",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BF",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BG",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BH",
        "name": "FRICCAO"
    },
    {
        "code": "2S2-881-023-A -CIO",
        "name": "ASSENTO"
    },
    {
        "code": "2U2-311-230-BJ",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BK",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BL",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BM",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BN",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BP",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BQ",
        "name": "FRICCAO"
    },
    {
        "code": "2U2-311-230-BR",
        "name": "FRICCAO"
    },
    {
        "code": "2Z0-198-156-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2Z0-198-156-C",
        "name": "JG.PECAS"
    },
    {
        "code": "2S2-881-031-A -QFE",
        "name": "ASSENTO"
    },
    {
        "code": "2Z0-198-156-D",
        "name": "BLOCO CILI"
    },
    {
        "code": "2Z0-198-156-E",
        "name": "JG.PECAS"
    },
    {
        "code": "2Z0-199-011",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-301-340-J",
        "name": "PARAFUSO"
    },
    {
        "code": "2W0-301-403",
        "name": "TRAVA"
    },
    {
        "code": "2V5-311-168-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-168-C",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V5-311-183",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-B",
        "name": "ARRUELA"
    },
    {
        "code": "2S2-881-031-A -QFF",
        "name": "ASSENTO"
    },
    {
        "code": "2V5-311-183-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-D",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-E",
        "name": "ARRUELA"
    },
    {
        "code": "2V5-311-183-F",
        "name": "ARRUELA"
    },
    {
        "code": "23B-711-940-A",
        "name": "CLIP"
    },
    {
        "code": "N  -106-645-02",
        "name": "PARAFUSO"
    },
    {
        "code": "23F-927-753",
        "name": "SENSOR"
    },
    {
        "code": "23F-927-754",
        "name": "SENSOR"
    },
    {
        "code": "2T2-971-050-AK",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-AL",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-881-032-  -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2T2-971-050-AM",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-AN",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-AP",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-AQ",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-AR",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-AS",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-AT",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-BA",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-BB",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-BC",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-881-032-C -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2T2-971-050-BD",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-BE",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-BF",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-BG",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-CD",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-CE",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-CF",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-CG",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-CR",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-CS",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-881-032-D -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "2T2-971-050-CT",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-DA",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-DB",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-DC",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-DD",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-DE",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-DF",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-DG",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-DT",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-EA",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-881-032-D -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2T2-971-050-EB",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-EC",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-ED",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-EE",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-EF",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-EG",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-EH",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-EJ",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-ER",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-ES",
        "name": "CHICOTE"
    },
    {
        "code": "23K-800-401-R -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-881-032-E -QFE",
        "name": "BANCO"
    },
    {
        "code": "2T2-971-050-ET",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-FA",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-FN",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-FP",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-FQ",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-050-FR",
        "name": "CHICOTE"
    },
    {
        "code": "WHT-011-754",
        "name": "ANEL"
    },
    {
        "code": "WHT-011-755",
        "name": "TAMP.ROSCA"
    },
    {
        "code": "N  -011-006-32",
        "name": "porca"
    },
    {
        "code": "2S2-607-315-F",
        "name": "CONEXAO"
    },
    {
        "code": "2S2-881-032-E -QFF",
        "name": "BANCO"
    },
    {
        "code": "2S2-607-315-G",
        "name": "COTOVELO"
    },
    {
        "code": "2S2-607-315-H",
        "name": "PECA EM T"
    },
    {
        "code": "2S2-607-315-J",
        "name": "CONEXAO"
    },
    {
        "code": "2S2-607-315-L",
        "name": "CONEXAO"
    },
    {
        "code": "2S2-607-315-N",
        "name": "PECA EM T"
    },
    {
        "code": "2S2-607-315-R",
        "name": "PECAJUNCAO"
    },
    {
        "code": "2S2-607-315-T",
        "name": "CONEXAO"
    },
    {
        "code": "T16-415-712-A",
        "name": "TERMINAL"
    },
    {
        "code": "T16-415-893-A",
        "name": "PARAFUSO"
    },
    {
        "code": "T16-415-895-A",
        "name": "PORCA"
    },
    {
        "code": "2S2-881-032-F -QFE",
        "name": "BANCO"
    },
    {
        "code": "N  -108-719-01",
        "name": "ARRUELA"
    },
    {
        "code": "2W0-145-745-D",
        "name": "MANGUEIRA"
    },
    {
        "code": "WHT-009-417",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-459",
        "name": "BRACADEIR"
    },
    {
        "code": "2RL-607-073-A",
        "name": "TAMPA"
    },
    {
        "code": "2RL-607-185",
        "name": "AMORTECEDO"
    },
    {
        "code": "2RL-607-567",
        "name": "CAMARA DO"
    },
    {
        "code": "N  -104-267-02",
        "name": "PARAFUSO"
    },
    {
        "code": "JZV-820-367",
        "name": "ELEM FILTR"
    },
    {
        "code": "JZV-955-169",
        "name": "PALHETA"
    },
    {
        "code": "2S2-881-038-  -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "N  -010-445-3",
        "name": "PARAFUSO"
    },
    {
        "code": "07W-012-216-AB",
        "name": "ARRUELA"
    },
    {
        "code": "2R0-100-173-A",
        "name": "ETIQUETAID"
    },
    {
        "code": "2R0-100-175-A",
        "name": "ADESIVO"
    },
    {
        "code": "2R0-100-598-B",
        "name": "PAST VEDAC"
    },
    {
        "code": "2R0-100-598-C",
        "name": "PAST VEDAC"
    },
    {
        "code": "2S2-927-191",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-927-191-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-927-192-B",
        "name": "INTERRUPTO"
    },
    {
        "code": "23B-957-039-C",
        "name": "TACOGRAFO"
    },
    {
        "code": "2S2-881-038-A -CIL",
        "name": "BANCO COMP"
    },
    {
        "code": "3D0-971-838-D",
        "name": "ABRACADEIR"
    },
    {
        "code": "23B-845-519-A",
        "name": "FITAVELCRO"
    },
    {
        "code": "5Z0-959-856-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2RD-011-245",
        "name": "BRACADEIR"
    },
    {
        "code": "2RD-012-501",
        "name": "BRACADEIRA"
    },
    {
        "code": "2U2-129-591-D",
        "name": "COLETOR"
    },
    {
        "code": "2U2-129-591-E",
        "name": "COLETOR"
    },
    {
        "code": "2U2-129-591-F",
        "name": "COLETOR"
    },
    {
        "code": "2U2-129-621",
        "name": "TUBO"
    },
    {
        "code": "2U2-129-621-B",
        "name": "TUBO"
    },
    {
        "code": "2S2-881-038-A -CIO",
        "name": "BANCO COMP"
    },
    {
        "code": "2U2-129-621-F",
        "name": "TUBO"
    },
    {
        "code": "2U2-129-621-G",
        "name": "TUBO"
    },
    {
        "code": "2U2-129-644",
        "name": "CONECTOR"
    },
    {
        "code": "2T0-609-819",
        "name": "MECANISMO"
    },
    {
        "code": "2T0-609-819-A",
        "name": "MECANISMO"
    },
    {
        "code": "2T0-609-819-C",
        "name": "MECANISMO"
    },
    {
        "code": "2T0-609-820",
        "name": "MECANISMO"
    },
    {
        "code": "2T0-609-820-A",
        "name": "MECANISMO"
    },
    {
        "code": "2T0-609-820-C",
        "name": "MECANISMO"
    },
    {
        "code": "N  -107-296-01",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-881-038-B -QFE",
        "name": "BANCO"
    },
    {
        "code": "23G-858-407-  -NA2",
        "name": "CAPA COBER"
    },
    {
        "code": "23G-858-547-  -9B9",
        "name": "CAPA"
    },
    {
        "code": "23G-858-547-  -NA2",
        "name": "CAPA"
    },
    {
        "code": "23G-858-547-A -1QB",
        "name": "CAPA"
    },
    {
        "code": "23G-858-547-D -NA2",
        "name": "CAPA"
    },
    {
        "code": "23G-858-756",
        "name": "COBERTURA"
    },
    {
        "code": "23G-863-865",
        "name": "ISOLANTE"
    },
    {
        "code": "23G-863-866",
        "name": "ISOLANTE"
    },
    {
        "code": "23G-863-883",
        "name": "ISOLANTE"
    },
    {
        "code": "N  -090-148-1",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-881-038-B -QFF",
        "name": "BANCO"
    },
    {
        "code": "23K-807-126",
        "name": "SUPORTE"
    },
    {
        "code": "23K-807-126-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-807-126-C",
        "name": "SUPORTE"
    },
    {
        "code": "23K-807-223",
        "name": "GRADEPROTE"
    },
    {
        "code": "23K-807-223-A",
        "name": "GRADEPROTE"
    },
    {
        "code": "23K-807-223-B",
        "name": "GRADEPROTE"
    },
    {
        "code": "23K-807-224",
        "name": "GRADEPROTE"
    },
    {
        "code": "23K-807-224-A",
        "name": "GRADEPROTE"
    },
    {
        "code": "23K-807-224-B",
        "name": "GRADEPROTE"
    },
    {
        "code": "23K-807-401-A",
        "name": "PINO"
    },
    {
        "code": "2S2-881-041-  -CIL",
        "name": "ENCOSTO"
    },
    {
        "code": "23K-809-099",
        "name": "COBERTURA"
    },
    {
        "code": "23K-809-100",
        "name": "COBERTURA"
    },
    {
        "code": "23K-809-343",
        "name": "SUPORTE"
    },
    {
        "code": "23K-809-343-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-809-343-D",
        "name": "SUPORTE"
    },
    {
        "code": "23K-809-343-E",
        "name": "SUPORTE"
    },
    {
        "code": "23K-809-344",
        "name": "SUPORTE"
    },
    {
        "code": "23K-809-344-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-809-344-D",
        "name": "SUPORTE"
    },
    {
        "code": "23K-809-344-E",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-881-805-A -CIL",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-817-025",
        "name": "TETO"
    },
    {
        "code": "23K-817-383",
        "name": "COBERTURA"
    },
    {
        "code": "23K-817-384",
        "name": "COBERTURA"
    },
    {
        "code": "23K-819-810",
        "name": "VALVULA"
    },
    {
        "code": "23K-820-721",
        "name": "TUBO"
    },
    {
        "code": "23K-820-722",
        "name": "TUBO"
    },
    {
        "code": "23K-820-742",
        "name": "TUBO"
    },
    {
        "code": "23K-820-761",
        "name": "SUPORTE"
    },
    {
        "code": "23K-820-761-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-820-761-E",
        "name": "SUPORTE"
    },
    {
        "code": "23K-800-401-S -I7N",
        "name": "Cabina"
    },
    {
        "code": "2S2-881-805-A -CIO",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-820-769",
        "name": "SUPORTE"
    },
    {
        "code": "23K-821-105",
        "name": "paralama"
    },
    {
        "code": "23K-821-105-A",
        "name": "paralama"
    },
    {
        "code": "23K-821-106",
        "name": "paralama"
    },
    {
        "code": "23K-821-106-A",
        "name": "paralama"
    },
    {
        "code": "23K-821-173",
        "name": "PARA BARRO"
    },
    {
        "code": "23K-821-175-H",
        "name": "SUPORTE"
    },
    {
        "code": "23K-821-176-H",
        "name": "SUPORTE"
    },
    {
        "code": "23K-821-289-A",
        "name": "SUPORTE"
    },
    {
        "code": "23K-821-290-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-881-969",
        "name": "COBERTURA"
    },
    {
        "code": "23K-821-301",
        "name": "paralama"
    },
    {
        "code": "23K-821-541",
        "name": "ESPACADOR"
    },
    {
        "code": "23K-821-681",
        "name": "DEGRAU"
    },
    {
        "code": "23K-821-682",
        "name": "DEGRAU"
    },
    {
        "code": "23K-837-861",
        "name": "COIFA"
    },
    {
        "code": "23K-853-653-A",
        "name": "GRADE"
    },
    {
        "code": "23K-853-653-D",
        "name": "GRADE"
    },
    {
        "code": "23K-853-685",
        "name": "ADESIVO"
    },
    {
        "code": "23K-854-431-A",
        "name": "LOGOTIPO"
    },
    {
        "code": "23K-854-431-E",
        "name": "LOGOTIPO"
    },
    {
        "code": "2S2-885-161-A",
        "name": "DOBRADICA"
    },
    {
        "code": "23K-854-431-F",
        "name": "LOGOTIPO"
    },
    {
        "code": "23K-854-431-G",
        "name": "LOGOTIPO"
    },
    {
        "code": "23K-854-433",
        "name": "LOGOTIPO"
    },
    {
        "code": "23K-854-750",
        "name": "estribo"
    },
    {
        "code": "23K-854-750-A",
        "name": "estribo"
    },
    {
        "code": "23K-857-192",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-857-391",
        "name": "HASTE"
    },
    {
        "code": "23K-857-501-  -999",
        "name": "RETROVISOR"
    },
    {
        "code": "23K-857-501-A -999",
        "name": "RETROVISOR"
    },
    {
        "code": "23K-857-502-  -999",
        "name": "RETROVISOR"
    },
    {
        "code": "2S2-885-161-B",
        "name": "DOBRADICA"
    },
    {
        "code": "23K-857-502-A -999",
        "name": "RETROVISOR"
    },
    {
        "code": "23K-857-503-  -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-857-504-  -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-857-537",
        "name": "CAPA"
    },
    {
        "code": "23K-857-538",
        "name": "CAPA"
    },
    {
        "code": "23K-857-566-  -NA2",
        "name": "REVESTIMEN"
    },
    {
        "code": "23K-857-684-A",
        "name": "FECHO"
    },
    {
        "code": "23K-857-684-B",
        "name": "CHICOTE"
    },
    {
        "code": "2S2-010-010-B",
        "name": "ETIQUETA"
    },
    {
        "code": "2S2-010-010-C",
        "name": "ETIQUETA"
    },
    {
        "code": "2S2-885-165",
        "name": "DOBRADICA"
    },
    {
        "code": "2S2-010-010-D",
        "name": "ETIQUETA"
    },
    {
        "code": "2S2-010-032",
        "name": "EMBLEMA"
    },
    {
        "code": "2S2-010-550",
        "name": "ETIQUETAID"
    },
    {
        "code": "2S2-012-499",
        "name": "MANGUEIRA"
    },
    {
        "code": "2T2-971-073-C",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-079-A",
        "name": "CHICOTE"
    },
    {
        "code": "2T2-971-079-F",
        "name": "CHICOTE"
    },
    {
        "code": "TJG-012-501",
        "name": "PRESILHA"
    },
    {
        "code": "TJG-012-501-A",
        "name": "PRESILHA"
    },
    {
        "code": "2T2-035-689",
        "name": "porca"
    },
    {
        "code": "2S2-898-511-A",
        "name": "HASTE"
    },
    {
        "code": "2T2-098-385",
        "name": "PORCA"
    },
    {
        "code": "2T2-100-015-BB",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-BE",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-CK",
        "name": "MOTOR COMP"
    },
    {
        "code": "2T2-100-015-CL",
        "name": "MOTOR COMP"
    },
    {
        "code": "WHT-009-663",
        "name": "BRACADEIRA"
    },
    {
        "code": "WHT-009-673",
        "name": "ANEL VEDAC"
    },
    {
        "code": "WHT-009-674",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-675",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-676",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-898-511-B",
        "name": "HASTE"
    },
    {
        "code": "2V3-103-196",
        "name": "ANEL"
    },
    {
        "code": "2V3-103-227",
        "name": "TUBO RESPI"
    },
    {
        "code": "2V3-103-246",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-103-246-A",
        "name": "BRACADEIR"
    },
    {
        "code": "2V3-103-351",
        "name": "CABECOTE"
    },
    {
        "code": "2V3-103-351-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-103-448-A",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-103-448-B",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-103-448-C",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-103-448-D",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-899-381-A",
        "name": "CHAPA"
    },
    {
        "code": "2V3-103-448-E",
        "name": "PORCA"
    },
    {
        "code": "2V3-103-517",
        "name": "JUNTA CABE"
    },
    {
        "code": "2V3-103-517-A",
        "name": "JUNTA CABE"
    },
    {
        "code": "2V3-103-537",
        "name": "CARCACA"
    },
    {
        "code": "2V3-103-537-A",
        "name": "CARCACA"
    },
    {
        "code": "2V3-103-587-C",
        "name": "suporte"
    },
    {
        "code": "2V3-103-704",
        "name": "TAMPA"
    },
    {
        "code": "2V3-103-774",
        "name": "TUBO"
    },
    {
        "code": "2T0-820-811",
        "name": "JG.PECAS"
    },
    {
        "code": "2T0-821-143",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-906-048",
        "name": "INTERRUPTO"
    },
    {
        "code": "2T0-821-147",
        "name": "ARRUELA"
    },
    {
        "code": "2T0-821-149",
        "name": "porca"
    },
    {
        "code": "WHT-009-703",
        "name": "PARAFUSO"
    },
    {
        "code": "2V5-885-711-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-885-711-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V5-886-069",
        "name": "TUBO"
    },
    {
        "code": "2V5-887-271",
        "name": "PINO"
    },
    {
        "code": "2V5-887-271-B",
        "name": "PINO"
    },
    {
        "code": "2V5-898-010",
        "name": "JG REPARO"
    },
    {
        "code": "2V5-898-010-A",
        "name": "JG.PARAFUS"
    },
    {
        "code": "2S2-906-048-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V5-898-014",
        "name": "ALAVANCA"
    },
    {
        "code": "2V5-898-193-B",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-898-337-D",
        "name": "COIFA"
    },
    {
        "code": "2V5-898-337-E",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-898-337-F",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-898-337-G",
        "name": "JG.PECAS"
    },
    {
        "code": "2V5-898-337-K",
        "name": "JG.PECAS"
    },
    {
        "code": "2V3-301-685-B",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V3-301-685-C",
        "name": "TUBO OLEO"
    },
    {
        "code": "2V3-301-857",
        "name": "CHAPA"
    },
    {
        "code": "23K-800-401-S -I9A",
        "name": "Cabina"
    },
    {
        "code": "2S2-907-104-A",
        "name": "MODULO"
    },
    {
        "code": "2V3-301-857-A",
        "name": "CHAPA"
    },
    {
        "code": "2V3-301-857-B",
        "name": "CHAPA"
    },
    {
        "code": "2V3-301-865",
        "name": "JUNTA"
    },
    {
        "code": "2V3-301-865-A",
        "name": "JUNTA"
    },
    {
        "code": "2V3-301-865-B",
        "name": "JUNTA"
    },
    {
        "code": "2V3-301-865-C",
        "name": "JUNTA"
    },
    {
        "code": "2V3-301-865-D",
        "name": "JUNTA"
    },
    {
        "code": "2V3-311-063",
        "name": "DISCO"
    },
    {
        "code": "2V3-311-063-A",
        "name": "DISCO"
    },
    {
        "code": "2V3-311-063-B",
        "name": "DISCO"
    },
    {
        "code": "2S2-907-104-B",
        "name": "MODULO"
    },
    {
        "code": "2V3-311-063-C",
        "name": "DISCO"
    },
    {
        "code": "2V3-311-103",
        "name": "Eixo princ"
    },
    {
        "code": "WHT-005-928",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-929",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-931",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-934",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-947",
        "name": "ANEL"
    },
    {
        "code": "WHT-005-960",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-963",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-966",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-907-247-A",
        "name": "ANTENA"
    },
    {
        "code": "WHT-005-967",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-968",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-978",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-979",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-980",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-982",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-005-983",
        "name": "ANEL"
    },
    {
        "code": "WHT-005-984",
        "name": "PARAFUSO"
    },
    {
        "code": "2VC-881-996",
        "name": "PARAFUSO"
    },
    {
        "code": "2V3-311-213",
        "name": "ROLAMENTO"
    },
    {
        "code": "2S2-907-247-C",
        "name": "ANTENA"
    },
    {
        "code": "2V3-311-230",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-230-A",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-245",
        "name": "GUIA"
    },
    {
        "code": "2V3-311-247",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-247-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-247-B",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-247-C",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-035",
        "name": "MANGUEIRA"
    },
    {
        "code": "WHT-006-037",
        "name": "porca"
    },
    {
        "code": "WHT-006-041",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-907-247-D",
        "name": "ANTENA"
    },
    {
        "code": "WHT-006-042",
        "name": "porca"
    },
    {
        "code": "WHT-006-044",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-049",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-006-055",
        "name": "PRISIONEIR"
    },
    {
        "code": "WHT-006-067",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-076",
        "name": "ANEL"
    },
    {
        "code": "WHT-006-082",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-285-B",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-285-C",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2V3-311-285-D",
        "name": "ENGRENAGEM"
    },
    {
        "code": "2S2-920-808-H",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V3-311-301",
        "name": "CORPOSINCR"
    },
    {
        "code": "2V3-311-301-A",
        "name": "CORPOSINCR"
    },
    {
        "code": "2V3-311-318",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-311-321",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-321-A",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-321-B",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-321-C",
        "name": "ANEL"
    },
    {
        "code": "23G-131-978",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-899-305",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-899-306",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-920-808-K",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V1-899-365",
        "name": "TUBO"
    },
    {
        "code": "2V1-899-365-A",
        "name": "TUBO"
    },
    {
        "code": "2V1-899-365-B",
        "name": "TUBO"
    },
    {
        "code": "2V1-899-381",
        "name": "suporte"
    },
    {
        "code": "2V1-899-382",
        "name": "suporte"
    },
    {
        "code": "2V1-899-383-A",
        "name": "suporte"
    },
    {
        "code": "2V1-899-383-B",
        "name": "suporte"
    },
    {
        "code": "2V1-899-383-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-899-387",
        "name": "suporte"
    },
    {
        "code": "2V1-899-387-A",
        "name": "suporte"
    },
    {
        "code": "2S2-920-808-L",
        "name": "INSTRUMENT"
    },
    {
        "code": "2V1-899-388-A",
        "name": "suporte"
    },
    {
        "code": "2V1-899-399",
        "name": "MANCAL"
    },
    {
        "code": "2V1-899-400",
        "name": "MANCAL"
    },
    {
        "code": "2V1-899-400-A",
        "name": "MANCAL"
    },
    {
        "code": "2V1-899-421",
        "name": "BASE"
    },
    {
        "code": "2V1-899-445",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-899-506",
        "name": "BARRA"
    },
    {
        "code": "2V1-899-521-A",
        "name": "ALAVANCA"
    },
    {
        "code": "2V1-899-521-B",
        "name": "ALAVANCA"
    },
    {
        "code": "2V1-899-521-C",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-927-192-C",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V1-905-367-A",
        "name": "UNI.COMAND"
    },
    {
        "code": "2V1-907-631",
        "name": "VALVULA"
    },
    {
        "code": "2V1-927-103",
        "name": "UNID.COMAN"
    },
    {
        "code": "2V1-937-149",
        "name": "TAMPA"
    },
    {
        "code": "2V1-937-197-  -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V1-945-567",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-945-568",
        "name": "SUPORTE"
    },
    {
        "code": "2V1-947-561",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V1-955-962",
        "name": "MANGUEIRA"
    },
    {
        "code": "2V1-959-565",
        "name": "INTERRUPTO"
    },
    {
        "code": "2S2-927-225",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V1-962-125",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V1-971-004",
        "name": "suporte"
    },
    {
        "code": "2V1-971-004-A",
        "name": "suporte"
    },
    {
        "code": "2V1-971-004-B",
        "name": "suporte"
    },
    {
        "code": "2V1-971-051-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-971-051-B",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-971-089",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-971-311-A",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-971-311-E",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-971-312-A",
        "name": "CHICOTE"
    },
    {
        "code": "2P0-000-367-A",
        "name": "ADESIVO"
    },
    {
        "code": "2S2-927-225-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V1-971-312-D",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-971-312-E",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-971-312-F",
        "name": "CHICOTE"
    },
    {
        "code": "2V1-971-796",
        "name": "suporte"
    },
    {
        "code": "WHT-009-098",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-118",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-127",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-130",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-132",
        "name": "APOIO"
    },
    {
        "code": "2V3-311-381-A",
        "name": "ANEL"
    },
    {
        "code": "2S2-927-451",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-311-381-B",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-381-C",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-381-D",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-381-E",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-381-F",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-383",
        "name": "ANEL"
    },
    {
        "code": "2V3-311-470",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V3-311-470-B",
        "name": "LUVA ENGAT"
    },
    {
        "code": "2V3-311-478",
        "name": "SENSOR"
    },
    {
        "code": "2V3-311-478-A",
        "name": "SENSOR"
    },
    {
        "code": "2S2-927-451-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-311-485",
        "name": "DISCO"
    },
    {
        "code": "2V3-145-820",
        "name": "TUBO"
    },
    {
        "code": "2V3-198-011",
        "name": "JG.VEDACAO"
    },
    {
        "code": "2V3-198-151",
        "name": "JG. ANEL"
    },
    {
        "code": "2V3-199-093-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-199-094-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-199-094-D",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-199-382",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-199-395",
        "name": "PRISIONEIR"
    },
    {
        "code": "2V3-201-050",
        "name": "VALVULA"
    },
    {
        "code": "2S2-941-531-  -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-201-060",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-201-060-A",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-201-060-B",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-201-060-C",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-201-060-D",
        "name": "RESERVATOR"
    },
    {
        "code": "2V3-201-060-E",
        "name": "RESERVATOR"
    },
    {
        "code": "WHT-009-144",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-154",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-163",
        "name": "PARAFUSO"
    },
    {
        "code": "WHT-009-164",
        "name": "PARAFUSO"
    },
    {
        "code": "2S2-941-531-A",
        "name": "INTERRUPTO"
    },
    {
        "code": "2R0-703-529-A",
        "name": "ARRUELA"
    },
    {
        "code": "2R0-703-529-C",
        "name": "ARRUELA"
    },
    {
        "code": "2V3-609-125",
        "name": "SUP FREIO"
    },
    {
        "code": "2V3-609-125-A",
        "name": "SUP FREIO"
    },
    {
        "code": "2V3-609-125-C",
        "name": "SUP FREIO"
    },
    {
        "code": "2V3-609-139",
        "name": "PINO"
    },
    {
        "code": "2V3-609-151",
        "name": "TRAVA"
    },
    {
        "code": "2V3-609-155",
        "name": "BUCHA"
    },
    {
        "code": "2V3-609-206",
        "name": "ANEL"
    },
    {
        "code": "2V3-609-206-A",
        "name": "ANEL"
    },
    {
        "code": "2S2-941-531-A -1QB",
        "name": "INTERRUPTO"
    },
    {
        "code": "2V3-609-206-B",
        "name": "ANEL"
    },
    {
        "code": "2V3-609-207",
        "name": "PINO"
    },
    {
        "code": "2V3-609-423",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-609-423-A",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-609-423-B",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-609-423-C",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-609-424",
        "name": "SUPORTE"
    },
    {
        "code": "2V3-609-457",
        "name": "MECANISMO"
    },
    {
        "code": "2V3-609-457-A",
        "name": "MECANISMO"
    },
    {
        "code": "2V3-609-457-B",
        "name": "MECANISMO"
    },
    {
        "code": "2S2-945-095",
        "name": "LANTERNA"
    },
    {
        "code": "2V3-609-458",
        "name": "MECANISMO"
    },
    {
        "code": "2V3-609-458-A",
        "name": "MECANISMO"
    },
    {
        "code": "2V3-609-458-B",
        "name": "MECANISMO"
    },
    {
        "code": "2V3-609-465",
        "name": "MOLA"
    },
    {
        "code": "2V3-609-523",
        "name": "SAPATA"
    },
    {
        "code": "2V3-609-523-A",
        "name": "SAPATA"
    },
    {
        "code": "2V3-609-649",
        "name": "TAMPAO"
    },
    {
        "code": "23B-858-756-A",
        "name": "COBERTURA"
    },
    {
        "code": "23B-858-923-  -82V",
        "name": "ANEL"
    },
    {
        "code": "2R2-937-025",
        "name": "CENTRAL EL"
    },
    {
        "code": "2S2-957-039-A",
        "name": "TACOGRAFO"
    },
    {
        "code": "2R2-937-031-B",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-937-069",
        "name": "TAMPA"
    },
    {
        "code": "2R2-937-115",
        "name": "PROTECAO"
    },
    {
        "code": "2R2-937-539-A",
        "name": "SUPORTE"
    },
    {
        "code": "2R2-937-540-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-817-017-C",
        "name": "TETO"
    },
    {
        "code": "23H-817-017-D",
        "name": "TETO"
    },
    {
        "code": "23H-817-117",
        "name": "QUAD TETO"
    },
    {
        "code": "23H-820-721-D",
        "name": "TUBO"
    },
    {
        "code": "23H-820-722-D",
        "name": "TUBO"
    },
    {
        "code": "2S2-959-856-B -1NN",
        "name": "INTERRUPTO"
    },
    {
        "code": "23H-820-742-D",
        "name": "TUBO"
    },
    {
        "code": "23H-820-761",
        "name": "SUPORTE"
    },
    {
        "code": "23H-820-761-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-820-761-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-821-151-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-821-151-B",
        "name": "SUPORTE"
    },
    {
        "code": "23H-821-152",
        "name": "SUPORTE"
    },
    {
        "code": "23H-821-152-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-821-175-A",
        "name": "SUPORTE"
    },
    {
        "code": "23H-821-176-A",
        "name": "SUPORTE"
    },
    {
        "code": "2S2-959-858-B -9B9",
        "name": "INTERRUPTO"
    },
    {
        "code": "23H-853-679-  -8RH",
        "name": "LOGOTIPO"
    },
    {
        "code": "23H-854-431-C",
        "name": "LOGOTIPO"
    },
    {
        "code": "23H-854-431-D",
        "name": "LOGOTIPO"
    },
    {
        "code": "23H-854-431-N",
        "name": "LOGOTIPO"
    },
    {
        "code": "2S0-261-847",
        "name": "BRACADEIRA"
    },
    {
        "code": "2T0-612-289",
        "name": "PINO"
    },
    {
        "code": "2T0-612-351",
        "name": "VALVULA"
    },
    {
        "code": "23K-609-741",
        "name": "pino"
    },
    {
        "code": "23K-609-745",
        "name": "suporte"
    },
    {
        "code": "23K-609-746",
        "name": "suporte"
    }
];

export const getParts = (searchTerm: string, limit: number = 20, page: number = 0) => {
  return partList.filter((part) => part.name.toLowerCase().includes(searchTerm.toLowerCase()) || part.code.toLowerCase().includes(searchTerm.toLowerCase())).slice(page * limit, (page + 1) * limit);
};